(function () {

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8040"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8040"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("k3FSZ", function(module, exports) {

module.exports = (parcelRequire("3PTKO"))($parcel$resolve("2cEx9")).then(()=>parcelRequire('hdWWD'));

});
parcelRegister("3PTKO", function(module, exports) {
"use strict";

var $3aKSr = parcelRequire("3aKSr");
module.exports = $3aKSr(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("3aKSr", function(module, exports) {
"use strict";
var $24f6ab11e2a2a7fd$var$cachedBundles = {};
var $24f6ab11e2a2a7fd$var$cachedPreloads = {};
var $24f6ab11e2a2a7fd$var$cachedPrefetches = {};
function $24f6ab11e2a2a7fd$var$getCache(type) {
    switch(type){
        case 'preload':
            return $24f6ab11e2a2a7fd$var$cachedPreloads;
        case 'prefetch':
            return $24f6ab11e2a2a7fd$var$cachedPrefetches;
        default:
            return $24f6ab11e2a2a7fd$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $24f6ab11e2a2a7fd$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



var $6a4d53a161ff0717$exports = {};
$parcel$extendImportMap({
    "2cEx9": "actioncable.ca52740c.js"
});


// Load turbo
var $ee40788d37d3b5ae$exports = {};

$parcel$export($ee40788d37d3b5ae$exports, "FrameLoadingStyle", function () { return $ee40788d37d3b5ae$export$65f98fefe20dbcb6; });
$parcel$export($ee40788d37d3b5ae$exports, "FrameElement", function () { return $ee40788d37d3b5ae$export$f464a8f0ffa32c44; });
$parcel$export($ee40788d37d3b5ae$exports, "config", function () { return $ee40788d37d3b5ae$export$e506a1d27d1eaa20; });
$parcel$export($ee40788d37d3b5ae$exports, "FetchResponse", function () { return $ee40788d37d3b5ae$export$3ae09bba5b6b906e; });
$parcel$export($ee40788d37d3b5ae$exports, "fetch", function () { return $ee40788d37d3b5ae$export$e7aa7bc5c1b3cfb3; });
$parcel$export($ee40788d37d3b5ae$exports, "fetchMethodFromString", function () { return $ee40788d37d3b5ae$export$4d71dd6e9f25af75; });
$parcel$export($ee40788d37d3b5ae$exports, "FetchMethod", function () { return $ee40788d37d3b5ae$export$76f6869e29ff06ee; });
$parcel$export($ee40788d37d3b5ae$exports, "fetchEnctypeFromString", function () { return $ee40788d37d3b5ae$export$4894fff9b16f993d; });
$parcel$export($ee40788d37d3b5ae$exports, "FetchEnctype", function () { return $ee40788d37d3b5ae$export$12bb94f0959cac5; });
$parcel$export($ee40788d37d3b5ae$exports, "FetchRequest", function () { return $ee40788d37d3b5ae$export$319b96fe59834522; });
$parcel$export($ee40788d37d3b5ae$exports, "isSafe", function () { return $ee40788d37d3b5ae$export$26e0721b40973527; });
$parcel$export($ee40788d37d3b5ae$exports, "FrameRenderer", function () { return $ee40788d37d3b5ae$export$f09c4165d16bb2b7; });
$parcel$export($ee40788d37d3b5ae$exports, "morphElements", function () { return $ee40788d37d3b5ae$export$dc74801294c91b10; });
$parcel$export($ee40788d37d3b5ae$exports, "morphChildren", function () { return $ee40788d37d3b5ae$export$e0eeaf5bc84bd47b; });
$parcel$export($ee40788d37d3b5ae$exports, "PageSnapshot", function () { return $ee40788d37d3b5ae$export$4f11b95e473fd113; });
$parcel$export($ee40788d37d3b5ae$exports, "PageRenderer", function () { return $ee40788d37d3b5ae$export$ac9642242cf7b3ce; });
$parcel$export($ee40788d37d3b5ae$exports, "session", function () { return $ee40788d37d3b5ae$export$55427e926be628d4; });
$parcel$export($ee40788d37d3b5ae$exports, "cache", function () { return $ee40788d37d3b5ae$export$69a3209f1a06c04d; });
$parcel$export($ee40788d37d3b5ae$exports, "navigator", function () { return $ee40788d37d3b5ae$export$ec7c8efa7f5790ae; });
$parcel$export($ee40788d37d3b5ae$exports, "start", function () { return $ee40788d37d3b5ae$export$b3571188c770cc5a; });
$parcel$export($ee40788d37d3b5ae$exports, "registerAdapter", function () { return $ee40788d37d3b5ae$export$ddf4d3602a252674; });
$parcel$export($ee40788d37d3b5ae$exports, "visit", function () { return $ee40788d37d3b5ae$export$bf638b60ea8b89b7; });
$parcel$export($ee40788d37d3b5ae$exports, "connectStreamSource", function () { return $ee40788d37d3b5ae$export$83667c2845c80463; });
$parcel$export($ee40788d37d3b5ae$exports, "disconnectStreamSource", function () { return $ee40788d37d3b5ae$export$26c56c74e3b67c59; });
$parcel$export($ee40788d37d3b5ae$exports, "renderStreamMessage", function () { return $ee40788d37d3b5ae$export$ebdee272e46e11d9; });
$parcel$export($ee40788d37d3b5ae$exports, "clearCache", function () { return $ee40788d37d3b5ae$export$d2adf65b87e47523; });
$parcel$export($ee40788d37d3b5ae$exports, "setProgressBarDelay", function () { return $ee40788d37d3b5ae$export$ddcc6947144c476c; });
$parcel$export($ee40788d37d3b5ae$exports, "setConfirmMethod", function () { return $ee40788d37d3b5ae$export$4696f1315e6aae7c; });
$parcel$export($ee40788d37d3b5ae$exports, "setFormMode", function () { return $ee40788d37d3b5ae$export$a94cfbb71d90abbd; });
$parcel$export($ee40788d37d3b5ae$exports, "morphBodyElements", function () { return $ee40788d37d3b5ae$export$3692fe532534b56a; });
$parcel$export($ee40788d37d3b5ae$exports, "morphTurboFrameElements", function () { return $ee40788d37d3b5ae$export$e23c491af5621dca; });
$parcel$export($ee40788d37d3b5ae$exports, "StreamActions", function () { return $ee40788d37d3b5ae$export$1b814a67c3a57eeb; });
$parcel$export($ee40788d37d3b5ae$exports, "StreamElement", function () { return $ee40788d37d3b5ae$export$144d499d37929ea8; });
$parcel$export($ee40788d37d3b5ae$exports, "StreamSourceElement", function () { return $ee40788d37d3b5ae$export$e87d51a4385a3903; });
/*!
Turbo 8.0.19
Copyright © 2025 37signals LLC
 */ /**
 * The MIT License (MIT)
 *
 * Copyright (c) 2019 Javan Makhmali
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ (function(prototype) {
    if (typeof prototype.requestSubmit == "function") return;
    prototype.requestSubmit = function(submitter) {
        if (submitter) {
            validateSubmitter(submitter, this);
            submitter.click();
        } else {
            submitter = document.createElement("input");
            submitter.type = "submit";
            submitter.hidden = true;
            this.appendChild(submitter);
            submitter.click();
            this.removeChild(submitter);
        }
    };
    function validateSubmitter(submitter, form) {
        submitter instanceof HTMLElement || raise(TypeError, "parameter 1 is not of type 'HTMLElement'");
        submitter.type == "submit" || raise(TypeError, "The specified element is not a submit button");
        submitter.form == form || raise(DOMException, "The specified element is not owned by this form element", "NotFoundError");
    }
    function raise(errorConstructor, message, name) {
        throw new errorConstructor("Failed to execute 'requestSubmit' on 'HTMLFormElement': " + message + ".", name);
    }
})(HTMLFormElement.prototype);
const $ee40788d37d3b5ae$var$submittersByForm = new WeakMap();
function $ee40788d37d3b5ae$var$findSubmitterFromClickTarget(target) {
    const element = target instanceof Element ? target : target instanceof Node ? target.parentElement : null;
    const candidate = element ? element.closest("input, button") : null;
    return candidate?.type == "submit" ? candidate : null;
}
function $ee40788d37d3b5ae$var$clickCaptured(event) {
    const submitter = $ee40788d37d3b5ae$var$findSubmitterFromClickTarget(event.target);
    if (submitter && submitter.form) $ee40788d37d3b5ae$var$submittersByForm.set(submitter.form, submitter);
}
(function() {
    if ("submitter" in Event.prototype) return;
    let prototype = window.Event.prototype;
    // Certain versions of Safari 15 have a bug where they won't
    // populate the submitter. This hurts TurboDrive's enable/disable detection.
    // See https://bugs.webkit.org/show_bug.cgi?id=229660
    if ("SubmitEvent" in window) {
        const prototypeOfSubmitEvent = window.SubmitEvent.prototype;
        if (/Apple Computer/.test(navigator.vendor) && !("submitter" in prototypeOfSubmitEvent)) prototype = prototypeOfSubmitEvent;
        else return; // polyfill not needed
    }
    addEventListener("click", $ee40788d37d3b5ae$var$clickCaptured, true);
    Object.defineProperty(prototype, "submitter", {
        get () {
            if (this.type == "submit" && this.target instanceof HTMLFormElement) return $ee40788d37d3b5ae$var$submittersByForm.get(this.target);
        }
    });
})();
const $ee40788d37d3b5ae$export$65f98fefe20dbcb6 = {
    eager: "eager",
    lazy: "lazy"
};
/**
 * Contains a fragment of HTML which is updated based on navigation within
 * it (e.g. via links or form submissions).
 *
 * @customElement turbo-frame
 * @example
 *   <turbo-frame id="messages">
 *     <a href="/messages/expanded">
 *       Show all expanded messages in this frame.
 *     </a>
 *
 *     <form action="/messages">
 *       Show response from this form within this frame.
 *     </form>
 *   </turbo-frame>
 */ class $ee40788d37d3b5ae$export$f464a8f0ffa32c44 extends HTMLElement {
    static delegateConstructor = undefined;
    loaded = Promise.resolve();
    static get observedAttributes() {
        return [
            "disabled",
            "loading",
            "src"
        ];
    }
    constructor(){
        super();
        this.delegate = new $ee40788d37d3b5ae$export$f464a8f0ffa32c44.delegateConstructor(this);
    }
    connectedCallback() {
        this.delegate.connect();
    }
    disconnectedCallback() {
        this.delegate.disconnect();
    }
    reload() {
        return this.delegate.sourceURLReloaded();
    }
    attributeChangedCallback(name) {
        if (name == "loading") this.delegate.loadingStyleChanged();
        else if (name == "src") this.delegate.sourceURLChanged();
        else if (name == "disabled") this.delegate.disabledChanged();
    }
    /**
   * Gets the URL to lazily load source HTML from
   */ get src() {
        return this.getAttribute("src");
    }
    /**
   * Sets the URL to lazily load source HTML from
   */ set src(value) {
        if (value) this.setAttribute("src", value);
        else this.removeAttribute("src");
    }
    /**
   * Gets the refresh mode for the frame.
   */ get refresh() {
        return this.getAttribute("refresh");
    }
    /**
   * Sets the refresh mode for the frame.
   */ set refresh(value) {
        if (value) this.setAttribute("refresh", value);
        else this.removeAttribute("refresh");
    }
    get shouldReloadWithMorph() {
        return this.src && this.refresh === "morph";
    }
    /**
   * Determines if the element is loading
   */ get loading() {
        return $ee40788d37d3b5ae$var$frameLoadingStyleFromString(this.getAttribute("loading") || "");
    }
    /**
   * Sets the value of if the element is loading
   */ set loading(value) {
        if (value) this.setAttribute("loading", value);
        else this.removeAttribute("loading");
    }
    /**
   * Gets the disabled state of the frame.
   *
   * If disabled, no requests will be intercepted by the frame.
   */ get disabled() {
        return this.hasAttribute("disabled");
    }
    /**
   * Sets the disabled state of the frame.
   *
   * If disabled, no requests will be intercepted by the frame.
   */ set disabled(value) {
        if (value) this.setAttribute("disabled", "");
        else this.removeAttribute("disabled");
    }
    /**
   * Gets the autoscroll state of the frame.
   *
   * If true, the frame will be scrolled into view automatically on update.
   */ get autoscroll() {
        return this.hasAttribute("autoscroll");
    }
    /**
   * Sets the autoscroll state of the frame.
   *
   * If true, the frame will be scrolled into view automatically on update.
   */ set autoscroll(value) {
        if (value) this.setAttribute("autoscroll", "");
        else this.removeAttribute("autoscroll");
    }
    /**
   * Determines if the element has finished loading
   */ get complete() {
        return !this.delegate.isLoading;
    }
    /**
   * Gets the active state of the frame.
   *
   * If inactive, source changes will not be observed.
   */ get isActive() {
        return this.ownerDocument === document && !this.isPreview;
    }
    /**
   * Sets the active state of the frame.
   *
   * If inactive, source changes will not be observed.
   */ get isPreview() {
        return this.ownerDocument?.documentElement?.hasAttribute("data-turbo-preview");
    }
}
function $ee40788d37d3b5ae$var$frameLoadingStyleFromString(style) {
    switch(style.toLowerCase()){
        case "lazy":
            return $ee40788d37d3b5ae$export$65f98fefe20dbcb6.lazy;
        default:
            return $ee40788d37d3b5ae$export$65f98fefe20dbcb6.eager;
    }
}
const $ee40788d37d3b5ae$var$drive = {
    enabled: true,
    progressBarDelay: 500,
    unvisitableExtensions: new Set([
        ".7z",
        ".aac",
        ".apk",
        ".avi",
        ".bmp",
        ".bz2",
        ".css",
        ".csv",
        ".deb",
        ".dmg",
        ".doc",
        ".docx",
        ".exe",
        ".gif",
        ".gz",
        ".heic",
        ".heif",
        ".ico",
        ".iso",
        ".jpeg",
        ".jpg",
        ".js",
        ".json",
        ".m4a",
        ".mkv",
        ".mov",
        ".mp3",
        ".mp4",
        ".mpeg",
        ".mpg",
        ".msi",
        ".ogg",
        ".ogv",
        ".pdf",
        ".pkg",
        ".png",
        ".ppt",
        ".pptx",
        ".rar",
        ".rtf",
        ".svg",
        ".tar",
        ".tif",
        ".tiff",
        ".txt",
        ".wav",
        ".webm",
        ".webp",
        ".wma",
        ".wmv",
        ".xls",
        ".xlsx",
        ".xml",
        ".zip"
    ])
};
function $ee40788d37d3b5ae$var$activateScriptElement(element) {
    if (element.getAttribute("data-turbo-eval") == "false") return element;
    else {
        const createdScriptElement = document.createElement("script");
        const cspNonce = $ee40788d37d3b5ae$var$getCspNonce();
        if (cspNonce) createdScriptElement.nonce = cspNonce;
        createdScriptElement.textContent = element.textContent;
        createdScriptElement.async = false;
        $ee40788d37d3b5ae$var$copyElementAttributes(createdScriptElement, element);
        return createdScriptElement;
    }
}
function $ee40788d37d3b5ae$var$copyElementAttributes(destinationElement, sourceElement) {
    for (const { name: name, value: value } of sourceElement.attributes)destinationElement.setAttribute(name, value);
}
function $ee40788d37d3b5ae$var$createDocumentFragment(html) {
    const template = document.createElement("template");
    template.innerHTML = html;
    return template.content;
}
function $ee40788d37d3b5ae$var$dispatch(eventName, { target: target, cancelable: cancelable, detail: detail } = {}) {
    const event = new CustomEvent(eventName, {
        cancelable: cancelable,
        bubbles: true,
        composed: true,
        detail: detail
    });
    if (target && target.isConnected) target.dispatchEvent(event);
    else document.documentElement.dispatchEvent(event);
    return event;
}
function $ee40788d37d3b5ae$var$cancelEvent(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}
function $ee40788d37d3b5ae$var$nextRepaint() {
    if (document.visibilityState === "hidden") return $ee40788d37d3b5ae$var$nextEventLoopTick();
    else return $ee40788d37d3b5ae$var$nextAnimationFrame();
}
function $ee40788d37d3b5ae$var$nextAnimationFrame() {
    return new Promise((resolve)=>requestAnimationFrame(()=>resolve()));
}
function $ee40788d37d3b5ae$var$nextEventLoopTick() {
    return new Promise((resolve)=>setTimeout(()=>resolve(), 0));
}
function $ee40788d37d3b5ae$var$nextMicrotask() {
    return Promise.resolve();
}
function $ee40788d37d3b5ae$var$parseHTMLDocument(html = "") {
    return new DOMParser().parseFromString(html, "text/html");
}
function $ee40788d37d3b5ae$var$unindent(strings, ...values) {
    const lines = $ee40788d37d3b5ae$var$interpolate(strings, values).replace(/^\n/, "").split("\n");
    const match = lines[0].match(/^\s+/);
    const indent = match ? match[0].length : 0;
    return lines.map((line)=>line.slice(indent)).join("\n");
}
function $ee40788d37d3b5ae$var$interpolate(strings, values) {
    return strings.reduce((result, string, i)=>{
        const value = values[i] == undefined ? "" : values[i];
        return result + string + value;
    }, "");
}
function $ee40788d37d3b5ae$var$uuid() {
    return Array.from({
        length: 36
    }).map((_, i)=>{
        if (i == 8 || i == 13 || i == 18 || i == 23) return "-";
        else if (i == 14) return "4";
        else if (i == 19) return (Math.floor(Math.random() * 4) + 8).toString(16);
        else return Math.floor(Math.random() * 15).toString(16);
    }).join("");
}
function $ee40788d37d3b5ae$var$getAttribute(attributeName, ...elements) {
    for (const value of elements.map((element)=>element?.getAttribute(attributeName))){
        if (typeof value == "string") return value;
    }
    return null;
}
function $ee40788d37d3b5ae$var$hasAttribute(attributeName, ...elements) {
    return elements.some((element)=>element && element.hasAttribute(attributeName));
}
function $ee40788d37d3b5ae$var$markAsBusy(...elements) {
    for (const element of elements){
        if (element.localName == "turbo-frame") element.setAttribute("busy", "");
        element.setAttribute("aria-busy", "true");
    }
}
function $ee40788d37d3b5ae$var$clearBusyState(...elements) {
    for (const element of elements){
        if (element.localName == "turbo-frame") element.removeAttribute("busy");
        element.removeAttribute("aria-busy");
    }
}
function $ee40788d37d3b5ae$var$waitForLoad(element, timeoutInMilliseconds = 2000) {
    return new Promise((resolve)=>{
        const onComplete = ()=>{
            element.removeEventListener("error", onComplete);
            element.removeEventListener("load", onComplete);
            resolve();
        };
        element.addEventListener("load", onComplete, {
            once: true
        });
        element.addEventListener("error", onComplete, {
            once: true
        });
        setTimeout(resolve, timeoutInMilliseconds);
    });
}
function $ee40788d37d3b5ae$var$getHistoryMethodForAction(action) {
    switch(action){
        case "replace":
            return history.replaceState;
        case "advance":
        case "restore":
            return history.pushState;
    }
}
function $ee40788d37d3b5ae$var$isAction(action) {
    return action == "advance" || action == "replace" || action == "restore";
}
function $ee40788d37d3b5ae$var$getVisitAction(...elements) {
    const action = $ee40788d37d3b5ae$var$getAttribute("data-turbo-action", ...elements);
    return $ee40788d37d3b5ae$var$isAction(action) ? action : null;
}
function $ee40788d37d3b5ae$var$getMetaElement(name) {
    return document.querySelector(`meta[name="${name}"]`);
}
function $ee40788d37d3b5ae$var$getMetaContent(name) {
    const element = $ee40788d37d3b5ae$var$getMetaElement(name);
    return element && element.content;
}
function $ee40788d37d3b5ae$var$getCspNonce() {
    const element = $ee40788d37d3b5ae$var$getMetaElement("csp-nonce");
    if (element) {
        const { nonce: nonce, content: content } = element;
        return nonce == "" ? content : nonce;
    }
}
function $ee40788d37d3b5ae$var$setMetaContent(name, content) {
    let element = $ee40788d37d3b5ae$var$getMetaElement(name);
    if (!element) {
        element = document.createElement("meta");
        element.setAttribute("name", name);
        document.head.appendChild(element);
    }
    element.setAttribute("content", content);
    return element;
}
function $ee40788d37d3b5ae$var$findClosestRecursively(element, selector) {
    if (element instanceof Element) return element.closest(selector) || $ee40788d37d3b5ae$var$findClosestRecursively(element.assignedSlot || element.getRootNode()?.host, selector);
}
function $ee40788d37d3b5ae$var$elementIsFocusable(element) {
    const inertDisabledOrHidden = "[inert], :disabled, [hidden], details:not([open]), dialog:not([open])";
    return !!element && element.closest(inertDisabledOrHidden) == null && typeof element.focus == "function";
}
function $ee40788d37d3b5ae$var$queryAutofocusableElement(elementOrDocumentFragment) {
    return Array.from(elementOrDocumentFragment.querySelectorAll("[autofocus]")).find($ee40788d37d3b5ae$var$elementIsFocusable);
}
async function $ee40788d37d3b5ae$var$around(callback, reader) {
    const before = reader();
    callback();
    await $ee40788d37d3b5ae$var$nextAnimationFrame();
    const after = reader();
    return [
        before,
        after
    ];
}
function $ee40788d37d3b5ae$var$doesNotTargetIFrame(name) {
    if (name === "_blank") return false;
    else if (name) {
        for (const element of document.getElementsByName(name)){
            if (element instanceof HTMLIFrameElement) return false;
        }
        return true;
    } else return true;
}
function $ee40788d37d3b5ae$var$findLinkFromClickTarget(target) {
    const link = $ee40788d37d3b5ae$var$findClosestRecursively(target, "a[href], a[xlink\\:href]");
    if (!link) return null;
    if (link.hasAttribute("download")) return null;
    if (link.hasAttribute("target") && link.target !== "_self") return null;
    return link;
}
function $ee40788d37d3b5ae$var$getLocationForLink(link) {
    return $ee40788d37d3b5ae$var$expandURL(link.getAttribute("href") || "");
}
function $ee40788d37d3b5ae$var$debounce(fn, delay) {
    let timeoutId = null;
    return (...args)=>{
        const callback = ()=>fn.apply(this, args);
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, delay);
    };
}
const $ee40788d37d3b5ae$var$submitter = {
    "aria-disabled": {
        beforeSubmit: (submitter)=>{
            submitter.setAttribute("aria-disabled", "true");
            submitter.addEventListener("click", $ee40788d37d3b5ae$var$cancelEvent);
        },
        afterSubmit: (submitter)=>{
            submitter.removeAttribute("aria-disabled");
            submitter.removeEventListener("click", $ee40788d37d3b5ae$var$cancelEvent);
        }
    },
    "disabled": {
        beforeSubmit: (submitter)=>submitter.disabled = true,
        afterSubmit: (submitter)=>submitter.disabled = false
    }
};
class $ee40788d37d3b5ae$var$Config {
    #submitter = null;
    constructor(config){
        Object.assign(this, config);
    }
    get submitter() {
        return this.#submitter;
    }
    set submitter(value) {
        this.#submitter = $ee40788d37d3b5ae$var$submitter[value] || value;
    }
}
const $ee40788d37d3b5ae$var$forms = new $ee40788d37d3b5ae$var$Config({
    mode: "on",
    submitter: "disabled"
});
const $ee40788d37d3b5ae$export$e506a1d27d1eaa20 = {
    drive: $ee40788d37d3b5ae$var$drive,
    forms: $ee40788d37d3b5ae$var$forms
};
function $ee40788d37d3b5ae$var$expandURL(locatable) {
    return new URL(locatable.toString(), document.baseURI);
}
function $ee40788d37d3b5ae$var$getAnchor(url) {
    let anchorMatch;
    if (url.hash) return url.hash.slice(1);
    else if (anchorMatch = url.href.match(/#(.*)$/)) return anchorMatch[1];
}
function $ee40788d37d3b5ae$var$getAction$1(form, submitter) {
    const action = submitter?.getAttribute("formaction") || form.getAttribute("action") || form.action;
    return $ee40788d37d3b5ae$var$expandURL(action);
}
function $ee40788d37d3b5ae$var$getExtension(url) {
    return ($ee40788d37d3b5ae$var$getLastPathComponent(url).match(/\.[^.]*$/) || [])[0] || "";
}
function $ee40788d37d3b5ae$var$isPrefixedBy(baseURL, url) {
    const prefix = $ee40788d37d3b5ae$var$addTrailingSlash(url.origin + url.pathname);
    return $ee40788d37d3b5ae$var$addTrailingSlash(baseURL.href) === prefix || baseURL.href.startsWith(prefix);
}
function $ee40788d37d3b5ae$var$locationIsVisitable(location1, rootLocation) {
    return $ee40788d37d3b5ae$var$isPrefixedBy(location1, rootLocation) && !$ee40788d37d3b5ae$export$e506a1d27d1eaa20.drive.unvisitableExtensions.has($ee40788d37d3b5ae$var$getExtension(location1));
}
function $ee40788d37d3b5ae$var$getRequestURL(url) {
    const anchor = $ee40788d37d3b5ae$var$getAnchor(url);
    return anchor != null ? url.href.slice(0, -(anchor.length + 1)) : url.href;
}
function $ee40788d37d3b5ae$var$toCacheKey(url) {
    return $ee40788d37d3b5ae$var$getRequestURL(url);
}
function $ee40788d37d3b5ae$var$urlsAreEqual(left, right) {
    return $ee40788d37d3b5ae$var$expandURL(left).href == $ee40788d37d3b5ae$var$expandURL(right).href;
}
function $ee40788d37d3b5ae$var$getPathComponents(url) {
    return url.pathname.split("/").slice(1);
}
function $ee40788d37d3b5ae$var$getLastPathComponent(url) {
    return $ee40788d37d3b5ae$var$getPathComponents(url).slice(-1)[0];
}
function $ee40788d37d3b5ae$var$addTrailingSlash(value) {
    return value.endsWith("/") ? value : value + "/";
}
class $ee40788d37d3b5ae$export$3ae09bba5b6b906e {
    constructor(response){
        this.response = response;
    }
    get succeeded() {
        return this.response.ok;
    }
    get failed() {
        return !this.succeeded;
    }
    get clientError() {
        return this.statusCode >= 400 && this.statusCode <= 499;
    }
    get serverError() {
        return this.statusCode >= 500 && this.statusCode <= 599;
    }
    get redirected() {
        return this.response.redirected;
    }
    get location() {
        return $ee40788d37d3b5ae$var$expandURL(this.response.url);
    }
    get isHTML() {
        return this.contentType && this.contentType.match(/^(?:text\/([^\s;,]+\b)?html|application\/xhtml\+xml)\b/);
    }
    get statusCode() {
        return this.response.status;
    }
    get contentType() {
        return this.header("Content-Type");
    }
    get responseText() {
        return this.response.clone().text();
    }
    get responseHTML() {
        if (this.isHTML) return this.response.clone().text();
        else return Promise.resolve(undefined);
    }
    header(name) {
        return this.response.headers.get(name);
    }
}
class $ee40788d37d3b5ae$var$LimitedSet extends Set {
    constructor(maxSize){
        super();
        this.maxSize = maxSize;
    }
    add(value) {
        if (this.size >= this.maxSize) {
            const iterator = this.values();
            const oldestValue = iterator.next().value;
            this.delete(oldestValue);
        }
        super.add(value);
    }
}
const $ee40788d37d3b5ae$var$recentRequests = new $ee40788d37d3b5ae$var$LimitedSet(20);
function $ee40788d37d3b5ae$export$e7aa7bc5c1b3cfb3(url, options = {}) {
    const modifiedHeaders = new Headers(options.headers || {});
    const requestUID = $ee40788d37d3b5ae$var$uuid();
    $ee40788d37d3b5ae$var$recentRequests.add(requestUID);
    modifiedHeaders.append("X-Turbo-Request-Id", requestUID);
    return window.fetch(url, {
        ...options,
        headers: modifiedHeaders
    });
}
function $ee40788d37d3b5ae$export$4d71dd6e9f25af75(method) {
    switch(method.toLowerCase()){
        case "get":
            return $ee40788d37d3b5ae$export$76f6869e29ff06ee.get;
        case "post":
            return $ee40788d37d3b5ae$export$76f6869e29ff06ee.post;
        case "put":
            return $ee40788d37d3b5ae$export$76f6869e29ff06ee.put;
        case "patch":
            return $ee40788d37d3b5ae$export$76f6869e29ff06ee.patch;
        case "delete":
            return $ee40788d37d3b5ae$export$76f6869e29ff06ee.delete;
    }
}
const $ee40788d37d3b5ae$export$76f6869e29ff06ee = {
    get: "get",
    post: "post",
    put: "put",
    patch: "patch",
    delete: "delete"
};
function $ee40788d37d3b5ae$export$4894fff9b16f993d(encoding) {
    switch(encoding.toLowerCase()){
        case $ee40788d37d3b5ae$export$12bb94f0959cac5.multipart:
            return $ee40788d37d3b5ae$export$12bb94f0959cac5.multipart;
        case $ee40788d37d3b5ae$export$12bb94f0959cac5.plain:
            return $ee40788d37d3b5ae$export$12bb94f0959cac5.plain;
        default:
            return $ee40788d37d3b5ae$export$12bb94f0959cac5.urlEncoded;
    }
}
const $ee40788d37d3b5ae$export$12bb94f0959cac5 = {
    urlEncoded: "application/x-www-form-urlencoded",
    multipart: "multipart/form-data",
    plain: "text/plain"
};
class $ee40788d37d3b5ae$export$319b96fe59834522 {
    abortController = new AbortController();
    #resolveRequestPromise = (_value)=>{};
    constructor(delegate, method, location1, requestBody = new URLSearchParams(), target = null, enctype = $ee40788d37d3b5ae$export$12bb94f0959cac5.urlEncoded){
        const [url, body] = $ee40788d37d3b5ae$var$buildResourceAndBody($ee40788d37d3b5ae$var$expandURL(location1), method, requestBody, enctype);
        this.delegate = delegate;
        this.url = url;
        this.target = target;
        this.fetchOptions = {
            credentials: "same-origin",
            redirect: "follow",
            method: method.toUpperCase(),
            headers: {
                ...this.defaultHeaders
            },
            body: body,
            signal: this.abortSignal,
            referrer: this.delegate.referrer?.href
        };
        this.enctype = enctype;
    }
    get method() {
        return this.fetchOptions.method;
    }
    set method(value) {
        const fetchBody = this.isSafe ? this.url.searchParams : this.fetchOptions.body || new FormData();
        const fetchMethod = $ee40788d37d3b5ae$export$4d71dd6e9f25af75(value) || $ee40788d37d3b5ae$export$76f6869e29ff06ee.get;
        this.url.search = "";
        const [url, body] = $ee40788d37d3b5ae$var$buildResourceAndBody(this.url, fetchMethod, fetchBody, this.enctype);
        this.url = url;
        this.fetchOptions.body = body;
        this.fetchOptions.method = fetchMethod.toUpperCase();
    }
    get headers() {
        return this.fetchOptions.headers;
    }
    set headers(value) {
        this.fetchOptions.headers = value;
    }
    get body() {
        if (this.isSafe) return this.url.searchParams;
        else return this.fetchOptions.body;
    }
    set body(value) {
        this.fetchOptions.body = value;
    }
    get location() {
        return this.url;
    }
    get params() {
        return this.url.searchParams;
    }
    get entries() {
        return this.body ? Array.from(this.body.entries()) : [];
    }
    cancel() {
        this.abortController.abort();
    }
    async perform() {
        const { fetchOptions: fetchOptions } = this;
        this.delegate.prepareRequest(this);
        const event = await this.#allowRequestToBeIntercepted(fetchOptions);
        try {
            this.delegate.requestStarted(this);
            if (event.detail.fetchRequest) this.response = event.detail.fetchRequest.response;
            else this.response = $ee40788d37d3b5ae$export$e7aa7bc5c1b3cfb3(this.url.href, fetchOptions);
            const response = await this.response;
            return await this.receive(response);
        } catch (error) {
            if (error.name !== "AbortError") {
                if (this.#willDelegateErrorHandling(error)) this.delegate.requestErrored(this, error);
                throw error;
            }
        } finally{
            this.delegate.requestFinished(this);
        }
    }
    async receive(response) {
        const fetchResponse = new $ee40788d37d3b5ae$export$3ae09bba5b6b906e(response);
        const event = $ee40788d37d3b5ae$var$dispatch("turbo:before-fetch-response", {
            cancelable: true,
            detail: {
                fetchResponse: fetchResponse
            },
            target: this.target
        });
        if (event.defaultPrevented) this.delegate.requestPreventedHandlingResponse(this, fetchResponse);
        else if (fetchResponse.succeeded) this.delegate.requestSucceededWithResponse(this, fetchResponse);
        else this.delegate.requestFailedWithResponse(this, fetchResponse);
        return fetchResponse;
    }
    get defaultHeaders() {
        return {
            Accept: "text/html, application/xhtml+xml"
        };
    }
    get isSafe() {
        return $ee40788d37d3b5ae$export$26e0721b40973527(this.method);
    }
    get abortSignal() {
        return this.abortController.signal;
    }
    acceptResponseType(mimeType) {
        this.headers["Accept"] = [
            mimeType,
            this.headers["Accept"]
        ].join(", ");
    }
    async #allowRequestToBeIntercepted(fetchOptions) {
        const requestInterception = new Promise((resolve)=>this.#resolveRequestPromise = resolve);
        const event = $ee40788d37d3b5ae$var$dispatch("turbo:before-fetch-request", {
            cancelable: true,
            detail: {
                fetchOptions: fetchOptions,
                url: this.url,
                resume: this.#resolveRequestPromise
            },
            target: this.target
        });
        this.url = event.detail.url;
        if (event.defaultPrevented) await requestInterception;
        return event;
    }
    #willDelegateErrorHandling(error) {
        const event = $ee40788d37d3b5ae$var$dispatch("turbo:fetch-request-error", {
            target: this.target,
            cancelable: true,
            detail: {
                request: this,
                error: error
            }
        });
        return !event.defaultPrevented;
    }
}
function $ee40788d37d3b5ae$export$26e0721b40973527(fetchMethod) {
    return $ee40788d37d3b5ae$export$4d71dd6e9f25af75(fetchMethod) == $ee40788d37d3b5ae$export$76f6869e29ff06ee.get;
}
function $ee40788d37d3b5ae$var$buildResourceAndBody(resource, method, requestBody, enctype) {
    const searchParams = Array.from(requestBody).length > 0 ? new URLSearchParams($ee40788d37d3b5ae$var$entriesExcludingFiles(requestBody)) : resource.searchParams;
    if ($ee40788d37d3b5ae$export$26e0721b40973527(method)) return [
        $ee40788d37d3b5ae$var$mergeIntoURLSearchParams(resource, searchParams),
        null
    ];
    else if (enctype == $ee40788d37d3b5ae$export$12bb94f0959cac5.urlEncoded) return [
        resource,
        searchParams
    ];
    else return [
        resource,
        requestBody
    ];
}
function $ee40788d37d3b5ae$var$entriesExcludingFiles(requestBody) {
    const entries = [];
    for (const [name, value] of requestBody){
        if (value instanceof File) continue;
        else entries.push([
            name,
            value
        ]);
    }
    return entries;
}
function $ee40788d37d3b5ae$var$mergeIntoURLSearchParams(url, requestBody) {
    const searchParams = new URLSearchParams($ee40788d37d3b5ae$var$entriesExcludingFiles(requestBody));
    url.search = searchParams.toString();
    return url;
}
class $ee40788d37d3b5ae$var$AppearanceObserver {
    started = false;
    constructor(delegate, element){
        this.delegate = delegate;
        this.element = element;
        this.intersectionObserver = new IntersectionObserver(this.intersect);
    }
    start() {
        if (!this.started) {
            this.started = true;
            this.intersectionObserver.observe(this.element);
        }
    }
    stop() {
        if (this.started) {
            this.started = false;
            this.intersectionObserver.unobserve(this.element);
        }
    }
    intersect = (entries)=>{
        const lastEntry = entries.slice(-1)[0];
        if (lastEntry?.isIntersecting) this.delegate.elementAppearedInViewport(this.element);
    };
}
class $ee40788d37d3b5ae$var$StreamMessage {
    static contentType = "text/vnd.turbo-stream.html";
    static wrap(message) {
        if (typeof message == "string") return new this($ee40788d37d3b5ae$var$createDocumentFragment(message));
        else return message;
    }
    constructor(fragment){
        this.fragment = $ee40788d37d3b5ae$var$importStreamElements(fragment);
    }
}
function $ee40788d37d3b5ae$var$importStreamElements(fragment) {
    for (const element of fragment.querySelectorAll("turbo-stream")){
        const streamElement = document.importNode(element, true);
        for (const inertScriptElement of streamElement.templateElement.content.querySelectorAll("script"))inertScriptElement.replaceWith($ee40788d37d3b5ae$var$activateScriptElement(inertScriptElement));
        element.replaceWith(streamElement);
    }
    return fragment;
}
const $ee40788d37d3b5ae$var$PREFETCH_DELAY = 100;
class $ee40788d37d3b5ae$var$PrefetchCache {
    #prefetchTimeout = null;
    #prefetched = null;
    get(url) {
        if (this.#prefetched && this.#prefetched.url === url && this.#prefetched.expire > Date.now()) return this.#prefetched.request;
    }
    setLater(url, request, ttl) {
        this.clear();
        this.#prefetchTimeout = setTimeout(()=>{
            request.perform();
            this.set(url, request, ttl);
            this.#prefetchTimeout = null;
        }, $ee40788d37d3b5ae$var$PREFETCH_DELAY);
    }
    set(url, request, ttl) {
        this.#prefetched = {
            url: url,
            request: request,
            expire: new Date(new Date().getTime() + ttl)
        };
    }
    clear() {
        if (this.#prefetchTimeout) clearTimeout(this.#prefetchTimeout);
        this.#prefetched = null;
    }
}
const $ee40788d37d3b5ae$var$cacheTtl = 10000;
const $ee40788d37d3b5ae$var$prefetchCache = new $ee40788d37d3b5ae$var$PrefetchCache();
const $ee40788d37d3b5ae$var$FormSubmissionState = {
    initialized: "initialized",
    requesting: "requesting",
    waiting: "waiting",
    receiving: "receiving",
    stopping: "stopping",
    stopped: "stopped"
};
class $ee40788d37d3b5ae$var$FormSubmission {
    state = $ee40788d37d3b5ae$var$FormSubmissionState.initialized;
    static confirmMethod(message) {
        return Promise.resolve(confirm(message));
    }
    constructor(delegate, formElement, submitter, mustRedirect = false){
        const method = $ee40788d37d3b5ae$var$getMethod(formElement, submitter);
        const action = $ee40788d37d3b5ae$var$getAction($ee40788d37d3b5ae$var$getFormAction(formElement, submitter), method);
        const body = $ee40788d37d3b5ae$var$buildFormData(formElement, submitter);
        const enctype = $ee40788d37d3b5ae$var$getEnctype(formElement, submitter);
        this.delegate = delegate;
        this.formElement = formElement;
        this.submitter = submitter;
        this.fetchRequest = new $ee40788d37d3b5ae$export$319b96fe59834522(this, method, action, body, formElement, enctype);
        this.mustRedirect = mustRedirect;
    }
    get method() {
        return this.fetchRequest.method;
    }
    set method(value) {
        this.fetchRequest.method = value;
    }
    get action() {
        return this.fetchRequest.url.toString();
    }
    set action(value) {
        this.fetchRequest.url = $ee40788d37d3b5ae$var$expandURL(value);
    }
    get body() {
        return this.fetchRequest.body;
    }
    get enctype() {
        return this.fetchRequest.enctype;
    }
    get isSafe() {
        return this.fetchRequest.isSafe;
    }
    get location() {
        return this.fetchRequest.url;
    }
    // The submission process
    async start() {
        const { initialized: initialized, requesting: requesting } = $ee40788d37d3b5ae$var$FormSubmissionState;
        const confirmationMessage = $ee40788d37d3b5ae$var$getAttribute("data-turbo-confirm", this.submitter, this.formElement);
        if (typeof confirmationMessage === "string") {
            const confirmMethod = typeof $ee40788d37d3b5ae$export$e506a1d27d1eaa20.forms.confirm === "function" ? $ee40788d37d3b5ae$export$e506a1d27d1eaa20.forms.confirm : $ee40788d37d3b5ae$var$FormSubmission.confirmMethod;
            const answer = await confirmMethod(confirmationMessage, this.formElement, this.submitter);
            if (!answer) return;
        }
        if (this.state == initialized) {
            this.state = requesting;
            return this.fetchRequest.perform();
        }
    }
    stop() {
        const { stopping: stopping, stopped: stopped } = $ee40788d37d3b5ae$var$FormSubmissionState;
        if (this.state != stopping && this.state != stopped) {
            this.state = stopping;
            this.fetchRequest.cancel();
            return true;
        }
    }
    // Fetch request delegate
    prepareRequest(request) {
        if (!request.isSafe) {
            const token = $ee40788d37d3b5ae$var$getCookieValue($ee40788d37d3b5ae$var$getMetaContent("csrf-param")) || $ee40788d37d3b5ae$var$getMetaContent("csrf-token");
            if (token) request.headers["X-CSRF-Token"] = token;
        }
        if (this.requestAcceptsTurboStreamResponse(request)) request.acceptResponseType($ee40788d37d3b5ae$var$StreamMessage.contentType);
    }
    requestStarted(_request) {
        this.state = $ee40788d37d3b5ae$var$FormSubmissionState.waiting;
        if (this.submitter) $ee40788d37d3b5ae$export$e506a1d27d1eaa20.forms.submitter.beforeSubmit(this.submitter);
        this.setSubmitsWith();
        $ee40788d37d3b5ae$var$markAsBusy(this.formElement);
        $ee40788d37d3b5ae$var$dispatch("turbo:submit-start", {
            target: this.formElement,
            detail: {
                formSubmission: this
            }
        });
        this.delegate.formSubmissionStarted(this);
    }
    requestPreventedHandlingResponse(request, response) {
        $ee40788d37d3b5ae$var$prefetchCache.clear();
        this.result = {
            success: response.succeeded,
            fetchResponse: response
        };
    }
    requestSucceededWithResponse(request, response) {
        if (response.clientError || response.serverError) {
            this.delegate.formSubmissionFailedWithResponse(this, response);
            return;
        }
        $ee40788d37d3b5ae$var$prefetchCache.clear();
        if (this.requestMustRedirect(request) && $ee40788d37d3b5ae$var$responseSucceededWithoutRedirect(response)) {
            const error = new Error("Form responses must redirect to another location");
            this.delegate.formSubmissionErrored(this, error);
        } else {
            this.state = $ee40788d37d3b5ae$var$FormSubmissionState.receiving;
            this.result = {
                success: true,
                fetchResponse: response
            };
            this.delegate.formSubmissionSucceededWithResponse(this, response);
        }
    }
    requestFailedWithResponse(request, response) {
        this.result = {
            success: false,
            fetchResponse: response
        };
        this.delegate.formSubmissionFailedWithResponse(this, response);
    }
    requestErrored(request, error) {
        this.result = {
            success: false,
            error: error
        };
        this.delegate.formSubmissionErrored(this, error);
    }
    requestFinished(_request) {
        this.state = $ee40788d37d3b5ae$var$FormSubmissionState.stopped;
        if (this.submitter) $ee40788d37d3b5ae$export$e506a1d27d1eaa20.forms.submitter.afterSubmit(this.submitter);
        this.resetSubmitterText();
        $ee40788d37d3b5ae$var$clearBusyState(this.formElement);
        $ee40788d37d3b5ae$var$dispatch("turbo:submit-end", {
            target: this.formElement,
            detail: {
                formSubmission: this,
                ...this.result
            }
        });
        this.delegate.formSubmissionFinished(this);
    }
    // Private
    setSubmitsWith() {
        if (!this.submitter || !this.submitsWith) return;
        if (this.submitter.matches("button")) {
            this.originalSubmitText = this.submitter.innerHTML;
            this.submitter.innerHTML = this.submitsWith;
        } else if (this.submitter.matches("input")) {
            const input = this.submitter;
            this.originalSubmitText = input.value;
            input.value = this.submitsWith;
        }
    }
    resetSubmitterText() {
        if (!this.submitter || !this.originalSubmitText) return;
        if (this.submitter.matches("button")) this.submitter.innerHTML = this.originalSubmitText;
        else if (this.submitter.matches("input")) {
            const input = this.submitter;
            input.value = this.originalSubmitText;
        }
    }
    requestMustRedirect(request) {
        return !request.isSafe && this.mustRedirect;
    }
    requestAcceptsTurboStreamResponse(request) {
        return !request.isSafe || $ee40788d37d3b5ae$var$hasAttribute("data-turbo-stream", this.submitter, this.formElement);
    }
    get submitsWith() {
        return this.submitter?.getAttribute("data-turbo-submits-with");
    }
}
function $ee40788d37d3b5ae$var$buildFormData(formElement, submitter) {
    const formData = new FormData(formElement);
    const name = submitter?.getAttribute("name");
    const value = submitter?.getAttribute("value");
    if (name) formData.append(name, value || "");
    return formData;
}
function $ee40788d37d3b5ae$var$getCookieValue(cookieName) {
    if (cookieName != null) {
        const cookies = document.cookie ? document.cookie.split("; ") : [];
        const cookie = cookies.find((cookie)=>cookie.startsWith(cookieName));
        if (cookie) {
            const value = cookie.split("=").slice(1).join("=");
            return value ? decodeURIComponent(value) : undefined;
        }
    }
}
function $ee40788d37d3b5ae$var$responseSucceededWithoutRedirect(response) {
    return response.statusCode == 200 && !response.redirected;
}
function $ee40788d37d3b5ae$var$getFormAction(formElement, submitter) {
    const formElementAction = typeof formElement.action === "string" ? formElement.action : null;
    if (submitter?.hasAttribute("formaction")) return submitter.getAttribute("formaction") || "";
    else return formElement.getAttribute("action") || formElementAction || "";
}
function $ee40788d37d3b5ae$var$getAction(formAction, fetchMethod) {
    const action = $ee40788d37d3b5ae$var$expandURL(formAction);
    if ($ee40788d37d3b5ae$export$26e0721b40973527(fetchMethod)) action.search = "";
    return action;
}
function $ee40788d37d3b5ae$var$getMethod(formElement, submitter) {
    const method = submitter?.getAttribute("formmethod") || formElement.getAttribute("method") || "";
    return $ee40788d37d3b5ae$export$4d71dd6e9f25af75(method.toLowerCase()) || $ee40788d37d3b5ae$export$76f6869e29ff06ee.get;
}
function $ee40788d37d3b5ae$var$getEnctype(formElement, submitter) {
    return $ee40788d37d3b5ae$export$4894fff9b16f993d(submitter?.getAttribute("formenctype") || formElement.enctype);
}
class $ee40788d37d3b5ae$var$Snapshot {
    constructor(element){
        this.element = element;
    }
    get activeElement() {
        return this.element.ownerDocument.activeElement;
    }
    get children() {
        return [
            ...this.element.children
        ];
    }
    hasAnchor(anchor) {
        return this.getElementForAnchor(anchor) != null;
    }
    getElementForAnchor(anchor) {
        return anchor ? this.element.querySelector(`[id='${anchor}'], a[name='${anchor}']`) : null;
    }
    get isConnected() {
        return this.element.isConnected;
    }
    get firstAutofocusableElement() {
        return $ee40788d37d3b5ae$var$queryAutofocusableElement(this.element);
    }
    get permanentElements() {
        return $ee40788d37d3b5ae$var$queryPermanentElementsAll(this.element);
    }
    getPermanentElementById(id) {
        return $ee40788d37d3b5ae$var$getPermanentElementById(this.element, id);
    }
    getPermanentElementMapForSnapshot(snapshot) {
        const permanentElementMap = {};
        for (const currentPermanentElement of this.permanentElements){
            const { id: id } = currentPermanentElement;
            const newPermanentElement = snapshot.getPermanentElementById(id);
            if (newPermanentElement) permanentElementMap[id] = [
                currentPermanentElement,
                newPermanentElement
            ];
        }
        return permanentElementMap;
    }
}
function $ee40788d37d3b5ae$var$getPermanentElementById(node, id) {
    return node.querySelector(`#${id}[data-turbo-permanent]`);
}
function $ee40788d37d3b5ae$var$queryPermanentElementsAll(node) {
    return node.querySelectorAll("[id][data-turbo-permanent]");
}
class $ee40788d37d3b5ae$var$FormSubmitObserver {
    started = false;
    constructor(delegate, eventTarget){
        this.delegate = delegate;
        this.eventTarget = eventTarget;
    }
    start() {
        if (!this.started) {
            this.eventTarget.addEventListener("submit", this.submitCaptured, true);
            this.started = true;
        }
    }
    stop() {
        if (this.started) {
            this.eventTarget.removeEventListener("submit", this.submitCaptured, true);
            this.started = false;
        }
    }
    submitCaptured = ()=>{
        this.eventTarget.removeEventListener("submit", this.submitBubbled, false);
        this.eventTarget.addEventListener("submit", this.submitBubbled, false);
    };
    submitBubbled = (event)=>{
        if (!event.defaultPrevented) {
            const form = event.target instanceof HTMLFormElement ? event.target : undefined;
            const submitter = event.submitter || undefined;
            if (form && $ee40788d37d3b5ae$var$submissionDoesNotDismissDialog(form, submitter) && $ee40788d37d3b5ae$var$submissionDoesNotTargetIFrame(form, submitter) && this.delegate.willSubmitForm(form, submitter)) {
                event.preventDefault();
                event.stopImmediatePropagation();
                this.delegate.formSubmitted(form, submitter);
            }
        }
    };
}
function $ee40788d37d3b5ae$var$submissionDoesNotDismissDialog(form, submitter) {
    const method = submitter?.getAttribute("formmethod") || form.getAttribute("method");
    return method != "dialog";
}
function $ee40788d37d3b5ae$var$submissionDoesNotTargetIFrame(form, submitter) {
    const target = submitter?.getAttribute("formtarget") || form.getAttribute("target");
    return $ee40788d37d3b5ae$var$doesNotTargetIFrame(target);
}
class $ee40788d37d3b5ae$var$View {
    #resolveRenderPromise = (_value)=>{};
    #resolveInterceptionPromise = (_value)=>{};
    constructor(delegate, element){
        this.delegate = delegate;
        this.element = element;
    }
    // Scrolling
    scrollToAnchor(anchor) {
        const element = this.snapshot.getElementForAnchor(anchor);
        if (element) {
            this.focusElement(element);
            this.scrollToElement(element);
        } else this.scrollToPosition({
            x: 0,
            y: 0
        });
    }
    scrollToAnchorFromLocation(location1) {
        this.scrollToAnchor($ee40788d37d3b5ae$var$getAnchor(location1));
    }
    scrollToElement(element) {
        element.scrollIntoView();
    }
    focusElement(element) {
        if (element instanceof HTMLElement) {
            if (element.hasAttribute("tabindex")) element.focus();
            else {
                element.setAttribute("tabindex", "-1");
                element.focus();
                element.removeAttribute("tabindex");
            }
        }
    }
    scrollToPosition({ x: x, y: y }) {
        this.scrollRoot.scrollTo(x, y);
    }
    scrollToTop() {
        this.scrollToPosition({
            x: 0,
            y: 0
        });
    }
    get scrollRoot() {
        return window;
    }
    // Rendering
    async render(renderer) {
        const { isPreview: isPreview, shouldRender: shouldRender, willRender: willRender, newSnapshot: snapshot } = renderer;
        // A workaround to ignore tracked element mismatch reloads when performing
        // a promoted Visit from a frame navigation
        const shouldInvalidate = willRender;
        if (shouldRender) try {
            this.renderPromise = new Promise((resolve)=>this.#resolveRenderPromise = resolve);
            this.renderer = renderer;
            await this.prepareToRenderSnapshot(renderer);
            const renderInterception = new Promise((resolve)=>this.#resolveInterceptionPromise = resolve);
            const options = {
                resume: this.#resolveInterceptionPromise,
                render: this.renderer.renderElement,
                renderMethod: this.renderer.renderMethod
            };
            const immediateRender = this.delegate.allowsImmediateRender(snapshot, options);
            if (!immediateRender) await renderInterception;
            await this.renderSnapshot(renderer);
            this.delegate.viewRenderedSnapshot(snapshot, isPreview, this.renderer.renderMethod);
            this.delegate.preloadOnLoadLinksForView(this.element);
            this.finishRenderingSnapshot(renderer);
        } finally{
            delete this.renderer;
            this.#resolveRenderPromise(undefined);
            delete this.renderPromise;
        }
        else if (shouldInvalidate) this.invalidate(renderer.reloadReason);
    }
    invalidate(reason) {
        this.delegate.viewInvalidated(reason);
    }
    async prepareToRenderSnapshot(renderer) {
        this.markAsPreview(renderer.isPreview);
        await renderer.prepareToRender();
    }
    markAsPreview(isPreview) {
        if (isPreview) this.element.setAttribute("data-turbo-preview", "");
        else this.element.removeAttribute("data-turbo-preview");
    }
    markVisitDirection(direction) {
        this.element.setAttribute("data-turbo-visit-direction", direction);
    }
    unmarkVisitDirection() {
        this.element.removeAttribute("data-turbo-visit-direction");
    }
    async renderSnapshot(renderer) {
        await renderer.render();
    }
    finishRenderingSnapshot(renderer) {
        renderer.finishRendering();
    }
}
class $ee40788d37d3b5ae$var$FrameView extends $ee40788d37d3b5ae$var$View {
    missing() {
        this.element.innerHTML = `<strong class="turbo-frame-error">Content missing</strong>`;
    }
    get snapshot() {
        return new $ee40788d37d3b5ae$var$Snapshot(this.element);
    }
}
class $ee40788d37d3b5ae$var$LinkInterceptor {
    constructor(delegate, element){
        this.delegate = delegate;
        this.element = element;
    }
    start() {
        this.element.addEventListener("click", this.clickBubbled);
        document.addEventListener("turbo:click", this.linkClicked);
        document.addEventListener("turbo:before-visit", this.willVisit);
    }
    stop() {
        this.element.removeEventListener("click", this.clickBubbled);
        document.removeEventListener("turbo:click", this.linkClicked);
        document.removeEventListener("turbo:before-visit", this.willVisit);
    }
    clickBubbled = (event)=>{
        if (this.clickEventIsSignificant(event)) this.clickEvent = event;
        else delete this.clickEvent;
    };
    linkClicked = (event)=>{
        if (this.clickEvent && this.clickEventIsSignificant(event)) {
            if (this.delegate.shouldInterceptLinkClick(event.target, event.detail.url, event.detail.originalEvent)) {
                this.clickEvent.preventDefault();
                event.preventDefault();
                this.delegate.linkClickIntercepted(event.target, event.detail.url, event.detail.originalEvent);
            }
        }
        delete this.clickEvent;
    };
    willVisit = (_event)=>{
        delete this.clickEvent;
    };
    clickEventIsSignificant(event) {
        const target = event.composed ? event.target?.parentElement : event.target;
        const element = $ee40788d37d3b5ae$var$findLinkFromClickTarget(target) || target;
        return element instanceof Element && element.closest("turbo-frame, html") == this.element;
    }
}
class $ee40788d37d3b5ae$var$LinkClickObserver {
    started = false;
    constructor(delegate, eventTarget){
        this.delegate = delegate;
        this.eventTarget = eventTarget;
    }
    start() {
        if (!this.started) {
            this.eventTarget.addEventListener("click", this.clickCaptured, true);
            this.started = true;
        }
    }
    stop() {
        if (this.started) {
            this.eventTarget.removeEventListener("click", this.clickCaptured, true);
            this.started = false;
        }
    }
    clickCaptured = ()=>{
        this.eventTarget.removeEventListener("click", this.clickBubbled, false);
        this.eventTarget.addEventListener("click", this.clickBubbled, false);
    };
    clickBubbled = (event)=>{
        if (event instanceof MouseEvent && this.clickEventIsSignificant(event)) {
            const target = event.composedPath && event.composedPath()[0] || event.target;
            const link = $ee40788d37d3b5ae$var$findLinkFromClickTarget(target);
            if (link && $ee40788d37d3b5ae$var$doesNotTargetIFrame(link.target)) {
                const location1 = $ee40788d37d3b5ae$var$getLocationForLink(link);
                if (this.delegate.willFollowLinkToLocation(link, location1, event)) {
                    event.preventDefault();
                    this.delegate.followedLinkToLocation(link, location1);
                }
            }
        }
    };
    clickEventIsSignificant(event) {
        return !(event.target && event.target.isContentEditable || event.defaultPrevented || event.which > 1 || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey);
    }
}
class $ee40788d37d3b5ae$var$FormLinkClickObserver {
    constructor(delegate, element){
        this.delegate = delegate;
        this.linkInterceptor = new $ee40788d37d3b5ae$var$LinkClickObserver(this, element);
    }
    start() {
        this.linkInterceptor.start();
    }
    stop() {
        this.linkInterceptor.stop();
    }
    // Link hover observer delegate
    canPrefetchRequestToLocation(link, location1) {
        return false;
    }
    prefetchAndCacheRequestToLocation(link, location1) {
        return;
    }
    // Link click observer delegate
    willFollowLinkToLocation(link, location1, originalEvent) {
        return this.delegate.willSubmitFormLinkToLocation(link, location1, originalEvent) && (link.hasAttribute("data-turbo-method") || link.hasAttribute("data-turbo-stream"));
    }
    followedLinkToLocation(link, location1) {
        const form = document.createElement("form");
        const type = "hidden";
        for (const [name, value] of location1.searchParams)form.append(Object.assign(document.createElement("input"), {
            type: type,
            name: name,
            value: value
        }));
        const action = Object.assign(location1, {
            search: ""
        });
        form.setAttribute("data-turbo", "true");
        form.setAttribute("action", action.href);
        form.setAttribute("hidden", "");
        const method = link.getAttribute("data-turbo-method");
        if (method) form.setAttribute("method", method);
        const turboFrame = link.getAttribute("data-turbo-frame");
        if (turboFrame) form.setAttribute("data-turbo-frame", turboFrame);
        const turboAction = $ee40788d37d3b5ae$var$getVisitAction(link);
        if (turboAction) form.setAttribute("data-turbo-action", turboAction);
        const turboConfirm = link.getAttribute("data-turbo-confirm");
        if (turboConfirm) form.setAttribute("data-turbo-confirm", turboConfirm);
        const turboStream = link.hasAttribute("data-turbo-stream");
        if (turboStream) form.setAttribute("data-turbo-stream", "");
        this.delegate.submittedFormLinkToLocation(link, location1, form);
        document.body.appendChild(form);
        form.addEventListener("turbo:submit-end", ()=>form.remove(), {
            once: true
        });
        requestAnimationFrame(()=>form.requestSubmit());
    }
}
class $ee40788d37d3b5ae$var$Bardo {
    static async preservingPermanentElements(delegate, permanentElementMap, callback) {
        const bardo = new this(delegate, permanentElementMap);
        bardo.enter();
        await callback();
        bardo.leave();
    }
    constructor(delegate, permanentElementMap){
        this.delegate = delegate;
        this.permanentElementMap = permanentElementMap;
    }
    enter() {
        for(const id in this.permanentElementMap){
            const [currentPermanentElement, newPermanentElement] = this.permanentElementMap[id];
            this.delegate.enteringBardo(currentPermanentElement, newPermanentElement);
            this.replaceNewPermanentElementWithPlaceholder(newPermanentElement);
        }
    }
    leave() {
        for(const id in this.permanentElementMap){
            const [currentPermanentElement] = this.permanentElementMap[id];
            this.replaceCurrentPermanentElementWithClone(currentPermanentElement);
            this.replacePlaceholderWithPermanentElement(currentPermanentElement);
            this.delegate.leavingBardo(currentPermanentElement);
        }
    }
    replaceNewPermanentElementWithPlaceholder(permanentElement) {
        const placeholder = $ee40788d37d3b5ae$var$createPlaceholderForPermanentElement(permanentElement);
        permanentElement.replaceWith(placeholder);
    }
    replaceCurrentPermanentElementWithClone(permanentElement) {
        const clone = permanentElement.cloneNode(true);
        permanentElement.replaceWith(clone);
    }
    replacePlaceholderWithPermanentElement(permanentElement) {
        const placeholder = this.getPlaceholderById(permanentElement.id);
        placeholder?.replaceWith(permanentElement);
    }
    getPlaceholderById(id) {
        return this.placeholders.find((element)=>element.content == id);
    }
    get placeholders() {
        return [
            ...document.querySelectorAll("meta[name=turbo-permanent-placeholder][content]")
        ];
    }
}
function $ee40788d37d3b5ae$var$createPlaceholderForPermanentElement(permanentElement) {
    const element = document.createElement("meta");
    element.setAttribute("name", "turbo-permanent-placeholder");
    element.setAttribute("content", permanentElement.id);
    return element;
}
class $ee40788d37d3b5ae$var$Renderer {
    #activeElement = null;
    static renderElement(currentElement, newElement) {
    // Abstract method
    }
    constructor(currentSnapshot, newSnapshot, isPreview, willRender = true){
        this.currentSnapshot = currentSnapshot;
        this.newSnapshot = newSnapshot;
        this.isPreview = isPreview;
        this.willRender = willRender;
        this.renderElement = this.constructor.renderElement;
        this.promise = new Promise((resolve, reject)=>this.resolvingFunctions = {
                resolve: resolve,
                reject: reject
            });
    }
    get shouldRender() {
        return true;
    }
    get shouldAutofocus() {
        return true;
    }
    get reloadReason() {
        return;
    }
    prepareToRender() {
        return;
    }
    render() {
    // Abstract method
    }
    finishRendering() {
        if (this.resolvingFunctions) {
            this.resolvingFunctions.resolve();
            delete this.resolvingFunctions;
        }
    }
    async preservingPermanentElements(callback) {
        await $ee40788d37d3b5ae$var$Bardo.preservingPermanentElements(this, this.permanentElementMap, callback);
    }
    focusFirstAutofocusableElement() {
        if (this.shouldAutofocus) {
            const element = this.connectedSnapshot.firstAutofocusableElement;
            if (element) element.focus();
        }
    }
    // Bardo delegate
    enteringBardo(currentPermanentElement) {
        if (this.#activeElement) return;
        if (currentPermanentElement.contains(this.currentSnapshot.activeElement)) this.#activeElement = this.currentSnapshot.activeElement;
    }
    leavingBardo(currentPermanentElement) {
        if (currentPermanentElement.contains(this.#activeElement) && this.#activeElement instanceof HTMLElement) {
            this.#activeElement.focus();
            this.#activeElement = null;
        }
    }
    get connectedSnapshot() {
        return this.newSnapshot.isConnected ? this.newSnapshot : this.currentSnapshot;
    }
    get currentElement() {
        return this.currentSnapshot.element;
    }
    get newElement() {
        return this.newSnapshot.element;
    }
    get permanentElementMap() {
        return this.currentSnapshot.getPermanentElementMapForSnapshot(this.newSnapshot);
    }
    get renderMethod() {
        return "replace";
    }
}
class $ee40788d37d3b5ae$export$f09c4165d16bb2b7 extends $ee40788d37d3b5ae$var$Renderer {
    static renderElement(currentElement, newElement) {
        const destinationRange = document.createRange();
        destinationRange.selectNodeContents(currentElement);
        destinationRange.deleteContents();
        const frameElement = newElement;
        const sourceRange = frameElement.ownerDocument?.createRange();
        if (sourceRange) {
            sourceRange.selectNodeContents(frameElement);
            currentElement.appendChild(sourceRange.extractContents());
        }
    }
    constructor(delegate, currentSnapshot, newSnapshot, renderElement, isPreview, willRender = true){
        super(currentSnapshot, newSnapshot, renderElement, isPreview, willRender);
        this.delegate = delegate;
    }
    get shouldRender() {
        return true;
    }
    async render() {
        await $ee40788d37d3b5ae$var$nextRepaint();
        this.preservingPermanentElements(()=>{
            this.loadFrameElement();
        });
        this.scrollFrameIntoView();
        await $ee40788d37d3b5ae$var$nextRepaint();
        this.focusFirstAutofocusableElement();
        await $ee40788d37d3b5ae$var$nextRepaint();
        this.activateScriptElements();
    }
    loadFrameElement() {
        this.delegate.willRenderFrame(this.currentElement, this.newElement);
        this.renderElement(this.currentElement, this.newElement);
    }
    scrollFrameIntoView() {
        if (this.currentElement.autoscroll || this.newElement.autoscroll) {
            const element = this.currentElement.firstElementChild;
            const block = $ee40788d37d3b5ae$var$readScrollLogicalPosition(this.currentElement.getAttribute("data-autoscroll-block"), "end");
            const behavior = $ee40788d37d3b5ae$var$readScrollBehavior(this.currentElement.getAttribute("data-autoscroll-behavior"), "auto");
            if (element) {
                element.scrollIntoView({
                    block: block,
                    behavior: behavior
                });
                return true;
            }
        }
        return false;
    }
    activateScriptElements() {
        for (const inertScriptElement of this.newScriptElements){
            const activatedScriptElement = $ee40788d37d3b5ae$var$activateScriptElement(inertScriptElement);
            inertScriptElement.replaceWith(activatedScriptElement);
        }
    }
    get newScriptElements() {
        return this.currentElement.querySelectorAll("script");
    }
}
function $ee40788d37d3b5ae$var$readScrollLogicalPosition(value, defaultValue) {
    if (value == "end" || value == "start" || value == "center" || value == "nearest") return value;
    else return defaultValue;
}
function $ee40788d37d3b5ae$var$readScrollBehavior(value, defaultValue) {
    if (value == "auto" || value == "smooth") return value;
    else return defaultValue;
}
/**
 * @typedef {object} ConfigHead
 *
 * @property {'merge' | 'append' | 'morph' | 'none'} [style]
 * @property {boolean} [block]
 * @property {boolean} [ignore]
 * @property {function(Element): boolean} [shouldPreserve]
 * @property {function(Element): boolean} [shouldReAppend]
 * @property {function(Element): boolean} [shouldRemove]
 * @property {function(Element, {added: Node[], kept: Element[], removed: Element[]}): void} [afterHeadMorphed]
 */ /**
 * @typedef {object} ConfigCallbacks
 *
 * @property {function(Node): boolean} [beforeNodeAdded]
 * @property {function(Node): void} [afterNodeAdded]
 * @property {function(Element, Node): boolean} [beforeNodeMorphed]
 * @property {function(Element, Node): void} [afterNodeMorphed]
 * @property {function(Element): boolean} [beforeNodeRemoved]
 * @property {function(Element): void} [afterNodeRemoved]
 * @property {function(string, Element, "update" | "remove"): boolean} [beforeAttributeUpdated]
 */ /**
 * @typedef {object} Config
 *
 * @property {'outerHTML' | 'innerHTML'} [morphStyle]
 * @property {boolean} [ignoreActive]
 * @property {boolean} [ignoreActiveValue]
 * @property {boolean} [restoreFocus]
 * @property {ConfigCallbacks} [callbacks]
 * @property {ConfigHead} [head]
 */ /**
 * @typedef {function} NoOp
 *
 * @returns {void}
 */ /**
 * @typedef {object} ConfigHeadInternal
 *
 * @property {'merge' | 'append' | 'morph' | 'none'} style
 * @property {boolean} [block]
 * @property {boolean} [ignore]
 * @property {(function(Element): boolean) | NoOp} shouldPreserve
 * @property {(function(Element): boolean) | NoOp} shouldReAppend
 * @property {(function(Element): boolean) | NoOp} shouldRemove
 * @property {(function(Element, {added: Node[], kept: Element[], removed: Element[]}): void) | NoOp} afterHeadMorphed
 */ /**
 * @typedef {object} ConfigCallbacksInternal
 *
 * @property {(function(Node): boolean) | NoOp} beforeNodeAdded
 * @property {(function(Node): void) | NoOp} afterNodeAdded
 * @property {(function(Node, Node): boolean) | NoOp} beforeNodeMorphed
 * @property {(function(Node, Node): void) | NoOp} afterNodeMorphed
 * @property {(function(Node): boolean) | NoOp} beforeNodeRemoved
 * @property {(function(Node): void) | NoOp} afterNodeRemoved
 * @property {(function(string, Element, "update" | "remove"): boolean) | NoOp} beforeAttributeUpdated
 */ /**
 * @typedef {object} ConfigInternal
 *
 * @property {'outerHTML' | 'innerHTML'} morphStyle
 * @property {boolean} [ignoreActive]
 * @property {boolean} [ignoreActiveValue]
 * @property {boolean} [restoreFocus]
 * @property {ConfigCallbacksInternal} callbacks
 * @property {ConfigHeadInternal} head
 */ /**
 * @typedef {Object} IdSets
 * @property {Set<string>} persistentIds
 * @property {Map<Node, Set<string>>} idMap
 */ /**
 * @typedef {Function} Morph
 *
 * @param {Element | Document} oldNode
 * @param {Element | Node | HTMLCollection | Node[] | string | null} newContent
 * @param {Config} [config]
 * @returns {undefined | Node[]}
 */ // base IIFE to define idiomorph
/**
 *
 * @type {{defaults: ConfigInternal, morph: Morph}}
 */ var $ee40788d37d3b5ae$var$Idiomorph = function() {
    /**
   * @typedef {object} MorphContext
   *
   * @property {Element} target
   * @property {Element} newContent
   * @property {ConfigInternal} config
   * @property {ConfigInternal['morphStyle']} morphStyle
   * @property {ConfigInternal['ignoreActive']} ignoreActive
   * @property {ConfigInternal['ignoreActiveValue']} ignoreActiveValue
   * @property {ConfigInternal['restoreFocus']} restoreFocus
   * @property {Map<Node, Set<string>>} idMap
   * @property {Set<string>} persistentIds
   * @property {ConfigInternal['callbacks']} callbacks
   * @property {ConfigInternal['head']} head
   * @property {HTMLDivElement} pantry
   * @property {Element[]} activeElementAndParents
   */ //=============================================================================
    // AND NOW IT BEGINS...
    //=============================================================================
    const noOp = ()=>{};
    /**
   * Default configuration values, updatable by users now
   * @type {ConfigInternal}
   */ const defaults = {
        morphStyle: "outerHTML",
        callbacks: {
            beforeNodeAdded: noOp,
            afterNodeAdded: noOp,
            beforeNodeMorphed: noOp,
            afterNodeMorphed: noOp,
            beforeNodeRemoved: noOp,
            afterNodeRemoved: noOp,
            beforeAttributeUpdated: noOp
        },
        head: {
            style: "merge",
            shouldPreserve: (elt)=>elt.getAttribute("im-preserve") === "true",
            shouldReAppend: (elt)=>elt.getAttribute("im-re-append") === "true",
            shouldRemove: noOp,
            afterHeadMorphed: noOp
        },
        restoreFocus: true
    };
    /**
   * Core idiomorph function for morphing one DOM tree to another
   *
   * @param {Element | Document} oldNode
   * @param {Element | Node | HTMLCollection | Node[] | string | null} newContent
   * @param {Config} [config]
   * @returns {Promise<Node[]> | Node[]}
   */ function morph(oldNode, newContent, config = {}) {
        oldNode = normalizeElement(oldNode);
        const newNode = normalizeParent(newContent);
        const ctx = createMorphContext(oldNode, newNode, config);
        const morphedNodes = saveAndRestoreFocus(ctx, ()=>{
            return withHeadBlocking(ctx, oldNode, newNode, /** @param {MorphContext} ctx */ (ctx)=>{
                if (ctx.morphStyle === "innerHTML") {
                    morphChildren(ctx, oldNode, newNode);
                    return Array.from(oldNode.childNodes);
                } else return morphOuterHTML(ctx, oldNode, newNode);
            });
        });
        ctx.pantry.remove();
        return morphedNodes;
    }
    /**
   * Morph just the outerHTML of the oldNode to the newContent
   * We have to be careful because the oldNode could have siblings which need to be untouched
   * @param {MorphContext} ctx
   * @param {Element} oldNode
   * @param {Element} newNode
   * @returns {Node[]}
   */ function morphOuterHTML(ctx, oldNode, newNode) {
        const oldParent = normalizeParent(oldNode);
        morphChildren(ctx, oldParent, newNode, // these two optional params are the secret sauce
        oldNode, oldNode.nextSibling);
        // this is safe even with siblings, because normalizeParent returns a SlicedParentNode if needed.
        return Array.from(oldParent.childNodes);
    }
    /**
   * @param {MorphContext} ctx
   * @param {Function} fn
   * @returns {Promise<Node[]> | Node[]}
   */ function saveAndRestoreFocus(ctx, fn) {
        if (!ctx.config.restoreFocus) return fn();
        let activeElement = /** @type {HTMLInputElement|HTMLTextAreaElement|null} */ document.activeElement;
        // don't bother if the active element is not an input or textarea
        if (!(activeElement instanceof HTMLInputElement || activeElement instanceof HTMLTextAreaElement)) return fn();
        const { id: activeElementId, selectionStart: selectionStart, selectionEnd: selectionEnd } = activeElement;
        const results = fn();
        if (activeElementId && activeElementId !== document.activeElement?.getAttribute("id")) {
            activeElement = ctx.target.querySelector(`[id="${activeElementId}"]`);
            activeElement?.focus();
        }
        if (activeElement && !activeElement.selectionEnd && selectionEnd) activeElement.setSelectionRange(selectionStart, selectionEnd);
        return results;
    }
    const morphChildren = function() {
        /**
     * This is the core algorithm for matching up children.  The idea is to use id sets to try to match up
     * nodes as faithfully as possible.  We greedily match, which allows us to keep the algorithm fast, but
     * by using id sets, we are able to better match up with content deeper in the DOM.
     *
     * Basic algorithm:
     * - for each node in the new content:
     *   - search self and siblings for an id set match, falling back to a soft match
     *   - if match found
     *     - remove any nodes up to the match:
     *       - pantry persistent nodes
     *       - delete the rest
     *     - morph the match
     *   - elsif no match found, and node is persistent
     *     - find its match by querying the old root (future) and pantry (past)
     *     - move it and its children here
     *     - morph it
     *   - else
     *     - create a new node from scratch as a last result
     *
     * @param {MorphContext} ctx the merge context
     * @param {Element} oldParent the old content that we are merging the new content into
     * @param {Element} newParent the parent element of the new content
     * @param {Node|null} [insertionPoint] the point in the DOM we start morphing at (defaults to first child)
     * @param {Node|null} [endPoint] the point in the DOM we stop morphing at (defaults to after last child)
     */ function morphChildren(ctx, oldParent, newParent, insertionPoint = null, endPoint = null) {
            // normalize
            if (oldParent instanceof HTMLTemplateElement && newParent instanceof HTMLTemplateElement) {
                // @ts-ignore we can pretend the DocumentFragment is an Element
                oldParent = oldParent.content;
                // @ts-ignore ditto
                newParent = newParent.content;
            }
            insertionPoint ||= oldParent.firstChild;
            // run through all the new content
            for (const newChild of newParent.childNodes){
                // once we reach the end of the old parent content skip to the end and insert the rest
                if (insertionPoint && insertionPoint != endPoint) {
                    const bestMatch = findBestMatch(ctx, newChild, insertionPoint, endPoint);
                    if (bestMatch) {
                        // if the node to morph is not at the insertion point then remove/move up to it
                        if (bestMatch !== insertionPoint) removeNodesBetween(ctx, insertionPoint, bestMatch);
                        morphNode(bestMatch, newChild, ctx);
                        insertionPoint = bestMatch.nextSibling;
                        continue;
                    }
                }
                // if the matching node is elsewhere in the original content
                if (newChild instanceof Element) {
                    // we can pretend the id is non-null because the next `.has` line will reject it if not
                    const newChildId = /** @type {String} */ newChild.getAttribute("id");
                    if (ctx.persistentIds.has(newChildId)) {
                        // move it and all its children here and morph
                        const movedChild = moveBeforeById(oldParent, newChildId, insertionPoint, ctx);
                        morphNode(movedChild, newChild, ctx);
                        insertionPoint = movedChild.nextSibling;
                        continue;
                    }
                }
                // last resort: insert the new node from scratch
                const insertedNode = createNode(oldParent, newChild, insertionPoint, ctx);
                // could be null if beforeNodeAdded prevented insertion
                if (insertedNode) insertionPoint = insertedNode.nextSibling;
            }
            // remove any remaining old nodes that didn't match up with new content
            while(insertionPoint && insertionPoint != endPoint){
                const tempNode = insertionPoint;
                insertionPoint = insertionPoint.nextSibling;
                removeNode(ctx, tempNode);
            }
        }
        /**
     * This performs the action of inserting a new node while handling situations where the node contains
     * elements with persistent ids and possible state info we can still preserve by moving in and then morphing
     *
     * @param {Element} oldParent
     * @param {Node} newChild
     * @param {Node|null} insertionPoint
     * @param {MorphContext} ctx
     * @returns {Node|null}
     */ function createNode(oldParent, newChild, insertionPoint, ctx) {
            if (ctx.callbacks.beforeNodeAdded(newChild) === false) return null;
            if (ctx.idMap.has(newChild)) {
                // node has children with ids with possible state so create a dummy elt of same type and apply full morph algorithm
                const newEmptyChild = document.createElement(/** @type {Element} */ newChild.tagName);
                oldParent.insertBefore(newEmptyChild, insertionPoint);
                morphNode(newEmptyChild, newChild, ctx);
                ctx.callbacks.afterNodeAdded(newEmptyChild);
                return newEmptyChild;
            } else {
                // optimisation: no id state to preserve so we can just insert a clone of the newChild and its descendants
                const newClonedChild = document.importNode(newChild, true); // importNode to not mutate newParent
                oldParent.insertBefore(newClonedChild, insertionPoint);
                ctx.callbacks.afterNodeAdded(newClonedChild);
                return newClonedChild;
            }
        }
        //=============================================================================
        // Matching Functions
        //=============================================================================
        const findBestMatch = function() {
            /**
       * Scans forward from the startPoint to the endPoint looking for a match
       * for the node. It looks for an id set match first, then a soft match.
       * We abort softmatching if we find two future soft matches, to reduce churn.
       * @param {Node} node
       * @param {MorphContext} ctx
       * @param {Node | null} startPoint
       * @param {Node | null} endPoint
       * @returns {Node | null}
       */ function findBestMatch(ctx, node, startPoint, endPoint) {
                let softMatch = null;
                let nextSibling = node.nextSibling;
                let siblingSoftMatchCount = 0;
                let cursor = startPoint;
                while(cursor && cursor != endPoint){
                    // soft matching is a prerequisite for id set matching
                    if (isSoftMatch(cursor, node)) {
                        if (isIdSetMatch(ctx, cursor, node)) return cursor; // found an id set match, we're done!
                        // we haven't yet saved a soft match fallback
                        if (softMatch === null) // the current soft match will hard match something else in the future, leave it
                        {
                            if (!ctx.idMap.has(cursor)) // save this as the fallback if we get through the loop without finding a hard match
                            softMatch = cursor;
                        }
                    }
                    if (softMatch === null && nextSibling && isSoftMatch(cursor, nextSibling)) {
                        // The next new node has a soft match with this node, so
                        // increment the count of future soft matches
                        siblingSoftMatchCount++;
                        nextSibling = nextSibling.nextSibling;
                        // If there are two future soft matches, block soft matching for this node to allow
                        // future siblings to soft match. This is to reduce churn in the DOM when an element
                        // is prepended.
                        if (siblingSoftMatchCount >= 2) softMatch = undefined;
                    }
                    // if the current node contains active element, stop looking for better future matches,
                    // because if one is found, this node will be moved to the pantry, reparenting it and thus losing focus
                    // @ts-ignore pretend cursor is Element rather than Node, we're just testing for array inclusion
                    if (ctx.activeElementAndParents.includes(cursor)) break;
                    cursor = cursor.nextSibling;
                }
                return softMatch || null;
            }
            /**
       *
       * @param {MorphContext} ctx
       * @param {Node} oldNode
       * @param {Node} newNode
       * @returns {boolean}
       */ function isIdSetMatch(ctx, oldNode, newNode) {
                let oldSet = ctx.idMap.get(oldNode);
                let newSet = ctx.idMap.get(newNode);
                if (!newSet || !oldSet) return false;
                for (const id of oldSet){
                    // a potential match is an id in the new and old nodes that
                    // has not already been merged into the DOM
                    // But the newNode content we call this on has not been
                    // merged yet and we don't allow duplicate IDs so it is simple
                    if (newSet.has(id)) return true;
                }
                return false;
            }
            /**
       *
       * @param {Node} oldNode
       * @param {Node} newNode
       * @returns {boolean}
       */ function isSoftMatch(oldNode, newNode) {
                // ok to cast: if one is not element, `id` and `tagName` will be undefined and we'll just compare that.
                const oldElt = /** @type {Element} */ oldNode;
                const newElt = /** @type {Element} */ newNode;
                return oldElt.nodeType === newElt.nodeType && oldElt.tagName === newElt.tagName && // If oldElt has an `id` with possible state and it doesn't match newElt.id then avoid morphing.
                // We'll still match an anonymous node with an IDed newElt, though, because if it got this far,
                // its not persistent, and new nodes can't have any hidden state.
                // We can't use .id because of form input shadowing, and we can't count on .getAttribute's presence because it could be a document-fragment
                (!oldElt.getAttribute?.("id") || oldElt.getAttribute?.("id") === newElt.getAttribute?.("id"));
            }
            return findBestMatch;
        }();
        //=============================================================================
        // DOM Manipulation Functions
        //=============================================================================
        /**
     * Gets rid of an unwanted DOM node; strategy depends on nature of its reuse:
     * - Persistent nodes will be moved to the pantry for later reuse
     * - Other nodes will have their hooks called, and then are removed
     * @param {MorphContext} ctx
     * @param {Node} node
     */ function removeNode(ctx, node) {
            // are we going to id set match this later?
            if (ctx.idMap.has(node)) // skip callbacks and move to pantry
            moveBefore(ctx.pantry, node, null);
            else {
                // remove for realsies
                if (ctx.callbacks.beforeNodeRemoved(node) === false) return;
                node.parentNode?.removeChild(node);
                ctx.callbacks.afterNodeRemoved(node);
            }
        }
        /**
     * Remove nodes between the start and end nodes
     * @param {MorphContext} ctx
     * @param {Node} startInclusive
     * @param {Node} endExclusive
     * @returns {Node|null}
     */ function removeNodesBetween(ctx, startInclusive, endExclusive) {
            /** @type {Node | null} */ let cursor = startInclusive;
            // remove nodes until the endExclusive node
            while(cursor && cursor !== endExclusive){
                let tempNode = /** @type {Node} */ cursor;
                cursor = cursor.nextSibling;
                removeNode(ctx, tempNode);
            }
            return cursor;
        }
        /**
     * Search for an element by id within the document and pantry, and move it using moveBefore.
     *
     * @param {Element} parentNode - The parent node to which the element will be moved.
     * @param {string} id - The ID of the element to be moved.
     * @param {Node | null} after - The reference node to insert the element before.
     *                              If `null`, the element is appended as the last child.
     * @param {MorphContext} ctx
     * @returns {Element} The found element
     */ function moveBeforeById(parentNode, id, after, ctx) {
            const target = /** @type {Element} - will always be found */ // ctx.target.id unsafe because of form input shadowing
            // ctx.target could be a document fragment which doesn't have `getAttribute`
            ctx.target.getAttribute?.("id") === id && ctx.target || ctx.target.querySelector(`[id="${id}"]`) || ctx.pantry.querySelector(`[id="${id}"]`);
            removeElementFromAncestorsIdMaps(target, ctx);
            moveBefore(parentNode, target, after);
            return target;
        }
        /**
     * Removes an element from its ancestors' id maps. This is needed when an element is moved from the
     * "future" via `moveBeforeId`. Otherwise, its erstwhile ancestors could be mistakenly moved to the
     * pantry rather than being deleted, preventing their removal hooks from being called.
     *
     * @param {Element} element - element to remove from its ancestors' id maps
     * @param {MorphContext} ctx
     */ function removeElementFromAncestorsIdMaps(element, ctx) {
            // we know id is non-null String, because this function is only called on elements with ids
            const id = /** @type {String} */ element.getAttribute("id");
            /** @ts-ignore - safe to loop in this way **/ while(element = element.parentNode){
                let idSet = ctx.idMap.get(element);
                if (idSet) {
                    idSet.delete(id);
                    if (!idSet.size) ctx.idMap.delete(element);
                }
            }
        }
        /**
     * Moves an element before another element within the same parent.
     * Uses the proposed `moveBefore` API if available (and working), otherwise falls back to `insertBefore`.
     * This is essentialy a forward-compat wrapper.
     *
     * @param {Element} parentNode - The parent node containing the after element.
     * @param {Node} element - The element to be moved.
     * @param {Node | null} after - The reference node to insert `element` before.
     *                              If `null`, `element` is appended as the last child.
     */ function moveBefore(parentNode, element, after) {
            // @ts-ignore - use proposed moveBefore feature
            if (parentNode.moveBefore) try {
                // @ts-ignore - use proposed moveBefore feature
                parentNode.moveBefore(element, after);
            } catch (e) {
                // fall back to insertBefore as some browsers may fail on moveBefore when trying to move Dom disconnected nodes to pantry
                parentNode.insertBefore(element, after);
            }
            else parentNode.insertBefore(element, after);
        }
        return morphChildren;
    }();
    //=============================================================================
    // Single Node Morphing Code
    //=============================================================================
    const morphNode = function() {
        /**
     * @param {Node} oldNode root node to merge content into
     * @param {Node} newContent new content to merge
     * @param {MorphContext} ctx the merge context
     * @returns {Node | null} the element that ended up in the DOM
     */ function morphNode(oldNode, newContent, ctx) {
            if (ctx.ignoreActive && oldNode === document.activeElement) // don't morph focused element
            return null;
            if (ctx.callbacks.beforeNodeMorphed(oldNode, newContent) === false) return oldNode;
            if (oldNode instanceof HTMLHeadElement && ctx.head.ignore) ;
            else if (oldNode instanceof HTMLHeadElement && ctx.head.style !== "morph") // ok to cast: if newContent wasn't also a <head>, it would've got caught in the `!isSoftMatch` branch above
            handleHeadElement(oldNode, /** @type {HTMLHeadElement} */ newContent, ctx);
            else {
                morphAttributes(oldNode, newContent, ctx);
                if (!ignoreValueOfActiveElement(oldNode, ctx)) // @ts-ignore newContent can be a node here because .firstChild will be null
                morphChildren(ctx, oldNode, newContent);
            }
            ctx.callbacks.afterNodeMorphed(oldNode, newContent);
            return oldNode;
        }
        /**
     * syncs the oldNode to the newNode, copying over all attributes and
     * inner element state from the newNode to the oldNode
     *
     * @param {Node} oldNode the node to copy attributes & state to
     * @param {Node} newNode the node to copy attributes & state from
     * @param {MorphContext} ctx the merge context
     */ function morphAttributes(oldNode, newNode, ctx) {
            let type = newNode.nodeType;
            // if is an element type, sync the attributes from the
            // new node into the new node
            if (type === 1 /* element type */ ) {
                const oldElt = /** @type {Element} */ oldNode;
                const newElt = /** @type {Element} */ newNode;
                const oldAttributes = oldElt.attributes;
                const newAttributes = newElt.attributes;
                for (const newAttribute of newAttributes){
                    if (ignoreAttribute(newAttribute.name, oldElt, "update", ctx)) continue;
                    if (oldElt.getAttribute(newAttribute.name) !== newAttribute.value) oldElt.setAttribute(newAttribute.name, newAttribute.value);
                }
                // iterate backwards to avoid skipping over items when a delete occurs
                for(let i = oldAttributes.length - 1; 0 <= i; i--){
                    const oldAttribute = oldAttributes[i];
                    // toAttributes is a live NamedNodeMap, so iteration+mutation is unsafe
                    // e.g. custom element attribute callbacks can remove other attributes
                    if (!oldAttribute) continue;
                    if (!newElt.hasAttribute(oldAttribute.name)) {
                        if (ignoreAttribute(oldAttribute.name, oldElt, "remove", ctx)) continue;
                        oldElt.removeAttribute(oldAttribute.name);
                    }
                }
                if (!ignoreValueOfActiveElement(oldElt, ctx)) syncInputValue(oldElt, newElt, ctx);
            }
            // sync text nodes
            if (type === 8 /* comment */  || type === 3 /* text */ ) {
                if (oldNode.nodeValue !== newNode.nodeValue) oldNode.nodeValue = newNode.nodeValue;
            }
        }
        /**
     * NB: many bothans died to bring us information:
     *
     *  https://github.com/patrick-steele-idem/morphdom/blob/master/src/specialElHandlers.js
     *  https://github.com/choojs/nanomorph/blob/master/lib/morph.jsL113
     *
     * @param {Element} oldElement the element to sync the input value to
     * @param {Element} newElement the element to sync the input value from
     * @param {MorphContext} ctx the merge context
     */ function syncInputValue(oldElement, newElement, ctx) {
            if (oldElement instanceof HTMLInputElement && newElement instanceof HTMLInputElement && newElement.type !== "file") {
                let newValue = newElement.value;
                let oldValue = oldElement.value;
                // sync boolean attributes
                syncBooleanAttribute(oldElement, newElement, "checked", ctx);
                syncBooleanAttribute(oldElement, newElement, "disabled", ctx);
                if (!newElement.hasAttribute("value")) {
                    if (!ignoreAttribute("value", oldElement, "remove", ctx)) {
                        oldElement.value = "";
                        oldElement.removeAttribute("value");
                    }
                } else if (oldValue !== newValue) {
                    if (!ignoreAttribute("value", oldElement, "update", ctx)) {
                        oldElement.setAttribute("value", newValue);
                        oldElement.value = newValue;
                    }
                }
            // TODO: QUESTION(1cg): this used to only check `newElement` unlike the other branches -- why?
            // did I break something?
            } else if (oldElement instanceof HTMLOptionElement && newElement instanceof HTMLOptionElement) syncBooleanAttribute(oldElement, newElement, "selected", ctx);
            else if (oldElement instanceof HTMLTextAreaElement && newElement instanceof HTMLTextAreaElement) {
                let newValue = newElement.value;
                let oldValue = oldElement.value;
                if (ignoreAttribute("value", oldElement, "update", ctx)) return;
                if (newValue !== oldValue) oldElement.value = newValue;
                if (oldElement.firstChild && oldElement.firstChild.nodeValue !== newValue) oldElement.firstChild.nodeValue = newValue;
            }
        }
        /**
     * @param {Element} oldElement element to write the value to
     * @param {Element} newElement element to read the value from
     * @param {string} attributeName the attribute name
     * @param {MorphContext} ctx the merge context
     */ function syncBooleanAttribute(oldElement, newElement, attributeName, ctx) {
            // @ts-ignore this function is only used on boolean attrs that are reflected as dom properties
            const newLiveValue = newElement[attributeName], // @ts-ignore ditto
            oldLiveValue = oldElement[attributeName];
            if (newLiveValue !== oldLiveValue) {
                const ignoreUpdate = ignoreAttribute(attributeName, oldElement, "update", ctx);
                if (!ignoreUpdate) // update attribute's associated DOM property
                // @ts-ignore this function is only used on boolean attrs that are reflected as dom properties
                oldElement[attributeName] = newElement[attributeName];
                if (newLiveValue) {
                    if (!ignoreUpdate) // https://developer.mozilla.org/en-US/docs/Glossary/Boolean/HTML
                    // this is the correct way to set a boolean attribute to "true"
                    oldElement.setAttribute(attributeName, "");
                } else if (!ignoreAttribute(attributeName, oldElement, "remove", ctx)) oldElement.removeAttribute(attributeName);
            }
        }
        /**
     * @param {string} attr the attribute to be mutated
     * @param {Element} element the element that is going to be updated
     * @param {"update" | "remove"} updateType
     * @param {MorphContext} ctx the merge context
     * @returns {boolean} true if the attribute should be ignored, false otherwise
     */ function ignoreAttribute(attr, element, updateType, ctx) {
            if (attr === "value" && ctx.ignoreActiveValue && element === document.activeElement) return true;
            return ctx.callbacks.beforeAttributeUpdated(attr, element, updateType) === false;
        }
        /**
     * @param {Node} possibleActiveElement
     * @param {MorphContext} ctx
     * @returns {boolean}
     */ function ignoreValueOfActiveElement(possibleActiveElement, ctx) {
            return !!ctx.ignoreActiveValue && possibleActiveElement === document.activeElement && possibleActiveElement !== document.body;
        }
        return morphNode;
    }();
    //=============================================================================
    // Head Management Functions
    //=============================================================================
    /**
   * @param {MorphContext} ctx
   * @param {Element} oldNode
   * @param {Element} newNode
   * @param {function} callback
   * @returns {Node[] | Promise<Node[]>}
   */ function withHeadBlocking(ctx, oldNode, newNode, callback) {
        if (ctx.head.block) {
            const oldHead = oldNode.querySelector("head");
            const newHead = newNode.querySelector("head");
            if (oldHead && newHead) {
                const promises = handleHeadElement(oldHead, newHead, ctx);
                // when head promises resolve, proceed ignoring the head tag
                return Promise.all(promises).then(()=>{
                    const newCtx = Object.assign(ctx, {
                        head: {
                            block: false,
                            ignore: true
                        }
                    });
                    return callback(newCtx);
                });
            }
        }
        // just proceed if we not head blocking
        return callback(ctx);
    }
    /**
   *  The HEAD tag can be handled specially, either w/ a 'merge' or 'append' style
   *
   * @param {Element} oldHead
   * @param {Element} newHead
   * @param {MorphContext} ctx
   * @returns {Promise<void>[]}
   */ function handleHeadElement(oldHead, newHead, ctx) {
        let added = [];
        let removed = [];
        let preserved = [];
        let nodesToAppend = [];
        // put all new head elements into a Map, by their outerHTML
        let srcToNewHeadNodes = new Map();
        for (const newHeadChild of newHead.children)srcToNewHeadNodes.set(newHeadChild.outerHTML, newHeadChild);
        // for each elt in the current head
        for (const currentHeadElt of oldHead.children){
            // If the current head element is in the map
            let inNewContent = srcToNewHeadNodes.has(currentHeadElt.outerHTML);
            let isReAppended = ctx.head.shouldReAppend(currentHeadElt);
            let isPreserved = ctx.head.shouldPreserve(currentHeadElt);
            if (inNewContent || isPreserved) {
                if (isReAppended) // remove the current version and let the new version replace it and re-execute
                removed.push(currentHeadElt);
                else {
                    // this element already exists and should not be re-appended, so remove it from
                    // the new content map, preserving it in the DOM
                    srcToNewHeadNodes.delete(currentHeadElt.outerHTML);
                    preserved.push(currentHeadElt);
                }
            } else {
                if (ctx.head.style === "append") // we are appending and this existing element is not new content
                // so if and only if it is marked for re-append do we do anything
                {
                    if (isReAppended) {
                        removed.push(currentHeadElt);
                        nodesToAppend.push(currentHeadElt);
                    }
                } else // if this is a merge, we remove this content since it is not in the new head
                if (ctx.head.shouldRemove(currentHeadElt) !== false) removed.push(currentHeadElt);
            }
        }
        // Push the remaining new head elements in the Map into the
        // nodes to append to the head tag
        nodesToAppend.push(...srcToNewHeadNodes.values());
        let promises = [];
        for (const newNode of nodesToAppend){
            // TODO: This could theoretically be null, based on type
            let newElt = /** @type {ChildNode} */ document.createRange().createContextualFragment(newNode.outerHTML).firstChild;
            if (ctx.callbacks.beforeNodeAdded(newElt) !== false) {
                if ("href" in newElt && newElt.href || "src" in newElt && newElt.src) {
                    /** @type {(result?: any) => void} */ let resolve;
                    let promise = new Promise(function(_resolve) {
                        resolve = _resolve;
                    });
                    newElt.addEventListener("load", function() {
                        resolve();
                    });
                    promises.push(promise);
                }
                oldHead.appendChild(newElt);
                ctx.callbacks.afterNodeAdded(newElt);
                added.push(newElt);
            }
        }
        // remove all removed elements, after we have appended the new elements to avoid
        // additional network requests for things like style sheets
        for (const removedElement of removed)if (ctx.callbacks.beforeNodeRemoved(removedElement) !== false) {
            oldHead.removeChild(removedElement);
            ctx.callbacks.afterNodeRemoved(removedElement);
        }
        ctx.head.afterHeadMorphed(oldHead, {
            added: added,
            kept: preserved,
            removed: removed
        });
        return promises;
    }
    //=============================================================================
    // Create Morph Context Functions
    //=============================================================================
    const createMorphContext = function() {
        /**
     *
     * @param {Element} oldNode
     * @param {Element} newContent
     * @param {Config} config
     * @returns {MorphContext}
     */ function createMorphContext(oldNode, newContent, config) {
            const { persistentIds: persistentIds, idMap: idMap } = createIdMaps(oldNode, newContent);
            const mergedConfig = mergeDefaults(config);
            const morphStyle = mergedConfig.morphStyle || "outerHTML";
            if (![
                "innerHTML",
                "outerHTML"
            ].includes(morphStyle)) throw `Do not understand how to morph style ${morphStyle}`;
            return {
                target: oldNode,
                newContent: newContent,
                config: mergedConfig,
                morphStyle: morphStyle,
                ignoreActive: mergedConfig.ignoreActive,
                ignoreActiveValue: mergedConfig.ignoreActiveValue,
                restoreFocus: mergedConfig.restoreFocus,
                idMap: idMap,
                persistentIds: persistentIds,
                pantry: createPantry(),
                activeElementAndParents: createActiveElementAndParents(oldNode),
                callbacks: mergedConfig.callbacks,
                head: mergedConfig.head
            };
        }
        /**
     * Deep merges the config object and the Idiomorph.defaults object to
     * produce a final configuration object
     * @param {Config} config
     * @returns {ConfigInternal}
     */ function mergeDefaults(config) {
            let finalConfig = Object.assign({}, defaults);
            // copy top level stuff into final config
            Object.assign(finalConfig, config);
            // copy callbacks into final config (do this to deep merge the callbacks)
            finalConfig.callbacks = Object.assign({}, defaults.callbacks, config.callbacks);
            // copy head config into final config  (do this to deep merge the head)
            finalConfig.head = Object.assign({}, defaults.head, config.head);
            return finalConfig;
        }
        /**
     * @returns {HTMLDivElement}
     */ function createPantry() {
            const pantry = document.createElement("div");
            pantry.hidden = true;
            document.body.insertAdjacentElement("afterend", pantry);
            return pantry;
        }
        /**
     * @param {Element} oldNode
     * @returns {Element[]}
     */ function createActiveElementAndParents(oldNode) {
            /** @type {Element[]} */ let activeElementAndParents = [];
            let elt = document.activeElement;
            if (elt?.tagName !== "BODY" && oldNode.contains(elt)) while(elt){
                activeElementAndParents.push(elt);
                if (elt === oldNode) break;
                elt = elt.parentElement;
            }
            return activeElementAndParents;
        }
        /**
     * Returns all elements with an ID contained within the root element and its descendants
     *
     * @param {Element} root
     * @returns {Element[]}
     */ function findIdElements(root) {
            let elements = Array.from(root.querySelectorAll("[id]"));
            // root could be a document fragment which doesn't have `getAttribute`
            if (root.getAttribute?.("id")) elements.push(root);
            return elements;
        }
        /**
     * A bottom-up algorithm that populates a map of Element -> IdSet.
     * The idSet for a given element is the set of all IDs contained within its subtree.
     * As an optimzation, we filter these IDs through the given list of persistent IDs,
     * because we don't need to bother considering IDed elements that won't be in the new content.
     *
     * @param {Map<Node, Set<string>>} idMap
     * @param {Set<string>} persistentIds
     * @param {Element} root
     * @param {Element[]} elements
     */ function populateIdMapWithTree(idMap, persistentIds, root, elements) {
            for (const elt of elements){
                // we can pretend id is non-null String, because the .has line will reject it immediately if not
                const id = /** @type {String} */ elt.getAttribute("id");
                if (persistentIds.has(id)) {
                    /** @type {Element|null} */ let current = elt;
                    // walk up the parent hierarchy of that element, adding the id
                    // of element to the parent's id set
                    while(current){
                        let idSet = idMap.get(current);
                        // if the id set doesn't exist, create it and insert it in the map
                        if (idSet == null) {
                            idSet = new Set();
                            idMap.set(current, idSet);
                        }
                        idSet.add(id);
                        if (current === root) break;
                        current = current.parentElement;
                    }
                }
            }
        }
        /**
     * This function computes a map of nodes to all ids contained within that node (inclusive of the
     * node).  This map can be used to ask if two nodes have intersecting sets of ids, which allows
     * for a looser definition of "matching" than tradition id matching, and allows child nodes
     * to contribute to a parent nodes matching.
     *
     * @param {Element} oldContent  the old content that will be morphed
     * @param {Element} newContent  the new content to morph to
     * @returns {IdSets}
     */ function createIdMaps(oldContent, newContent) {
            const oldIdElements = findIdElements(oldContent);
            const newIdElements = findIdElements(newContent);
            const persistentIds = createPersistentIds(oldIdElements, newIdElements);
            /** @type {Map<Node, Set<string>>} */ let idMap = new Map();
            populateIdMapWithTree(idMap, persistentIds, oldContent, oldIdElements);
            /** @ts-ignore - if newContent is a duck-typed parent, pass its single child node as the root to halt upwards iteration */ const newRoot = newContent.__idiomorphRoot || newContent;
            populateIdMapWithTree(idMap, persistentIds, newRoot, newIdElements);
            return {
                persistentIds: persistentIds,
                idMap: idMap
            };
        }
        /**
     * This function computes the set of ids that persist between the two contents excluding duplicates
     *
     * @param {Element[]} oldIdElements
     * @param {Element[]} newIdElements
     * @returns {Set<string>}
     */ function createPersistentIds(oldIdElements, newIdElements) {
            let duplicateIds = new Set();
            /** @type {Map<string, string>} */ let oldIdTagNameMap = new Map();
            for (const { id: id, tagName: tagName } of oldIdElements)if (oldIdTagNameMap.has(id)) duplicateIds.add(id);
            else oldIdTagNameMap.set(id, tagName);
            let persistentIds = new Set();
            for (const { id: id, tagName: tagName } of newIdElements){
                if (persistentIds.has(id)) duplicateIds.add(id);
                else if (oldIdTagNameMap.get(id) === tagName) persistentIds.add(id);
            // skip if tag types mismatch because its not possible to morph one tag into another
            }
            for (const id of duplicateIds)persistentIds.delete(id);
            return persistentIds;
        }
        return createMorphContext;
    }();
    //=============================================================================
    // HTML Normalization Functions
    //=============================================================================
    const { normalizeElement: normalizeElement, normalizeParent: normalizeParent } = function() {
        /** @type {WeakSet<Node>} */ const generatedByIdiomorph = new WeakSet();
        /**
     *
     * @param {Element | Document} content
     * @returns {Element}
     */ function normalizeElement(content) {
            if (content instanceof Document) return content.documentElement;
            else return content;
        }
        /**
     *
     * @param {null | string | Node | HTMLCollection | Node[] | Document & {generatedByIdiomorph:boolean}} newContent
     * @returns {Element}
     */ function normalizeParent(newContent) {
            if (newContent == null) return document.createElement("div"); // dummy parent element
            else if (typeof newContent === "string") return normalizeParent(parseContent(newContent));
            else if (generatedByIdiomorph.has(/** @type {Element} */ newContent)) // the template tag created by idiomorph parsing can serve as a dummy parent
            return /** @type {Element} */ newContent;
            else if (newContent instanceof Node) {
                if (newContent.parentNode) // we can't use the parent directly because newContent may have siblings
                // that we don't want in the morph, and reparenting might be expensive (TODO is it?),
                // so instead we create a fake parent node that only sees a slice of its children.
                /** @type {Element} */ return /** @type {any} */ new SlicedParentNode(newContent);
                else {
                    // a single node is added as a child to a dummy parent
                    const dummyParent = document.createElement("div");
                    dummyParent.append(newContent);
                    return dummyParent;
                }
            } else {
                // all nodes in the array or HTMLElement collection are consolidated under
                // a single dummy parent element
                const dummyParent = document.createElement("div");
                for (const elt of [
                    ...newContent
                ])dummyParent.append(elt);
                return dummyParent;
            }
        }
        /**
     * A fake duck-typed parent element to wrap a single node, without actually reparenting it.
     * This is useful because the node may have siblings that we don't want in the morph, and it may also be moved
     * or replaced with one or more elements during the morph. This class effectively allows us a window into
     * a slice of a node's children.
     * "If it walks like a duck, and quacks like a duck, then it must be a duck!" -- James Whitcomb Riley (1849–1916)
     */ class SlicedParentNode {
            /** @param {Node} node */ constructor(node){
                this.originalNode = node;
                this.realParentNode = /** @type {Element} */ node.parentNode;
                this.previousSibling = node.previousSibling;
                this.nextSibling = node.nextSibling;
            }
            /** @returns {Node[]} */ get childNodes() {
                // return slice of realParent's current childNodes, based on previousSibling and nextSibling
                const nodes = [];
                let cursor = this.previousSibling ? this.previousSibling.nextSibling : this.realParentNode.firstChild;
                while(cursor && cursor != this.nextSibling){
                    nodes.push(cursor);
                    cursor = cursor.nextSibling;
                }
                return nodes;
            }
            /**
       * @param {string} selector
       * @returns {Element[]}
       */ querySelectorAll(selector) {
                return this.childNodes.reduce((results, node)=>{
                    if (node instanceof Element) {
                        if (node.matches(selector)) results.push(node);
                        const nodeList = node.querySelectorAll(selector);
                        for(let i = 0; i < nodeList.length; i++)results.push(nodeList[i]);
                    }
                    return results;
                }, /** @type {Element[]} */ []);
            }
            /**
       * @param {Node} node
       * @param {Node} referenceNode
       * @returns {Node}
       */ insertBefore(node, referenceNode) {
                return this.realParentNode.insertBefore(node, referenceNode);
            }
            /**
       * @param {Node} node
       * @param {Node} referenceNode
       * @returns {Node}
       */ moveBefore(node, referenceNode) {
                // @ts-ignore - use new moveBefore feature
                return this.realParentNode.moveBefore(node, referenceNode);
            }
            /**
       * for later use with populateIdMapWithTree to halt upwards iteration
       * @returns {Node}
       */ get __idiomorphRoot() {
                return this.originalNode;
            }
        }
        /**
     *
     * @param {string} newContent
     * @returns {Node | null | DocumentFragment}
     */ function parseContent(newContent) {
            let parser = new DOMParser();
            // remove svgs to avoid false-positive matches on head, etc.
            let contentWithSvgsRemoved = newContent.replace(/<svg(\s[^>]*>|>)([\s\S]*?)<\/svg>/gim, "");
            // if the newContent contains a html, head or body tag, we can simply parse it w/o wrapping
            if (contentWithSvgsRemoved.match(/<\/html>/) || contentWithSvgsRemoved.match(/<\/head>/) || contentWithSvgsRemoved.match(/<\/body>/)) {
                let content = parser.parseFromString(newContent, "text/html");
                // if it is a full HTML document, return the document itself as the parent container
                if (contentWithSvgsRemoved.match(/<\/html>/)) {
                    generatedByIdiomorph.add(content);
                    return content;
                } else {
                    // otherwise return the html element as the parent container
                    let htmlElement = content.firstChild;
                    if (htmlElement) generatedByIdiomorph.add(htmlElement);
                    return htmlElement;
                }
            } else {
                // if it is partial HTML, wrap it in a template tag to provide a parent element and also to help
                // deal with touchy tags like tr, tbody, etc.
                let responseDoc = parser.parseFromString("<body><template>" + newContent + "</template></body>", "text/html");
                let content = /** @type {HTMLTemplateElement} */ responseDoc.body.querySelector("template").content;
                generatedByIdiomorph.add(content);
                return content;
            }
        }
        return {
            normalizeElement: normalizeElement,
            normalizeParent: normalizeParent
        };
    }();
    //=============================================================================
    // This is what ends up becoming the Idiomorph global object
    //=============================================================================
    return {
        morph: morph,
        defaults: defaults
    };
}();
/**
 * Morph the state of the currentElement based on the attributes and contents of
 * the newElement. Morphing may dispatch turbo:before-morph-element,
 * turbo:before-morph-attribute, and turbo:morph-element events.
 *
 * @param currentElement Element destination of morphing changes
 * @param newElement Element source of morphing changes
 */ function $ee40788d37d3b5ae$export$dc74801294c91b10(currentElement, newElement, { callbacks: callbacks, ...options } = {}) {
    $ee40788d37d3b5ae$var$Idiomorph.morph(currentElement, newElement, {
        ...options,
        callbacks: new $ee40788d37d3b5ae$var$DefaultIdiomorphCallbacks(callbacks)
    });
}
/**
 * Morph the child elements of the currentElement based on the child elements of
 * the newElement. Morphing children may dispatch turbo:before-morph-element,
 * turbo:before-morph-attribute, and turbo:morph-element events.
 *
 * @param currentElement Element destination of morphing children changes
 * @param newElement Element source of morphing children changes
 */ function $ee40788d37d3b5ae$export$e0eeaf5bc84bd47b(currentElement, newElement, options = {}) {
    $ee40788d37d3b5ae$export$dc74801294c91b10(currentElement, newElement.childNodes, {
        ...options,
        morphStyle: "innerHTML"
    });
}
function $ee40788d37d3b5ae$var$shouldRefreshFrameWithMorphing(currentFrame, newFrame) {
    return currentFrame instanceof $ee40788d37d3b5ae$export$f464a8f0ffa32c44 && currentFrame.shouldReloadWithMorph && (!newFrame || $ee40788d37d3b5ae$var$areFramesCompatibleForRefreshing(currentFrame, newFrame)) && !currentFrame.closest("[data-turbo-permanent]");
}
function $ee40788d37d3b5ae$var$areFramesCompatibleForRefreshing(currentFrame, newFrame) {
    // newFrame cannot yet be an instance of FrameElement because custom
    // elements don't get initialized until they're attached to the DOM, so
    // test its Element#nodeName instead
    return newFrame instanceof Element && newFrame.nodeName === "TURBO-FRAME" && currentFrame.id === newFrame.id && (!newFrame.getAttribute("src") || $ee40788d37d3b5ae$var$urlsAreEqual(currentFrame.src, newFrame.getAttribute("src")));
}
function $ee40788d37d3b5ae$var$closestFrameReloadableWithMorphing(node) {
    return node.parentElement.closest("turbo-frame[src][refresh=morph]");
}
class $ee40788d37d3b5ae$var$DefaultIdiomorphCallbacks {
    #beforeNodeMorphed;
    constructor({ beforeNodeMorphed: beforeNodeMorphed } = {}){
        this.#beforeNodeMorphed = beforeNodeMorphed || (()=>true);
    }
    beforeNodeAdded = (node)=>{
        return !(node.id && node.hasAttribute("data-turbo-permanent") && document.getElementById(node.id));
    };
    beforeNodeMorphed = (currentElement, newElement)=>{
        if (currentElement instanceof Element) {
            if (!currentElement.hasAttribute("data-turbo-permanent") && this.#beforeNodeMorphed(currentElement, newElement)) {
                const event = $ee40788d37d3b5ae$var$dispatch("turbo:before-morph-element", {
                    cancelable: true,
                    target: currentElement,
                    detail: {
                        currentElement: currentElement,
                        newElement: newElement
                    }
                });
                return !event.defaultPrevented;
            } else return false;
        }
    };
    beforeAttributeUpdated = (attributeName, target, mutationType)=>{
        const event = $ee40788d37d3b5ae$var$dispatch("turbo:before-morph-attribute", {
            cancelable: true,
            target: target,
            detail: {
                attributeName: attributeName,
                mutationType: mutationType
            }
        });
        return !event.defaultPrevented;
    };
    beforeNodeRemoved = (node)=>{
        return this.beforeNodeMorphed(node);
    };
    afterNodeMorphed = (currentElement, newElement)=>{
        if (currentElement instanceof Element) $ee40788d37d3b5ae$var$dispatch("turbo:morph-element", {
            target: currentElement,
            detail: {
                currentElement: currentElement,
                newElement: newElement
            }
        });
    };
}
class $ee40788d37d3b5ae$var$MorphingFrameRenderer extends $ee40788d37d3b5ae$export$f09c4165d16bb2b7 {
    static renderElement(currentElement, newElement) {
        $ee40788d37d3b5ae$var$dispatch("turbo:before-frame-morph", {
            target: currentElement,
            detail: {
                currentElement: currentElement,
                newElement: newElement
            }
        });
        $ee40788d37d3b5ae$export$e0eeaf5bc84bd47b(currentElement, newElement, {
            callbacks: {
                beforeNodeMorphed: (node, newNode)=>{
                    if ($ee40788d37d3b5ae$var$shouldRefreshFrameWithMorphing(node, newNode) && $ee40788d37d3b5ae$var$closestFrameReloadableWithMorphing(node) === currentElement) {
                        node.reload();
                        return false;
                    }
                    return true;
                }
            }
        });
    }
    async preservingPermanentElements(callback) {
        return await callback();
    }
}
class $ee40788d37d3b5ae$var$ProgressBar {
    static animationDuration = 300 /*ms*/ ;
    static get defaultCSS() {
        return $ee40788d37d3b5ae$var$unindent`
      .turbo-progress-bar {
        position: fixed;
        display: block;
        top: 0;
        left: 0;
        height: 3px;
        background: #0076ff;
        z-index: 2147483647;
        transition:
          width ${$ee40788d37d3b5ae$var$ProgressBar.animationDuration}ms ease-out,
          opacity ${$ee40788d37d3b5ae$var$ProgressBar.animationDuration / 2}ms ${$ee40788d37d3b5ae$var$ProgressBar.animationDuration / 2}ms ease-in;
        transform: translate3d(0, 0, 0);
      }
    `;
    }
    hiding = false;
    value = 0;
    visible = false;
    constructor(){
        this.stylesheetElement = this.createStylesheetElement();
        this.progressElement = this.createProgressElement();
        this.installStylesheetElement();
        this.setValue(0);
    }
    show() {
        if (!this.visible) {
            this.visible = true;
            this.installProgressElement();
            this.startTrickling();
        }
    }
    hide() {
        if (this.visible && !this.hiding) {
            this.hiding = true;
            this.fadeProgressElement(()=>{
                this.uninstallProgressElement();
                this.stopTrickling();
                this.visible = false;
                this.hiding = false;
            });
        }
    }
    setValue(value) {
        this.value = value;
        this.refresh();
    }
    // Private
    installStylesheetElement() {
        document.head.insertBefore(this.stylesheetElement, document.head.firstChild);
    }
    installProgressElement() {
        this.progressElement.style.width = "0";
        this.progressElement.style.opacity = "1";
        document.documentElement.insertBefore(this.progressElement, document.body);
        this.refresh();
    }
    fadeProgressElement(callback) {
        this.progressElement.style.opacity = "0";
        setTimeout(callback, $ee40788d37d3b5ae$var$ProgressBar.animationDuration * 1.5);
    }
    uninstallProgressElement() {
        if (this.progressElement.parentNode) document.documentElement.removeChild(this.progressElement);
    }
    startTrickling() {
        if (!this.trickleInterval) this.trickleInterval = window.setInterval(this.trickle, $ee40788d37d3b5ae$var$ProgressBar.animationDuration);
    }
    stopTrickling() {
        window.clearInterval(this.trickleInterval);
        delete this.trickleInterval;
    }
    trickle = ()=>{
        this.setValue(this.value + Math.random() / 100);
    };
    refresh() {
        requestAnimationFrame(()=>{
            this.progressElement.style.width = `${10 + this.value * 90}%`;
        });
    }
    createStylesheetElement() {
        const element = document.createElement("style");
        element.type = "text/css";
        element.textContent = $ee40788d37d3b5ae$var$ProgressBar.defaultCSS;
        const cspNonce = $ee40788d37d3b5ae$var$getCspNonce();
        if (cspNonce) element.nonce = cspNonce;
        return element;
    }
    createProgressElement() {
        const element = document.createElement("div");
        element.className = "turbo-progress-bar";
        return element;
    }
}
class $ee40788d37d3b5ae$var$HeadSnapshot extends $ee40788d37d3b5ae$var$Snapshot {
    detailsByOuterHTML = this.children.filter((element)=>!$ee40788d37d3b5ae$var$elementIsNoscript(element)).map((element)=>$ee40788d37d3b5ae$var$elementWithoutNonce(element)).reduce((result, element)=>{
        const { outerHTML: outerHTML } = element;
        const details = outerHTML in result ? result[outerHTML] : {
            type: $ee40788d37d3b5ae$var$elementType(element),
            tracked: $ee40788d37d3b5ae$var$elementIsTracked(element),
            elements: []
        };
        return {
            ...result,
            [outerHTML]: {
                ...details,
                elements: [
                    ...details.elements,
                    element
                ]
            }
        };
    }, {});
    get trackedElementSignature() {
        return Object.keys(this.detailsByOuterHTML).filter((outerHTML)=>this.detailsByOuterHTML[outerHTML].tracked).join("");
    }
    getScriptElementsNotInSnapshot(snapshot) {
        return this.getElementsMatchingTypeNotInSnapshot("script", snapshot);
    }
    getStylesheetElementsNotInSnapshot(snapshot) {
        return this.getElementsMatchingTypeNotInSnapshot("stylesheet", snapshot);
    }
    getElementsMatchingTypeNotInSnapshot(matchedType, snapshot) {
        return Object.keys(this.detailsByOuterHTML).filter((outerHTML)=>!(outerHTML in snapshot.detailsByOuterHTML)).map((outerHTML)=>this.detailsByOuterHTML[outerHTML]).filter(({ type: type })=>type == matchedType).map(({ elements: [element] })=>element);
    }
    get provisionalElements() {
        return Object.keys(this.detailsByOuterHTML).reduce((result, outerHTML)=>{
            const { type: type, tracked: tracked, elements: elements } = this.detailsByOuterHTML[outerHTML];
            if (type == null && !tracked) return [
                ...result,
                ...elements
            ];
            else if (elements.length > 1) return [
                ...result,
                ...elements.slice(1)
            ];
            else return result;
        }, []);
    }
    getMetaValue(name) {
        const element = this.findMetaElementByName(name);
        return element ? element.getAttribute("content") : null;
    }
    findMetaElementByName(name) {
        return Object.keys(this.detailsByOuterHTML).reduce((result, outerHTML)=>{
            const { elements: [element] } = this.detailsByOuterHTML[outerHTML];
            return $ee40788d37d3b5ae$var$elementIsMetaElementWithName(element, name) ? element : result;
        }, 0);
    }
}
function $ee40788d37d3b5ae$var$elementType(element) {
    if ($ee40788d37d3b5ae$var$elementIsScript(element)) return "script";
    else if ($ee40788d37d3b5ae$var$elementIsStylesheet(element)) return "stylesheet";
}
function $ee40788d37d3b5ae$var$elementIsTracked(element) {
    return element.getAttribute("data-turbo-track") == "reload";
}
function $ee40788d37d3b5ae$var$elementIsScript(element) {
    const tagName = element.localName;
    return tagName == "script";
}
function $ee40788d37d3b5ae$var$elementIsNoscript(element) {
    const tagName = element.localName;
    return tagName == "noscript";
}
function $ee40788d37d3b5ae$var$elementIsStylesheet(element) {
    const tagName = element.localName;
    return tagName == "style" || tagName == "link" && element.getAttribute("rel") == "stylesheet";
}
function $ee40788d37d3b5ae$var$elementIsMetaElementWithName(element, name) {
    const tagName = element.localName;
    return tagName == "meta" && element.getAttribute("name") == name;
}
function $ee40788d37d3b5ae$var$elementWithoutNonce(element) {
    if (element.hasAttribute("nonce")) element.setAttribute("nonce", "");
    return element;
}
class $ee40788d37d3b5ae$export$4f11b95e473fd113 extends $ee40788d37d3b5ae$var$Snapshot {
    static fromHTMLString(html = "") {
        return this.fromDocument($ee40788d37d3b5ae$var$parseHTMLDocument(html));
    }
    static fromElement(element) {
        return this.fromDocument(element.ownerDocument);
    }
    static fromDocument({ documentElement: documentElement, body: body, head: head }) {
        return new this(documentElement, body, new $ee40788d37d3b5ae$var$HeadSnapshot(head));
    }
    constructor(documentElement, body, headSnapshot){
        super(body);
        this.documentElement = documentElement;
        this.headSnapshot = headSnapshot;
    }
    clone() {
        const clonedElement = this.element.cloneNode(true);
        const selectElements = this.element.querySelectorAll("select");
        const clonedSelectElements = clonedElement.querySelectorAll("select");
        for (const [index, source] of selectElements.entries()){
            const clone = clonedSelectElements[index];
            for (const option of clone.selectedOptions)option.selected = false;
            for (const option of source.selectedOptions)clone.options[option.index].selected = true;
        }
        for (const clonedPasswordInput of clonedElement.querySelectorAll('input[type="password"]'))clonedPasswordInput.value = "";
        return new $ee40788d37d3b5ae$export$4f11b95e473fd113(this.documentElement, clonedElement, this.headSnapshot);
    }
    get lang() {
        return this.documentElement.getAttribute("lang");
    }
    get headElement() {
        return this.headSnapshot.element;
    }
    get rootLocation() {
        const root = this.getSetting("root") ?? "/";
        return $ee40788d37d3b5ae$var$expandURL(root);
    }
    get cacheControlValue() {
        return this.getSetting("cache-control");
    }
    get isPreviewable() {
        return this.cacheControlValue != "no-preview";
    }
    get isCacheable() {
        return this.cacheControlValue != "no-cache";
    }
    get isVisitable() {
        return this.getSetting("visit-control") != "reload";
    }
    get prefersViewTransitions() {
        const viewTransitionEnabled = this.getSetting("view-transition") === "true" || this.headSnapshot.getMetaValue("view-transition") === "same-origin";
        return viewTransitionEnabled && !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }
    get shouldMorphPage() {
        return this.getSetting("refresh-method") === "morph";
    }
    get shouldPreserveScrollPosition() {
        return this.getSetting("refresh-scroll") === "preserve";
    }
    // Private
    getSetting(name) {
        return this.headSnapshot.getMetaValue(`turbo-${name}`);
    }
}
class $ee40788d37d3b5ae$var$ViewTransitioner {
    #viewTransitionStarted = false;
    #lastOperation = Promise.resolve();
    renderChange(useViewTransition, render) {
        if (useViewTransition && this.viewTransitionsAvailable && !this.#viewTransitionStarted) {
            this.#viewTransitionStarted = true;
            this.#lastOperation = this.#lastOperation.then(async ()=>{
                await document.startViewTransition(render).finished;
            });
        } else this.#lastOperation = this.#lastOperation.then(render);
        return this.#lastOperation;
    }
    get viewTransitionsAvailable() {
        return document.startViewTransition;
    }
}
const $ee40788d37d3b5ae$var$defaultOptions = {
    action: "advance",
    historyChanged: false,
    visitCachedSnapshot: ()=>{},
    willRender: true,
    updateHistory: true,
    shouldCacheSnapshot: true,
    acceptsStreamResponse: false
};
const $ee40788d37d3b5ae$var$TimingMetric = {
    visitStart: "visitStart",
    requestStart: "requestStart",
    requestEnd: "requestEnd",
    visitEnd: "visitEnd"
};
const $ee40788d37d3b5ae$var$VisitState = {
    initialized: "initialized",
    started: "started",
    canceled: "canceled",
    failed: "failed",
    completed: "completed"
};
const $ee40788d37d3b5ae$var$SystemStatusCode = {
    networkFailure: 0,
    timeoutFailure: -1,
    contentTypeMismatch: -2
};
const $ee40788d37d3b5ae$var$Direction = {
    advance: "forward",
    restore: "back",
    replace: "none"
};
class $ee40788d37d3b5ae$var$Visit {
    identifier = $ee40788d37d3b5ae$var$uuid() // Required by turbo-ios
    ;
    timingMetrics = {};
    followedRedirect = false;
    historyChanged = false;
    scrolled = false;
    shouldCacheSnapshot = true;
    acceptsStreamResponse = false;
    snapshotCached = false;
    state = $ee40788d37d3b5ae$var$VisitState.initialized;
    viewTransitioner = new $ee40788d37d3b5ae$var$ViewTransitioner();
    constructor(delegate, location1, restorationIdentifier, options = {}){
        this.delegate = delegate;
        this.location = location1;
        this.restorationIdentifier = restorationIdentifier || $ee40788d37d3b5ae$var$uuid();
        const { action: action, historyChanged: historyChanged, referrer: referrer, snapshot: snapshot, snapshotHTML: snapshotHTML, response: response, visitCachedSnapshot: visitCachedSnapshot, willRender: willRender, updateHistory: updateHistory, shouldCacheSnapshot: shouldCacheSnapshot, acceptsStreamResponse: acceptsStreamResponse, direction: direction } = {
            ...$ee40788d37d3b5ae$var$defaultOptions,
            ...options
        };
        this.action = action;
        this.historyChanged = historyChanged;
        this.referrer = referrer;
        this.snapshot = snapshot;
        this.snapshotHTML = snapshotHTML;
        this.response = response;
        this.isSamePage = this.delegate.locationWithActionIsSamePage(this.location, this.action);
        this.isPageRefresh = this.view.isPageRefresh(this);
        this.visitCachedSnapshot = visitCachedSnapshot;
        this.willRender = willRender;
        this.updateHistory = updateHistory;
        this.scrolled = !willRender;
        this.shouldCacheSnapshot = shouldCacheSnapshot;
        this.acceptsStreamResponse = acceptsStreamResponse;
        this.direction = direction || $ee40788d37d3b5ae$var$Direction[action];
    }
    get adapter() {
        return this.delegate.adapter;
    }
    get view() {
        return this.delegate.view;
    }
    get history() {
        return this.delegate.history;
    }
    get restorationData() {
        return this.history.getRestorationDataForIdentifier(this.restorationIdentifier);
    }
    get silent() {
        return this.isSamePage;
    }
    start() {
        if (this.state == $ee40788d37d3b5ae$var$VisitState.initialized) {
            this.recordTimingMetric($ee40788d37d3b5ae$var$TimingMetric.visitStart);
            this.state = $ee40788d37d3b5ae$var$VisitState.started;
            this.adapter.visitStarted(this);
            this.delegate.visitStarted(this);
        }
    }
    cancel() {
        if (this.state == $ee40788d37d3b5ae$var$VisitState.started) {
            if (this.request) this.request.cancel();
            this.cancelRender();
            this.state = $ee40788d37d3b5ae$var$VisitState.canceled;
        }
    }
    complete() {
        if (this.state == $ee40788d37d3b5ae$var$VisitState.started) {
            this.recordTimingMetric($ee40788d37d3b5ae$var$TimingMetric.visitEnd);
            this.adapter.visitCompleted(this);
            this.state = $ee40788d37d3b5ae$var$VisitState.completed;
            this.followRedirect();
            if (!this.followedRedirect) this.delegate.visitCompleted(this);
        }
    }
    fail() {
        if (this.state == $ee40788d37d3b5ae$var$VisitState.started) {
            this.state = $ee40788d37d3b5ae$var$VisitState.failed;
            this.adapter.visitFailed(this);
            this.delegate.visitCompleted(this);
        }
    }
    changeHistory() {
        if (!this.historyChanged && this.updateHistory) {
            const actionForHistory = this.location.href === this.referrer?.href ? "replace" : this.action;
            const method = $ee40788d37d3b5ae$var$getHistoryMethodForAction(actionForHistory);
            this.history.update(method, this.location, this.restorationIdentifier);
            this.historyChanged = true;
        }
    }
    issueRequest() {
        if (this.hasPreloadedResponse()) this.simulateRequest();
        else if (this.shouldIssueRequest() && !this.request) {
            this.request = new $ee40788d37d3b5ae$export$319b96fe59834522(this, $ee40788d37d3b5ae$export$76f6869e29ff06ee.get, this.location);
            this.request.perform();
        }
    }
    simulateRequest() {
        if (this.response) {
            this.startRequest();
            this.recordResponse();
            this.finishRequest();
        }
    }
    startRequest() {
        this.recordTimingMetric($ee40788d37d3b5ae$var$TimingMetric.requestStart);
        this.adapter.visitRequestStarted(this);
    }
    recordResponse(response = this.response) {
        this.response = response;
        if (response) {
            const { statusCode: statusCode } = response;
            if ($ee40788d37d3b5ae$var$isSuccessful(statusCode)) this.adapter.visitRequestCompleted(this);
            else this.adapter.visitRequestFailedWithStatusCode(this, statusCode);
        }
    }
    finishRequest() {
        this.recordTimingMetric($ee40788d37d3b5ae$var$TimingMetric.requestEnd);
        this.adapter.visitRequestFinished(this);
    }
    loadResponse() {
        if (this.response) {
            const { statusCode: statusCode, responseHTML: responseHTML } = this.response;
            this.render(async ()=>{
                if (this.shouldCacheSnapshot) this.cacheSnapshot();
                if (this.view.renderPromise) await this.view.renderPromise;
                if ($ee40788d37d3b5ae$var$isSuccessful(statusCode) && responseHTML != null) {
                    const snapshot = $ee40788d37d3b5ae$export$4f11b95e473fd113.fromHTMLString(responseHTML);
                    await this.renderPageSnapshot(snapshot, false);
                    this.adapter.visitRendered(this);
                    this.complete();
                } else {
                    await this.view.renderError($ee40788d37d3b5ae$export$4f11b95e473fd113.fromHTMLString(responseHTML), this);
                    this.adapter.visitRendered(this);
                    this.fail();
                }
            });
        }
    }
    getCachedSnapshot() {
        const snapshot = this.view.getCachedSnapshotForLocation(this.location) || this.getPreloadedSnapshot();
        if (snapshot && (!$ee40788d37d3b5ae$var$getAnchor(this.location) || snapshot.hasAnchor($ee40788d37d3b5ae$var$getAnchor(this.location)))) {
            if (this.action == "restore" || snapshot.isPreviewable) return snapshot;
        }
    }
    getPreloadedSnapshot() {
        if (this.snapshotHTML) return $ee40788d37d3b5ae$export$4f11b95e473fd113.fromHTMLString(this.snapshotHTML);
    }
    hasCachedSnapshot() {
        return this.getCachedSnapshot() != null;
    }
    loadCachedSnapshot() {
        const snapshot = this.getCachedSnapshot();
        if (snapshot) {
            const isPreview = this.shouldIssueRequest();
            this.render(async ()=>{
                this.cacheSnapshot();
                if (this.isSamePage || this.isPageRefresh) this.adapter.visitRendered(this);
                else {
                    if (this.view.renderPromise) await this.view.renderPromise;
                    await this.renderPageSnapshot(snapshot, isPreview);
                    this.adapter.visitRendered(this);
                    if (!isPreview) this.complete();
                }
            });
        }
    }
    followRedirect() {
        if (this.redirectedToLocation && !this.followedRedirect && this.response?.redirected) {
            this.adapter.visitProposedToLocation(this.redirectedToLocation, {
                action: "replace",
                response: this.response,
                shouldCacheSnapshot: false,
                willRender: false
            });
            this.followedRedirect = true;
        }
    }
    goToSamePageAnchor() {
        if (this.isSamePage) this.render(async ()=>{
            this.cacheSnapshot();
            this.performScroll();
            this.changeHistory();
            this.adapter.visitRendered(this);
        });
    }
    // Fetch request delegate
    prepareRequest(request) {
        if (this.acceptsStreamResponse) request.acceptResponseType($ee40788d37d3b5ae$var$StreamMessage.contentType);
    }
    requestStarted() {
        this.startRequest();
    }
    requestPreventedHandlingResponse(_request, _response) {}
    async requestSucceededWithResponse(request, response) {
        const responseHTML = await response.responseHTML;
        const { redirected: redirected, statusCode: statusCode } = response;
        if (responseHTML == undefined) this.recordResponse({
            statusCode: $ee40788d37d3b5ae$var$SystemStatusCode.contentTypeMismatch,
            redirected: redirected
        });
        else {
            this.redirectedToLocation = response.redirected ? response.location : undefined;
            this.recordResponse({
                statusCode: statusCode,
                responseHTML: responseHTML,
                redirected: redirected
            });
        }
    }
    async requestFailedWithResponse(request, response) {
        const responseHTML = await response.responseHTML;
        const { redirected: redirected, statusCode: statusCode } = response;
        if (responseHTML == undefined) this.recordResponse({
            statusCode: $ee40788d37d3b5ae$var$SystemStatusCode.contentTypeMismatch,
            redirected: redirected
        });
        else this.recordResponse({
            statusCode: statusCode,
            responseHTML: responseHTML,
            redirected: redirected
        });
    }
    requestErrored(_request, _error) {
        this.recordResponse({
            statusCode: $ee40788d37d3b5ae$var$SystemStatusCode.networkFailure,
            redirected: false
        });
    }
    requestFinished() {
        this.finishRequest();
    }
    // Scrolling
    performScroll() {
        if (!this.scrolled && !this.view.forceReloaded && !this.view.shouldPreserveScrollPosition(this)) {
            if (this.action == "restore") this.scrollToRestoredPosition() || this.scrollToAnchor() || this.view.scrollToTop();
            else this.scrollToAnchor() || this.view.scrollToTop();
            if (this.isSamePage) this.delegate.visitScrolledToSamePageLocation(this.view.lastRenderedLocation, this.location);
            this.scrolled = true;
        }
    }
    scrollToRestoredPosition() {
        const { scrollPosition: scrollPosition } = this.restorationData;
        if (scrollPosition) {
            this.view.scrollToPosition(scrollPosition);
            return true;
        }
    }
    scrollToAnchor() {
        const anchor = $ee40788d37d3b5ae$var$getAnchor(this.location);
        if (anchor != null) {
            this.view.scrollToAnchor(anchor);
            return true;
        }
    }
    // Instrumentation
    recordTimingMetric(metric) {
        this.timingMetrics[metric] = new Date().getTime();
    }
    getTimingMetrics() {
        return {
            ...this.timingMetrics
        };
    }
    // Private
    hasPreloadedResponse() {
        return typeof this.response == "object";
    }
    shouldIssueRequest() {
        if (this.isSamePage) return false;
        else if (this.action == "restore") return !this.hasCachedSnapshot();
        else return this.willRender;
    }
    cacheSnapshot() {
        if (!this.snapshotCached) {
            this.view.cacheSnapshot(this.snapshot).then((snapshot)=>snapshot && this.visitCachedSnapshot(snapshot));
            this.snapshotCached = true;
        }
    }
    async render(callback) {
        this.cancelRender();
        await new Promise((resolve)=>{
            this.frame = document.visibilityState === "hidden" ? setTimeout(()=>resolve(), 0) : requestAnimationFrame(()=>resolve());
        });
        await callback();
        delete this.frame;
    }
    async renderPageSnapshot(snapshot, isPreview) {
        await this.viewTransitioner.renderChange(this.view.shouldTransitionTo(snapshot), async ()=>{
            await this.view.renderPage(snapshot, isPreview, this.willRender, this);
            this.performScroll();
        });
    }
    cancelRender() {
        if (this.frame) {
            cancelAnimationFrame(this.frame);
            delete this.frame;
        }
    }
}
function $ee40788d37d3b5ae$var$isSuccessful(statusCode) {
    return statusCode >= 200 && statusCode < 300;
}
class $ee40788d37d3b5ae$var$BrowserAdapter {
    progressBar = new $ee40788d37d3b5ae$var$ProgressBar();
    constructor(session){
        this.session = session;
    }
    visitProposedToLocation(location1, options) {
        if ($ee40788d37d3b5ae$var$locationIsVisitable(location1, this.navigator.rootLocation)) this.navigator.startVisit(location1, options?.restorationIdentifier || $ee40788d37d3b5ae$var$uuid(), options);
        else window.location.href = location1.toString();
    }
    visitStarted(visit) {
        this.location = visit.location;
        this.redirectedToLocation = null;
        visit.loadCachedSnapshot();
        visit.issueRequest();
        visit.goToSamePageAnchor();
    }
    visitRequestStarted(visit) {
        this.progressBar.setValue(0);
        if (visit.hasCachedSnapshot() || visit.action != "restore") this.showVisitProgressBarAfterDelay();
        else this.showProgressBar();
    }
    visitRequestCompleted(visit) {
        visit.loadResponse();
        if (visit.response.redirected) this.redirectedToLocation = visit.redirectedToLocation;
    }
    visitRequestFailedWithStatusCode(visit, statusCode) {
        switch(statusCode){
            case $ee40788d37d3b5ae$var$SystemStatusCode.networkFailure:
            case $ee40788d37d3b5ae$var$SystemStatusCode.timeoutFailure:
            case $ee40788d37d3b5ae$var$SystemStatusCode.contentTypeMismatch:
                return this.reload({
                    reason: "request_failed",
                    context: {
                        statusCode: statusCode
                    }
                });
            default:
                return visit.loadResponse();
        }
    }
    visitRequestFinished(_visit) {}
    visitCompleted(_visit) {
        this.progressBar.setValue(1);
        this.hideVisitProgressBar();
    }
    pageInvalidated(reason) {
        this.reload(reason);
    }
    visitFailed(_visit) {
        this.progressBar.setValue(1);
        this.hideVisitProgressBar();
    }
    visitRendered(_visit) {}
    // Link prefetching
    linkPrefetchingIsEnabledForLocation(location1) {
        return true;
    }
    // Form Submission Delegate
    formSubmissionStarted(_formSubmission) {
        this.progressBar.setValue(0);
        this.showFormProgressBarAfterDelay();
    }
    formSubmissionFinished(_formSubmission) {
        this.progressBar.setValue(1);
        this.hideFormProgressBar();
    }
    // Private
    showVisitProgressBarAfterDelay() {
        this.visitProgressBarTimeout = window.setTimeout(this.showProgressBar, this.session.progressBarDelay);
    }
    hideVisitProgressBar() {
        this.progressBar.hide();
        if (this.visitProgressBarTimeout != null) {
            window.clearTimeout(this.visitProgressBarTimeout);
            delete this.visitProgressBarTimeout;
        }
    }
    showFormProgressBarAfterDelay() {
        if (this.formProgressBarTimeout == null) this.formProgressBarTimeout = window.setTimeout(this.showProgressBar, this.session.progressBarDelay);
    }
    hideFormProgressBar() {
        this.progressBar.hide();
        if (this.formProgressBarTimeout != null) {
            window.clearTimeout(this.formProgressBarTimeout);
            delete this.formProgressBarTimeout;
        }
    }
    showProgressBar = ()=>{
        this.progressBar.show();
    };
    reload(reason) {
        $ee40788d37d3b5ae$var$dispatch("turbo:reload", {
            detail: reason
        });
        window.location.href = (this.redirectedToLocation || this.location)?.toString() || window.location.href;
    }
    get navigator() {
        return this.session.navigator;
    }
}
class $ee40788d37d3b5ae$var$CacheObserver {
    selector = "[data-turbo-temporary]";
    deprecatedSelector = "[data-turbo-cache=false]";
    started = false;
    start() {
        if (!this.started) {
            this.started = true;
            addEventListener("turbo:before-cache", this.removeTemporaryElements, false);
        }
    }
    stop() {
        if (this.started) {
            this.started = false;
            removeEventListener("turbo:before-cache", this.removeTemporaryElements, false);
        }
    }
    removeTemporaryElements = (_event)=>{
        for (const element of this.temporaryElements)element.remove();
    };
    get temporaryElements() {
        return [
            ...document.querySelectorAll(this.selector),
            ...this.temporaryElementsWithDeprecation
        ];
    }
    get temporaryElementsWithDeprecation() {
        const elements = document.querySelectorAll(this.deprecatedSelector);
        if (elements.length) console.warn(`The ${this.deprecatedSelector} selector is deprecated and will be removed in a future version. Use ${this.selector} instead.`);
        return [
            ...elements
        ];
    }
}
class $ee40788d37d3b5ae$var$FrameRedirector {
    constructor(session, element){
        this.session = session;
        this.element = element;
        this.linkInterceptor = new $ee40788d37d3b5ae$var$LinkInterceptor(this, element);
        this.formSubmitObserver = new $ee40788d37d3b5ae$var$FormSubmitObserver(this, element);
    }
    start() {
        this.linkInterceptor.start();
        this.formSubmitObserver.start();
    }
    stop() {
        this.linkInterceptor.stop();
        this.formSubmitObserver.stop();
    }
    // Link interceptor delegate
    shouldInterceptLinkClick(element, _location, _event) {
        return this.#shouldRedirect(element);
    }
    linkClickIntercepted(element, url, event) {
        const frame = this.#findFrameElement(element);
        if (frame) frame.delegate.linkClickIntercepted(element, url, event);
    }
    // Form submit observer delegate
    willSubmitForm(element, submitter) {
        return element.closest("turbo-frame") == null && this.#shouldSubmit(element, submitter) && this.#shouldRedirect(element, submitter);
    }
    formSubmitted(element, submitter) {
        const frame = this.#findFrameElement(element, submitter);
        if (frame) frame.delegate.formSubmitted(element, submitter);
    }
    #shouldSubmit(form, submitter) {
        const action = $ee40788d37d3b5ae$var$getAction$1(form, submitter);
        const meta = this.element.ownerDocument.querySelector(`meta[name="turbo-root"]`);
        const rootLocation = $ee40788d37d3b5ae$var$expandURL(meta?.content ?? "/");
        return this.#shouldRedirect(form, submitter) && $ee40788d37d3b5ae$var$locationIsVisitable(action, rootLocation);
    }
    #shouldRedirect(element, submitter) {
        const isNavigatable = element instanceof HTMLFormElement ? this.session.submissionIsNavigatable(element, submitter) : this.session.elementIsNavigatable(element);
        if (isNavigatable) {
            const frame = this.#findFrameElement(element, submitter);
            return frame ? frame != element.closest("turbo-frame") : false;
        } else return false;
    }
    #findFrameElement(element, submitter) {
        const id = submitter?.getAttribute("data-turbo-frame") || element.getAttribute("data-turbo-frame");
        if (id && id != "_top") {
            const frame = this.element.querySelector(`#${id}:not([disabled])`);
            if (frame instanceof $ee40788d37d3b5ae$export$f464a8f0ffa32c44) return frame;
        }
    }
}
class $ee40788d37d3b5ae$var$History {
    location;
    restorationIdentifier = $ee40788d37d3b5ae$var$uuid();
    restorationData = {};
    started = false;
    pageLoaded = false;
    currentIndex = 0;
    constructor(delegate){
        this.delegate = delegate;
    }
    start() {
        if (!this.started) {
            addEventListener("popstate", this.onPopState, false);
            addEventListener("load", this.onPageLoad, false);
            this.currentIndex = history.state?.turbo?.restorationIndex || 0;
            this.started = true;
            this.replace(new URL(window.location.href));
        }
    }
    stop() {
        if (this.started) {
            removeEventListener("popstate", this.onPopState, false);
            removeEventListener("load", this.onPageLoad, false);
            this.started = false;
        }
    }
    push(location1, restorationIdentifier) {
        this.update(history.pushState, location1, restorationIdentifier);
    }
    replace(location1, restorationIdentifier) {
        this.update(history.replaceState, location1, restorationIdentifier);
    }
    update(method, location1, restorationIdentifier = $ee40788d37d3b5ae$var$uuid()) {
        if (method === history.pushState) ++this.currentIndex;
        const state = {
            turbo: {
                restorationIdentifier: restorationIdentifier,
                restorationIndex: this.currentIndex
            }
        };
        method.call(history, state, "", location1.href);
        this.location = location1;
        this.restorationIdentifier = restorationIdentifier;
    }
    // Restoration data
    getRestorationDataForIdentifier(restorationIdentifier) {
        return this.restorationData[restorationIdentifier] || {};
    }
    updateRestorationData(additionalData) {
        const { restorationIdentifier: restorationIdentifier } = this;
        const restorationData = this.restorationData[restorationIdentifier];
        this.restorationData[restorationIdentifier] = {
            ...restorationData,
            ...additionalData
        };
    }
    // Scroll restoration
    assumeControlOfScrollRestoration() {
        if (!this.previousScrollRestoration) {
            this.previousScrollRestoration = history.scrollRestoration ?? "auto";
            history.scrollRestoration = "manual";
        }
    }
    relinquishControlOfScrollRestoration() {
        if (this.previousScrollRestoration) {
            history.scrollRestoration = this.previousScrollRestoration;
            delete this.previousScrollRestoration;
        }
    }
    // Event handlers
    onPopState = (event)=>{
        if (this.shouldHandlePopState()) {
            const { turbo: turbo } = event.state || {};
            if (turbo) {
                this.location = new URL(window.location.href);
                const { restorationIdentifier: restorationIdentifier, restorationIndex: restorationIndex } = turbo;
                this.restorationIdentifier = restorationIdentifier;
                const direction = restorationIndex > this.currentIndex ? "forward" : "back";
                this.delegate.historyPoppedToLocationWithRestorationIdentifierAndDirection(this.location, restorationIdentifier, direction);
                this.currentIndex = restorationIndex;
            }
        }
    };
    onPageLoad = async (_event)=>{
        await $ee40788d37d3b5ae$var$nextMicrotask();
        this.pageLoaded = true;
    };
    // Private
    shouldHandlePopState() {
        // Safari dispatches a popstate event after window's load event, ignore it
        return this.pageIsLoaded();
    }
    pageIsLoaded() {
        return this.pageLoaded || document.readyState == "complete";
    }
}
class $ee40788d37d3b5ae$var$LinkPrefetchObserver {
    started = false;
    #prefetchedLink = null;
    constructor(delegate, eventTarget){
        this.delegate = delegate;
        this.eventTarget = eventTarget;
    }
    start() {
        if (this.started) return;
        if (this.eventTarget.readyState === "loading") this.eventTarget.addEventListener("DOMContentLoaded", this.#enable, {
            once: true
        });
        else this.#enable();
    }
    stop() {
        if (!this.started) return;
        this.eventTarget.removeEventListener("mouseenter", this.#tryToPrefetchRequest, {
            capture: true,
            passive: true
        });
        this.eventTarget.removeEventListener("mouseleave", this.#cancelRequestIfObsolete, {
            capture: true,
            passive: true
        });
        this.eventTarget.removeEventListener("turbo:before-fetch-request", this.#tryToUsePrefetchedRequest, true);
        this.started = false;
    }
    #enable = ()=>{
        this.eventTarget.addEventListener("mouseenter", this.#tryToPrefetchRequest, {
            capture: true,
            passive: true
        });
        this.eventTarget.addEventListener("mouseleave", this.#cancelRequestIfObsolete, {
            capture: true,
            passive: true
        });
        this.eventTarget.addEventListener("turbo:before-fetch-request", this.#tryToUsePrefetchedRequest, true);
        this.started = true;
    };
    #tryToPrefetchRequest = (event)=>{
        if ($ee40788d37d3b5ae$var$getMetaContent("turbo-prefetch") === "false") return;
        const target = event.target;
        const isLink = target.matches && target.matches("a[href]:not([target^=_]):not([download])");
        if (isLink && this.#isPrefetchable(target)) {
            const link = target;
            const location1 = $ee40788d37d3b5ae$var$getLocationForLink(link);
            if (this.delegate.canPrefetchRequestToLocation(link, location1)) {
                this.#prefetchedLink = link;
                const fetchRequest = new $ee40788d37d3b5ae$export$319b96fe59834522(this, $ee40788d37d3b5ae$export$76f6869e29ff06ee.get, location1, new URLSearchParams(), target);
                fetchRequest.fetchOptions.priority = "low";
                $ee40788d37d3b5ae$var$prefetchCache.setLater(location1.toString(), fetchRequest, this.#cacheTtl);
            }
        }
    };
    #cancelRequestIfObsolete = (event)=>{
        if (event.target === this.#prefetchedLink) this.#cancelPrefetchRequest();
    };
    #cancelPrefetchRequest = ()=>{
        $ee40788d37d3b5ae$var$prefetchCache.clear();
        this.#prefetchedLink = null;
    };
    #tryToUsePrefetchedRequest = (event)=>{
        if (event.target.tagName !== "FORM" && event.detail.fetchOptions.method === "GET") {
            const cached = $ee40788d37d3b5ae$var$prefetchCache.get(event.detail.url.toString());
            if (cached) // User clicked link, use cache response
            event.detail.fetchRequest = cached;
            $ee40788d37d3b5ae$var$prefetchCache.clear();
        }
    };
    prepareRequest(request) {
        const link = request.target;
        request.headers["X-Sec-Purpose"] = "prefetch";
        const turboFrame = link.closest("turbo-frame");
        const turboFrameTarget = link.getAttribute("data-turbo-frame") || turboFrame?.getAttribute("target") || turboFrame?.id;
        if (turboFrameTarget && turboFrameTarget !== "_top") request.headers["Turbo-Frame"] = turboFrameTarget;
    }
    // Fetch request interface
    requestSucceededWithResponse() {}
    requestStarted(fetchRequest) {}
    requestErrored(fetchRequest) {}
    requestFinished(fetchRequest) {}
    requestPreventedHandlingResponse(fetchRequest, fetchResponse) {}
    requestFailedWithResponse(fetchRequest, fetchResponse) {}
    get #cacheTtl() {
        return Number($ee40788d37d3b5ae$var$getMetaContent("turbo-prefetch-cache-time")) || $ee40788d37d3b5ae$var$cacheTtl;
    }
    #isPrefetchable(link) {
        const href = link.getAttribute("href");
        if (!href) return false;
        if ($ee40788d37d3b5ae$var$unfetchableLink(link)) return false;
        if ($ee40788d37d3b5ae$var$linkToTheSamePage(link)) return false;
        if ($ee40788d37d3b5ae$var$linkOptsOut(link)) return false;
        if ($ee40788d37d3b5ae$var$nonSafeLink(link)) return false;
        if ($ee40788d37d3b5ae$var$eventPrevented(link)) return false;
        return true;
    }
}
const $ee40788d37d3b5ae$var$unfetchableLink = (link)=>{
    return link.origin !== document.location.origin || ![
        "http:",
        "https:"
    ].includes(link.protocol) || link.hasAttribute("target");
};
const $ee40788d37d3b5ae$var$linkToTheSamePage = (link)=>{
    return link.pathname + link.search === document.location.pathname + document.location.search || link.href.startsWith("#");
};
const $ee40788d37d3b5ae$var$linkOptsOut = (link)=>{
    if (link.getAttribute("data-turbo-prefetch") === "false") return true;
    if (link.getAttribute("data-turbo") === "false") return true;
    const turboPrefetchParent = $ee40788d37d3b5ae$var$findClosestRecursively(link, "[data-turbo-prefetch]");
    if (turboPrefetchParent && turboPrefetchParent.getAttribute("data-turbo-prefetch") === "false") return true;
    return false;
};
const $ee40788d37d3b5ae$var$nonSafeLink = (link)=>{
    const turboMethod = link.getAttribute("data-turbo-method");
    if (turboMethod && turboMethod.toLowerCase() !== "get") return true;
    if ($ee40788d37d3b5ae$var$isUJS(link)) return true;
    if (link.hasAttribute("data-turbo-confirm")) return true;
    if (link.hasAttribute("data-turbo-stream")) return true;
    return false;
};
const $ee40788d37d3b5ae$var$isUJS = (link)=>{
    return link.hasAttribute("data-remote") || link.hasAttribute("data-behavior") || link.hasAttribute("data-confirm") || link.hasAttribute("data-method");
};
const $ee40788d37d3b5ae$var$eventPrevented = (link)=>{
    const event = $ee40788d37d3b5ae$var$dispatch("turbo:before-prefetch", {
        target: link,
        cancelable: true
    });
    return event.defaultPrevented;
};
class $ee40788d37d3b5ae$var$Navigator {
    constructor(delegate){
        this.delegate = delegate;
    }
    proposeVisit(location1, options = {}) {
        if (this.delegate.allowsVisitingLocationWithAction(location1, options.action)) this.delegate.visitProposedToLocation(location1, options);
    }
    startVisit(locatable, restorationIdentifier, options = {}) {
        this.stop();
        this.currentVisit = new $ee40788d37d3b5ae$var$Visit(this, $ee40788d37d3b5ae$var$expandURL(locatable), restorationIdentifier, {
            referrer: this.location,
            ...options
        });
        this.currentVisit.start();
    }
    submitForm(form, submitter) {
        this.stop();
        this.formSubmission = new $ee40788d37d3b5ae$var$FormSubmission(this, form, submitter, true);
        this.formSubmission.start();
    }
    stop() {
        if (this.formSubmission) {
            this.formSubmission.stop();
            delete this.formSubmission;
        }
        if (this.currentVisit) {
            this.currentVisit.cancel();
            delete this.currentVisit;
        }
    }
    get adapter() {
        return this.delegate.adapter;
    }
    get view() {
        return this.delegate.view;
    }
    get rootLocation() {
        return this.view.snapshot.rootLocation;
    }
    get history() {
        return this.delegate.history;
    }
    // Form submission delegate
    formSubmissionStarted(formSubmission) {
        // Not all adapters implement formSubmissionStarted
        if (typeof this.adapter.formSubmissionStarted === "function") this.adapter.formSubmissionStarted(formSubmission);
    }
    async formSubmissionSucceededWithResponse(formSubmission, fetchResponse) {
        if (formSubmission == this.formSubmission) {
            const responseHTML = await fetchResponse.responseHTML;
            if (responseHTML) {
                const shouldCacheSnapshot = formSubmission.isSafe;
                if (!shouldCacheSnapshot) this.view.clearSnapshotCache();
                const { statusCode: statusCode, redirected: redirected } = fetchResponse;
                const action = this.#getActionForFormSubmission(formSubmission, fetchResponse);
                const visitOptions = {
                    action: action,
                    shouldCacheSnapshot: shouldCacheSnapshot,
                    response: {
                        statusCode: statusCode,
                        responseHTML: responseHTML,
                        redirected: redirected
                    }
                };
                this.proposeVisit(fetchResponse.location, visitOptions);
            }
        }
    }
    async formSubmissionFailedWithResponse(formSubmission, fetchResponse) {
        const responseHTML = await fetchResponse.responseHTML;
        if (responseHTML) {
            const snapshot = $ee40788d37d3b5ae$export$4f11b95e473fd113.fromHTMLString(responseHTML);
            if (fetchResponse.serverError) await this.view.renderError(snapshot, this.currentVisit);
            else await this.view.renderPage(snapshot, false, true, this.currentVisit);
            if (!snapshot.shouldPreserveScrollPosition) this.view.scrollToTop();
            this.view.clearSnapshotCache();
        }
    }
    formSubmissionErrored(formSubmission, error) {
        console.error(error);
    }
    formSubmissionFinished(formSubmission) {
        // Not all adapters implement formSubmissionFinished
        if (typeof this.adapter.formSubmissionFinished === "function") this.adapter.formSubmissionFinished(formSubmission);
    }
    // Link prefetching
    linkPrefetchingIsEnabledForLocation(location1) {
        // Not all adapters implement linkPrefetchingIsEnabledForLocation
        if (typeof this.adapter.linkPrefetchingIsEnabledForLocation === "function") return this.adapter.linkPrefetchingIsEnabledForLocation(location1);
        return true;
    }
    // Visit delegate
    visitStarted(visit) {
        this.delegate.visitStarted(visit);
    }
    visitCompleted(visit) {
        this.delegate.visitCompleted(visit);
        delete this.currentVisit;
    }
    locationWithActionIsSamePage(location1, action) {
        const anchor = $ee40788d37d3b5ae$var$getAnchor(location1);
        const currentAnchor = $ee40788d37d3b5ae$var$getAnchor(this.view.lastRenderedLocation);
        const isRestorationToTop = action === "restore" && typeof anchor === "undefined";
        return action !== "replace" && $ee40788d37d3b5ae$var$getRequestURL(location1) === $ee40788d37d3b5ae$var$getRequestURL(this.view.lastRenderedLocation) && (isRestorationToTop || anchor != null && anchor !== currentAnchor);
    }
    visitScrolledToSamePageLocation(oldURL, newURL) {
        this.delegate.visitScrolledToSamePageLocation(oldURL, newURL);
    }
    // Visits
    get location() {
        return this.history.location;
    }
    get restorationIdentifier() {
        return this.history.restorationIdentifier;
    }
    #getActionForFormSubmission(formSubmission, fetchResponse) {
        const { submitter: submitter, formElement: formElement } = formSubmission;
        return $ee40788d37d3b5ae$var$getVisitAction(submitter, formElement) || this.#getDefaultAction(fetchResponse);
    }
    #getDefaultAction(fetchResponse) {
        const sameLocationRedirect = fetchResponse.redirected && fetchResponse.location.href === this.location?.href;
        return sameLocationRedirect ? "replace" : "advance";
    }
}
const $ee40788d37d3b5ae$var$PageStage = {
    initial: 0,
    loading: 1,
    interactive: 2,
    complete: 3
};
class $ee40788d37d3b5ae$var$PageObserver {
    stage = $ee40788d37d3b5ae$var$PageStage.initial;
    started = false;
    constructor(delegate){
        this.delegate = delegate;
    }
    start() {
        if (!this.started) {
            if (this.stage == $ee40788d37d3b5ae$var$PageStage.initial) this.stage = $ee40788d37d3b5ae$var$PageStage.loading;
            document.addEventListener("readystatechange", this.interpretReadyState, false);
            addEventListener("pagehide", this.pageWillUnload, false);
            this.started = true;
        }
    }
    stop() {
        if (this.started) {
            document.removeEventListener("readystatechange", this.interpretReadyState, false);
            removeEventListener("pagehide", this.pageWillUnload, false);
            this.started = false;
        }
    }
    interpretReadyState = ()=>{
        const { readyState: readyState } = this;
        if (readyState == "interactive") this.pageIsInteractive();
        else if (readyState == "complete") this.pageIsComplete();
    };
    pageIsInteractive() {
        if (this.stage == $ee40788d37d3b5ae$var$PageStage.loading) {
            this.stage = $ee40788d37d3b5ae$var$PageStage.interactive;
            this.delegate.pageBecameInteractive();
        }
    }
    pageIsComplete() {
        this.pageIsInteractive();
        if (this.stage == $ee40788d37d3b5ae$var$PageStage.interactive) {
            this.stage = $ee40788d37d3b5ae$var$PageStage.complete;
            this.delegate.pageLoaded();
        }
    }
    pageWillUnload = ()=>{
        this.delegate.pageWillUnload();
    };
    get readyState() {
        return document.readyState;
    }
}
class $ee40788d37d3b5ae$var$ScrollObserver {
    started = false;
    constructor(delegate){
        this.delegate = delegate;
    }
    start() {
        if (!this.started) {
            addEventListener("scroll", this.onScroll, false);
            this.onScroll();
            this.started = true;
        }
    }
    stop() {
        if (this.started) {
            removeEventListener("scroll", this.onScroll, false);
            this.started = false;
        }
    }
    onScroll = ()=>{
        this.updatePosition({
            x: window.pageXOffset,
            y: window.pageYOffset
        });
    };
    // Private
    updatePosition(position) {
        this.delegate.scrollPositionChanged(position);
    }
}
class $ee40788d37d3b5ae$var$StreamMessageRenderer {
    render({ fragment: fragment }) {
        $ee40788d37d3b5ae$var$Bardo.preservingPermanentElements(this, $ee40788d37d3b5ae$var$getPermanentElementMapForFragment(fragment), ()=>{
            $ee40788d37d3b5ae$var$withAutofocusFromFragment(fragment, ()=>{
                $ee40788d37d3b5ae$var$withPreservedFocus(()=>{
                    document.documentElement.appendChild(fragment);
                });
            });
        });
    }
    // Bardo delegate
    enteringBardo(currentPermanentElement, newPermanentElement) {
        newPermanentElement.replaceWith(currentPermanentElement.cloneNode(true));
    }
    leavingBardo() {}
}
function $ee40788d37d3b5ae$var$getPermanentElementMapForFragment(fragment) {
    const permanentElementsInDocument = $ee40788d37d3b5ae$var$queryPermanentElementsAll(document.documentElement);
    const permanentElementMap = {};
    for (const permanentElementInDocument of permanentElementsInDocument){
        const { id: id } = permanentElementInDocument;
        for (const streamElement of fragment.querySelectorAll("turbo-stream")){
            const elementInStream = $ee40788d37d3b5ae$var$getPermanentElementById(streamElement.templateElement.content, id);
            if (elementInStream) permanentElementMap[id] = [
                permanentElementInDocument,
                elementInStream
            ];
        }
    }
    return permanentElementMap;
}
async function $ee40788d37d3b5ae$var$withAutofocusFromFragment(fragment, callback) {
    const generatedID = `turbo-stream-autofocus-${$ee40788d37d3b5ae$var$uuid()}`;
    const turboStreams = fragment.querySelectorAll("turbo-stream");
    const elementWithAutofocus = $ee40788d37d3b5ae$var$firstAutofocusableElementInStreams(turboStreams);
    let willAutofocusId = null;
    if (elementWithAutofocus) {
        if (elementWithAutofocus.id) willAutofocusId = elementWithAutofocus.id;
        else willAutofocusId = generatedID;
        elementWithAutofocus.id = willAutofocusId;
    }
    callback();
    await $ee40788d37d3b5ae$var$nextRepaint();
    const hasNoActiveElement = document.activeElement == null || document.activeElement == document.body;
    if (hasNoActiveElement && willAutofocusId) {
        const elementToAutofocus = document.getElementById(willAutofocusId);
        if ($ee40788d37d3b5ae$var$elementIsFocusable(elementToAutofocus)) elementToAutofocus.focus();
        if (elementToAutofocus && elementToAutofocus.id == generatedID) elementToAutofocus.removeAttribute("id");
    }
}
async function $ee40788d37d3b5ae$var$withPreservedFocus(callback) {
    const [activeElementBeforeRender, activeElementAfterRender] = await $ee40788d37d3b5ae$var$around(callback, ()=>document.activeElement);
    const restoreFocusTo = activeElementBeforeRender && activeElementBeforeRender.id;
    if (restoreFocusTo) {
        const elementToFocus = document.getElementById(restoreFocusTo);
        if ($ee40788d37d3b5ae$var$elementIsFocusable(elementToFocus) && elementToFocus != activeElementAfterRender) elementToFocus.focus();
    }
}
function $ee40788d37d3b5ae$var$firstAutofocusableElementInStreams(nodeListOfStreamElements) {
    for (const streamElement of nodeListOfStreamElements){
        const elementWithAutofocus = $ee40788d37d3b5ae$var$queryAutofocusableElement(streamElement.templateElement.content);
        if (elementWithAutofocus) return elementWithAutofocus;
    }
    return null;
}
class $ee40788d37d3b5ae$var$StreamObserver {
    sources = new Set();
    #started = false;
    constructor(delegate){
        this.delegate = delegate;
    }
    start() {
        if (!this.#started) {
            this.#started = true;
            addEventListener("turbo:before-fetch-response", this.inspectFetchResponse, false);
        }
    }
    stop() {
        if (this.#started) {
            this.#started = false;
            removeEventListener("turbo:before-fetch-response", this.inspectFetchResponse, false);
        }
    }
    connectStreamSource(source) {
        if (!this.streamSourceIsConnected(source)) {
            this.sources.add(source);
            source.addEventListener("message", this.receiveMessageEvent, false);
        }
    }
    disconnectStreamSource(source) {
        if (this.streamSourceIsConnected(source)) {
            this.sources.delete(source);
            source.removeEventListener("message", this.receiveMessageEvent, false);
        }
    }
    streamSourceIsConnected(source) {
        return this.sources.has(source);
    }
    inspectFetchResponse = (event)=>{
        const response = $ee40788d37d3b5ae$var$fetchResponseFromEvent(event);
        if (response && $ee40788d37d3b5ae$var$fetchResponseIsStream(response)) {
            event.preventDefault();
            this.receiveMessageResponse(response);
        }
    };
    receiveMessageEvent = (event)=>{
        if (this.#started && typeof event.data == "string") this.receiveMessageHTML(event.data);
    };
    async receiveMessageResponse(response) {
        const html = await response.responseHTML;
        if (html) this.receiveMessageHTML(html);
    }
    receiveMessageHTML(html) {
        this.delegate.receivedMessageFromStream($ee40788d37d3b5ae$var$StreamMessage.wrap(html));
    }
}
function $ee40788d37d3b5ae$var$fetchResponseFromEvent(event) {
    const fetchResponse = event.detail?.fetchResponse;
    if (fetchResponse instanceof $ee40788d37d3b5ae$export$3ae09bba5b6b906e) return fetchResponse;
}
function $ee40788d37d3b5ae$var$fetchResponseIsStream(response) {
    const contentType = response.contentType ?? "";
    return contentType.startsWith($ee40788d37d3b5ae$var$StreamMessage.contentType);
}
class $ee40788d37d3b5ae$var$ErrorRenderer extends $ee40788d37d3b5ae$var$Renderer {
    static renderElement(currentElement, newElement) {
        const { documentElement: documentElement, body: body } = document;
        documentElement.replaceChild(newElement, body);
    }
    async render() {
        this.replaceHeadAndBody();
        this.activateScriptElements();
    }
    replaceHeadAndBody() {
        const { documentElement: documentElement, head: head } = document;
        documentElement.replaceChild(this.newHead, head);
        this.renderElement(this.currentElement, this.newElement);
    }
    activateScriptElements() {
        for (const replaceableElement of this.scriptElements){
            const parentNode = replaceableElement.parentNode;
            if (parentNode) {
                const element = $ee40788d37d3b5ae$var$activateScriptElement(replaceableElement);
                parentNode.replaceChild(element, replaceableElement);
            }
        }
    }
    get newHead() {
        return this.newSnapshot.headSnapshot.element;
    }
    get scriptElements() {
        return document.documentElement.querySelectorAll("script");
    }
}
class $ee40788d37d3b5ae$export$ac9642242cf7b3ce extends $ee40788d37d3b5ae$var$Renderer {
    static renderElement(currentElement, newElement) {
        if (document.body && newElement instanceof HTMLBodyElement) document.body.replaceWith(newElement);
        else document.documentElement.appendChild(newElement);
    }
    get shouldRender() {
        return this.newSnapshot.isVisitable && this.trackedElementsAreIdentical;
    }
    get reloadReason() {
        if (!this.newSnapshot.isVisitable) return {
            reason: "turbo_visit_control_is_reload"
        };
        if (!this.trackedElementsAreIdentical) return {
            reason: "tracked_element_mismatch"
        };
    }
    async prepareToRender() {
        this.#setLanguage();
        await this.mergeHead();
    }
    async render() {
        if (this.willRender) await this.replaceBody();
    }
    finishRendering() {
        super.finishRendering();
        if (!this.isPreview) this.focusFirstAutofocusableElement();
    }
    get currentHeadSnapshot() {
        return this.currentSnapshot.headSnapshot;
    }
    get newHeadSnapshot() {
        return this.newSnapshot.headSnapshot;
    }
    get newElement() {
        return this.newSnapshot.element;
    }
    #setLanguage() {
        const { documentElement: documentElement } = this.currentSnapshot;
        const { lang: lang } = this.newSnapshot;
        if (lang) documentElement.setAttribute("lang", lang);
        else documentElement.removeAttribute("lang");
    }
    async mergeHead() {
        const mergedHeadElements = this.mergeProvisionalElements();
        const newStylesheetElements = this.copyNewHeadStylesheetElements();
        this.copyNewHeadScriptElements();
        await mergedHeadElements;
        await newStylesheetElements;
        if (this.willRender) this.removeUnusedDynamicStylesheetElements();
    }
    async replaceBody() {
        await this.preservingPermanentElements(async ()=>{
            this.activateNewBody();
            await this.assignNewBody();
        });
    }
    get trackedElementsAreIdentical() {
        return this.currentHeadSnapshot.trackedElementSignature == this.newHeadSnapshot.trackedElementSignature;
    }
    async copyNewHeadStylesheetElements() {
        const loadingElements = [];
        for (const element of this.newHeadStylesheetElements){
            loadingElements.push($ee40788d37d3b5ae$var$waitForLoad(element));
            document.head.appendChild(element);
        }
        await Promise.all(loadingElements);
    }
    copyNewHeadScriptElements() {
        for (const element of this.newHeadScriptElements)document.head.appendChild($ee40788d37d3b5ae$var$activateScriptElement(element));
    }
    removeUnusedDynamicStylesheetElements() {
        for (const element of this.unusedDynamicStylesheetElements)document.head.removeChild(element);
    }
    async mergeProvisionalElements() {
        const newHeadElements = [
            ...this.newHeadProvisionalElements
        ];
        for (const element of this.currentHeadProvisionalElements)if (!this.isCurrentElementInElementList(element, newHeadElements)) document.head.removeChild(element);
        for (const element of newHeadElements)document.head.appendChild(element);
    }
    isCurrentElementInElementList(element, elementList) {
        for (const [index, newElement] of elementList.entries()){
            // if title element...
            if (element.tagName == "TITLE") {
                if (newElement.tagName != "TITLE") continue;
                if (element.innerHTML == newElement.innerHTML) {
                    elementList.splice(index, 1);
                    return true;
                }
            }
            // if any other element...
            if (newElement.isEqualNode(element)) {
                elementList.splice(index, 1);
                return true;
            }
        }
        return false;
    }
    removeCurrentHeadProvisionalElements() {
        for (const element of this.currentHeadProvisionalElements)document.head.removeChild(element);
    }
    copyNewHeadProvisionalElements() {
        for (const element of this.newHeadProvisionalElements)document.head.appendChild(element);
    }
    activateNewBody() {
        document.adoptNode(this.newElement);
        this.activateNewBodyScriptElements();
    }
    activateNewBodyScriptElements() {
        for (const inertScriptElement of this.newBodyScriptElements){
            const activatedScriptElement = $ee40788d37d3b5ae$var$activateScriptElement(inertScriptElement);
            inertScriptElement.replaceWith(activatedScriptElement);
        }
    }
    async assignNewBody() {
        await this.renderElement(this.currentElement, this.newElement);
    }
    get unusedDynamicStylesheetElements() {
        return this.oldHeadStylesheetElements.filter((element)=>{
            return element.getAttribute("data-turbo-track") === "dynamic";
        });
    }
    get oldHeadStylesheetElements() {
        return this.currentHeadSnapshot.getStylesheetElementsNotInSnapshot(this.newHeadSnapshot);
    }
    get newHeadStylesheetElements() {
        return this.newHeadSnapshot.getStylesheetElementsNotInSnapshot(this.currentHeadSnapshot);
    }
    get newHeadScriptElements() {
        return this.newHeadSnapshot.getScriptElementsNotInSnapshot(this.currentHeadSnapshot);
    }
    get currentHeadProvisionalElements() {
        return this.currentHeadSnapshot.provisionalElements;
    }
    get newHeadProvisionalElements() {
        return this.newHeadSnapshot.provisionalElements;
    }
    get newBodyScriptElements() {
        return this.newElement.querySelectorAll("script");
    }
}
class $ee40788d37d3b5ae$var$MorphingPageRenderer extends $ee40788d37d3b5ae$export$ac9642242cf7b3ce {
    static renderElement(currentElement, newElement) {
        $ee40788d37d3b5ae$export$dc74801294c91b10(currentElement, newElement, {
            callbacks: {
                beforeNodeMorphed: (node, newNode)=>{
                    if ($ee40788d37d3b5ae$var$shouldRefreshFrameWithMorphing(node, newNode) && !$ee40788d37d3b5ae$var$closestFrameReloadableWithMorphing(node)) {
                        node.reload();
                        return false;
                    }
                    return true;
                }
            }
        });
        $ee40788d37d3b5ae$var$dispatch("turbo:morph", {
            detail: {
                currentElement: currentElement,
                newElement: newElement
            }
        });
    }
    async preservingPermanentElements(callback) {
        return await callback();
    }
    get renderMethod() {
        return "morph";
    }
    get shouldAutofocus() {
        return false;
    }
}
class $ee40788d37d3b5ae$var$SnapshotCache {
    keys = [];
    snapshots = {};
    constructor(size){
        this.size = size;
    }
    has(location1) {
        return $ee40788d37d3b5ae$var$toCacheKey(location1) in this.snapshots;
    }
    get(location1) {
        if (this.has(location1)) {
            const snapshot = this.read(location1);
            this.touch(location1);
            return snapshot;
        }
    }
    put(location1, snapshot) {
        this.write(location1, snapshot);
        this.touch(location1);
        return snapshot;
    }
    clear() {
        this.snapshots = {};
    }
    // Private
    read(location1) {
        return this.snapshots[$ee40788d37d3b5ae$var$toCacheKey(location1)];
    }
    write(location1, snapshot) {
        this.snapshots[$ee40788d37d3b5ae$var$toCacheKey(location1)] = snapshot;
    }
    touch(location1) {
        const key = $ee40788d37d3b5ae$var$toCacheKey(location1);
        const index = this.keys.indexOf(key);
        if (index > -1) this.keys.splice(index, 1);
        this.keys.unshift(key);
        this.trim();
    }
    trim() {
        for (const key of this.keys.splice(this.size))delete this.snapshots[key];
    }
}
class $ee40788d37d3b5ae$var$PageView extends $ee40788d37d3b5ae$var$View {
    snapshotCache = new $ee40788d37d3b5ae$var$SnapshotCache(10);
    lastRenderedLocation = new URL(location.href);
    forceReloaded = false;
    shouldTransitionTo(newSnapshot) {
        return this.snapshot.prefersViewTransitions && newSnapshot.prefersViewTransitions;
    }
    renderPage(snapshot, isPreview = false, willRender = true, visit) {
        const shouldMorphPage = this.isPageRefresh(visit) && this.snapshot.shouldMorphPage;
        const rendererClass = shouldMorphPage ? $ee40788d37d3b5ae$var$MorphingPageRenderer : $ee40788d37d3b5ae$export$ac9642242cf7b3ce;
        const renderer = new rendererClass(this.snapshot, snapshot, isPreview, willRender);
        if (!renderer.shouldRender) this.forceReloaded = true;
        else visit?.changeHistory();
        return this.render(renderer);
    }
    renderError(snapshot, visit) {
        visit?.changeHistory();
        const renderer = new $ee40788d37d3b5ae$var$ErrorRenderer(this.snapshot, snapshot, false);
        return this.render(renderer);
    }
    clearSnapshotCache() {
        this.snapshotCache.clear();
    }
    async cacheSnapshot(snapshot = this.snapshot) {
        if (snapshot.isCacheable) {
            this.delegate.viewWillCacheSnapshot();
            const { lastRenderedLocation: location1 } = this;
            await $ee40788d37d3b5ae$var$nextEventLoopTick();
            const cachedSnapshot = snapshot.clone();
            this.snapshotCache.put(location1, cachedSnapshot);
            return cachedSnapshot;
        }
    }
    getCachedSnapshotForLocation(location1) {
        return this.snapshotCache.get(location1);
    }
    isPageRefresh(visit) {
        return !visit || this.lastRenderedLocation.pathname === visit.location.pathname && visit.action === "replace";
    }
    shouldPreserveScrollPosition(visit) {
        return this.isPageRefresh(visit) && this.snapshot.shouldPreserveScrollPosition;
    }
    get snapshot() {
        return $ee40788d37d3b5ae$export$4f11b95e473fd113.fromElement(this.element);
    }
}
class $ee40788d37d3b5ae$var$Preloader {
    selector = "a[data-turbo-preload]";
    constructor(delegate, snapshotCache){
        this.delegate = delegate;
        this.snapshotCache = snapshotCache;
    }
    start() {
        if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", this.#preloadAll);
        else this.preloadOnLoadLinksForView(document.body);
    }
    stop() {
        document.removeEventListener("DOMContentLoaded", this.#preloadAll);
    }
    preloadOnLoadLinksForView(element) {
        for (const link of element.querySelectorAll(this.selector))if (this.delegate.shouldPreloadLink(link)) this.preloadURL(link);
    }
    async preloadURL(link) {
        const location1 = new URL(link.href);
        if (this.snapshotCache.has(location1)) return;
        const fetchRequest = new $ee40788d37d3b5ae$export$319b96fe59834522(this, $ee40788d37d3b5ae$export$76f6869e29ff06ee.get, location1, new URLSearchParams(), link);
        await fetchRequest.perform();
    }
    // Fetch request delegate
    prepareRequest(fetchRequest) {
        fetchRequest.headers["X-Sec-Purpose"] = "prefetch";
    }
    async requestSucceededWithResponse(fetchRequest, fetchResponse) {
        try {
            const responseHTML = await fetchResponse.responseHTML;
            const snapshot = $ee40788d37d3b5ae$export$4f11b95e473fd113.fromHTMLString(responseHTML);
            this.snapshotCache.put(fetchRequest.url, snapshot);
        } catch (_) {
        // If we cannot preload that is ok!
        }
    }
    requestStarted(fetchRequest) {}
    requestErrored(fetchRequest) {}
    requestFinished(fetchRequest) {}
    requestPreventedHandlingResponse(fetchRequest, fetchResponse) {}
    requestFailedWithResponse(fetchRequest, fetchResponse) {}
    #preloadAll = ()=>{
        this.preloadOnLoadLinksForView(document.body);
    };
}
class $ee40788d37d3b5ae$var$Cache {
    constructor(session){
        this.session = session;
    }
    clear() {
        this.session.clearCache();
    }
    resetCacheControl() {
        this.#setCacheControl("");
    }
    exemptPageFromCache() {
        this.#setCacheControl("no-cache");
    }
    exemptPageFromPreview() {
        this.#setCacheControl("no-preview");
    }
    #setCacheControl(value) {
        $ee40788d37d3b5ae$var$setMetaContent("turbo-cache-control", value);
    }
}
class $ee40788d37d3b5ae$var$Session {
    navigator = new $ee40788d37d3b5ae$var$Navigator(this);
    history = new $ee40788d37d3b5ae$var$History(this);
    view = new $ee40788d37d3b5ae$var$PageView(this, document.documentElement);
    adapter = new $ee40788d37d3b5ae$var$BrowserAdapter(this);
    pageObserver = new $ee40788d37d3b5ae$var$PageObserver(this);
    cacheObserver = new $ee40788d37d3b5ae$var$CacheObserver();
    linkPrefetchObserver = new $ee40788d37d3b5ae$var$LinkPrefetchObserver(this, document);
    linkClickObserver = new $ee40788d37d3b5ae$var$LinkClickObserver(this, window);
    formSubmitObserver = new $ee40788d37d3b5ae$var$FormSubmitObserver(this, document);
    scrollObserver = new $ee40788d37d3b5ae$var$ScrollObserver(this);
    streamObserver = new $ee40788d37d3b5ae$var$StreamObserver(this);
    formLinkClickObserver = new $ee40788d37d3b5ae$var$FormLinkClickObserver(this, document.documentElement);
    frameRedirector = new $ee40788d37d3b5ae$var$FrameRedirector(this, document.documentElement);
    streamMessageRenderer = new $ee40788d37d3b5ae$var$StreamMessageRenderer();
    cache = new $ee40788d37d3b5ae$var$Cache(this);
    enabled = true;
    started = false;
    #pageRefreshDebouncePeriod = 150;
    constructor(recentRequests){
        this.recentRequests = recentRequests;
        this.preloader = new $ee40788d37d3b5ae$var$Preloader(this, this.view.snapshotCache);
        this.debouncedRefresh = this.refresh;
        this.pageRefreshDebouncePeriod = this.pageRefreshDebouncePeriod;
    }
    start() {
        if (!this.started) {
            this.pageObserver.start();
            this.cacheObserver.start();
            this.linkPrefetchObserver.start();
            this.formLinkClickObserver.start();
            this.linkClickObserver.start();
            this.formSubmitObserver.start();
            this.scrollObserver.start();
            this.streamObserver.start();
            this.frameRedirector.start();
            this.history.start();
            this.preloader.start();
            this.started = true;
            this.enabled = true;
        }
    }
    disable() {
        this.enabled = false;
    }
    stop() {
        if (this.started) {
            this.pageObserver.stop();
            this.cacheObserver.stop();
            this.linkPrefetchObserver.stop();
            this.formLinkClickObserver.stop();
            this.linkClickObserver.stop();
            this.formSubmitObserver.stop();
            this.scrollObserver.stop();
            this.streamObserver.stop();
            this.frameRedirector.stop();
            this.history.stop();
            this.preloader.stop();
            this.started = false;
        }
    }
    registerAdapter(adapter) {
        this.adapter = adapter;
    }
    visit(location1, options = {}) {
        const frameElement = options.frame ? document.getElementById(options.frame) : null;
        if (frameElement instanceof $ee40788d37d3b5ae$export$f464a8f0ffa32c44) {
            const action = options.action || $ee40788d37d3b5ae$var$getVisitAction(frameElement);
            frameElement.delegate.proposeVisitIfNavigatedWithAction(frameElement, action);
            frameElement.src = location1.toString();
        } else this.navigator.proposeVisit($ee40788d37d3b5ae$var$expandURL(location1), options);
    }
    refresh(url, requestId) {
        const isRecentRequest = requestId && this.recentRequests.has(requestId);
        const isCurrentUrl = url === document.baseURI;
        if (!isRecentRequest && !this.navigator.currentVisit && isCurrentUrl) this.visit(url, {
            action: "replace",
            shouldCacheSnapshot: false
        });
    }
    connectStreamSource(source) {
        this.streamObserver.connectStreamSource(source);
    }
    disconnectStreamSource(source) {
        this.streamObserver.disconnectStreamSource(source);
    }
    renderStreamMessage(message) {
        this.streamMessageRenderer.render($ee40788d37d3b5ae$var$StreamMessage.wrap(message));
    }
    clearCache() {
        this.view.clearSnapshotCache();
    }
    setProgressBarDelay(delay) {
        console.warn("Please replace `session.setProgressBarDelay(delay)` with `session.progressBarDelay = delay`. The function is deprecated and will be removed in a future version of Turbo.`");
        this.progressBarDelay = delay;
    }
    set progressBarDelay(delay) {
        $ee40788d37d3b5ae$export$e506a1d27d1eaa20.drive.progressBarDelay = delay;
    }
    get progressBarDelay() {
        return $ee40788d37d3b5ae$export$e506a1d27d1eaa20.drive.progressBarDelay;
    }
    set drive(value) {
        $ee40788d37d3b5ae$export$e506a1d27d1eaa20.drive.enabled = value;
    }
    get drive() {
        return $ee40788d37d3b5ae$export$e506a1d27d1eaa20.drive.enabled;
    }
    set formMode(value) {
        $ee40788d37d3b5ae$export$e506a1d27d1eaa20.forms.mode = value;
    }
    get formMode() {
        return $ee40788d37d3b5ae$export$e506a1d27d1eaa20.forms.mode;
    }
    get location() {
        return this.history.location;
    }
    get restorationIdentifier() {
        return this.history.restorationIdentifier;
    }
    get pageRefreshDebouncePeriod() {
        return this.#pageRefreshDebouncePeriod;
    }
    set pageRefreshDebouncePeriod(value) {
        this.refresh = $ee40788d37d3b5ae$var$debounce(this.debouncedRefresh.bind(this), value);
        this.#pageRefreshDebouncePeriod = value;
    }
    // Preloader delegate
    shouldPreloadLink(element) {
        const isUnsafe = element.hasAttribute("data-turbo-method");
        const isStream = element.hasAttribute("data-turbo-stream");
        const frameTarget = element.getAttribute("data-turbo-frame");
        const frame = frameTarget == "_top" ? null : document.getElementById(frameTarget) || $ee40788d37d3b5ae$var$findClosestRecursively(element, "turbo-frame:not([disabled])");
        if (isUnsafe || isStream || frame instanceof $ee40788d37d3b5ae$export$f464a8f0ffa32c44) return false;
        else {
            const location1 = new URL(element.href);
            return this.elementIsNavigatable(element) && $ee40788d37d3b5ae$var$locationIsVisitable(location1, this.snapshot.rootLocation);
        }
    }
    // History delegate
    historyPoppedToLocationWithRestorationIdentifierAndDirection(location1, restorationIdentifier, direction) {
        if (this.enabled) this.navigator.startVisit(location1, restorationIdentifier, {
            action: "restore",
            historyChanged: true,
            direction: direction
        });
        else this.adapter.pageInvalidated({
            reason: "turbo_disabled"
        });
    }
    // Scroll observer delegate
    scrollPositionChanged(position) {
        this.history.updateRestorationData({
            scrollPosition: position
        });
    }
    // Form click observer delegate
    willSubmitFormLinkToLocation(link, location1) {
        return this.elementIsNavigatable(link) && $ee40788d37d3b5ae$var$locationIsVisitable(location1, this.snapshot.rootLocation);
    }
    submittedFormLinkToLocation() {}
    // Link hover observer delegate
    canPrefetchRequestToLocation(link, location1) {
        return this.elementIsNavigatable(link) && $ee40788d37d3b5ae$var$locationIsVisitable(location1, this.snapshot.rootLocation) && this.navigator.linkPrefetchingIsEnabledForLocation(location1);
    }
    // Link click observer delegate
    willFollowLinkToLocation(link, location1, event) {
        return this.elementIsNavigatable(link) && $ee40788d37d3b5ae$var$locationIsVisitable(location1, this.snapshot.rootLocation) && this.applicationAllowsFollowingLinkToLocation(link, location1, event);
    }
    followedLinkToLocation(link, location1) {
        const action = this.getActionForLink(link);
        const acceptsStreamResponse = link.hasAttribute("data-turbo-stream");
        this.visit(location1.href, {
            action: action,
            acceptsStreamResponse: acceptsStreamResponse
        });
    }
    // Navigator delegate
    allowsVisitingLocationWithAction(location1, action) {
        return this.locationWithActionIsSamePage(location1, action) || this.applicationAllowsVisitingLocation(location1);
    }
    visitProposedToLocation(location1, options) {
        $ee40788d37d3b5ae$var$extendURLWithDeprecatedProperties(location1);
        this.adapter.visitProposedToLocation(location1, options);
    }
    // Visit delegate
    visitStarted(visit) {
        if (!visit.acceptsStreamResponse) {
            $ee40788d37d3b5ae$var$markAsBusy(document.documentElement);
            this.view.markVisitDirection(visit.direction);
        }
        $ee40788d37d3b5ae$var$extendURLWithDeprecatedProperties(visit.location);
        if (!visit.silent) this.notifyApplicationAfterVisitingLocation(visit.location, visit.action);
    }
    visitCompleted(visit) {
        this.view.unmarkVisitDirection();
        $ee40788d37d3b5ae$var$clearBusyState(document.documentElement);
        this.notifyApplicationAfterPageLoad(visit.getTimingMetrics());
    }
    locationWithActionIsSamePage(location1, action) {
        return this.navigator.locationWithActionIsSamePage(location1, action);
    }
    visitScrolledToSamePageLocation(oldURL, newURL) {
        this.notifyApplicationAfterVisitingSamePageLocation(oldURL, newURL);
    }
    // Form submit observer delegate
    willSubmitForm(form, submitter) {
        const action = $ee40788d37d3b5ae$var$getAction$1(form, submitter);
        return this.submissionIsNavigatable(form, submitter) && $ee40788d37d3b5ae$var$locationIsVisitable($ee40788d37d3b5ae$var$expandURL(action), this.snapshot.rootLocation);
    }
    formSubmitted(form, submitter) {
        this.navigator.submitForm(form, submitter);
    }
    // Page observer delegate
    pageBecameInteractive() {
        this.view.lastRenderedLocation = this.location;
        this.notifyApplicationAfterPageLoad();
    }
    pageLoaded() {
        this.history.assumeControlOfScrollRestoration();
    }
    pageWillUnload() {
        this.history.relinquishControlOfScrollRestoration();
    }
    // Stream observer delegate
    receivedMessageFromStream(message) {
        this.renderStreamMessage(message);
    }
    // Page view delegate
    viewWillCacheSnapshot() {
        if (!this.navigator.currentVisit?.silent) this.notifyApplicationBeforeCachingSnapshot();
    }
    allowsImmediateRender({ element: element }, options) {
        const event = this.notifyApplicationBeforeRender(element, options);
        const { defaultPrevented: defaultPrevented, detail: { render: render } } = event;
        if (this.view.renderer && render) this.view.renderer.renderElement = render;
        return !defaultPrevented;
    }
    viewRenderedSnapshot(_snapshot, _isPreview, renderMethod) {
        this.view.lastRenderedLocation = this.history.location;
        this.notifyApplicationAfterRender(renderMethod);
    }
    preloadOnLoadLinksForView(element) {
        this.preloader.preloadOnLoadLinksForView(element);
    }
    viewInvalidated(reason) {
        this.adapter.pageInvalidated(reason);
    }
    // Frame element
    frameLoaded(frame) {
        this.notifyApplicationAfterFrameLoad(frame);
    }
    frameRendered(fetchResponse, frame) {
        this.notifyApplicationAfterFrameRender(fetchResponse, frame);
    }
    // Application events
    applicationAllowsFollowingLinkToLocation(link, location1, ev) {
        const event = this.notifyApplicationAfterClickingLinkToLocation(link, location1, ev);
        return !event.defaultPrevented;
    }
    applicationAllowsVisitingLocation(location1) {
        const event = this.notifyApplicationBeforeVisitingLocation(location1);
        return !event.defaultPrevented;
    }
    notifyApplicationAfterClickingLinkToLocation(link, location1, event) {
        return $ee40788d37d3b5ae$var$dispatch("turbo:click", {
            target: link,
            detail: {
                url: location1.href,
                originalEvent: event
            },
            cancelable: true
        });
    }
    notifyApplicationBeforeVisitingLocation(location1) {
        return $ee40788d37d3b5ae$var$dispatch("turbo:before-visit", {
            detail: {
                url: location1.href
            },
            cancelable: true
        });
    }
    notifyApplicationAfterVisitingLocation(location1, action) {
        return $ee40788d37d3b5ae$var$dispatch("turbo:visit", {
            detail: {
                url: location1.href,
                action: action
            }
        });
    }
    notifyApplicationBeforeCachingSnapshot() {
        return $ee40788d37d3b5ae$var$dispatch("turbo:before-cache");
    }
    notifyApplicationBeforeRender(newBody, options) {
        return $ee40788d37d3b5ae$var$dispatch("turbo:before-render", {
            detail: {
                newBody: newBody,
                ...options
            },
            cancelable: true
        });
    }
    notifyApplicationAfterRender(renderMethod) {
        return $ee40788d37d3b5ae$var$dispatch("turbo:render", {
            detail: {
                renderMethod: renderMethod
            }
        });
    }
    notifyApplicationAfterPageLoad(timing = {}) {
        return $ee40788d37d3b5ae$var$dispatch("turbo:load", {
            detail: {
                url: this.location.href,
                timing: timing
            }
        });
    }
    notifyApplicationAfterVisitingSamePageLocation(oldURL, newURL) {
        dispatchEvent(new HashChangeEvent("hashchange", {
            oldURL: oldURL.toString(),
            newURL: newURL.toString()
        }));
    }
    notifyApplicationAfterFrameLoad(frame) {
        return $ee40788d37d3b5ae$var$dispatch("turbo:frame-load", {
            target: frame
        });
    }
    notifyApplicationAfterFrameRender(fetchResponse, frame) {
        return $ee40788d37d3b5ae$var$dispatch("turbo:frame-render", {
            detail: {
                fetchResponse: fetchResponse
            },
            target: frame,
            cancelable: true
        });
    }
    // Helpers
    submissionIsNavigatable(form, submitter) {
        if ($ee40788d37d3b5ae$export$e506a1d27d1eaa20.forms.mode == "off") return false;
        else {
            const submitterIsNavigatable = submitter ? this.elementIsNavigatable(submitter) : true;
            if ($ee40788d37d3b5ae$export$e506a1d27d1eaa20.forms.mode == "optin") return submitterIsNavigatable && form.closest('[data-turbo="true"]') != null;
            else return submitterIsNavigatable && this.elementIsNavigatable(form);
        }
    }
    elementIsNavigatable(element) {
        const container = $ee40788d37d3b5ae$var$findClosestRecursively(element, "[data-turbo]");
        const withinFrame = $ee40788d37d3b5ae$var$findClosestRecursively(element, "turbo-frame");
        // Check if Drive is enabled on the session or we're within a Frame.
        if ($ee40788d37d3b5ae$export$e506a1d27d1eaa20.drive.enabled || withinFrame) {
            // Element is navigatable by default, unless `data-turbo="false"`.
            if (container) return container.getAttribute("data-turbo") != "false";
            else return true;
        } else {
            // Element isn't navigatable by default, unless `data-turbo="true"`.
            if (container) return container.getAttribute("data-turbo") == "true";
            else return false;
        }
    }
    // Private
    getActionForLink(link) {
        return $ee40788d37d3b5ae$var$getVisitAction(link) || "advance";
    }
    get snapshot() {
        return this.view.snapshot;
    }
}
// Older versions of the Turbo Native adapters referenced the
// `Location#absoluteURL` property in their implementations of
// the `Adapter#visitProposedToLocation()` and `#visitStarted()`
// methods. The Location class has since been removed in favor
// of the DOM URL API, and accordingly all Adapter methods now
// receive URL objects.
//
// We alias #absoluteURL to #toString() here to avoid crashing
// older adapters which do not expect URL objects. We should
// consider removing this support at some point in the future.
function $ee40788d37d3b5ae$var$extendURLWithDeprecatedProperties(url) {
    Object.defineProperties(url, $ee40788d37d3b5ae$var$deprecatedLocationPropertyDescriptors);
}
const $ee40788d37d3b5ae$var$deprecatedLocationPropertyDescriptors = {
    absoluteURL: {
        get () {
            return this.toString();
        }
    }
};
const $ee40788d37d3b5ae$export$55427e926be628d4 = new $ee40788d37d3b5ae$var$Session($ee40788d37d3b5ae$var$recentRequests);
const { cache: $ee40788d37d3b5ae$export$69a3209f1a06c04d, navigator: $ee40788d37d3b5ae$export$ec7c8efa7f5790ae } = $ee40788d37d3b5ae$export$55427e926be628d4;
/**
 * Starts the main session.
 * This initialises any necessary observers such as those to monitor
 * link interactions.
 */ function $ee40788d37d3b5ae$export$b3571188c770cc5a() {
    $ee40788d37d3b5ae$export$55427e926be628d4.start();
}
/**
 * Registers an adapter for the main session.
 *
 * @param adapter Adapter to register
 */ function $ee40788d37d3b5ae$export$ddf4d3602a252674(adapter) {
    $ee40788d37d3b5ae$export$55427e926be628d4.registerAdapter(adapter);
}
/**
 * Performs an application visit to the given location.
 *
 * @param location Location to visit (a URL or path)
 * @param options Options to apply
 * @param options.action Type of history navigation to apply ("restore",
 * "replace" or "advance")
 * @param options.historyChanged Specifies whether the browser history has
 * already been changed for this visit or not
 * @param options.referrer Specifies the referrer of this visit such that
 * navigations to the same page will not result in a new history entry.
 * @param options.snapshotHTML Cached snapshot to render
 * @param options.response Response of the specified location
 */ function $ee40788d37d3b5ae$export$bf638b60ea8b89b7(location1, options) {
    $ee40788d37d3b5ae$export$55427e926be628d4.visit(location1, options);
}
/**
 * Connects a stream source to the main session.
 *
 * @param source Stream source to connect
 */ function $ee40788d37d3b5ae$export$83667c2845c80463(source) {
    $ee40788d37d3b5ae$export$55427e926be628d4.connectStreamSource(source);
}
/**
 * Disconnects a stream source from the main session.
 *
 * @param source Stream source to disconnect
 */ function $ee40788d37d3b5ae$export$26c56c74e3b67c59(source) {
    $ee40788d37d3b5ae$export$55427e926be628d4.disconnectStreamSource(source);
}
/**
 * Renders a stream message to the main session by appending it to the
 * current document.
 *
 * @param message Message to render
 */ function $ee40788d37d3b5ae$export$ebdee272e46e11d9(message) {
    $ee40788d37d3b5ae$export$55427e926be628d4.renderStreamMessage(message);
}
/**
 * Removes all entries from the Turbo Drive page cache.
 * Call this when state has changed on the server that may affect cached pages.
 *
 * @deprecated since version 7.2.0 in favor of `Turbo.cache.clear()`
 */ function $ee40788d37d3b5ae$export$d2adf65b87e47523() {
    console.warn("Please replace `Turbo.clearCache()` with `Turbo.cache.clear()`. The top-level function is deprecated and will be removed in a future version of Turbo.`");
    $ee40788d37d3b5ae$export$55427e926be628d4.clearCache();
}
/**
 * Sets the delay after which the progress bar will appear during navigation.
 *
 * The progress bar appears after 500ms by default.
 *
 * Note that this method has no effect when used with the iOS or Android
 * adapters.
 *
 * @param delay Time to delay in milliseconds
 */ function $ee40788d37d3b5ae$export$ddcc6947144c476c(delay) {
    console.warn("Please replace `Turbo.setProgressBarDelay(delay)` with `Turbo.config.drive.progressBarDelay = delay`. The top-level function is deprecated and will be removed in a future version of Turbo.`");
    $ee40788d37d3b5ae$export$e506a1d27d1eaa20.drive.progressBarDelay = delay;
}
function $ee40788d37d3b5ae$export$4696f1315e6aae7c(confirmMethod) {
    console.warn("Please replace `Turbo.setConfirmMethod(confirmMethod)` with `Turbo.config.forms.confirm = confirmMethod`. The top-level function is deprecated and will be removed in a future version of Turbo.`");
    $ee40788d37d3b5ae$export$e506a1d27d1eaa20.forms.confirm = confirmMethod;
}
function $ee40788d37d3b5ae$export$a94cfbb71d90abbd(mode) {
    console.warn("Please replace `Turbo.setFormMode(mode)` with `Turbo.config.forms.mode = mode`. The top-level function is deprecated and will be removed in a future version of Turbo.`");
    $ee40788d37d3b5ae$export$e506a1d27d1eaa20.forms.mode = mode;
}
/**
 * Morph the state of the currentBody based on the attributes and contents of
 * the newBody. Morphing body elements may dispatch turbo:morph,
 * turbo:before-morph-element, turbo:before-morph-attribute, and
 * turbo:morph-element events.
 *
 * @param currentBody HTMLBodyElement destination of morphing changes
 * @param newBody HTMLBodyElement source of morphing changes
 */ function $ee40788d37d3b5ae$export$3692fe532534b56a(currentBody, newBody) {
    $ee40788d37d3b5ae$var$MorphingPageRenderer.renderElement(currentBody, newBody);
}
/**
 * Morph the child elements of the currentFrame based on the child elements of
 * the newFrame. Morphing turbo-frame elements may dispatch turbo:before-frame-morph,
 * turbo:before-morph-element, turbo:before-morph-attribute, and
 * turbo:morph-element events.
 *
 * @param currentFrame FrameElement destination of morphing children changes
 * @param newFrame FrameElement source of morphing children changes
 */ function $ee40788d37d3b5ae$export$e23c491af5621dca(currentFrame, newFrame) {
    $ee40788d37d3b5ae$var$MorphingFrameRenderer.renderElement(currentFrame, newFrame);
}
var $ee40788d37d3b5ae$var$Turbo = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    navigator: $ee40788d37d3b5ae$export$ec7c8efa7f5790ae,
    session: $ee40788d37d3b5ae$export$55427e926be628d4,
    cache: $ee40788d37d3b5ae$export$69a3209f1a06c04d,
    PageRenderer: $ee40788d37d3b5ae$export$ac9642242cf7b3ce,
    PageSnapshot: $ee40788d37d3b5ae$export$4f11b95e473fd113,
    FrameRenderer: $ee40788d37d3b5ae$export$f09c4165d16bb2b7,
    fetch: $ee40788d37d3b5ae$export$e7aa7bc5c1b3cfb3,
    config: $ee40788d37d3b5ae$export$e506a1d27d1eaa20,
    start: $ee40788d37d3b5ae$export$b3571188c770cc5a,
    registerAdapter: $ee40788d37d3b5ae$export$ddf4d3602a252674,
    visit: $ee40788d37d3b5ae$export$bf638b60ea8b89b7,
    connectStreamSource: $ee40788d37d3b5ae$export$83667c2845c80463,
    disconnectStreamSource: $ee40788d37d3b5ae$export$26c56c74e3b67c59,
    renderStreamMessage: $ee40788d37d3b5ae$export$ebdee272e46e11d9,
    clearCache: $ee40788d37d3b5ae$export$d2adf65b87e47523,
    setProgressBarDelay: $ee40788d37d3b5ae$export$ddcc6947144c476c,
    setConfirmMethod: $ee40788d37d3b5ae$export$4696f1315e6aae7c,
    setFormMode: $ee40788d37d3b5ae$export$a94cfbb71d90abbd,
    morphBodyElements: $ee40788d37d3b5ae$export$3692fe532534b56a,
    morphTurboFrameElements: $ee40788d37d3b5ae$export$e23c491af5621dca,
    morphChildren: $ee40788d37d3b5ae$export$e0eeaf5bc84bd47b,
    morphElements: $ee40788d37d3b5ae$export$dc74801294c91b10
});
class $ee40788d37d3b5ae$var$TurboFrameMissingError extends Error {
}
class $ee40788d37d3b5ae$var$FrameController {
    fetchResponseLoaded = (_fetchResponse)=>Promise.resolve();
    #currentFetchRequest = null;
    #resolveVisitPromise = ()=>{};
    #connected = false;
    #hasBeenLoaded = false;
    #ignoredAttributes = new Set();
    #shouldMorphFrame = false;
    action = null;
    constructor(element){
        this.element = element;
        this.view = new $ee40788d37d3b5ae$var$FrameView(this, this.element);
        this.appearanceObserver = new $ee40788d37d3b5ae$var$AppearanceObserver(this, this.element);
        this.formLinkClickObserver = new $ee40788d37d3b5ae$var$FormLinkClickObserver(this, this.element);
        this.linkInterceptor = new $ee40788d37d3b5ae$var$LinkInterceptor(this, this.element);
        this.restorationIdentifier = $ee40788d37d3b5ae$var$uuid();
        this.formSubmitObserver = new $ee40788d37d3b5ae$var$FormSubmitObserver(this, this.element);
    }
    // Frame delegate
    connect() {
        if (!this.#connected) {
            this.#connected = true;
            if (this.loadingStyle == $ee40788d37d3b5ae$export$65f98fefe20dbcb6.lazy) this.appearanceObserver.start();
            else this.#loadSourceURL();
            this.formLinkClickObserver.start();
            this.linkInterceptor.start();
            this.formSubmitObserver.start();
        }
    }
    disconnect() {
        if (this.#connected) {
            this.#connected = false;
            this.appearanceObserver.stop();
            this.formLinkClickObserver.stop();
            this.linkInterceptor.stop();
            this.formSubmitObserver.stop();
        }
    }
    disabledChanged() {
        if (this.loadingStyle == $ee40788d37d3b5ae$export$65f98fefe20dbcb6.eager) this.#loadSourceURL();
    }
    sourceURLChanged() {
        if (this.#isIgnoringChangesTo("src")) return;
        if (this.element.isConnected) this.complete = false;
        if (this.loadingStyle == $ee40788d37d3b5ae$export$65f98fefe20dbcb6.eager || this.#hasBeenLoaded) this.#loadSourceURL();
    }
    sourceURLReloaded() {
        const { refresh: refresh, src: src } = this.element;
        this.#shouldMorphFrame = src && refresh === "morph";
        this.element.removeAttribute("complete");
        this.element.src = null;
        this.element.src = src;
        return this.element.loaded;
    }
    loadingStyleChanged() {
        if (this.loadingStyle == $ee40788d37d3b5ae$export$65f98fefe20dbcb6.lazy) this.appearanceObserver.start();
        else {
            this.appearanceObserver.stop();
            this.#loadSourceURL();
        }
    }
    async #loadSourceURL() {
        if (this.enabled && this.isActive && !this.complete && this.sourceURL) {
            this.element.loaded = this.#visit($ee40788d37d3b5ae$var$expandURL(this.sourceURL));
            this.appearanceObserver.stop();
            await this.element.loaded;
            this.#hasBeenLoaded = true;
        }
    }
    async loadResponse(fetchResponse) {
        if (fetchResponse.redirected || fetchResponse.succeeded && fetchResponse.isHTML) this.sourceURL = fetchResponse.response.url;
        try {
            const html = await fetchResponse.responseHTML;
            if (html) {
                const document1 = $ee40788d37d3b5ae$var$parseHTMLDocument(html);
                const pageSnapshot = $ee40788d37d3b5ae$export$4f11b95e473fd113.fromDocument(document1);
                if (pageSnapshot.isVisitable) await this.#loadFrameResponse(fetchResponse, document1);
                else await this.#handleUnvisitableFrameResponse(fetchResponse);
            }
        } finally{
            this.#shouldMorphFrame = false;
            this.fetchResponseLoaded = ()=>Promise.resolve();
        }
    }
    // Appearance observer delegate
    elementAppearedInViewport(element) {
        this.proposeVisitIfNavigatedWithAction(element, $ee40788d37d3b5ae$var$getVisitAction(element));
        this.#loadSourceURL();
    }
    // Form link click observer delegate
    willSubmitFormLinkToLocation(link) {
        return this.#shouldInterceptNavigation(link);
    }
    submittedFormLinkToLocation(link, _location, form) {
        const frame = this.#findFrameElement(link);
        if (frame) form.setAttribute("data-turbo-frame", frame.id);
    }
    // Link interceptor delegate
    shouldInterceptLinkClick(element, _location, _event) {
        return this.#shouldInterceptNavigation(element);
    }
    linkClickIntercepted(element, location1) {
        this.#navigateFrame(element, location1);
    }
    // Form submit observer delegate
    willSubmitForm(element, submitter) {
        return element.closest("turbo-frame") == this.element && this.#shouldInterceptNavigation(element, submitter);
    }
    formSubmitted(element, submitter) {
        if (this.formSubmission) this.formSubmission.stop();
        this.formSubmission = new $ee40788d37d3b5ae$var$FormSubmission(this, element, submitter);
        const { fetchRequest: fetchRequest } = this.formSubmission;
        this.prepareRequest(fetchRequest);
        this.formSubmission.start();
    }
    // Fetch request delegate
    prepareRequest(request) {
        request.headers["Turbo-Frame"] = this.id;
        if (this.currentNavigationElement?.hasAttribute("data-turbo-stream")) request.acceptResponseType($ee40788d37d3b5ae$var$StreamMessage.contentType);
    }
    requestStarted(_request) {
        $ee40788d37d3b5ae$var$markAsBusy(this.element);
    }
    requestPreventedHandlingResponse(_request, _response) {
        this.#resolveVisitPromise();
    }
    async requestSucceededWithResponse(request, response) {
        await this.loadResponse(response);
        this.#resolveVisitPromise();
    }
    async requestFailedWithResponse(request, response) {
        await this.loadResponse(response);
        this.#resolveVisitPromise();
    }
    requestErrored(request, error) {
        console.error(error);
        this.#resolveVisitPromise();
    }
    requestFinished(_request) {
        $ee40788d37d3b5ae$var$clearBusyState(this.element);
    }
    // Form submission delegate
    formSubmissionStarted({ formElement: formElement }) {
        $ee40788d37d3b5ae$var$markAsBusy(formElement, this.#findFrameElement(formElement));
    }
    formSubmissionSucceededWithResponse(formSubmission, response) {
        const frame = this.#findFrameElement(formSubmission.formElement, formSubmission.submitter);
        frame.delegate.proposeVisitIfNavigatedWithAction(frame, $ee40788d37d3b5ae$var$getVisitAction(formSubmission.submitter, formSubmission.formElement, frame));
        frame.delegate.loadResponse(response);
        if (!formSubmission.isSafe) $ee40788d37d3b5ae$export$55427e926be628d4.clearCache();
    }
    formSubmissionFailedWithResponse(formSubmission, fetchResponse) {
        this.element.delegate.loadResponse(fetchResponse);
        $ee40788d37d3b5ae$export$55427e926be628d4.clearCache();
    }
    formSubmissionErrored(formSubmission, error) {
        console.error(error);
    }
    formSubmissionFinished({ formElement: formElement }) {
        $ee40788d37d3b5ae$var$clearBusyState(formElement, this.#findFrameElement(formElement));
    }
    // View delegate
    allowsImmediateRender({ element: newFrame }, options) {
        const event = $ee40788d37d3b5ae$var$dispatch("turbo:before-frame-render", {
            target: this.element,
            detail: {
                newFrame: newFrame,
                ...options
            },
            cancelable: true
        });
        const { defaultPrevented: defaultPrevented, detail: { render: render } } = event;
        if (this.view.renderer && render) this.view.renderer.renderElement = render;
        return !defaultPrevented;
    }
    viewRenderedSnapshot(_snapshot, _isPreview, _renderMethod) {}
    preloadOnLoadLinksForView(element) {
        $ee40788d37d3b5ae$export$55427e926be628d4.preloadOnLoadLinksForView(element);
    }
    viewInvalidated() {}
    // Frame renderer delegate
    willRenderFrame(currentElement, _newElement) {
        this.previousFrameElement = currentElement.cloneNode(true);
    }
    visitCachedSnapshot = ({ element: element })=>{
        const frame = element.querySelector("#" + this.element.id);
        if (frame && this.previousFrameElement) frame.replaceChildren(...this.previousFrameElement.children);
        delete this.previousFrameElement;
    };
    // Private
    async #loadFrameResponse(fetchResponse, document1) {
        const newFrameElement = await this.extractForeignFrameElement(document1.body);
        const rendererClass = this.#shouldMorphFrame ? $ee40788d37d3b5ae$var$MorphingFrameRenderer : $ee40788d37d3b5ae$export$f09c4165d16bb2b7;
        if (newFrameElement) {
            const snapshot = new $ee40788d37d3b5ae$var$Snapshot(newFrameElement);
            const renderer = new rendererClass(this, this.view.snapshot, snapshot, false, false);
            if (this.view.renderPromise) await this.view.renderPromise;
            this.changeHistory();
            await this.view.render(renderer);
            this.complete = true;
            $ee40788d37d3b5ae$export$55427e926be628d4.frameRendered(fetchResponse, this.element);
            $ee40788d37d3b5ae$export$55427e926be628d4.frameLoaded(this.element);
            await this.fetchResponseLoaded(fetchResponse);
        } else if (this.#willHandleFrameMissingFromResponse(fetchResponse)) this.#handleFrameMissingFromResponse(fetchResponse);
    }
    async #visit(url) {
        const request = new $ee40788d37d3b5ae$export$319b96fe59834522(this, $ee40788d37d3b5ae$export$76f6869e29ff06ee.get, url, new URLSearchParams(), this.element);
        this.#currentFetchRequest?.cancel();
        this.#currentFetchRequest = request;
        return new Promise((resolve)=>{
            this.#resolveVisitPromise = ()=>{
                this.#resolveVisitPromise = ()=>{};
                this.#currentFetchRequest = null;
                resolve();
            };
            request.perform();
        });
    }
    #navigateFrame(element, url, submitter) {
        const frame = this.#findFrameElement(element, submitter);
        frame.delegate.proposeVisitIfNavigatedWithAction(frame, $ee40788d37d3b5ae$var$getVisitAction(submitter, element, frame));
        this.#withCurrentNavigationElement(element, ()=>{
            frame.src = url;
        });
    }
    proposeVisitIfNavigatedWithAction(frame, action = null) {
        this.action = action;
        if (this.action) {
            const pageSnapshot = $ee40788d37d3b5ae$export$4f11b95e473fd113.fromElement(frame).clone();
            const { visitCachedSnapshot: visitCachedSnapshot } = frame.delegate;
            frame.delegate.fetchResponseLoaded = async (fetchResponse)=>{
                if (frame.src) {
                    const { statusCode: statusCode, redirected: redirected } = fetchResponse;
                    const responseHTML = await fetchResponse.responseHTML;
                    const response = {
                        statusCode: statusCode,
                        redirected: redirected,
                        responseHTML: responseHTML
                    };
                    const options = {
                        response: response,
                        visitCachedSnapshot: visitCachedSnapshot,
                        willRender: false,
                        updateHistory: false,
                        restorationIdentifier: this.restorationIdentifier,
                        snapshot: pageSnapshot
                    };
                    if (this.action) options.action = this.action;
                    $ee40788d37d3b5ae$export$55427e926be628d4.visit(frame.src, options);
                }
            };
        }
    }
    changeHistory() {
        if (this.action) {
            const method = $ee40788d37d3b5ae$var$getHistoryMethodForAction(this.action);
            $ee40788d37d3b5ae$export$55427e926be628d4.history.update(method, $ee40788d37d3b5ae$var$expandURL(this.element.src || ""), this.restorationIdentifier);
        }
    }
    async #handleUnvisitableFrameResponse(fetchResponse) {
        console.warn(`The response (${fetchResponse.statusCode}) from <turbo-frame id="${this.element.id}"> is performing a full page visit due to turbo-visit-control.`);
        await this.#visitResponse(fetchResponse.response);
    }
    #willHandleFrameMissingFromResponse(fetchResponse) {
        this.element.setAttribute("complete", "");
        const response = fetchResponse.response;
        const visit = async (url, options)=>{
            if (url instanceof Response) this.#visitResponse(url);
            else $ee40788d37d3b5ae$export$55427e926be628d4.visit(url, options);
        };
        const event = $ee40788d37d3b5ae$var$dispatch("turbo:frame-missing", {
            target: this.element,
            detail: {
                response: response,
                visit: visit
            },
            cancelable: true
        });
        return !event.defaultPrevented;
    }
    #handleFrameMissingFromResponse(fetchResponse) {
        this.view.missing();
        this.#throwFrameMissingError(fetchResponse);
    }
    #throwFrameMissingError(fetchResponse) {
        const message = `The response (${fetchResponse.statusCode}) did not contain the expected <turbo-frame id="${this.element.id}"> and will be ignored. To perform a full page visit instead, set turbo-visit-control to reload.`;
        throw new $ee40788d37d3b5ae$var$TurboFrameMissingError(message);
    }
    async #visitResponse(response) {
        const wrapped = new $ee40788d37d3b5ae$export$3ae09bba5b6b906e(response);
        const responseHTML = await wrapped.responseHTML;
        const { location: location1, redirected: redirected, statusCode: statusCode } = wrapped;
        return $ee40788d37d3b5ae$export$55427e926be628d4.visit(location1, {
            response: {
                redirected: redirected,
                statusCode: statusCode,
                responseHTML: responseHTML
            }
        });
    }
    #findFrameElement(element, submitter) {
        const id = $ee40788d37d3b5ae$var$getAttribute("data-turbo-frame", submitter, element) || this.element.getAttribute("target");
        return $ee40788d37d3b5ae$var$getFrameElementById(id) ?? this.element;
    }
    async extractForeignFrameElement(container) {
        let element;
        const id = CSS.escape(this.id);
        try {
            element = $ee40788d37d3b5ae$var$activateElement(container.querySelector(`turbo-frame#${id}`), this.sourceURL);
            if (element) return element;
            element = $ee40788d37d3b5ae$var$activateElement(container.querySelector(`turbo-frame[src][recurse~=${id}]`), this.sourceURL);
            if (element) {
                await element.loaded;
                return await this.extractForeignFrameElement(element);
            }
        } catch (error) {
            console.error(error);
            return new $ee40788d37d3b5ae$export$f464a8f0ffa32c44();
        }
        return null;
    }
    #formActionIsVisitable(form, submitter) {
        const action = $ee40788d37d3b5ae$var$getAction$1(form, submitter);
        return $ee40788d37d3b5ae$var$locationIsVisitable($ee40788d37d3b5ae$var$expandURL(action), this.rootLocation);
    }
    #shouldInterceptNavigation(element, submitter) {
        const id = $ee40788d37d3b5ae$var$getAttribute("data-turbo-frame", submitter, element) || this.element.getAttribute("target");
        if (element instanceof HTMLFormElement && !this.#formActionIsVisitable(element, submitter)) return false;
        if (!this.enabled || id == "_top") return false;
        if (id) {
            const frameElement = $ee40788d37d3b5ae$var$getFrameElementById(id);
            if (frameElement) return !frameElement.disabled;
        }
        if (!$ee40788d37d3b5ae$export$55427e926be628d4.elementIsNavigatable(element)) return false;
        if (submitter && !$ee40788d37d3b5ae$export$55427e926be628d4.elementIsNavigatable(submitter)) return false;
        return true;
    }
    // Computed properties
    get id() {
        return this.element.id;
    }
    get enabled() {
        return !this.element.disabled;
    }
    get sourceURL() {
        if (this.element.src) return this.element.src;
    }
    set sourceURL(sourceURL) {
        this.#ignoringChangesToAttribute("src", ()=>{
            this.element.src = sourceURL ?? null;
        });
    }
    get loadingStyle() {
        return this.element.loading;
    }
    get isLoading() {
        return this.formSubmission !== undefined || this.#resolveVisitPromise() !== undefined;
    }
    get complete() {
        return this.element.hasAttribute("complete");
    }
    set complete(value) {
        if (value) this.element.setAttribute("complete", "");
        else this.element.removeAttribute("complete");
    }
    get isActive() {
        return this.element.isActive && this.#connected;
    }
    get rootLocation() {
        const meta = this.element.ownerDocument.querySelector(`meta[name="turbo-root"]`);
        const root = meta?.content ?? "/";
        return $ee40788d37d3b5ae$var$expandURL(root);
    }
    #isIgnoringChangesTo(attributeName) {
        return this.#ignoredAttributes.has(attributeName);
    }
    #ignoringChangesToAttribute(attributeName, callback) {
        this.#ignoredAttributes.add(attributeName);
        callback();
        this.#ignoredAttributes.delete(attributeName);
    }
    #withCurrentNavigationElement(element, callback) {
        this.currentNavigationElement = element;
        callback();
        delete this.currentNavigationElement;
    }
}
function $ee40788d37d3b5ae$var$getFrameElementById(id) {
    if (id != null) {
        const element = document.getElementById(id);
        if (element instanceof $ee40788d37d3b5ae$export$f464a8f0ffa32c44) return element;
    }
}
function $ee40788d37d3b5ae$var$activateElement(element, currentURL) {
    if (element) {
        const src = element.getAttribute("src");
        if (src != null && currentURL != null && $ee40788d37d3b5ae$var$urlsAreEqual(src, currentURL)) throw new Error(`Matching <turbo-frame id="${element.id}"> element has a source URL which references itself`);
        if (element.ownerDocument !== document) element = document.importNode(element, true);
        if (element instanceof $ee40788d37d3b5ae$export$f464a8f0ffa32c44) {
            element.connectedCallback();
            element.disconnectedCallback();
            return element;
        }
    }
}
const $ee40788d37d3b5ae$export$1b814a67c3a57eeb = {
    after () {
        this.targetElements.forEach((e)=>e.parentElement?.insertBefore(this.templateContent, e.nextSibling));
    },
    append () {
        this.removeDuplicateTargetChildren();
        this.targetElements.forEach((e)=>e.append(this.templateContent));
    },
    before () {
        this.targetElements.forEach((e)=>e.parentElement?.insertBefore(this.templateContent, e));
    },
    prepend () {
        this.removeDuplicateTargetChildren();
        this.targetElements.forEach((e)=>e.prepend(this.templateContent));
    },
    remove () {
        this.targetElements.forEach((e)=>e.remove());
    },
    replace () {
        const method = this.getAttribute("method");
        this.targetElements.forEach((targetElement)=>{
            if (method === "morph") $ee40788d37d3b5ae$export$dc74801294c91b10(targetElement, this.templateContent);
            else targetElement.replaceWith(this.templateContent);
        });
    },
    update () {
        const method = this.getAttribute("method");
        this.targetElements.forEach((targetElement)=>{
            if (method === "morph") $ee40788d37d3b5ae$export$e0eeaf5bc84bd47b(targetElement, this.templateContent);
            else {
                targetElement.innerHTML = "";
                targetElement.append(this.templateContent);
            }
        });
    },
    refresh () {
        $ee40788d37d3b5ae$export$55427e926be628d4.refresh(this.baseURI, this.requestId);
    }
};
// <turbo-stream action=replace target=id><template>...
/**
 * Renders updates to the page from a stream of messages.
 *
 * Using the `action` attribute, this can be configured one of eight ways:
 *
 * - `after` - inserts the result after the target
 * - `append` - appends the result to the target
 * - `before` - inserts the result before the target
 * - `prepend` - prepends the result to the target
 * - `refresh` - initiates a page refresh
 * - `remove` - removes the target
 * - `replace` - replaces the outer HTML of the target
 * - `update` - replaces the inner HTML of the target
 *
 * @customElement turbo-stream
 * @example
 *   <turbo-stream action="append" target="dom_id">
 *     <template>
 *       Content to append to target designated with the dom_id.
 *     </template>
 *   </turbo-stream>
 */ class $ee40788d37d3b5ae$export$144d499d37929ea8 extends HTMLElement {
    static async renderElement(newElement) {
        await newElement.performAction();
    }
    async connectedCallback() {
        try {
            await this.render();
        } catch (error) {
            console.error(error);
        } finally{
            this.disconnect();
        }
    }
    async render() {
        return this.renderPromise ??= (async ()=>{
            const event = this.beforeRenderEvent;
            if (this.dispatchEvent(event)) {
                await $ee40788d37d3b5ae$var$nextRepaint();
                await event.detail.render(this);
            }
        })();
    }
    disconnect() {
        try {
            this.remove();
        // eslint-disable-next-line no-empty
        } catch  {}
    }
    /**
   * Removes duplicate children (by ID)
   */ removeDuplicateTargetChildren() {
        this.duplicateChildren.forEach((c)=>c.remove());
    }
    /**
   * Gets the list of duplicate children (i.e. those with the same ID)
   */ get duplicateChildren() {
        const existingChildren = this.targetElements.flatMap((e)=>[
                ...e.children
            ]).filter((c)=>!!c.getAttribute("id"));
        const newChildrenIds = [
            ...this.templateContent?.children || []
        ].filter((c)=>!!c.getAttribute("id")).map((c)=>c.getAttribute("id"));
        return existingChildren.filter((c)=>newChildrenIds.includes(c.getAttribute("id")));
    }
    /**
   * Gets the action function to be performed.
   */ get performAction() {
        if (this.action) {
            const actionFunction = $ee40788d37d3b5ae$export$1b814a67c3a57eeb[this.action];
            if (actionFunction) return actionFunction;
            this.#raise("unknown action");
        }
        this.#raise("action attribute is missing");
    }
    /**
   * Gets the target elements which the template will be rendered to.
   */ get targetElements() {
        if (this.target) return this.targetElementsById;
        else if (this.targets) return this.targetElementsByQuery;
        else this.#raise("target or targets attribute is missing");
    }
    /**
   * Gets the contents of the main `<template>`.
   */ get templateContent() {
        return this.templateElement.content.cloneNode(true);
    }
    /**
   * Gets the main `<template>` used for rendering
   */ get templateElement() {
        if (this.firstElementChild === null) {
            const template = this.ownerDocument.createElement("template");
            this.appendChild(template);
            return template;
        } else if (this.firstElementChild instanceof HTMLTemplateElement) return this.firstElementChild;
        this.#raise("first child element must be a <template> element");
    }
    /**
   * Gets the current action.
   */ get action() {
        return this.getAttribute("action");
    }
    /**
   * Gets the current target (an element ID) to which the result will
   * be rendered.
   */ get target() {
        return this.getAttribute("target");
    }
    /**
   * Gets the current "targets" selector (a CSS selector)
   */ get targets() {
        return this.getAttribute("targets");
    }
    /**
   * Reads the request-id attribute
   */ get requestId() {
        return this.getAttribute("request-id");
    }
    #raise(message) {
        throw new Error(`${this.description}: ${message}`);
    }
    get description() {
        return (this.outerHTML.match(/<[^>]+>/) ?? [])[0] ?? "<turbo-stream>";
    }
    get beforeRenderEvent() {
        return new CustomEvent("turbo:before-stream-render", {
            bubbles: true,
            cancelable: true,
            detail: {
                newStream: this,
                render: $ee40788d37d3b5ae$export$144d499d37929ea8.renderElement
            }
        });
    }
    get targetElementsById() {
        const element = this.ownerDocument?.getElementById(this.target);
        if (element !== null) return [
            element
        ];
        else return [];
    }
    get targetElementsByQuery() {
        const elements = this.ownerDocument?.querySelectorAll(this.targets);
        if (elements.length !== 0) return Array.prototype.slice.call(elements);
        else return [];
    }
}
class $ee40788d37d3b5ae$export$e87d51a4385a3903 extends HTMLElement {
    streamSource = null;
    connectedCallback() {
        this.streamSource = this.src.match(/^ws{1,2}:/) ? new WebSocket(this.src) : new EventSource(this.src);
        $ee40788d37d3b5ae$export$83667c2845c80463(this.streamSource);
    }
    disconnectedCallback() {
        if (this.streamSource) {
            this.streamSource.close();
            $ee40788d37d3b5ae$export$26c56c74e3b67c59(this.streamSource);
        }
    }
    get src() {
        return this.getAttribute("src") || "";
    }
}
$ee40788d37d3b5ae$export$f464a8f0ffa32c44.delegateConstructor = $ee40788d37d3b5ae$var$FrameController;
if (customElements.get("turbo-frame") === undefined) customElements.define("turbo-frame", $ee40788d37d3b5ae$export$f464a8f0ffa32c44);
if (customElements.get("turbo-stream") === undefined) customElements.define("turbo-stream", $ee40788d37d3b5ae$export$144d499d37929ea8);
if (customElements.get("turbo-stream-source") === undefined) customElements.define("turbo-stream-source", $ee40788d37d3b5ae$export$e87d51a4385a3903);
(()=>{
    let element = document.currentScript;
    if (!element) return;
    if (element.hasAttribute("data-turbo-suppress-warning")) return;
    element = element.parentElement;
    while(element){
        if (element == document.body) return console.warn($ee40788d37d3b5ae$var$unindent`
        You are loading Turbo from a <script> element inside the <body> element. This is probably not what you meant to do!

        Load your application’s JavaScript bundle inside the <head> element instead. <script> elements in <body> are evaluated with each page change.

        For more information, see: https://turbo.hotwired.dev/handbook/building#working-with-script-elements

        ——
        Suppress this warning by adding a "data-turbo-suppress-warning" attribute to: %s
      `, element.outerHTML);
        element = element.parentElement;
    }
})();
window.Turbo = {
    ...$ee40788d37d3b5ae$var$Turbo,
    StreamActions: $ee40788d37d3b5ae$export$1b814a67c3a57eeb
};
$ee40788d37d3b5ae$export$b3571188c770cc5a();


let $58af0ff6d7696cfb$var$consumer;
async function $58af0ff6d7696cfb$export$7c15b69060cece89() {
    return $58af0ff6d7696cfb$var$consumer || $58af0ff6d7696cfb$export$3b3dab8459a1e5c5($58af0ff6d7696cfb$export$799d131dbb74b992().then($58af0ff6d7696cfb$export$3b3dab8459a1e5c5));
}
function $58af0ff6d7696cfb$export$3b3dab8459a1e5c5(newConsumer) {
    return $58af0ff6d7696cfb$var$consumer = newConsumer;
}

async function $58af0ff6d7696cfb$export$799d131dbb74b992() {
    const { createConsumer: createConsumer } = await (parcelRequire("k3FSZ"));
    return createConsumer();
}
async function $58af0ff6d7696cfb$export$45e4095b0ba1d337(channel, mixin) {
    const { subscriptions: subscriptions } = await $58af0ff6d7696cfb$export$7c15b69060cece89();
    return subscriptions.create(channel, mixin);
}


// Based on https://github.com/nathan7/snakeize
//
// This software is released under the MIT license:
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
function $dd3fcccd6f562270$export$2e2bcd8739ae039(obj) {
    if (!obj || typeof obj !== 'object') return obj;
    if (obj instanceof Date || obj instanceof RegExp) return obj;
    if (Array.isArray(obj)) return obj.map($dd3fcccd6f562270$export$2e2bcd8739ae039);
    return Object.keys(obj).reduce(function(acc, key) {
        var camel = key[0].toLowerCase() + key.slice(1).replace(/([A-Z]+)/g, function(m, x) {
            return '_' + x.toLowerCase();
        });
        acc[camel] = $dd3fcccd6f562270$export$2e2bcd8739ae039(obj[key]);
        return acc;
    }, {});
}


class $6ecb842ff89ff51d$var$TurboCableStreamSourceElement extends HTMLElement {
    static observedAttributes = [
        "channel",
        "signed-stream-name"
    ];
    async connectedCallback() {
        (0, $ee40788d37d3b5ae$export$83667c2845c80463)(this);
        this.subscription = await (0, $58af0ff6d7696cfb$export$45e4095b0ba1d337)(this.channel, {
            received: this.dispatchMessageEvent.bind(this),
            connected: this.subscriptionConnected.bind(this),
            disconnected: this.subscriptionDisconnected.bind(this)
        });
    }
    disconnectedCallback() {
        (0, $ee40788d37d3b5ae$export$26c56c74e3b67c59)(this);
        if (this.subscription) this.subscription.unsubscribe();
        this.subscriptionDisconnected();
    }
    attributeChangedCallback() {
        if (this.subscription) {
            this.disconnectedCallback();
            this.connectedCallback();
        }
    }
    dispatchMessageEvent(data) {
        const event = new MessageEvent("message", {
            data: data
        });
        return this.dispatchEvent(event);
    }
    subscriptionConnected() {
        this.setAttribute("connected", "");
    }
    subscriptionDisconnected() {
        this.removeAttribute("connected");
    }
    get channel() {
        const channel = this.getAttribute("channel");
        const signed_stream_name = this.getAttribute("signed-stream-name");
        return {
            channel: channel,
            signed_stream_name: signed_stream_name,
            ...(0, $dd3fcccd6f562270$export$2e2bcd8739ae039)({
                ...this.dataset
            })
        };
    }
}
if (customElements.get("turbo-cable-stream-source") === undefined) customElements.define("turbo-cable-stream-source", $6ecb842ff89ff51d$var$TurboCableStreamSourceElement);




function $6ae1f87bf8cb4454$export$9aa7804f3d3e4be(event) {
    if (event.target instanceof HTMLFormElement) {
        const { target: form, detail: { fetchOptions: fetchOptions } } = event;
        form.addEventListener("turbo:submit-start", ({ detail: { formSubmission: { submitter: submitter } } })=>{
            const body = $6ae1f87bf8cb4454$var$isBodyInit(fetchOptions.body) ? fetchOptions.body : new URLSearchParams();
            const method = $6ae1f87bf8cb4454$var$determineFetchMethod(submitter, body, form);
            if (!/get/i.test(method)) {
                if (/post/i.test(method)) body.delete("_method");
                else body.set("_method", method);
                fetchOptions.method = "post";
            }
        }, {
            once: true
        });
    }
}
function $6ae1f87bf8cb4454$var$determineFetchMethod(submitter, body, form) {
    const formMethod = $6ae1f87bf8cb4454$var$determineFormMethod(submitter);
    const overrideMethod = body.get("_method");
    const method = form.getAttribute("method") || "get";
    if (typeof formMethod == "string") return formMethod;
    else if (typeof overrideMethod == "string") return overrideMethod;
    else return method;
}
function $6ae1f87bf8cb4454$var$determineFormMethod(submitter) {
    if (submitter instanceof HTMLButtonElement || submitter instanceof HTMLInputElement) {
        // Rails 7 ActionView::Helpers::FormBuilder#button method has an override
        // for formmethod if the button does not have name or value attributes
        // set, which is the default. This means that if you use <%= f.button
        // formmethod: :delete %>, it will generate a <button name="_method"
        // value="delete" formmethod="post">. Therefore, if the submitter's name
        // is already _method, it's value attribute already contains the desired
        // method.
        if (submitter.name === '_method') return submitter.value;
        else if (submitter.hasAttribute("formmethod")) return submitter.formMethod;
        else return null;
    } else return null;
}
function $6ae1f87bf8cb4454$var$isBodyInit(body) {
    return body instanceof FormData || body instanceof URLSearchParams;
}


window.Turbo = $ee40788d37d3b5ae$exports;
addEventListener("turbo:before-fetch-request", (0, $6ae1f87bf8cb4454$export$9aa7804f3d3e4be));


/*
Stimulus 3.2.1
Copyright © 2023 Basecamp, LLC
 */ class $c8b99022ff3c634f$var$EventListener {
    constructor(eventTarget, eventName, eventOptions){
        this.eventTarget = eventTarget;
        this.eventName = eventName;
        this.eventOptions = eventOptions;
        this.unorderedBindings = new Set();
    }
    connect() {
        this.eventTarget.addEventListener(this.eventName, this, this.eventOptions);
    }
    disconnect() {
        this.eventTarget.removeEventListener(this.eventName, this, this.eventOptions);
    }
    bindingConnected(binding) {
        this.unorderedBindings.add(binding);
    }
    bindingDisconnected(binding) {
        this.unorderedBindings.delete(binding);
    }
    handleEvent(event) {
        const extendedEvent = $c8b99022ff3c634f$var$extendEvent(event);
        for (const binding of this.bindings){
            if (extendedEvent.immediatePropagationStopped) break;
            else binding.handleEvent(extendedEvent);
        }
    }
    hasBindings() {
        return this.unorderedBindings.size > 0;
    }
    get bindings() {
        return Array.from(this.unorderedBindings).sort((left, right)=>{
            const leftIndex = left.index, rightIndex = right.index;
            return leftIndex < rightIndex ? -1 : leftIndex > rightIndex ? 1 : 0;
        });
    }
}
function $c8b99022ff3c634f$var$extendEvent(event) {
    if ("immediatePropagationStopped" in event) return event;
    else {
        const { stopImmediatePropagation: stopImmediatePropagation } = event;
        return Object.assign(event, {
            immediatePropagationStopped: false,
            stopImmediatePropagation () {
                this.immediatePropagationStopped = true;
                stopImmediatePropagation.call(this);
            }
        });
    }
}
class $c8b99022ff3c634f$var$Dispatcher {
    constructor(application){
        this.application = application;
        this.eventListenerMaps = new Map();
        this.started = false;
    }
    start() {
        if (!this.started) {
            this.started = true;
            this.eventListeners.forEach((eventListener)=>eventListener.connect());
        }
    }
    stop() {
        if (this.started) {
            this.started = false;
            this.eventListeners.forEach((eventListener)=>eventListener.disconnect());
        }
    }
    get eventListeners() {
        return Array.from(this.eventListenerMaps.values()).reduce((listeners, map)=>listeners.concat(Array.from(map.values())), []);
    }
    bindingConnected(binding) {
        this.fetchEventListenerForBinding(binding).bindingConnected(binding);
    }
    bindingDisconnected(binding, clearEventListeners = false) {
        this.fetchEventListenerForBinding(binding).bindingDisconnected(binding);
        if (clearEventListeners) this.clearEventListenersForBinding(binding);
    }
    handleError(error, message, detail = {}) {
        this.application.handleError(error, `Error ${message}`, detail);
    }
    clearEventListenersForBinding(binding) {
        const eventListener = this.fetchEventListenerForBinding(binding);
        if (!eventListener.hasBindings()) {
            eventListener.disconnect();
            this.removeMappedEventListenerFor(binding);
        }
    }
    removeMappedEventListenerFor(binding) {
        const { eventTarget: eventTarget, eventName: eventName, eventOptions: eventOptions } = binding;
        const eventListenerMap = this.fetchEventListenerMapForEventTarget(eventTarget);
        const cacheKey = this.cacheKey(eventName, eventOptions);
        eventListenerMap.delete(cacheKey);
        if (eventListenerMap.size == 0) this.eventListenerMaps.delete(eventTarget);
    }
    fetchEventListenerForBinding(binding) {
        const { eventTarget: eventTarget, eventName: eventName, eventOptions: eventOptions } = binding;
        return this.fetchEventListener(eventTarget, eventName, eventOptions);
    }
    fetchEventListener(eventTarget, eventName, eventOptions) {
        const eventListenerMap = this.fetchEventListenerMapForEventTarget(eventTarget);
        const cacheKey = this.cacheKey(eventName, eventOptions);
        let eventListener = eventListenerMap.get(cacheKey);
        if (!eventListener) {
            eventListener = this.createEventListener(eventTarget, eventName, eventOptions);
            eventListenerMap.set(cacheKey, eventListener);
        }
        return eventListener;
    }
    createEventListener(eventTarget, eventName, eventOptions) {
        const eventListener = new $c8b99022ff3c634f$var$EventListener(eventTarget, eventName, eventOptions);
        if (this.started) eventListener.connect();
        return eventListener;
    }
    fetchEventListenerMapForEventTarget(eventTarget) {
        let eventListenerMap = this.eventListenerMaps.get(eventTarget);
        if (!eventListenerMap) {
            eventListenerMap = new Map();
            this.eventListenerMaps.set(eventTarget, eventListenerMap);
        }
        return eventListenerMap;
    }
    cacheKey(eventName, eventOptions) {
        const parts = [
            eventName
        ];
        Object.keys(eventOptions).sort().forEach((key)=>{
            parts.push(`${eventOptions[key] ? "" : "!"}${key}`);
        });
        return parts.join(":");
    }
}
const $c8b99022ff3c634f$var$defaultActionDescriptorFilters = {
    stop ({ event: event, value: value }) {
        if (value) event.stopPropagation();
        return true;
    },
    prevent ({ event: event, value: value }) {
        if (value) event.preventDefault();
        return true;
    },
    self ({ event: event, value: value, element: element }) {
        if (value) return element === event.target;
        else return true;
    }
};
const $c8b99022ff3c634f$var$descriptorPattern = /^(?:(?:([^.]+?)\+)?(.+?)(?:\.(.+?))?(?:@(window|document))?->)?(.+?)(?:#([^:]+?))(?::(.+))?$/;
function $c8b99022ff3c634f$var$parseActionDescriptorString(descriptorString) {
    const source = descriptorString.trim();
    const matches = source.match($c8b99022ff3c634f$var$descriptorPattern) || [];
    let eventName = matches[2];
    let keyFilter = matches[3];
    if (keyFilter && ![
        "keydown",
        "keyup",
        "keypress"
    ].includes(eventName)) {
        eventName += `.${keyFilter}`;
        keyFilter = "";
    }
    return {
        eventTarget: $c8b99022ff3c634f$var$parseEventTarget(matches[4]),
        eventName: eventName,
        eventOptions: matches[7] ? $c8b99022ff3c634f$var$parseEventOptions(matches[7]) : {},
        identifier: matches[5],
        methodName: matches[6],
        keyFilter: matches[1] || keyFilter
    };
}
function $c8b99022ff3c634f$var$parseEventTarget(eventTargetName) {
    if (eventTargetName == "window") return window;
    else if (eventTargetName == "document") return document;
}
function $c8b99022ff3c634f$var$parseEventOptions(eventOptions) {
    return eventOptions.split(":").reduce((options, token)=>Object.assign(options, {
            [token.replace(/^!/, "")]: !/^!/.test(token)
        }), {});
}
function $c8b99022ff3c634f$var$stringifyEventTarget(eventTarget) {
    if (eventTarget == window) return "window";
    else if (eventTarget == document) return "document";
}
function $c8b99022ff3c634f$var$camelize(value) {
    return value.replace(/(?:[_-])([a-z0-9])/g, (_, char)=>char.toUpperCase());
}
function $c8b99022ff3c634f$var$namespaceCamelize(value) {
    return $c8b99022ff3c634f$var$camelize(value.replace(/--/g, "-").replace(/__/g, "_"));
}
function $c8b99022ff3c634f$var$capitalize(value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
}
function $c8b99022ff3c634f$var$dasherize(value) {
    return value.replace(/([A-Z])/g, (_, char)=>`-${char.toLowerCase()}`);
}
function $c8b99022ff3c634f$var$tokenize(value) {
    return value.match(/[^\s]+/g) || [];
}
function $c8b99022ff3c634f$var$isSomething(object) {
    return object !== null && object !== undefined;
}
function $c8b99022ff3c634f$var$hasProperty(object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
}
const $c8b99022ff3c634f$var$allModifiers = [
    "meta",
    "ctrl",
    "alt",
    "shift"
];
class $c8b99022ff3c634f$var$Action {
    constructor(element, index, descriptor, schema){
        this.element = element;
        this.index = index;
        this.eventTarget = descriptor.eventTarget || element;
        this.eventName = descriptor.eventName || $c8b99022ff3c634f$var$getDefaultEventNameForElement(element) || $c8b99022ff3c634f$var$error("missing event name");
        this.eventOptions = descriptor.eventOptions || {};
        this.identifier = descriptor.identifier || $c8b99022ff3c634f$var$error("missing identifier");
        this.methodName = descriptor.methodName || $c8b99022ff3c634f$var$error("missing method name");
        this.keyFilter = descriptor.keyFilter || "";
        this.schema = schema;
    }
    static forToken(token, schema) {
        return new this(token.element, token.index, $c8b99022ff3c634f$var$parseActionDescriptorString(token.content), schema);
    }
    toString() {
        const eventFilter = this.keyFilter ? `.${this.keyFilter}` : "";
        const eventTarget = this.eventTargetName ? `@${this.eventTargetName}` : "";
        return `${this.eventName}${eventFilter}${eventTarget}->${this.identifier}#${this.methodName}`;
    }
    shouldIgnoreKeyboardEvent(event) {
        if (!this.keyFilter) return false;
        const filters = this.keyFilter.split("+");
        if (this.keyFilterDissatisfied(event, filters)) return true;
        const standardFilter = filters.filter((key)=>!$c8b99022ff3c634f$var$allModifiers.includes(key))[0];
        if (!standardFilter) return false;
        if (!$c8b99022ff3c634f$var$hasProperty(this.keyMappings, standardFilter)) $c8b99022ff3c634f$var$error(`contains unknown key filter: ${this.keyFilter}`);
        return this.keyMappings[standardFilter].toLowerCase() !== event.key.toLowerCase();
    }
    shouldIgnoreMouseEvent(event) {
        if (!this.keyFilter) return false;
        const filters = [
            this.keyFilter
        ];
        if (this.keyFilterDissatisfied(event, filters)) return true;
        return false;
    }
    get params() {
        const params = {};
        const pattern = new RegExp(`^data-${this.identifier}-(.+)-param$`, "i");
        for (const { name: name, value: value } of Array.from(this.element.attributes)){
            const match = name.match(pattern);
            const key = match && match[1];
            if (key) params[$c8b99022ff3c634f$var$camelize(key)] = $c8b99022ff3c634f$var$typecast(value);
        }
        return params;
    }
    get eventTargetName() {
        return $c8b99022ff3c634f$var$stringifyEventTarget(this.eventTarget);
    }
    get keyMappings() {
        return this.schema.keyMappings;
    }
    keyFilterDissatisfied(event, filters) {
        const [meta, ctrl, alt, shift] = $c8b99022ff3c634f$var$allModifiers.map((modifier)=>filters.includes(modifier));
        return event.metaKey !== meta || event.ctrlKey !== ctrl || event.altKey !== alt || event.shiftKey !== shift;
    }
}
const $c8b99022ff3c634f$var$defaultEventNames = {
    a: ()=>"click",
    button: ()=>"click",
    form: ()=>"submit",
    details: ()=>"toggle",
    input: (e)=>e.getAttribute("type") == "submit" ? "click" : "input",
    select: ()=>"change",
    textarea: ()=>"input"
};
function $c8b99022ff3c634f$var$getDefaultEventNameForElement(element) {
    const tagName = element.tagName.toLowerCase();
    if (tagName in $c8b99022ff3c634f$var$defaultEventNames) return $c8b99022ff3c634f$var$defaultEventNames[tagName](element);
}
function $c8b99022ff3c634f$var$error(message) {
    throw new Error(message);
}
function $c8b99022ff3c634f$var$typecast(value) {
    try {
        return JSON.parse(value);
    } catch (o_O) {
        return value;
    }
}
class $c8b99022ff3c634f$var$Binding {
    constructor(context, action){
        this.context = context;
        this.action = action;
    }
    get index() {
        return this.action.index;
    }
    get eventTarget() {
        return this.action.eventTarget;
    }
    get eventOptions() {
        return this.action.eventOptions;
    }
    get identifier() {
        return this.context.identifier;
    }
    handleEvent(event) {
        const actionEvent = this.prepareActionEvent(event);
        if (this.willBeInvokedByEvent(event) && this.applyEventModifiers(actionEvent)) this.invokeWithEvent(actionEvent);
    }
    get eventName() {
        return this.action.eventName;
    }
    get method() {
        const method = this.controller[this.methodName];
        if (typeof method == "function") return method;
        throw new Error(`Action "${this.action}" references undefined method "${this.methodName}"`);
    }
    applyEventModifiers(event) {
        const { element: element } = this.action;
        const { actionDescriptorFilters: actionDescriptorFilters } = this.context.application;
        const { controller: controller } = this.context;
        let passes = true;
        for (const [name, value] of Object.entries(this.eventOptions)){
            if (name in actionDescriptorFilters) {
                const filter = actionDescriptorFilters[name];
                passes = passes && filter({
                    name: name,
                    value: value,
                    event: event,
                    element: element,
                    controller: controller
                });
            } else continue;
        }
        return passes;
    }
    prepareActionEvent(event) {
        return Object.assign(event, {
            params: this.action.params
        });
    }
    invokeWithEvent(event) {
        const { target: target, currentTarget: currentTarget } = event;
        try {
            this.method.call(this.controller, event);
            this.context.logDebugActivity(this.methodName, {
                event: event,
                target: target,
                currentTarget: currentTarget,
                action: this.methodName
            });
        } catch (error) {
            const { identifier: identifier, controller: controller, element: element, index: index } = this;
            const detail = {
                identifier: identifier,
                controller: controller,
                element: element,
                index: index,
                event: event
            };
            this.context.handleError(error, `invoking action "${this.action}"`, detail);
        }
    }
    willBeInvokedByEvent(event) {
        const eventTarget = event.target;
        if (event instanceof KeyboardEvent && this.action.shouldIgnoreKeyboardEvent(event)) return false;
        if (event instanceof MouseEvent && this.action.shouldIgnoreMouseEvent(event)) return false;
        if (this.element === eventTarget) return true;
        else if (eventTarget instanceof Element && this.element.contains(eventTarget)) return this.scope.containsElement(eventTarget);
        else return this.scope.containsElement(this.action.element);
    }
    get controller() {
        return this.context.controller;
    }
    get methodName() {
        return this.action.methodName;
    }
    get element() {
        return this.scope.element;
    }
    get scope() {
        return this.context.scope;
    }
}
class $c8b99022ff3c634f$export$12e07a2a9f87578a {
    constructor(element, delegate){
        this.mutationObserverInit = {
            attributes: true,
            childList: true,
            subtree: true
        };
        this.element = element;
        this.started = false;
        this.delegate = delegate;
        this.elements = new Set();
        this.mutationObserver = new MutationObserver((mutations)=>this.processMutations(mutations));
    }
    start() {
        if (!this.started) {
            this.started = true;
            this.mutationObserver.observe(this.element, this.mutationObserverInit);
            this.refresh();
        }
    }
    pause(callback) {
        if (this.started) {
            this.mutationObserver.disconnect();
            this.started = false;
        }
        callback();
        if (!this.started) {
            this.mutationObserver.observe(this.element, this.mutationObserverInit);
            this.started = true;
        }
    }
    stop() {
        if (this.started) {
            this.mutationObserver.takeRecords();
            this.mutationObserver.disconnect();
            this.started = false;
        }
    }
    refresh() {
        if (this.started) {
            const matches = new Set(this.matchElementsInTree());
            for (const element of Array.from(this.elements))if (!matches.has(element)) this.removeElement(element);
            for (const element of Array.from(matches))this.addElement(element);
        }
    }
    processMutations(mutations) {
        if (this.started) for (const mutation of mutations)this.processMutation(mutation);
    }
    processMutation(mutation) {
        if (mutation.type == "attributes") this.processAttributeChange(mutation.target, mutation.attributeName);
        else if (mutation.type == "childList") {
            this.processRemovedNodes(mutation.removedNodes);
            this.processAddedNodes(mutation.addedNodes);
        }
    }
    processAttributeChange(element, attributeName) {
        if (this.elements.has(element)) {
            if (this.delegate.elementAttributeChanged && this.matchElement(element)) this.delegate.elementAttributeChanged(element, attributeName);
            else this.removeElement(element);
        } else if (this.matchElement(element)) this.addElement(element);
    }
    processRemovedNodes(nodes) {
        for (const node of Array.from(nodes)){
            const element = this.elementFromNode(node);
            if (element) this.processTree(element, this.removeElement);
        }
    }
    processAddedNodes(nodes) {
        for (const node of Array.from(nodes)){
            const element = this.elementFromNode(node);
            if (element && this.elementIsActive(element)) this.processTree(element, this.addElement);
        }
    }
    matchElement(element) {
        return this.delegate.matchElement(element);
    }
    matchElementsInTree(tree = this.element) {
        return this.delegate.matchElementsInTree(tree);
    }
    processTree(tree, processor) {
        for (const element of this.matchElementsInTree(tree))processor.call(this, element);
    }
    elementFromNode(node) {
        if (node.nodeType == Node.ELEMENT_NODE) return node;
    }
    elementIsActive(element) {
        if (element.isConnected != this.element.isConnected) return false;
        else return this.element.contains(element);
    }
    addElement(element) {
        if (!this.elements.has(element)) {
            if (this.elementIsActive(element)) {
                this.elements.add(element);
                if (this.delegate.elementMatched) this.delegate.elementMatched(element);
            }
        }
    }
    removeElement(element) {
        if (this.elements.has(element)) {
            this.elements.delete(element);
            if (this.delegate.elementUnmatched) this.delegate.elementUnmatched(element);
        }
    }
}
class $c8b99022ff3c634f$export$fe68319d413d05cb {
    constructor(element, attributeName, delegate){
        this.attributeName = attributeName;
        this.delegate = delegate;
        this.elementObserver = new $c8b99022ff3c634f$export$12e07a2a9f87578a(element, this);
    }
    get element() {
        return this.elementObserver.element;
    }
    get selector() {
        return `[${this.attributeName}]`;
    }
    start() {
        this.elementObserver.start();
    }
    pause(callback) {
        this.elementObserver.pause(callback);
    }
    stop() {
        this.elementObserver.stop();
    }
    refresh() {
        this.elementObserver.refresh();
    }
    get started() {
        return this.elementObserver.started;
    }
    matchElement(element) {
        return element.hasAttribute(this.attributeName);
    }
    matchElementsInTree(tree) {
        const match = this.matchElement(tree) ? [
            tree
        ] : [];
        const matches = Array.from(tree.querySelectorAll(this.selector));
        return match.concat(matches);
    }
    elementMatched(element) {
        if (this.delegate.elementMatchedAttribute) this.delegate.elementMatchedAttribute(element, this.attributeName);
    }
    elementUnmatched(element) {
        if (this.delegate.elementUnmatchedAttribute) this.delegate.elementUnmatchedAttribute(element, this.attributeName);
    }
    elementAttributeChanged(element, attributeName) {
        if (this.delegate.elementAttributeValueChanged && this.attributeName == attributeName) this.delegate.elementAttributeValueChanged(element, attributeName);
    }
}
function $c8b99022ff3c634f$export$e16d8520af44a096(map, key, value) {
    $c8b99022ff3c634f$export$e7aa7bc5c1b3cfb3(map, key).add(value);
}
function $c8b99022ff3c634f$export$1d2f21e549771e67(map, key, value) {
    $c8b99022ff3c634f$export$e7aa7bc5c1b3cfb3(map, key).delete(value);
    $c8b99022ff3c634f$export$d6cf75919f12ca5a(map, key);
}
function $c8b99022ff3c634f$export$e7aa7bc5c1b3cfb3(map, key) {
    let values = map.get(key);
    if (!values) {
        values = new Set();
        map.set(key, values);
    }
    return values;
}
function $c8b99022ff3c634f$export$d6cf75919f12ca5a(map, key) {
    const values = map.get(key);
    if (values != null && values.size == 0) map.delete(key);
}
class $c8b99022ff3c634f$export$8bd4ad37b76db6ba {
    constructor(){
        this.valuesByKey = new Map();
    }
    get keys() {
        return Array.from(this.valuesByKey.keys());
    }
    get values() {
        const sets = Array.from(this.valuesByKey.values());
        return sets.reduce((values, set)=>values.concat(Array.from(set)), []);
    }
    get size() {
        const sets = Array.from(this.valuesByKey.values());
        return sets.reduce((size, set)=>size + set.size, 0);
    }
    add(key, value) {
        $c8b99022ff3c634f$export$e16d8520af44a096(this.valuesByKey, key, value);
    }
    delete(key, value) {
        $c8b99022ff3c634f$export$1d2f21e549771e67(this.valuesByKey, key, value);
    }
    has(key, value) {
        const values = this.valuesByKey.get(key);
        return values != null && values.has(value);
    }
    hasKey(key) {
        return this.valuesByKey.has(key);
    }
    hasValue(value) {
        const sets = Array.from(this.valuesByKey.values());
        return sets.some((set)=>set.has(value));
    }
    getValuesForKey(key) {
        const values = this.valuesByKey.get(key);
        return values ? Array.from(values) : [];
    }
    getKeysForValue(value) {
        return Array.from(this.valuesByKey).filter(([_key, values])=>values.has(value)).map(([key, _values])=>key);
    }
}
class $c8b99022ff3c634f$export$a7c3d2c2552a674d extends $c8b99022ff3c634f$export$8bd4ad37b76db6ba {
    constructor(){
        super();
        this.keysByValue = new Map();
    }
    get values() {
        return Array.from(this.keysByValue.keys());
    }
    add(key, value) {
        super.add(key, value);
        $c8b99022ff3c634f$export$e16d8520af44a096(this.keysByValue, value, key);
    }
    delete(key, value) {
        super.delete(key, value);
        $c8b99022ff3c634f$export$1d2f21e549771e67(this.keysByValue, value, key);
    }
    hasValue(value) {
        return this.keysByValue.has(value);
    }
    getKeysForValue(value) {
        const set = this.keysByValue.get(value);
        return set ? Array.from(set) : [];
    }
}
class $c8b99022ff3c634f$export$116e0b48509995b {
    constructor(element, selector, delegate, details){
        this._selector = selector;
        this.details = details;
        this.elementObserver = new $c8b99022ff3c634f$export$12e07a2a9f87578a(element, this);
        this.delegate = delegate;
        this.matchesByElement = new $c8b99022ff3c634f$export$8bd4ad37b76db6ba();
    }
    get started() {
        return this.elementObserver.started;
    }
    get selector() {
        return this._selector;
    }
    set selector(selector) {
        this._selector = selector;
        this.refresh();
    }
    start() {
        this.elementObserver.start();
    }
    pause(callback) {
        this.elementObserver.pause(callback);
    }
    stop() {
        this.elementObserver.stop();
    }
    refresh() {
        this.elementObserver.refresh();
    }
    get element() {
        return this.elementObserver.element;
    }
    matchElement(element) {
        const { selector: selector } = this;
        if (selector) {
            const matches = element.matches(selector);
            if (this.delegate.selectorMatchElement) return matches && this.delegate.selectorMatchElement(element, this.details);
            return matches;
        } else return false;
    }
    matchElementsInTree(tree) {
        const { selector: selector } = this;
        if (selector) {
            const match = this.matchElement(tree) ? [
                tree
            ] : [];
            const matches = Array.from(tree.querySelectorAll(selector)).filter((match)=>this.matchElement(match));
            return match.concat(matches);
        } else return [];
    }
    elementMatched(element) {
        const { selector: selector } = this;
        if (selector) this.selectorMatched(element, selector);
    }
    elementUnmatched(element) {
        const selectors = this.matchesByElement.getKeysForValue(element);
        for (const selector of selectors)this.selectorUnmatched(element, selector);
    }
    elementAttributeChanged(element, _attributeName) {
        const { selector: selector } = this;
        if (selector) {
            const matches = this.matchElement(element);
            const matchedBefore = this.matchesByElement.has(selector, element);
            if (matches && !matchedBefore) this.selectorMatched(element, selector);
            else if (!matches && matchedBefore) this.selectorUnmatched(element, selector);
        }
    }
    selectorMatched(element, selector) {
        this.delegate.selectorMatched(element, selector, this.details);
        this.matchesByElement.add(selector, element);
    }
    selectorUnmatched(element, selector) {
        this.delegate.selectorUnmatched(element, selector, this.details);
        this.matchesByElement.delete(selector, element);
    }
}
class $c8b99022ff3c634f$export$da226bebbf7f6caa {
    constructor(element, delegate){
        this.element = element;
        this.delegate = delegate;
        this.started = false;
        this.stringMap = new Map();
        this.mutationObserver = new MutationObserver((mutations)=>this.processMutations(mutations));
    }
    start() {
        if (!this.started) {
            this.started = true;
            this.mutationObserver.observe(this.element, {
                attributes: true,
                attributeOldValue: true
            });
            this.refresh();
        }
    }
    stop() {
        if (this.started) {
            this.mutationObserver.takeRecords();
            this.mutationObserver.disconnect();
            this.started = false;
        }
    }
    refresh() {
        if (this.started) for (const attributeName of this.knownAttributeNames)this.refreshAttribute(attributeName, null);
    }
    processMutations(mutations) {
        if (this.started) for (const mutation of mutations)this.processMutation(mutation);
    }
    processMutation(mutation) {
        const attributeName = mutation.attributeName;
        if (attributeName) this.refreshAttribute(attributeName, mutation.oldValue);
    }
    refreshAttribute(attributeName, oldValue) {
        const key = this.delegate.getStringMapKeyForAttribute(attributeName);
        if (key != null) {
            if (!this.stringMap.has(attributeName)) this.stringMapKeyAdded(key, attributeName);
            const value = this.element.getAttribute(attributeName);
            if (this.stringMap.get(attributeName) != value) this.stringMapValueChanged(value, key, oldValue);
            if (value == null) {
                const oldValue = this.stringMap.get(attributeName);
                this.stringMap.delete(attributeName);
                if (oldValue) this.stringMapKeyRemoved(key, attributeName, oldValue);
            } else this.stringMap.set(attributeName, value);
        }
    }
    stringMapKeyAdded(key, attributeName) {
        if (this.delegate.stringMapKeyAdded) this.delegate.stringMapKeyAdded(key, attributeName);
    }
    stringMapValueChanged(value, key, oldValue) {
        if (this.delegate.stringMapValueChanged) this.delegate.stringMapValueChanged(value, key, oldValue);
    }
    stringMapKeyRemoved(key, attributeName, oldValue) {
        if (this.delegate.stringMapKeyRemoved) this.delegate.stringMapKeyRemoved(key, attributeName, oldValue);
    }
    get knownAttributeNames() {
        return Array.from(new Set(this.currentAttributeNames.concat(this.recordedAttributeNames)));
    }
    get currentAttributeNames() {
        return Array.from(this.element.attributes).map((attribute)=>attribute.name);
    }
    get recordedAttributeNames() {
        return Array.from(this.stringMap.keys());
    }
}
class $c8b99022ff3c634f$export$3aa21c2f03ef6b3b {
    constructor(element, attributeName, delegate){
        this.attributeObserver = new $c8b99022ff3c634f$export$fe68319d413d05cb(element, attributeName, this);
        this.delegate = delegate;
        this.tokensByElement = new $c8b99022ff3c634f$export$8bd4ad37b76db6ba();
    }
    get started() {
        return this.attributeObserver.started;
    }
    start() {
        this.attributeObserver.start();
    }
    pause(callback) {
        this.attributeObserver.pause(callback);
    }
    stop() {
        this.attributeObserver.stop();
    }
    refresh() {
        this.attributeObserver.refresh();
    }
    get element() {
        return this.attributeObserver.element;
    }
    get attributeName() {
        return this.attributeObserver.attributeName;
    }
    elementMatchedAttribute(element) {
        this.tokensMatched(this.readTokensForElement(element));
    }
    elementAttributeValueChanged(element) {
        const [unmatchedTokens, matchedTokens] = this.refreshTokensForElement(element);
        this.tokensUnmatched(unmatchedTokens);
        this.tokensMatched(matchedTokens);
    }
    elementUnmatchedAttribute(element) {
        this.tokensUnmatched(this.tokensByElement.getValuesForKey(element));
    }
    tokensMatched(tokens) {
        tokens.forEach((token)=>this.tokenMatched(token));
    }
    tokensUnmatched(tokens) {
        tokens.forEach((token)=>this.tokenUnmatched(token));
    }
    tokenMatched(token) {
        this.delegate.tokenMatched(token);
        this.tokensByElement.add(token.element, token);
    }
    tokenUnmatched(token) {
        this.delegate.tokenUnmatched(token);
        this.tokensByElement.delete(token.element, token);
    }
    refreshTokensForElement(element) {
        const previousTokens = this.tokensByElement.getValuesForKey(element);
        const currentTokens = this.readTokensForElement(element);
        const firstDifferingIndex = $c8b99022ff3c634f$var$zip(previousTokens, currentTokens).findIndex(([previousToken, currentToken])=>!$c8b99022ff3c634f$var$tokensAreEqual(previousToken, currentToken));
        if (firstDifferingIndex == -1) return [
            [],
            []
        ];
        else return [
            previousTokens.slice(firstDifferingIndex),
            currentTokens.slice(firstDifferingIndex)
        ];
    }
    readTokensForElement(element) {
        const attributeName = this.attributeName;
        const tokenString = element.getAttribute(attributeName) || "";
        return $c8b99022ff3c634f$var$parseTokenString(tokenString, element, attributeName);
    }
}
function $c8b99022ff3c634f$var$parseTokenString(tokenString, element, attributeName) {
    return tokenString.trim().split(/\s+/).filter((content)=>content.length).map((content, index)=>({
            element: element,
            attributeName: attributeName,
            content: content,
            index: index
        }));
}
function $c8b99022ff3c634f$var$zip(left, right) {
    const length = Math.max(left.length, right.length);
    return Array.from({
        length: length
    }, (_, index)=>[
            left[index],
            right[index]
        ]);
}
function $c8b99022ff3c634f$var$tokensAreEqual(left, right) {
    return left && right && left.index == right.index && left.content == right.content;
}
class $c8b99022ff3c634f$export$d27fa4c7330a452e {
    constructor(element, attributeName, delegate){
        this.tokenListObserver = new $c8b99022ff3c634f$export$3aa21c2f03ef6b3b(element, attributeName, this);
        this.delegate = delegate;
        this.parseResultsByToken = new WeakMap();
        this.valuesByTokenByElement = new WeakMap();
    }
    get started() {
        return this.tokenListObserver.started;
    }
    start() {
        this.tokenListObserver.start();
    }
    stop() {
        this.tokenListObserver.stop();
    }
    refresh() {
        this.tokenListObserver.refresh();
    }
    get element() {
        return this.tokenListObserver.element;
    }
    get attributeName() {
        return this.tokenListObserver.attributeName;
    }
    tokenMatched(token) {
        const { element: element } = token;
        const { value: value } = this.fetchParseResultForToken(token);
        if (value) {
            this.fetchValuesByTokenForElement(element).set(token, value);
            this.delegate.elementMatchedValue(element, value);
        }
    }
    tokenUnmatched(token) {
        const { element: element } = token;
        const { value: value } = this.fetchParseResultForToken(token);
        if (value) {
            this.fetchValuesByTokenForElement(element).delete(token);
            this.delegate.elementUnmatchedValue(element, value);
        }
    }
    fetchParseResultForToken(token) {
        let parseResult = this.parseResultsByToken.get(token);
        if (!parseResult) {
            parseResult = this.parseToken(token);
            this.parseResultsByToken.set(token, parseResult);
        }
        return parseResult;
    }
    fetchValuesByTokenForElement(element) {
        let valuesByToken = this.valuesByTokenByElement.get(element);
        if (!valuesByToken) {
            valuesByToken = new Map();
            this.valuesByTokenByElement.set(element, valuesByToken);
        }
        return valuesByToken;
    }
    parseToken(token) {
        try {
            const value = this.delegate.parseValueForToken(token);
            return {
                value: value
            };
        } catch (error) {
            return {
                error: error
            };
        }
    }
}
class $c8b99022ff3c634f$var$BindingObserver {
    constructor(context, delegate){
        this.context = context;
        this.delegate = delegate;
        this.bindingsByAction = new Map();
    }
    start() {
        if (!this.valueListObserver) {
            this.valueListObserver = new $c8b99022ff3c634f$export$d27fa4c7330a452e(this.element, this.actionAttribute, this);
            this.valueListObserver.start();
        }
    }
    stop() {
        if (this.valueListObserver) {
            this.valueListObserver.stop();
            delete this.valueListObserver;
            this.disconnectAllActions();
        }
    }
    get element() {
        return this.context.element;
    }
    get identifier() {
        return this.context.identifier;
    }
    get actionAttribute() {
        return this.schema.actionAttribute;
    }
    get schema() {
        return this.context.schema;
    }
    get bindings() {
        return Array.from(this.bindingsByAction.values());
    }
    connectAction(action) {
        const binding = new $c8b99022ff3c634f$var$Binding(this.context, action);
        this.bindingsByAction.set(action, binding);
        this.delegate.bindingConnected(binding);
    }
    disconnectAction(action) {
        const binding = this.bindingsByAction.get(action);
        if (binding) {
            this.bindingsByAction.delete(action);
            this.delegate.bindingDisconnected(binding);
        }
    }
    disconnectAllActions() {
        this.bindings.forEach((binding)=>this.delegate.bindingDisconnected(binding, true));
        this.bindingsByAction.clear();
    }
    parseValueForToken(token) {
        const action = $c8b99022ff3c634f$var$Action.forToken(token, this.schema);
        if (action.identifier == this.identifier) return action;
    }
    elementMatchedValue(element, action) {
        this.connectAction(action);
    }
    elementUnmatchedValue(element, action) {
        this.disconnectAction(action);
    }
}
class $c8b99022ff3c634f$var$ValueObserver {
    constructor(context, receiver){
        this.context = context;
        this.receiver = receiver;
        this.stringMapObserver = new $c8b99022ff3c634f$export$da226bebbf7f6caa(this.element, this);
        this.valueDescriptorMap = this.controller.valueDescriptorMap;
    }
    start() {
        this.stringMapObserver.start();
        this.invokeChangedCallbacksForDefaultValues();
    }
    stop() {
        this.stringMapObserver.stop();
    }
    get element() {
        return this.context.element;
    }
    get controller() {
        return this.context.controller;
    }
    getStringMapKeyForAttribute(attributeName) {
        if (attributeName in this.valueDescriptorMap) return this.valueDescriptorMap[attributeName].name;
    }
    stringMapKeyAdded(key, attributeName) {
        const descriptor = this.valueDescriptorMap[attributeName];
        if (!this.hasValue(key)) this.invokeChangedCallback(key, descriptor.writer(this.receiver[key]), descriptor.writer(descriptor.defaultValue));
    }
    stringMapValueChanged(value, name, oldValue) {
        const descriptor = this.valueDescriptorNameMap[name];
        if (value === null) return;
        if (oldValue === null) oldValue = descriptor.writer(descriptor.defaultValue);
        this.invokeChangedCallback(name, value, oldValue);
    }
    stringMapKeyRemoved(key, attributeName, oldValue) {
        const descriptor = this.valueDescriptorNameMap[key];
        if (this.hasValue(key)) this.invokeChangedCallback(key, descriptor.writer(this.receiver[key]), oldValue);
        else this.invokeChangedCallback(key, descriptor.writer(descriptor.defaultValue), oldValue);
    }
    invokeChangedCallbacksForDefaultValues() {
        for (const { key: key, name: name, defaultValue: defaultValue, writer: writer } of this.valueDescriptors)if (defaultValue != undefined && !this.controller.data.has(key)) this.invokeChangedCallback(name, writer(defaultValue), undefined);
    }
    invokeChangedCallback(name, rawValue, rawOldValue) {
        const changedMethodName = `${name}Changed`;
        const changedMethod = this.receiver[changedMethodName];
        if (typeof changedMethod == "function") {
            const descriptor = this.valueDescriptorNameMap[name];
            try {
                const value = descriptor.reader(rawValue);
                let oldValue = rawOldValue;
                if (rawOldValue) oldValue = descriptor.reader(rawOldValue);
                changedMethod.call(this.receiver, value, oldValue);
            } catch (error) {
                if (error instanceof TypeError) error.message = `Stimulus Value "${this.context.identifier}.${descriptor.name}" - ${error.message}`;
                throw error;
            }
        }
    }
    get valueDescriptors() {
        const { valueDescriptorMap: valueDescriptorMap } = this;
        return Object.keys(valueDescriptorMap).map((key)=>valueDescriptorMap[key]);
    }
    get valueDescriptorNameMap() {
        const descriptors = {};
        Object.keys(this.valueDescriptorMap).forEach((key)=>{
            const descriptor = this.valueDescriptorMap[key];
            descriptors[descriptor.name] = descriptor;
        });
        return descriptors;
    }
    hasValue(attributeName) {
        const descriptor = this.valueDescriptorNameMap[attributeName];
        const hasMethodName = `has${$c8b99022ff3c634f$var$capitalize(descriptor.name)}`;
        return this.receiver[hasMethodName];
    }
}
class $c8b99022ff3c634f$var$TargetObserver {
    constructor(context, delegate){
        this.context = context;
        this.delegate = delegate;
        this.targetsByName = new $c8b99022ff3c634f$export$8bd4ad37b76db6ba();
    }
    start() {
        if (!this.tokenListObserver) {
            this.tokenListObserver = new $c8b99022ff3c634f$export$3aa21c2f03ef6b3b(this.element, this.attributeName, this);
            this.tokenListObserver.start();
        }
    }
    stop() {
        if (this.tokenListObserver) {
            this.disconnectAllTargets();
            this.tokenListObserver.stop();
            delete this.tokenListObserver;
        }
    }
    tokenMatched({ element: element, content: name }) {
        if (this.scope.containsElement(element)) this.connectTarget(element, name);
    }
    tokenUnmatched({ element: element, content: name }) {
        this.disconnectTarget(element, name);
    }
    connectTarget(element, name) {
        var _a;
        if (!this.targetsByName.has(name, element)) {
            this.targetsByName.add(name, element);
            (_a = this.tokenListObserver) === null || _a === void 0 || _a.pause(()=>this.delegate.targetConnected(element, name));
        }
    }
    disconnectTarget(element, name) {
        var _a;
        if (this.targetsByName.has(name, element)) {
            this.targetsByName.delete(name, element);
            (_a = this.tokenListObserver) === null || _a === void 0 || _a.pause(()=>this.delegate.targetDisconnected(element, name));
        }
    }
    disconnectAllTargets() {
        for (const name of this.targetsByName.keys)for (const element of this.targetsByName.getValuesForKey(name))this.disconnectTarget(element, name);
    }
    get attributeName() {
        return `data-${this.context.identifier}-target`;
    }
    get element() {
        return this.context.element;
    }
    get scope() {
        return this.context.scope;
    }
}
function $c8b99022ff3c634f$var$readInheritableStaticArrayValues(constructor, propertyName) {
    const ancestors = $c8b99022ff3c634f$var$getAncestorsForConstructor(constructor);
    return Array.from(ancestors.reduce((values, constructor)=>{
        $c8b99022ff3c634f$var$getOwnStaticArrayValues(constructor, propertyName).forEach((name)=>values.add(name));
        return values;
    }, new Set()));
}
function $c8b99022ff3c634f$var$readInheritableStaticObjectPairs(constructor, propertyName) {
    const ancestors = $c8b99022ff3c634f$var$getAncestorsForConstructor(constructor);
    return ancestors.reduce((pairs, constructor)=>{
        pairs.push(...$c8b99022ff3c634f$var$getOwnStaticObjectPairs(constructor, propertyName));
        return pairs;
    }, []);
}
function $c8b99022ff3c634f$var$getAncestorsForConstructor(constructor) {
    const ancestors = [];
    while(constructor){
        ancestors.push(constructor);
        constructor = Object.getPrototypeOf(constructor);
    }
    return ancestors.reverse();
}
function $c8b99022ff3c634f$var$getOwnStaticArrayValues(constructor, propertyName) {
    const definition = constructor[propertyName];
    return Array.isArray(definition) ? definition : [];
}
function $c8b99022ff3c634f$var$getOwnStaticObjectPairs(constructor, propertyName) {
    const definition = constructor[propertyName];
    return definition ? Object.keys(definition).map((key)=>[
            key,
            definition[key]
        ]) : [];
}
class $c8b99022ff3c634f$var$OutletObserver {
    constructor(context, delegate){
        this.started = false;
        this.context = context;
        this.delegate = delegate;
        this.outletsByName = new $c8b99022ff3c634f$export$8bd4ad37b76db6ba();
        this.outletElementsByName = new $c8b99022ff3c634f$export$8bd4ad37b76db6ba();
        this.selectorObserverMap = new Map();
        this.attributeObserverMap = new Map();
    }
    start() {
        if (!this.started) {
            this.outletDefinitions.forEach((outletName)=>{
                this.setupSelectorObserverForOutlet(outletName);
                this.setupAttributeObserverForOutlet(outletName);
            });
            this.started = true;
            this.dependentContexts.forEach((context)=>context.refresh());
        }
    }
    refresh() {
        this.selectorObserverMap.forEach((observer)=>observer.refresh());
        this.attributeObserverMap.forEach((observer)=>observer.refresh());
    }
    stop() {
        if (this.started) {
            this.started = false;
            this.disconnectAllOutlets();
            this.stopSelectorObservers();
            this.stopAttributeObservers();
        }
    }
    stopSelectorObservers() {
        if (this.selectorObserverMap.size > 0) {
            this.selectorObserverMap.forEach((observer)=>observer.stop());
            this.selectorObserverMap.clear();
        }
    }
    stopAttributeObservers() {
        if (this.attributeObserverMap.size > 0) {
            this.attributeObserverMap.forEach((observer)=>observer.stop());
            this.attributeObserverMap.clear();
        }
    }
    selectorMatched(element, _selector, { outletName: outletName }) {
        const outlet = this.getOutlet(element, outletName);
        if (outlet) this.connectOutlet(outlet, element, outletName);
    }
    selectorUnmatched(element, _selector, { outletName: outletName }) {
        const outlet = this.getOutletFromMap(element, outletName);
        if (outlet) this.disconnectOutlet(outlet, element, outletName);
    }
    selectorMatchElement(element, { outletName: outletName }) {
        const selector = this.selector(outletName);
        const hasOutlet = this.hasOutlet(element, outletName);
        const hasOutletController = element.matches(`[${this.schema.controllerAttribute}~=${outletName}]`);
        if (selector) return hasOutlet && hasOutletController && element.matches(selector);
        else return false;
    }
    elementMatchedAttribute(_element, attributeName) {
        const outletName = this.getOutletNameFromOutletAttributeName(attributeName);
        if (outletName) this.updateSelectorObserverForOutlet(outletName);
    }
    elementAttributeValueChanged(_element, attributeName) {
        const outletName = this.getOutletNameFromOutletAttributeName(attributeName);
        if (outletName) this.updateSelectorObserverForOutlet(outletName);
    }
    elementUnmatchedAttribute(_element, attributeName) {
        const outletName = this.getOutletNameFromOutletAttributeName(attributeName);
        if (outletName) this.updateSelectorObserverForOutlet(outletName);
    }
    connectOutlet(outlet, element, outletName) {
        var _a;
        if (!this.outletElementsByName.has(outletName, element)) {
            this.outletsByName.add(outletName, outlet);
            this.outletElementsByName.add(outletName, element);
            (_a = this.selectorObserverMap.get(outletName)) === null || _a === void 0 || _a.pause(()=>this.delegate.outletConnected(outlet, element, outletName));
        }
    }
    disconnectOutlet(outlet, element, outletName) {
        var _a;
        if (this.outletElementsByName.has(outletName, element)) {
            this.outletsByName.delete(outletName, outlet);
            this.outletElementsByName.delete(outletName, element);
            (_a = this.selectorObserverMap.get(outletName)) === null || _a === void 0 || _a.pause(()=>this.delegate.outletDisconnected(outlet, element, outletName));
        }
    }
    disconnectAllOutlets() {
        for (const outletName of this.outletElementsByName.keys){
            for (const element of this.outletElementsByName.getValuesForKey(outletName))for (const outlet of this.outletsByName.getValuesForKey(outletName))this.disconnectOutlet(outlet, element, outletName);
        }
    }
    updateSelectorObserverForOutlet(outletName) {
        const observer = this.selectorObserverMap.get(outletName);
        if (observer) observer.selector = this.selector(outletName);
    }
    setupSelectorObserverForOutlet(outletName) {
        const selector = this.selector(outletName);
        const selectorObserver = new $c8b99022ff3c634f$export$116e0b48509995b(document.body, selector, this, {
            outletName: outletName
        });
        this.selectorObserverMap.set(outletName, selectorObserver);
        selectorObserver.start();
    }
    setupAttributeObserverForOutlet(outletName) {
        const attributeName = this.attributeNameForOutletName(outletName);
        const attributeObserver = new $c8b99022ff3c634f$export$fe68319d413d05cb(this.scope.element, attributeName, this);
        this.attributeObserverMap.set(outletName, attributeObserver);
        attributeObserver.start();
    }
    selector(outletName) {
        return this.scope.outlets.getSelectorForOutletName(outletName);
    }
    attributeNameForOutletName(outletName) {
        return this.scope.schema.outletAttributeForScope(this.identifier, outletName);
    }
    getOutletNameFromOutletAttributeName(attributeName) {
        return this.outletDefinitions.find((outletName)=>this.attributeNameForOutletName(outletName) === attributeName);
    }
    get outletDependencies() {
        const dependencies = new $c8b99022ff3c634f$export$8bd4ad37b76db6ba();
        this.router.modules.forEach((module)=>{
            const constructor = module.definition.controllerConstructor;
            const outlets = $c8b99022ff3c634f$var$readInheritableStaticArrayValues(constructor, "outlets");
            outlets.forEach((outlet)=>dependencies.add(outlet, module.identifier));
        });
        return dependencies;
    }
    get outletDefinitions() {
        return this.outletDependencies.getKeysForValue(this.identifier);
    }
    get dependentControllerIdentifiers() {
        return this.outletDependencies.getValuesForKey(this.identifier);
    }
    get dependentContexts() {
        const identifiers = this.dependentControllerIdentifiers;
        return this.router.contexts.filter((context)=>identifiers.includes(context.identifier));
    }
    hasOutlet(element, outletName) {
        return !!this.getOutlet(element, outletName) || !!this.getOutletFromMap(element, outletName);
    }
    getOutlet(element, outletName) {
        return this.application.getControllerForElementAndIdentifier(element, outletName);
    }
    getOutletFromMap(element, outletName) {
        return this.outletsByName.getValuesForKey(outletName).find((outlet)=>outlet.element === element);
    }
    get scope() {
        return this.context.scope;
    }
    get schema() {
        return this.context.schema;
    }
    get identifier() {
        return this.context.identifier;
    }
    get application() {
        return this.context.application;
    }
    get router() {
        return this.application.router;
    }
}
class $c8b99022ff3c634f$export$841858b892ce1f4c {
    constructor(module, scope){
        this.logDebugActivity = (functionName, detail = {})=>{
            const { identifier: identifier, controller: controller, element: element } = this;
            detail = Object.assign({
                identifier: identifier,
                controller: controller,
                element: element
            }, detail);
            this.application.logDebugActivity(this.identifier, functionName, detail);
        };
        this.module = module;
        this.scope = scope;
        this.controller = new module.controllerConstructor(this);
        this.bindingObserver = new $c8b99022ff3c634f$var$BindingObserver(this, this.dispatcher);
        this.valueObserver = new $c8b99022ff3c634f$var$ValueObserver(this, this.controller);
        this.targetObserver = new $c8b99022ff3c634f$var$TargetObserver(this, this);
        this.outletObserver = new $c8b99022ff3c634f$var$OutletObserver(this, this);
        try {
            this.controller.initialize();
            this.logDebugActivity("initialize");
        } catch (error) {
            this.handleError(error, "initializing controller");
        }
    }
    connect() {
        this.bindingObserver.start();
        this.valueObserver.start();
        this.targetObserver.start();
        this.outletObserver.start();
        try {
            this.controller.connect();
            this.logDebugActivity("connect");
        } catch (error) {
            this.handleError(error, "connecting controller");
        }
    }
    refresh() {
        this.outletObserver.refresh();
    }
    disconnect() {
        try {
            this.controller.disconnect();
            this.logDebugActivity("disconnect");
        } catch (error) {
            this.handleError(error, "disconnecting controller");
        }
        this.outletObserver.stop();
        this.targetObserver.stop();
        this.valueObserver.stop();
        this.bindingObserver.stop();
    }
    get application() {
        return this.module.application;
    }
    get identifier() {
        return this.module.identifier;
    }
    get schema() {
        return this.application.schema;
    }
    get dispatcher() {
        return this.application.dispatcher;
    }
    get element() {
        return this.scope.element;
    }
    get parentElement() {
        return this.element.parentElement;
    }
    handleError(error, message, detail = {}) {
        const { identifier: identifier, controller: controller, element: element } = this;
        detail = Object.assign({
            identifier: identifier,
            controller: controller,
            element: element
        }, detail);
        this.application.handleError(error, `Error ${message}`, detail);
    }
    targetConnected(element, name) {
        this.invokeControllerMethod(`${name}TargetConnected`, element);
    }
    targetDisconnected(element, name) {
        this.invokeControllerMethod(`${name}TargetDisconnected`, element);
    }
    outletConnected(outlet, element, name) {
        this.invokeControllerMethod(`${$c8b99022ff3c634f$var$namespaceCamelize(name)}OutletConnected`, outlet, element);
    }
    outletDisconnected(outlet, element, name) {
        this.invokeControllerMethod(`${$c8b99022ff3c634f$var$namespaceCamelize(name)}OutletDisconnected`, outlet, element);
    }
    invokeControllerMethod(methodName, ...args) {
        const controller = this.controller;
        if (typeof controller[methodName] == "function") controller[methodName](...args);
    }
}
function $c8b99022ff3c634f$var$bless(constructor) {
    return $c8b99022ff3c634f$var$shadow(constructor, $c8b99022ff3c634f$var$getBlessedProperties(constructor));
}
function $c8b99022ff3c634f$var$shadow(constructor, properties) {
    const shadowConstructor = $c8b99022ff3c634f$var$extend(constructor);
    const shadowProperties = $c8b99022ff3c634f$var$getShadowProperties(constructor.prototype, properties);
    Object.defineProperties(shadowConstructor.prototype, shadowProperties);
    return shadowConstructor;
}
function $c8b99022ff3c634f$var$getBlessedProperties(constructor) {
    const blessings = $c8b99022ff3c634f$var$readInheritableStaticArrayValues(constructor, "blessings");
    return blessings.reduce((blessedProperties, blessing)=>{
        const properties = blessing(constructor);
        for(const key in properties){
            const descriptor = blessedProperties[key] || {};
            blessedProperties[key] = Object.assign(descriptor, properties[key]);
        }
        return blessedProperties;
    }, {});
}
function $c8b99022ff3c634f$var$getShadowProperties(prototype, properties) {
    return $c8b99022ff3c634f$var$getOwnKeys(properties).reduce((shadowProperties, key)=>{
        const descriptor = $c8b99022ff3c634f$var$getShadowedDescriptor(prototype, properties, key);
        if (descriptor) Object.assign(shadowProperties, {
            [key]: descriptor
        });
        return shadowProperties;
    }, {});
}
function $c8b99022ff3c634f$var$getShadowedDescriptor(prototype, properties, key) {
    const shadowingDescriptor = Object.getOwnPropertyDescriptor(prototype, key);
    const shadowedByValue = shadowingDescriptor && "value" in shadowingDescriptor;
    if (!shadowedByValue) {
        const descriptor = Object.getOwnPropertyDescriptor(properties, key).value;
        if (shadowingDescriptor) {
            descriptor.get = shadowingDescriptor.get || descriptor.get;
            descriptor.set = shadowingDescriptor.set || descriptor.set;
        }
        return descriptor;
    }
}
const $c8b99022ff3c634f$var$getOwnKeys = (()=>{
    if (typeof Object.getOwnPropertySymbols == "function") return (object)=>[
            ...Object.getOwnPropertyNames(object),
            ...Object.getOwnPropertySymbols(object)
        ];
    else return Object.getOwnPropertyNames;
})();
const $c8b99022ff3c634f$var$extend = (()=>{
    function extendWithReflect(constructor) {
        function extended() {
            return Reflect.construct(constructor, arguments, new.target);
        }
        extended.prototype = Object.create(constructor.prototype, {
            constructor: {
                value: extended
            }
        });
        Reflect.setPrototypeOf(extended, constructor);
        return extended;
    }
    function testReflectExtension() {
        const a = function() {
            this.a.call(this);
        };
        const b = extendWithReflect(a);
        b.prototype.a = function() {};
        return new b();
    }
    try {
        testReflectExtension();
        return extendWithReflect;
    } catch (error) {
        return (constructor)=>class extended extends constructor {
            };
    }
})();
function $c8b99022ff3c634f$var$blessDefinition(definition) {
    return {
        identifier: definition.identifier,
        controllerConstructor: $c8b99022ff3c634f$var$bless(definition.controllerConstructor)
    };
}
class $c8b99022ff3c634f$var$Module {
    constructor(application, definition){
        this.application = application;
        this.definition = $c8b99022ff3c634f$var$blessDefinition(definition);
        this.contextsByScope = new WeakMap();
        this.connectedContexts = new Set();
    }
    get identifier() {
        return this.definition.identifier;
    }
    get controllerConstructor() {
        return this.definition.controllerConstructor;
    }
    get contexts() {
        return Array.from(this.connectedContexts);
    }
    connectContextForScope(scope) {
        const context = this.fetchContextForScope(scope);
        this.connectedContexts.add(context);
        context.connect();
    }
    disconnectContextForScope(scope) {
        const context = this.contextsByScope.get(scope);
        if (context) {
            this.connectedContexts.delete(context);
            context.disconnect();
        }
    }
    fetchContextForScope(scope) {
        let context = this.contextsByScope.get(scope);
        if (!context) {
            context = new $c8b99022ff3c634f$export$841858b892ce1f4c(this, scope);
            this.contextsByScope.set(scope, context);
        }
        return context;
    }
}
class $c8b99022ff3c634f$var$ClassMap {
    constructor(scope){
        this.scope = scope;
    }
    has(name) {
        return this.data.has(this.getDataKey(name));
    }
    get(name) {
        return this.getAll(name)[0];
    }
    getAll(name) {
        const tokenString = this.data.get(this.getDataKey(name)) || "";
        return $c8b99022ff3c634f$var$tokenize(tokenString);
    }
    getAttributeName(name) {
        return this.data.getAttributeNameForKey(this.getDataKey(name));
    }
    getDataKey(name) {
        return `${name}-class`;
    }
    get data() {
        return this.scope.data;
    }
}
class $c8b99022ff3c634f$var$DataMap {
    constructor(scope){
        this.scope = scope;
    }
    get element() {
        return this.scope.element;
    }
    get identifier() {
        return this.scope.identifier;
    }
    get(key) {
        const name = this.getAttributeNameForKey(key);
        return this.element.getAttribute(name);
    }
    set(key, value) {
        const name = this.getAttributeNameForKey(key);
        this.element.setAttribute(name, value);
        return this.get(key);
    }
    has(key) {
        const name = this.getAttributeNameForKey(key);
        return this.element.hasAttribute(name);
    }
    delete(key) {
        if (this.has(key)) {
            const name = this.getAttributeNameForKey(key);
            this.element.removeAttribute(name);
            return true;
        } else return false;
    }
    getAttributeNameForKey(key) {
        return `data-${this.identifier}-${$c8b99022ff3c634f$var$dasherize(key)}`;
    }
}
class $c8b99022ff3c634f$var$Guide {
    constructor(logger){
        this.warnedKeysByObject = new WeakMap();
        this.logger = logger;
    }
    warn(object, key, message) {
        let warnedKeys = this.warnedKeysByObject.get(object);
        if (!warnedKeys) {
            warnedKeys = new Set();
            this.warnedKeysByObject.set(object, warnedKeys);
        }
        if (!warnedKeys.has(key)) {
            warnedKeys.add(key);
            this.logger.warn(message, object);
        }
    }
}
function $c8b99022ff3c634f$var$attributeValueContainsToken(attributeName, token) {
    return `[${attributeName}~="${token}"]`;
}
class $c8b99022ff3c634f$var$TargetSet {
    constructor(scope){
        this.scope = scope;
    }
    get element() {
        return this.scope.element;
    }
    get identifier() {
        return this.scope.identifier;
    }
    get schema() {
        return this.scope.schema;
    }
    has(targetName) {
        return this.find(targetName) != null;
    }
    find(...targetNames) {
        return targetNames.reduce((target, targetName)=>target || this.findTarget(targetName) || this.findLegacyTarget(targetName), undefined);
    }
    findAll(...targetNames) {
        return targetNames.reduce((targets, targetName)=>[
                ...targets,
                ...this.findAllTargets(targetName),
                ...this.findAllLegacyTargets(targetName)
            ], []);
    }
    findTarget(targetName) {
        const selector = this.getSelectorForTargetName(targetName);
        return this.scope.findElement(selector);
    }
    findAllTargets(targetName) {
        const selector = this.getSelectorForTargetName(targetName);
        return this.scope.findAllElements(selector);
    }
    getSelectorForTargetName(targetName) {
        const attributeName = this.schema.targetAttributeForScope(this.identifier);
        return $c8b99022ff3c634f$var$attributeValueContainsToken(attributeName, targetName);
    }
    findLegacyTarget(targetName) {
        const selector = this.getLegacySelectorForTargetName(targetName);
        return this.deprecate(this.scope.findElement(selector), targetName);
    }
    findAllLegacyTargets(targetName) {
        const selector = this.getLegacySelectorForTargetName(targetName);
        return this.scope.findAllElements(selector).map((element)=>this.deprecate(element, targetName));
    }
    getLegacySelectorForTargetName(targetName) {
        const targetDescriptor = `${this.identifier}.${targetName}`;
        return $c8b99022ff3c634f$var$attributeValueContainsToken(this.schema.targetAttribute, targetDescriptor);
    }
    deprecate(element, targetName) {
        if (element) {
            const { identifier: identifier } = this;
            const attributeName = this.schema.targetAttribute;
            const revisedAttributeName = this.schema.targetAttributeForScope(identifier);
            this.guide.warn(element, `target:${targetName}`, `Please replace ${attributeName}="${identifier}.${targetName}" with ${revisedAttributeName}="${targetName}". ` + `The ${attributeName} attribute is deprecated and will be removed in a future version of Stimulus.`);
        }
        return element;
    }
    get guide() {
        return this.scope.guide;
    }
}
class $c8b99022ff3c634f$var$OutletSet {
    constructor(scope, controllerElement){
        this.scope = scope;
        this.controllerElement = controllerElement;
    }
    get element() {
        return this.scope.element;
    }
    get identifier() {
        return this.scope.identifier;
    }
    get schema() {
        return this.scope.schema;
    }
    has(outletName) {
        return this.find(outletName) != null;
    }
    find(...outletNames) {
        return outletNames.reduce((outlet, outletName)=>outlet || this.findOutlet(outletName), undefined);
    }
    findAll(...outletNames) {
        return outletNames.reduce((outlets, outletName)=>[
                ...outlets,
                ...this.findAllOutlets(outletName)
            ], []);
    }
    getSelectorForOutletName(outletName) {
        const attributeName = this.schema.outletAttributeForScope(this.identifier, outletName);
        return this.controllerElement.getAttribute(attributeName);
    }
    findOutlet(outletName) {
        const selector = this.getSelectorForOutletName(outletName);
        if (selector) return this.findElement(selector, outletName);
    }
    findAllOutlets(outletName) {
        const selector = this.getSelectorForOutletName(outletName);
        return selector ? this.findAllElements(selector, outletName) : [];
    }
    findElement(selector, outletName) {
        const elements = this.scope.queryElements(selector);
        return elements.filter((element)=>this.matchesElement(element, selector, outletName))[0];
    }
    findAllElements(selector, outletName) {
        const elements = this.scope.queryElements(selector);
        return elements.filter((element)=>this.matchesElement(element, selector, outletName));
    }
    matchesElement(element, selector, outletName) {
        const controllerAttribute = element.getAttribute(this.scope.schema.controllerAttribute) || "";
        return element.matches(selector) && controllerAttribute.split(" ").includes(outletName);
    }
}
class $c8b99022ff3c634f$var$Scope {
    constructor(schema, element, identifier, logger){
        this.targets = new $c8b99022ff3c634f$var$TargetSet(this);
        this.classes = new $c8b99022ff3c634f$var$ClassMap(this);
        this.data = new $c8b99022ff3c634f$var$DataMap(this);
        this.containsElement = (element)=>{
            return element.closest(this.controllerSelector) === this.element;
        };
        this.schema = schema;
        this.element = element;
        this.identifier = identifier;
        this.guide = new $c8b99022ff3c634f$var$Guide(logger);
        this.outlets = new $c8b99022ff3c634f$var$OutletSet(this.documentScope, element);
    }
    findElement(selector) {
        return this.element.matches(selector) ? this.element : this.queryElements(selector).find(this.containsElement);
    }
    findAllElements(selector) {
        return [
            ...this.element.matches(selector) ? [
                this.element
            ] : [],
            ...this.queryElements(selector).filter(this.containsElement)
        ];
    }
    queryElements(selector) {
        return Array.from(this.element.querySelectorAll(selector));
    }
    get controllerSelector() {
        return $c8b99022ff3c634f$var$attributeValueContainsToken(this.schema.controllerAttribute, this.identifier);
    }
    get isDocumentScope() {
        return this.element === document.documentElement;
    }
    get documentScope() {
        return this.isDocumentScope ? this : new $c8b99022ff3c634f$var$Scope(this.schema, document.documentElement, this.identifier, this.guide.logger);
    }
}
class $c8b99022ff3c634f$var$ScopeObserver {
    constructor(element, schema, delegate){
        this.element = element;
        this.schema = schema;
        this.delegate = delegate;
        this.valueListObserver = new $c8b99022ff3c634f$export$d27fa4c7330a452e(this.element, this.controllerAttribute, this);
        this.scopesByIdentifierByElement = new WeakMap();
        this.scopeReferenceCounts = new WeakMap();
    }
    start() {
        this.valueListObserver.start();
    }
    stop() {
        this.valueListObserver.stop();
    }
    get controllerAttribute() {
        return this.schema.controllerAttribute;
    }
    parseValueForToken(token) {
        const { element: element, content: identifier } = token;
        return this.parseValueForElementAndIdentifier(element, identifier);
    }
    parseValueForElementAndIdentifier(element, identifier) {
        const scopesByIdentifier = this.fetchScopesByIdentifierForElement(element);
        let scope = scopesByIdentifier.get(identifier);
        if (!scope) {
            scope = this.delegate.createScopeForElementAndIdentifier(element, identifier);
            scopesByIdentifier.set(identifier, scope);
        }
        return scope;
    }
    elementMatchedValue(element, value) {
        const referenceCount = (this.scopeReferenceCounts.get(value) || 0) + 1;
        this.scopeReferenceCounts.set(value, referenceCount);
        if (referenceCount == 1) this.delegate.scopeConnected(value);
    }
    elementUnmatchedValue(element, value) {
        const referenceCount = this.scopeReferenceCounts.get(value);
        if (referenceCount) {
            this.scopeReferenceCounts.set(value, referenceCount - 1);
            if (referenceCount == 1) this.delegate.scopeDisconnected(value);
        }
    }
    fetchScopesByIdentifierForElement(element) {
        let scopesByIdentifier = this.scopesByIdentifierByElement.get(element);
        if (!scopesByIdentifier) {
            scopesByIdentifier = new Map();
            this.scopesByIdentifierByElement.set(element, scopesByIdentifier);
        }
        return scopesByIdentifier;
    }
}
class $c8b99022ff3c634f$var$Router {
    constructor(application){
        this.application = application;
        this.scopeObserver = new $c8b99022ff3c634f$var$ScopeObserver(this.element, this.schema, this);
        this.scopesByIdentifier = new $c8b99022ff3c634f$export$8bd4ad37b76db6ba();
        this.modulesByIdentifier = new Map();
    }
    get element() {
        return this.application.element;
    }
    get schema() {
        return this.application.schema;
    }
    get logger() {
        return this.application.logger;
    }
    get controllerAttribute() {
        return this.schema.controllerAttribute;
    }
    get modules() {
        return Array.from(this.modulesByIdentifier.values());
    }
    get contexts() {
        return this.modules.reduce((contexts, module)=>contexts.concat(module.contexts), []);
    }
    start() {
        this.scopeObserver.start();
    }
    stop() {
        this.scopeObserver.stop();
    }
    loadDefinition(definition) {
        this.unloadIdentifier(definition.identifier);
        const module = new $c8b99022ff3c634f$var$Module(this.application, definition);
        this.connectModule(module);
        const afterLoad = definition.controllerConstructor.afterLoad;
        if (afterLoad) afterLoad.call(definition.controllerConstructor, definition.identifier, this.application);
    }
    unloadIdentifier(identifier) {
        const module = this.modulesByIdentifier.get(identifier);
        if (module) this.disconnectModule(module);
    }
    getContextForElementAndIdentifier(element, identifier) {
        const module = this.modulesByIdentifier.get(identifier);
        if (module) return module.contexts.find((context)=>context.element == element);
    }
    proposeToConnectScopeForElementAndIdentifier(element, identifier) {
        const scope = this.scopeObserver.parseValueForElementAndIdentifier(element, identifier);
        if (scope) this.scopeObserver.elementMatchedValue(scope.element, scope);
        else console.error(`Couldn't find or create scope for identifier: "${identifier}" and element:`, element);
    }
    handleError(error, message, detail) {
        this.application.handleError(error, message, detail);
    }
    createScopeForElementAndIdentifier(element, identifier) {
        return new $c8b99022ff3c634f$var$Scope(this.schema, element, identifier, this.logger);
    }
    scopeConnected(scope) {
        this.scopesByIdentifier.add(scope.identifier, scope);
        const module = this.modulesByIdentifier.get(scope.identifier);
        if (module) module.connectContextForScope(scope);
    }
    scopeDisconnected(scope) {
        this.scopesByIdentifier.delete(scope.identifier, scope);
        const module = this.modulesByIdentifier.get(scope.identifier);
        if (module) module.disconnectContextForScope(scope);
    }
    connectModule(module) {
        this.modulesByIdentifier.set(module.identifier, module);
        const scopes = this.scopesByIdentifier.getValuesForKey(module.identifier);
        scopes.forEach((scope)=>module.connectContextForScope(scope));
    }
    disconnectModule(module) {
        this.modulesByIdentifier.delete(module.identifier);
        const scopes = this.scopesByIdentifier.getValuesForKey(module.identifier);
        scopes.forEach((scope)=>module.disconnectContextForScope(scope));
    }
}
const $c8b99022ff3c634f$export$1db618b7b2275ea1 = {
    controllerAttribute: "data-controller",
    actionAttribute: "data-action",
    targetAttribute: "data-target",
    targetAttributeForScope: (identifier)=>`data-${identifier}-target`,
    outletAttributeForScope: (identifier, outlet)=>`data-${identifier}-${outlet}-outlet`,
    keyMappings: Object.assign(Object.assign({
        enter: "Enter",
        tab: "Tab",
        esc: "Escape",
        space: " ",
        up: "ArrowUp",
        down: "ArrowDown",
        left: "ArrowLeft",
        right: "ArrowRight",
        home: "Home",
        end: "End",
        page_up: "PageUp",
        page_down: "PageDown"
    }, $c8b99022ff3c634f$var$objectFromEntries("abcdefghijklmnopqrstuvwxyz".split("").map((c)=>[
            c,
            c
        ]))), $c8b99022ff3c634f$var$objectFromEntries("0123456789".split("").map((n)=>[
            n,
            n
        ])))
};
function $c8b99022ff3c634f$var$objectFromEntries(array) {
    return array.reduce((memo, [k, v])=>Object.assign(Object.assign({}, memo), {
            [k]: v
        }), {});
}
class $c8b99022ff3c634f$export$16975c34e60e1e61 {
    constructor(element = document.documentElement, schema = $c8b99022ff3c634f$export$1db618b7b2275ea1){
        this.logger = console;
        this.debug = false;
        this.logDebugActivity = (identifier, functionName, detail = {})=>{
            if (this.debug) this.logFormattedMessage(identifier, functionName, detail);
        };
        this.element = element;
        this.schema = schema;
        this.dispatcher = new $c8b99022ff3c634f$var$Dispatcher(this);
        this.router = new $c8b99022ff3c634f$var$Router(this);
        this.actionDescriptorFilters = Object.assign({}, $c8b99022ff3c634f$var$defaultActionDescriptorFilters);
    }
    static start(element, schema) {
        const application = new this(element, schema);
        application.start();
        return application;
    }
    async start() {
        await $c8b99022ff3c634f$var$domReady();
        this.logDebugActivity("application", "starting");
        this.dispatcher.start();
        this.router.start();
        this.logDebugActivity("application", "start");
    }
    stop() {
        this.logDebugActivity("application", "stopping");
        this.dispatcher.stop();
        this.router.stop();
        this.logDebugActivity("application", "stop");
    }
    register(identifier, controllerConstructor) {
        this.load({
            identifier: identifier,
            controllerConstructor: controllerConstructor
        });
    }
    registerActionOption(name, filter) {
        this.actionDescriptorFilters[name] = filter;
    }
    load(head, ...rest) {
        const definitions = Array.isArray(head) ? head : [
            head,
            ...rest
        ];
        definitions.forEach((definition)=>{
            if (definition.controllerConstructor.shouldLoad) this.router.loadDefinition(definition);
        });
    }
    unload(head, ...rest) {
        const identifiers = Array.isArray(head) ? head : [
            head,
            ...rest
        ];
        identifiers.forEach((identifier)=>this.router.unloadIdentifier(identifier));
    }
    get controllers() {
        return this.router.contexts.map((context)=>context.controller);
    }
    getControllerForElementAndIdentifier(element, identifier) {
        const context = this.router.getContextForElementAndIdentifier(element, identifier);
        return context ? context.controller : null;
    }
    handleError(error, message, detail) {
        var _a;
        this.logger.error(`%s\n\n%o\n\n%o`, message, error, detail);
        (_a = window.onerror) === null || _a === void 0 || _a.call(window, message, "", 0, 0, error);
    }
    logFormattedMessage(identifier, functionName, detail = {}) {
        detail = Object.assign({
            application: this
        }, detail);
        this.logger.groupCollapsed(`${identifier} #${functionName}`);
        this.logger.log("details:", Object.assign({}, detail));
        this.logger.groupEnd();
    }
}
function $c8b99022ff3c634f$var$domReady() {
    return new Promise((resolve)=>{
        if (document.readyState == "loading") document.addEventListener("DOMContentLoaded", ()=>resolve());
        else resolve();
    });
}
function $c8b99022ff3c634f$var$ClassPropertiesBlessing(constructor) {
    const classes = $c8b99022ff3c634f$var$readInheritableStaticArrayValues(constructor, "classes");
    return classes.reduce((properties, classDefinition)=>{
        return Object.assign(properties, $c8b99022ff3c634f$var$propertiesForClassDefinition(classDefinition));
    }, {});
}
function $c8b99022ff3c634f$var$propertiesForClassDefinition(key) {
    return {
        [`${key}Class`]: {
            get () {
                const { classes: classes } = this;
                if (classes.has(key)) return classes.get(key);
                else {
                    const attribute = classes.getAttributeName(key);
                    throw new Error(`Missing attribute "${attribute}"`);
                }
            }
        },
        [`${key}Classes`]: {
            get () {
                return this.classes.getAll(key);
            }
        },
        [`has${$c8b99022ff3c634f$var$capitalize(key)}Class`]: {
            get () {
                return this.classes.has(key);
            }
        }
    };
}
function $c8b99022ff3c634f$var$OutletPropertiesBlessing(constructor) {
    const outlets = $c8b99022ff3c634f$var$readInheritableStaticArrayValues(constructor, "outlets");
    return outlets.reduce((properties, outletDefinition)=>{
        return Object.assign(properties, $c8b99022ff3c634f$var$propertiesForOutletDefinition(outletDefinition));
    }, {});
}
function $c8b99022ff3c634f$var$getOutletController(controller, element, identifier) {
    return controller.application.getControllerForElementAndIdentifier(element, identifier);
}
function $c8b99022ff3c634f$var$getControllerAndEnsureConnectedScope(controller, element, outletName) {
    let outletController = $c8b99022ff3c634f$var$getOutletController(controller, element, outletName);
    if (outletController) return outletController;
    controller.application.router.proposeToConnectScopeForElementAndIdentifier(element, outletName);
    outletController = $c8b99022ff3c634f$var$getOutletController(controller, element, outletName);
    if (outletController) return outletController;
}
function $c8b99022ff3c634f$var$propertiesForOutletDefinition(name) {
    const camelizedName = $c8b99022ff3c634f$var$namespaceCamelize(name);
    return {
        [`${camelizedName}Outlet`]: {
            get () {
                const outletElement = this.outlets.find(name);
                const selector = this.outlets.getSelectorForOutletName(name);
                if (outletElement) {
                    const outletController = $c8b99022ff3c634f$var$getControllerAndEnsureConnectedScope(this, outletElement, name);
                    if (outletController) return outletController;
                    throw new Error(`The provided outlet element is missing an outlet controller "${name}" instance for host controller "${this.identifier}"`);
                }
                throw new Error(`Missing outlet element "${name}" for host controller "${this.identifier}". Stimulus couldn't find a matching outlet element using selector "${selector}".`);
            }
        },
        [`${camelizedName}Outlets`]: {
            get () {
                const outlets = this.outlets.findAll(name);
                if (outlets.length > 0) return outlets.map((outletElement)=>{
                    const outletController = $c8b99022ff3c634f$var$getControllerAndEnsureConnectedScope(this, outletElement, name);
                    if (outletController) return outletController;
                    console.warn(`The provided outlet element is missing an outlet controller "${name}" instance for host controller "${this.identifier}"`, outletElement);
                }).filter((controller)=>controller);
                return [];
            }
        },
        [`${camelizedName}OutletElement`]: {
            get () {
                const outletElement = this.outlets.find(name);
                const selector = this.outlets.getSelectorForOutletName(name);
                if (outletElement) return outletElement;
                else throw new Error(`Missing outlet element "${name}" for host controller "${this.identifier}". Stimulus couldn't find a matching outlet element using selector "${selector}".`);
            }
        },
        [`${camelizedName}OutletElements`]: {
            get () {
                return this.outlets.findAll(name);
            }
        },
        [`has${$c8b99022ff3c634f$var$capitalize(camelizedName)}Outlet`]: {
            get () {
                return this.outlets.has(name);
            }
        }
    };
}
function $c8b99022ff3c634f$var$TargetPropertiesBlessing(constructor) {
    const targets = $c8b99022ff3c634f$var$readInheritableStaticArrayValues(constructor, "targets");
    return targets.reduce((properties, targetDefinition)=>{
        return Object.assign(properties, $c8b99022ff3c634f$var$propertiesForTargetDefinition(targetDefinition));
    }, {});
}
function $c8b99022ff3c634f$var$propertiesForTargetDefinition(name) {
    return {
        [`${name}Target`]: {
            get () {
                const target = this.targets.find(name);
                if (target) return target;
                else throw new Error(`Missing target element "${name}" for "${this.identifier}" controller`);
            }
        },
        [`${name}Targets`]: {
            get () {
                return this.targets.findAll(name);
            }
        },
        [`has${$c8b99022ff3c634f$var$capitalize(name)}Target`]: {
            get () {
                return this.targets.has(name);
            }
        }
    };
}
function $c8b99022ff3c634f$var$ValuePropertiesBlessing(constructor) {
    const valueDefinitionPairs = $c8b99022ff3c634f$var$readInheritableStaticObjectPairs(constructor, "values");
    const propertyDescriptorMap = {
        valueDescriptorMap: {
            get () {
                return valueDefinitionPairs.reduce((result, valueDefinitionPair)=>{
                    const valueDescriptor = $c8b99022ff3c634f$var$parseValueDefinitionPair(valueDefinitionPair, this.identifier);
                    const attributeName = this.data.getAttributeNameForKey(valueDescriptor.key);
                    return Object.assign(result, {
                        [attributeName]: valueDescriptor
                    });
                }, {});
            }
        }
    };
    return valueDefinitionPairs.reduce((properties, valueDefinitionPair)=>{
        return Object.assign(properties, $c8b99022ff3c634f$var$propertiesForValueDefinitionPair(valueDefinitionPair));
    }, propertyDescriptorMap);
}
function $c8b99022ff3c634f$var$propertiesForValueDefinitionPair(valueDefinitionPair, controller) {
    const definition = $c8b99022ff3c634f$var$parseValueDefinitionPair(valueDefinitionPair, controller);
    const { key: key, name: name, reader: read, writer: write } = definition;
    return {
        [name]: {
            get () {
                const value = this.data.get(key);
                if (value !== null) return read(value);
                else return definition.defaultValue;
            },
            set (value) {
                if (value === undefined) this.data.delete(key);
                else this.data.set(key, write(value));
            }
        },
        [`has${$c8b99022ff3c634f$var$capitalize(name)}`]: {
            get () {
                return this.data.has(key) || definition.hasCustomDefaultValue;
            }
        }
    };
}
function $c8b99022ff3c634f$var$parseValueDefinitionPair([token, typeDefinition], controller) {
    return $c8b99022ff3c634f$var$valueDescriptorForTokenAndTypeDefinition({
        controller: controller,
        token: token,
        typeDefinition: typeDefinition
    });
}
function $c8b99022ff3c634f$var$parseValueTypeConstant(constant) {
    switch(constant){
        case Array:
            return "array";
        case Boolean:
            return "boolean";
        case Number:
            return "number";
        case Object:
            return "object";
        case String:
            return "string";
    }
}
function $c8b99022ff3c634f$var$parseValueTypeDefault(defaultValue) {
    switch(typeof defaultValue){
        case "boolean":
            return "boolean";
        case "number":
            return "number";
        case "string":
            return "string";
    }
    if (Array.isArray(defaultValue)) return "array";
    if (Object.prototype.toString.call(defaultValue) === "[object Object]") return "object";
}
function $c8b99022ff3c634f$var$parseValueTypeObject(payload) {
    const { controller: controller, token: token, typeObject: typeObject } = payload;
    const hasType = $c8b99022ff3c634f$var$isSomething(typeObject.type);
    const hasDefault = $c8b99022ff3c634f$var$isSomething(typeObject.default);
    const fullObject = hasType && hasDefault;
    const onlyType = hasType && !hasDefault;
    const onlyDefault = !hasType && hasDefault;
    const typeFromObject = $c8b99022ff3c634f$var$parseValueTypeConstant(typeObject.type);
    const typeFromDefaultValue = $c8b99022ff3c634f$var$parseValueTypeDefault(payload.typeObject.default);
    if (onlyType) return typeFromObject;
    if (onlyDefault) return typeFromDefaultValue;
    if (typeFromObject !== typeFromDefaultValue) {
        const propertyPath = controller ? `${controller}.${token}` : token;
        throw new Error(`The specified default value for the Stimulus Value "${propertyPath}" must match the defined type "${typeFromObject}". The provided default value of "${typeObject.default}" is of type "${typeFromDefaultValue}".`);
    }
    if (fullObject) return typeFromObject;
}
function $c8b99022ff3c634f$var$parseValueTypeDefinition(payload) {
    const { controller: controller, token: token, typeDefinition: typeDefinition } = payload;
    const typeObject = {
        controller: controller,
        token: token,
        typeObject: typeDefinition
    };
    const typeFromObject = $c8b99022ff3c634f$var$parseValueTypeObject(typeObject);
    const typeFromDefaultValue = $c8b99022ff3c634f$var$parseValueTypeDefault(typeDefinition);
    const typeFromConstant = $c8b99022ff3c634f$var$parseValueTypeConstant(typeDefinition);
    const type = typeFromObject || typeFromDefaultValue || typeFromConstant;
    if (type) return type;
    const propertyPath = controller ? `${controller}.${typeDefinition}` : token;
    throw new Error(`Unknown value type "${propertyPath}" for "${token}" value`);
}
function $c8b99022ff3c634f$var$defaultValueForDefinition(typeDefinition) {
    const constant = $c8b99022ff3c634f$var$parseValueTypeConstant(typeDefinition);
    if (constant) return $c8b99022ff3c634f$var$defaultValuesByType[constant];
    const hasDefault = $c8b99022ff3c634f$var$hasProperty(typeDefinition, "default");
    const hasType = $c8b99022ff3c634f$var$hasProperty(typeDefinition, "type");
    const typeObject = typeDefinition;
    if (hasDefault) return typeObject.default;
    if (hasType) {
        const { type: type } = typeObject;
        const constantFromType = $c8b99022ff3c634f$var$parseValueTypeConstant(type);
        if (constantFromType) return $c8b99022ff3c634f$var$defaultValuesByType[constantFromType];
    }
    return typeDefinition;
}
function $c8b99022ff3c634f$var$valueDescriptorForTokenAndTypeDefinition(payload) {
    const { token: token, typeDefinition: typeDefinition } = payload;
    const key = `${$c8b99022ff3c634f$var$dasherize(token)}-value`;
    const type = $c8b99022ff3c634f$var$parseValueTypeDefinition(payload);
    return {
        type: type,
        key: key,
        name: $c8b99022ff3c634f$var$camelize(key),
        get defaultValue () {
            return $c8b99022ff3c634f$var$defaultValueForDefinition(typeDefinition);
        },
        get hasCustomDefaultValue () {
            return $c8b99022ff3c634f$var$parseValueTypeDefault(typeDefinition) !== undefined;
        },
        reader: $c8b99022ff3c634f$var$readers[type],
        writer: $c8b99022ff3c634f$var$writers[type] || $c8b99022ff3c634f$var$writers.default
    };
}
const $c8b99022ff3c634f$var$defaultValuesByType = {
    get array () {
        return [];
    },
    boolean: false,
    number: 0,
    get object () {
        return {};
    },
    string: ""
};
const $c8b99022ff3c634f$var$readers = {
    array (value) {
        const array = JSON.parse(value);
        if (!Array.isArray(array)) throw new TypeError(`expected value of type "array" but instead got value "${value}" of type "${$c8b99022ff3c634f$var$parseValueTypeDefault(array)}"`);
        return array;
    },
    boolean (value) {
        return !(value == "0" || String(value).toLowerCase() == "false");
    },
    number (value) {
        return Number(value.replace(/_/g, ""));
    },
    object (value) {
        const object = JSON.parse(value);
        if (object === null || typeof object != "object" || Array.isArray(object)) throw new TypeError(`expected value of type "object" but instead got value "${value}" of type "${$c8b99022ff3c634f$var$parseValueTypeDefault(object)}"`);
        return object;
    },
    string (value) {
        return value;
    }
};
const $c8b99022ff3c634f$var$writers = {
    default: $c8b99022ff3c634f$var$writeString,
    array: $c8b99022ff3c634f$var$writeJSON,
    object: $c8b99022ff3c634f$var$writeJSON
};
function $c8b99022ff3c634f$var$writeJSON(value) {
    return JSON.stringify(value);
}
function $c8b99022ff3c634f$var$writeString(value) {
    return `${value}`;
}
class $c8b99022ff3c634f$export$bd0bf19f25da8474 {
    constructor(context){
        this.context = context;
    }
    static get shouldLoad() {
        return true;
    }
    static afterLoad(_identifier, _application) {
        return;
    }
    get application() {
        return this.context.application;
    }
    get scope() {
        return this.context.scope;
    }
    get element() {
        return this.scope.element;
    }
    get identifier() {
        return this.scope.identifier;
    }
    get targets() {
        return this.scope.targets;
    }
    get outlets() {
        return this.scope.outlets;
    }
    get classes() {
        return this.scope.classes;
    }
    get data() {
        return this.scope.data;
    }
    initialize() {}
    connect() {}
    disconnect() {}
    dispatch(eventName, { target: target = this.element, detail: detail = {}, prefix: prefix = this.identifier, bubbles: bubbles = true, cancelable: cancelable = true } = {}) {
        const type = prefix ? `${prefix}:${eventName}` : eventName;
        const event = new CustomEvent(type, {
            detail: detail,
            bubbles: bubbles,
            cancelable: cancelable
        });
        target.dispatchEvent(event);
        return event;
    }
}
$c8b99022ff3c634f$export$bd0bf19f25da8474.blessings = [
    $c8b99022ff3c634f$var$ClassPropertiesBlessing,
    $c8b99022ff3c634f$var$TargetPropertiesBlessing,
    $c8b99022ff3c634f$var$ValuePropertiesBlessing,
    $c8b99022ff3c634f$var$OutletPropertiesBlessing
];
$c8b99022ff3c634f$export$bd0bf19f25da8474.targets = [];
$c8b99022ff3c634f$export$bd0bf19f25da8474.outlets = [];
$c8b99022ff3c634f$export$bd0bf19f25da8474.values = {};



class $730b239cf4b48d74$export$2e2bcd8739ae039 extends (0, $c8b99022ff3c634f$export$bd0bf19f25da8474) {
    static targets = [
        "colorModeButton",
        "lightIcon",
        "darkIcon",
        "autoIcon",
        "lightText",
        "darkText",
        "autoText"
    ];
    static values = {
        lightMode: String,
        darkMode: String,
        autoMode: String
    };
    connect() {
        const colorMode = this.getPreferredColorMode();
        this.setColorMode(colorMode);
    }
    getPreferredColorMode() {
        const storedColorMode = this.getStoredColorMode();
        if (storedColorMode === 'light' || storedColorMode === 'dark' || storedColorMode === 'auto') return storedColorMode;
        return 'light';
    }
    setColorMode(colorMode) {
        if (colorMode === 'auto' && window.matchMedia('(prefers-color-scheme: dark)').matches) document.documentElement.setAttribute('data-bs-theme', 'dark');
        else if (colorMode === 'auto' && window.matchMedia('(prefers-color-scheme: light)').matches) document.documentElement.setAttribute('data-bs-theme', 'light');
        else if (colorMode === 'dark') document.documentElement.setAttribute('data-bs-theme', 'dark');
        else document.documentElement.setAttribute('data-bs-theme', 'light');
        this.storeColorMode(colorMode);
        this.setUI(colorMode);
    }
    setLightColorMode() {
        this.setColorMode('light');
    }
    setDarkColorMode() {
        this.setColorMode('dark');
    }
    setAutoColorMode() {
        this.setColorMode('auto');
    }
    getStoredColorMode() {
        return localStorage.getItem('color-mode');
    }
    storeColorMode(colorMode) {
        localStorage.setItem('color-mode', colorMode);
    }
    setUI(colorMode) {
        if (colorMode === 'light') this.colorModeButtonTarget.innerHTML = `${this.lightIconTarget.outerHTML}${this.lightTextTarget.outerHTML}`;
        else if (colorMode === 'dark') this.colorModeButtonTarget.innerHTML = `${this.darkIconTarget.outerHTML}${this.darkTextTarget.outerHTML}`;
        else this.colorModeButtonTarget.innerHTML = `${this.autoIconTarget.outerHTML}${this.autoTextTarget.outerHTML}`;
    }
}



class $07e8f9449b8acef1$export$2e2bcd8739ae039 extends (0, $c8b99022ff3c634f$export$bd0bf19f25da8474) {
    static targets = [
        "target",
        "template",
        "emptyMessage"
    ];
    static values = {
        wrapperSelector: {
            type: String,
            default: ".nested-form-wrapper"
        }
    };
    connect() {
        this.updateUI();
    }
    add(event) {
        event.preventDefault();
        const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime().toString());
        this.targetTarget.insertAdjacentHTML("beforeend", content);
        const customEvent = new CustomEvent("nested-form:add", {
            bubbles: true
        });
        this.element.dispatchEvent(customEvent);
        this.updateUI();
    }
    remove(event) {
        event.preventDefault();
        const wrapper = event.target.closest(this.wrapperSelectorValue);
        if (wrapper.dataset.newRecord === "true") wrapper.remove();
        else {
            wrapper.style.display = "none";
            const input = wrapper.querySelector("input[name*='_destroy']");
            input.value = "1";
        }
        const customEvent = new CustomEvent("rails-nested-form:remove", {
            bubbles: true
        });
        this.element.dispatchEvent(customEvent);
        this.updateUI();
    }
    // @private
    updateUI() {
        // Show or hide the "empty message" that gets displayed when there are no nested forms
        // currently visible.
        if (this.hasEmptyMessageTarget) this.emptyMessageTarget.hidden = this.noOfVisibleNestedForms > 0;
        // Show or hide the target element based on the number of visible nested forms.
        // We hide the target with `display: none !important` to ensure it is not displayed
        // and also works when styling the element using flexbox and gap utilities.
        if (this.noOfVisibleNestedForms <= 0) this.targetTarget.style.setProperty("display", "none", "important");
        else this.targetTarget.style.setProperty("display", "inherit");
    }
    // @private
    get noOfVisibleNestedForms() {
        // Find all wrapper that are not hidden and directly children of the target element
        const visibleWrappers = Array.from(this.targetTarget.children).filter((wrapper)=>wrapper.matches(this.wrapperSelectorValue) && wrapper.style.display !== "none");
        return visibleWrappers.length;
    }
}



class $4ca809d63d45f9a1$export$2e2bcd8739ae039 extends (0, $c8b99022ff3c634f$export$bd0bf19f25da8474) {
    static targets = [
        "input",
        "results",
        "selectedValueInput",
        "selectedValueContainer",
        "resultTemplate"
    ];
    static classes = [
        "resultsDefault",
        "resultsHidden",
        "resultsVisible"
    ];
    static values = {
        url: String,
        minLength: {
            type: Number,
            default: 3
        },
        delay: {
            type: Number,
            default: 150
        },
        queryParam: {
            type: String,
            default: "query"
        },
        hideEmptySelectedValue: {
            type: Boolean,
            default: true
        }
    };
    connect() {
        this.inputTarget.setAttribute("autocomplete", "off");
        this.inputTarget.setAttribute("spellcheck", "false");
        this.inputTarget.addEventListener("input", $4ca809d63d45f9a1$var$debounce(this.onInputChange, this.delayValue));
        this.inputTarget.addEventListener("keydown", this.onInputKeydown);
        this.inputTarget.addEventListener("blur", this.onInputBlur);
        this.resultsTarget.classList.add(this.resultsDefaultClass);
        this.resultsTarget.addEventListener("mousedown", this.onResultsMouseDown);
        this.resultsTarget.addEventListener("click", this.onResultsClick);
        this.closeResults();
        this.hideOrShowSelectedValueContainer();
    }
    disconnect() {
        this.inputTarget.removeEventListener("input", this.onInputChange);
        this.inputTarget.removeEventListener("keydown", this.onInputKeydown);
        this.inputTarget.removeEventListener("blur", this.onInputBlur);
        this.resultsTarget.removeEventListener("mousedown", this.onResultsMouseDown);
        this.resultsTarget.removeEventListener("click", this.onResultsClick);
    }
    /*
  **
  ** Event handling
  **
  */ onInputChange = ()=>{
        this.clearSelectedValue();
        this.queryResults();
    };
    onInputBlur = (event)=>{
        // Ignore blur if mouse is down on results. Otherwise we will not be able to select a result with a mouse click.
        if (this.mouseDown) return;
        this.closeResults();
    };
    onInputKeydown = (event)=>{
        const handler = this[`onInput${event.key}Keydown`];
        if (handler) handler(event);
    };
    onInputEscapeKeydown = (event)=>{
        event.preventDefault();
        this.closeResults();
    };
    onInputArrowDownKeydown = (event)=>{
        event.preventDefault();
        const resultNode = this.nextResultNode({
            direction: "next"
        });
        if (resultNode) this.selectResult(resultNode);
    };
    onInputArrowUpKeydown = (event)=>{
        event.preventDefault();
        const resultNode = this.nextResultNode({
            direction: "previous"
        });
        if (resultNode) this.selectResult(resultNode);
    };
    onInputEnterKeydown = (event)=>{
        event.preventDefault();
        if (this.resultsVisible) {
            const selectedResultNode = this.selectedResultNode;
            if (selectedResultNode) this.commitSelectedResult(selectedResultNode);
            else this.closeResults();
        } else this.queryResults();
    };
    onResultsMouseDown = ()=>{
        this.mouseDown = true;
        this.resultsTarget.addEventListener("mouseup", ()=>{
            this.mouseDown = false;
            this.inputTarget.focus();
        }, {
            once: true
        });
    };
    onResultsClick = (event)=>{
        event.preventDefault();
        if (!(event.target instanceof Element)) return;
        const selectedResultNode = event.target.closest("[data-autocomplete-value]");
        if (selectedResultNode) this.commitSelectedResult(selectedResultNode);
        else this.closeResults();
    };
    /*
  **
  ** Results UI handling
  **
  */ queryResults() {
        const query = this.inputTarget.value.trim();
        if (query && query.length >= this.minLengthValue) this.fetchResults(query).then((results)=>{
            if (results && Array.isArray(results) && results.length > 0) {
                this.replaceResults(results);
                this.openResults();
            } else this.closeResults();
        });
        else this.closeResults();
    }
    closeResults = ({ clear: clear = true } = {})=>{
        this.resultsTarget.classList.remove(this.resultsVisibleClass);
        this.resultsTarget.classList.add(this.resultsHiddenClass);
        this.resultsTarget.hidden = true;
        if (clear) this.replaceResults([]);
    };
    openResults() {
        this.resultsTarget.classList.remove(this.resultsHiddenClass);
        this.resultsTarget.classList.add(this.resultsVisibleClass);
        this.resultsTarget.hidden = false;
    }
    get resultsVisible() {
        return !this.resultsTarget.hidden;
    }
    get resultsHidden() {
        return !this.resultsVisible;
    }
    replaceResults(results) {
        this.resultsTarget.innerHTML = "";
        if (Array.isArray(results) && results.length > 0) results.forEach((result)=>{
            const resultNode = this.resultTemplateTarget.content.cloneNode(true).firstElementChild;
            resultNode.textContent = result.label;
            resultNode.dataset.autocompleteValue = result.value;
            this.resultsTarget.appendChild(resultNode);
        });
    }
    hideOrShowSelectedValueContainer() {
        if (!this.hideEmptySelectedValueValue) return;
        if (!this.hasSelectedValueInputTarget) return;
        if (!this.hasSelectedValueContainerTarget) return;
        const value = this.selectedValueInputTarget.value;
        this.selectedValueContainerTarget.hidden = !value;
    }
    /*
  **
  ** Results selection handling
  **
  */ nextResultNode({ direction: direction = "next" } = {}) {
        const resultNodes = this.resultNodes;
        const selectedResultNode = this.selectedResultNode;
        const index = resultNodes.indexOf(selectedResultNode);
        const sibling = direction === "next" ? resultNodes[index + 1] : resultNodes[index - 1];
        const def = direction === "next" ? resultNodes[0] : resultNodes[resultNodes.length - 1];
        return sibling || def;
    }
    get resultNodes() {
        return Array.from(this.resultsTarget.querySelectorAll("[data-autocomplete-value]"));
    }
    get selectedResultNode() {
        return this.resultsTarget.querySelector("[data-autocomplete-value].active");
    }
    selectResult(resultNode) {
        const previouslySelected = this.selectedResultNode;
        if (previouslySelected) {
            previouslySelected.classList.remove("active");
            previouslySelected.removeAttribute("aria-current");
        }
        resultNode.classList.add("active");
        resultNode.setAttribute("aria-current", "true");
        resultNode.scrollIntoView({
            behavior: "auto",
            block: "nearest"
        });
    }
    commitSelectedResult(selectedResultNode) {
        if (!selectedResultNode) return;
        const textValue = selectedResultNode.textContent.trim();
        const value = selectedResultNode.dataset.autocompleteValue || textValue;
        this.selectedValue = value;
        this.inputTarget.value = textValue;
        this.inputTarget.focus();
        this.element.scrollIntoView({
            behavior: "auto",
            block: "nearest"
        });
        this.closeResults();
    }
    clearSelectedValue() {
        this.selectedValue = "";
    }
    set selectedValue(value) {
        if (this.hasSelectedValueInputTarget) {
            this.selectedValueInputTarget.value = value;
            this.hideOrShowSelectedValueContainer();
        }
    }
    /*
  **
  ** Network tasks
  **
  */ fetchResults = async (query)=>{
        if (!this.hasUrlValue) return;
        const url = this.buildURL(query);
        const data = await this.doFetch(url);
        return data;
    };
    buildURL(query) {
        const url = new URL(this.urlValue, window.location.href);
        const params = new URLSearchParams(url.search.slice(1));
        params.append(this.queryParamValue, query);
        url.search = params.toString();
        return url.toString();
    }
    doFetch = async (url)=>{
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Server request failed: ${response.statusText}`);
        const data = await response.json();
        return data;
    };
}
const $4ca809d63d45f9a1$var$debounce = (fn, delay = 10)=>{
    let timeoutId = null;
    return (...args)=>{
        clearTimeout(timeoutId);
        timeoutId = setTimeout(fn, delay);
    };
};



class $242c575d17b95698$export$2e2bcd8739ae039 extends (0, $c8b99022ff3c634f$export$bd0bf19f25da8474) {
    static targets = [
        "container"
    ];
    static classes = [
        "container"
    ];
    connect() {
        if (this.hasContainerClass) this.containerTarget.classList.add(this.containerClass);
        this.hideStickybar();
        this._observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                this.setStickybarVisible(!entry.isIntersecting);
            });
        }, {
            threshold: 0.1
        });
        this._observer.observe(this.element);
    }
    disconnect() {
        if (this._observer) {
            this._observer.disconnect();
            this._observer = null;
        }
    }
    setStickybarVisible(visible) {
        visible ? this.showStickybar() : this.hideStickybar();
    }
    showStickybar() {
        this.containerTarget.style.display = "inherit";
    }
    hideStickybar() {
        this.containerTarget.style.display = "none";
    }
}



class $d90d775eacadaaad$export$2e2bcd8739ae039 extends (0, $c8b99022ff3c634f$export$bd0bf19f25da8474) {
    static targets = [
        "nameTypeSelect",
        "singleNameInputGroup",
        "singleNameInput",
        "detailedNameInputGroup",
        "givenNameInput",
        "familyNameInput"
    ];
    static values = {
        isPersonal: {
            type: String,
            default: "Personal"
        }
    };
    connect() {
        if (!this.hasNameTypeSelectTarget) return;
        this.nameTypeSelectTarget.addEventListener("change", (function() {
            this.toggleNameInputs(true);
        }).bind(this));
        this.toggleNameInputs(false);
    }
    disconnect() {
        if (!this.hasNameTypeSelectTarget) return;
        this.nameTypeSelectTarget.removeEventListener("change", this.toggleNameInputs);
    }
    toggleNameInputs(clearInputs = false) {
        const isPersonal = this.nameTypeSelectTarget.value === this.isPersonalValue;
        if (clearInputs) {
            this.givenNameInputTarget.value = "";
            this.familyNameInputTarget.value = "";
            this.singleNameInputTarget.value = "";
        }
        if (this.hasSingleNameInputGroupTarget) this.singleNameInputGroupTarget.style.display = isPersonal ? "none" : "block";
        if (this.hasDetailedNameInputGroupTarget) this.detailedNameInputGroupTarget.style.display = isPersonal ? "block" : "none";
    }
}



/*!
  * Bootstrap v5.3.8 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ var $9c7d6940ce3062ea$exports = {};

$parcel$export($9c7d6940ce3062ea$exports, "popperGenerator", function () { return $36f6067a80e359f0$export$ed5e13716264f202; });
$parcel$export($9c7d6940ce3062ea$exports, "detectOverflow", function () { return $eeb30ec09a46be00$export$2e2bcd8739ae039; });
$parcel$export($9c7d6940ce3062ea$exports, "createPopperBase", function () { return $36f6067a80e359f0$export$8f7491d57c8f97a9; });
$parcel$export($9c7d6940ce3062ea$exports, "createPopper", function () { return $cbce3287da02ea86$export$8f7491d57c8f97a9; });
$parcel$export($9c7d6940ce3062ea$exports, "createPopperLite", function () { return $c6c5dcfbc6208579$export$8f7491d57c8f97a9; });
var $f5f5dc8e799584a0$exports = {};

$parcel$export($f5f5dc8e799584a0$exports, "top", function () { return $f5f5dc8e799584a0$export$1e95b668f3b82d; });
$parcel$export($f5f5dc8e799584a0$exports, "bottom", function () { return $f5f5dc8e799584a0$export$40e543e69a8b3fbb; });
$parcel$export($f5f5dc8e799584a0$exports, "right", function () { return $f5f5dc8e799584a0$export$79ffe56a765070d2; });
$parcel$export($f5f5dc8e799584a0$exports, "left", function () { return $f5f5dc8e799584a0$export$eabcd2c8791e7bf4; });
$parcel$export($f5f5dc8e799584a0$exports, "auto", function () { return $f5f5dc8e799584a0$export$dfb5619354ba860; });
$parcel$export($f5f5dc8e799584a0$exports, "basePlacements", function () { return $f5f5dc8e799584a0$export$aec2ce47c367b8c3; });
$parcel$export($f5f5dc8e799584a0$exports, "start", function () { return $f5f5dc8e799584a0$export$b3571188c770cc5a; });
$parcel$export($f5f5dc8e799584a0$exports, "end", function () { return $f5f5dc8e799584a0$export$bd5df0f255a350f8; });
$parcel$export($f5f5dc8e799584a0$exports, "clippingParents", function () { return $f5f5dc8e799584a0$export$390fd549c5303b4d; });
$parcel$export($f5f5dc8e799584a0$exports, "viewport", function () { return $f5f5dc8e799584a0$export$d7b7311ec04a3e8f; });
$parcel$export($f5f5dc8e799584a0$exports, "popper", function () { return $f5f5dc8e799584a0$export$ae5ab1c730825774; });
$parcel$export($f5f5dc8e799584a0$exports, "reference", function () { return $f5f5dc8e799584a0$export$ca50aac9f3ba507f; });
$parcel$export($f5f5dc8e799584a0$exports, "variationPlacements", function () { return $f5f5dc8e799584a0$export$368f9a87e87fa4e1; });
$parcel$export($f5f5dc8e799584a0$exports, "placements", function () { return $f5f5dc8e799584a0$export$803cd8101b6c182b; });
$parcel$export($f5f5dc8e799584a0$exports, "beforeRead", function () { return $f5f5dc8e799584a0$export$421679a7c3d56e; });
$parcel$export($f5f5dc8e799584a0$exports, "read", function () { return $f5f5dc8e799584a0$export$aafa59e2e03f2942; });
$parcel$export($f5f5dc8e799584a0$exports, "afterRead", function () { return $f5f5dc8e799584a0$export$6964f6c886723980; });
$parcel$export($f5f5dc8e799584a0$exports, "beforeMain", function () { return $f5f5dc8e799584a0$export$c65e99957a05207c; });
$parcel$export($f5f5dc8e799584a0$exports, "main", function () { return $f5f5dc8e799584a0$export$f22da7240b7add18; });
$parcel$export($f5f5dc8e799584a0$exports, "afterMain", function () { return $f5f5dc8e799584a0$export$bab79516f2d662fe; });
$parcel$export($f5f5dc8e799584a0$exports, "beforeWrite", function () { return $f5f5dc8e799584a0$export$8d4d2d70e7d46032; });
$parcel$export($f5f5dc8e799584a0$exports, "write", function () { return $f5f5dc8e799584a0$export$68d8715fc104d294; });
$parcel$export($f5f5dc8e799584a0$exports, "afterWrite", function () { return $f5f5dc8e799584a0$export$70a6e5159acce2e6; });
$parcel$export($f5f5dc8e799584a0$exports, "modifierPhases", function () { return $f5f5dc8e799584a0$export$d087d3878fdf71d5; });
var $f5f5dc8e799584a0$export$1e95b668f3b82d = 'top';
var $f5f5dc8e799584a0$export$40e543e69a8b3fbb = 'bottom';
var $f5f5dc8e799584a0$export$79ffe56a765070d2 = 'right';
var $f5f5dc8e799584a0$export$eabcd2c8791e7bf4 = 'left';
var $f5f5dc8e799584a0$export$dfb5619354ba860 = 'auto';
var $f5f5dc8e799584a0$export$aec2ce47c367b8c3 = [
    $f5f5dc8e799584a0$export$1e95b668f3b82d,
    $f5f5dc8e799584a0$export$40e543e69a8b3fbb,
    $f5f5dc8e799584a0$export$79ffe56a765070d2,
    $f5f5dc8e799584a0$export$eabcd2c8791e7bf4
];
var $f5f5dc8e799584a0$export$b3571188c770cc5a = 'start';
var $f5f5dc8e799584a0$export$bd5df0f255a350f8 = 'end';
var $f5f5dc8e799584a0$export$390fd549c5303b4d = 'clippingParents';
var $f5f5dc8e799584a0$export$d7b7311ec04a3e8f = 'viewport';
var $f5f5dc8e799584a0$export$ae5ab1c730825774 = 'popper';
var $f5f5dc8e799584a0$export$ca50aac9f3ba507f = 'reference';
var $f5f5dc8e799584a0$export$368f9a87e87fa4e1 = /*#__PURE__*/ $f5f5dc8e799584a0$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $f5f5dc8e799584a0$export$b3571188c770cc5a,
        placement + "-" + $f5f5dc8e799584a0$export$bd5df0f255a350f8
    ]);
}, []);
var $f5f5dc8e799584a0$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($f5f5dc8e799584a0$export$aec2ce47c367b8c3, [
    $f5f5dc8e799584a0$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $f5f5dc8e799584a0$export$b3571188c770cc5a,
        placement + "-" + $f5f5dc8e799584a0$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $f5f5dc8e799584a0$export$421679a7c3d56e = 'beforeRead';
var $f5f5dc8e799584a0$export$aafa59e2e03f2942 = 'read';
var $f5f5dc8e799584a0$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $f5f5dc8e799584a0$export$c65e99957a05207c = 'beforeMain';
var $f5f5dc8e799584a0$export$f22da7240b7add18 = 'main';
var $f5f5dc8e799584a0$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $f5f5dc8e799584a0$export$8d4d2d70e7d46032 = 'beforeWrite';
var $f5f5dc8e799584a0$export$68d8715fc104d294 = 'write';
var $f5f5dc8e799584a0$export$70a6e5159acce2e6 = 'afterWrite';
var $f5f5dc8e799584a0$export$d087d3878fdf71d5 = [
    $f5f5dc8e799584a0$export$421679a7c3d56e,
    $f5f5dc8e799584a0$export$aafa59e2e03f2942,
    $f5f5dc8e799584a0$export$6964f6c886723980,
    $f5f5dc8e799584a0$export$c65e99957a05207c,
    $f5f5dc8e799584a0$export$f22da7240b7add18,
    $f5f5dc8e799584a0$export$bab79516f2d662fe,
    $f5f5dc8e799584a0$export$8d4d2d70e7d46032,
    $f5f5dc8e799584a0$export$68d8715fc104d294,
    $f5f5dc8e799584a0$export$70a6e5159acce2e6
];


var $e572d264a00d9174$exports = {};

$parcel$export($e572d264a00d9174$exports, "applyStyles", function () { return $8355a151646ac2da$export$2e2bcd8739ae039; });
$parcel$export($e572d264a00d9174$exports, "arrow", function () { return $7fea263e29145da0$export$2e2bcd8739ae039; });
$parcel$export($e572d264a00d9174$exports, "computeStyles", function () { return $62907a1cfcefc14d$export$2e2bcd8739ae039; });
$parcel$export($e572d264a00d9174$exports, "eventListeners", function () { return $71b46d08bc4c1acf$export$2e2bcd8739ae039; });
$parcel$export($e572d264a00d9174$exports, "flip", function () { return $7665f76d0b67ff70$export$2e2bcd8739ae039; });
$parcel$export($e572d264a00d9174$exports, "hide", function () { return $3940c04d93f1771e$export$2e2bcd8739ae039; });
$parcel$export($e572d264a00d9174$exports, "offset", function () { return $61b4016f4d917af8$export$2e2bcd8739ae039; });
$parcel$export($e572d264a00d9174$exports, "popperOffsets", function () { return $5b780a29ad0bea69$export$2e2bcd8739ae039; });
$parcel$export($e572d264a00d9174$exports, "preventOverflow", function () { return $8d68ebca01da9ca3$export$2e2bcd8739ae039; });
function $29687ec9f6ee164f$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}


function $fa5f8796cd52395c$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $ea3dadf9ae11c0d5$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $fa5f8796cd52395c$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $ea3dadf9ae11c0d5$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $fa5f8796cd52395c$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $ea3dadf9ae11c0d5$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $fa5f8796cd52395c$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $8355a151646ac2da$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $ea3dadf9ae11c0d5$export$1b3bfaa9684536aa)(element) || !(0, $29687ec9f6ee164f$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $8355a151646ac2da$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $ea3dadf9ae11c0d5$export$1b3bfaa9684536aa)(element) || !(0, $29687ec9f6ee164f$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $8355a151646ac2da$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $8355a151646ac2da$var$applyStyles,
    effect: $8355a151646ac2da$var$effect,
    requires: [
        'computeStyles'
    ]
};



function $1939daaee1c43e73$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}



var $55bed22464e5409d$export$8960430cfd85939f = Math.max;
var $55bed22464e5409d$export$96ec731ed4dcb222 = Math.min;
var $55bed22464e5409d$export$2077e0241d6afd3c = Math.round;



function $f63fb30660088585$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $67d2ff19a3a9dbe4$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $f63fb30660088585$export$2e2bcd8739ae039)());
}


function $770bcd2fe7238312$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $ea3dadf9ae11c0d5$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $55bed22464e5409d$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $55bed22464e5409d$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $ea3dadf9ae11c0d5$export$45a5e7f76e0caa8d)(element) ? (0, $fa5f8796cd52395c$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $67d2ff19a3a9dbe4$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $7f4df160e3d12556$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $770bcd2fe7238312$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $66119da85dcae1d4$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $ea3dadf9ae11c0d5$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $49f7bbbd67bb9f67$export$2e2bcd8739ae039(element) {
    return (0, $fa5f8796cd52395c$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $9ae1c56d9ec6af6c$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $29687ec9f6ee164f$export$2e2bcd8739ae039)(element)) >= 0;
}




function $9b6bf19f7af0bd3d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $ea3dadf9ae11c0d5$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $92832adfec89487d$export$2e2bcd8739ae039(element) {
    if ((0, $29687ec9f6ee164f$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $ea3dadf9ae11c0d5$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $9b6bf19f7af0bd3d$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $d4605e327deaec55$var$getTrueOffsetParent(element) {
    if (!(0, $ea3dadf9ae11c0d5$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $49f7bbbd67bb9f67$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $d4605e327deaec55$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $f63fb30660088585$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $f63fb30660088585$export$2e2bcd8739ae039)());
    if (isIE && (0, $ea3dadf9ae11c0d5$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $49f7bbbd67bb9f67$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $92832adfec89487d$export$2e2bcd8739ae039)(element);
    if ((0, $ea3dadf9ae11c0d5$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $ea3dadf9ae11c0d5$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $29687ec9f6ee164f$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $49f7bbbd67bb9f67$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $d4605e327deaec55$export$2e2bcd8739ae039(element) {
    var window = (0, $fa5f8796cd52395c$export$2e2bcd8739ae039)(element);
    var offsetParent = $d4605e327deaec55$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $9ae1c56d9ec6af6c$export$2e2bcd8739ae039)(offsetParent) && (0, $49f7bbbd67bb9f67$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $d4605e327deaec55$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $29687ec9f6ee164f$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $29687ec9f6ee164f$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $49f7bbbd67bb9f67$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $d4605e327deaec55$var$getContainingBlock(element) || window;
}


function $d9ad77da5c2a1d8a$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $eabd0bf518fd3388$export$f28d906d67a997f3(min, value, max) {
    return (0, $55bed22464e5409d$export$8960430cfd85939f)(min, (0, $55bed22464e5409d$export$96ec731ed4dcb222)(value, max));
}
function $eabd0bf518fd3388$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $eabd0bf518fd3388$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $8839d800d4eecb77$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $690f8cb2a8c0da64$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $8839d800d4eecb77$export$2e2bcd8739ae039)(), paddingObject);
}


function $b5c947d66a8564cd$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $7fea263e29145da0$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $690f8cb2a8c0da64$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $b5c947d66a8564cd$export$2e2bcd8739ae039)(padding, (0, $f5f5dc8e799584a0$export$aec2ce47c367b8c3)));
};
function $7fea263e29145da0$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $1939daaee1c43e73$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $d9ad77da5c2a1d8a$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $f5f5dc8e799584a0$export$eabcd2c8791e7bf4),
        (0, $f5f5dc8e799584a0$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $7fea263e29145da0$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $7f4df160e3d12556$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $f5f5dc8e799584a0$export$1e95b668f3b82d) : (0, $f5f5dc8e799584a0$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $f5f5dc8e799584a0$export$40e543e69a8b3fbb) : (0, $f5f5dc8e799584a0$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $d4605e327deaec55$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $eabd0bf518fd3388$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $7fea263e29145da0$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $66119da85dcae1d4$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $7fea263e29145da0$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $7fea263e29145da0$var$arrow,
    effect: $7fea263e29145da0$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $b2f278014f4156d8$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $62907a1cfcefc14d$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $62907a1cfcefc14d$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $55bed22464e5409d$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $55bed22464e5409d$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $62907a1cfcefc14d$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $f5f5dc8e799584a0$export$eabcd2c8791e7bf4);
    var sideY = (0, $f5f5dc8e799584a0$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $d4605e327deaec55$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $fa5f8796cd52395c$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $9b6bf19f7af0bd3d$export$2e2bcd8739ae039)(popper);
            if ((0, $49f7bbbd67bb9f67$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $f5f5dc8e799584a0$export$1e95b668f3b82d) || (placement === (0, $f5f5dc8e799584a0$export$eabcd2c8791e7bf4) || placement === (0, $f5f5dc8e799584a0$export$79ffe56a765070d2)) && variation === (0, $f5f5dc8e799584a0$export$bd5df0f255a350f8)) {
            sideY = (0, $f5f5dc8e799584a0$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $f5f5dc8e799584a0$export$eabcd2c8791e7bf4) || (placement === (0, $f5f5dc8e799584a0$export$1e95b668f3b82d) || placement === (0, $f5f5dc8e799584a0$export$40e543e69a8b3fbb)) && variation === (0, $f5f5dc8e799584a0$export$bd5df0f255a350f8)) {
            sideX = (0, $f5f5dc8e799584a0$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $62907a1cfcefc14d$var$unsetSides);
    var _ref4 = roundOffsets === true ? $62907a1cfcefc14d$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $fa5f8796cd52395c$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $62907a1cfcefc14d$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $1939daaee1c43e73$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $b2f278014f4156d8$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $62907a1cfcefc14d$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $62907a1cfcefc14d$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $62907a1cfcefc14d$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $62907a1cfcefc14d$var$computeStyles,
    data: {}
};



var $71b46d08bc4c1acf$var$passive = {
    passive: true
};
function $71b46d08bc4c1acf$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $fa5f8796cd52395c$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $71b46d08bc4c1acf$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $71b46d08bc4c1acf$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $71b46d08bc4c1acf$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $71b46d08bc4c1acf$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $71b46d08bc4c1acf$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $71b46d08bc4c1acf$var$effect,
    data: {}
};


var $ca4f2c7d99422290$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $ca4f2c7d99422290$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $ca4f2c7d99422290$var$hash[matched];
    });
}



var $4e96942aa819603b$var$hash = {
    start: 'end',
    end: 'start'
};
function $4e96942aa819603b$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $4e96942aa819603b$var$hash[matched];
    });
}








function $43a4df761cf82fa9$export$2e2bcd8739ae039(node) {
    var win = (0, $fa5f8796cd52395c$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $79d85edbdb464983$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $770bcd2fe7238312$export$2e2bcd8739ae039)((0, $9b6bf19f7af0bd3d$export$2e2bcd8739ae039)(element)).left + (0, $43a4df761cf82fa9$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $6356b8b07fca389a$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $fa5f8796cd52395c$export$2e2bcd8739ae039)(element);
    var html = (0, $9b6bf19f7af0bd3d$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $67d2ff19a3a9dbe4$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $79d85edbdb464983$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $09b789657e3d7870$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $9b6bf19f7af0bd3d$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $43a4df761cf82fa9$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $55bed22464e5409d$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $55bed22464e5409d$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $79d85edbdb464983$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $49f7bbbd67bb9f67$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $55bed22464e5409d$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $e79ff55a316916d3$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $49f7bbbd67bb9f67$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $29079ceb9f369ec6$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $29687ec9f6ee164f$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $ea3dadf9ae11c0d5$export$1b3bfaa9684536aa)(node) && (0, $e79ff55a316916d3$export$2e2bcd8739ae039)(node)) return node;
    return $29079ceb9f369ec6$export$2e2bcd8739ae039((0, $92832adfec89487d$export$2e2bcd8739ae039)(node));
}





function $4c4e510cb5c0056f$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $29079ceb9f369ec6$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $fa5f8796cd52395c$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $e79ff55a316916d3$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($4c4e510cb5c0056f$export$2e2bcd8739ae039((0, $92832adfec89487d$export$2e2bcd8739ae039)(target)));
}










function $54689a87d9c593d3$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $4f5e76bb865a8fb2$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $770bcd2fe7238312$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $4f5e76bb865a8fb2$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $f5f5dc8e799584a0$export$d7b7311ec04a3e8f) ? (0, $54689a87d9c593d3$export$2e2bcd8739ae039)((0, $6356b8b07fca389a$export$2e2bcd8739ae039)(element, strategy)) : (0, $ea3dadf9ae11c0d5$export$45a5e7f76e0caa8d)(clippingParent) ? $4f5e76bb865a8fb2$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $54689a87d9c593d3$export$2e2bcd8739ae039)((0, $09b789657e3d7870$export$2e2bcd8739ae039)((0, $9b6bf19f7af0bd3d$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $4f5e76bb865a8fb2$var$getClippingParents(element) {
    var clippingParents = (0, $4c4e510cb5c0056f$export$2e2bcd8739ae039)((0, $92832adfec89487d$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $49f7bbbd67bb9f67$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $ea3dadf9ae11c0d5$export$1b3bfaa9684536aa)(element) ? (0, $d4605e327deaec55$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $ea3dadf9ae11c0d5$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $ea3dadf9ae11c0d5$export$45a5e7f76e0caa8d)(clippingParent) && (0, $66119da85dcae1d4$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $29687ec9f6ee164f$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $4f5e76bb865a8fb2$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $4f5e76bb865a8fb2$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $4f5e76bb865a8fb2$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $55bed22464e5409d$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $55bed22464e5409d$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $55bed22464e5409d$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $55bed22464e5409d$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $4f5e76bb865a8fb2$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $e7258e5b0920db65$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $1939daaee1c43e73$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $b2f278014f4156d8$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $f5f5dc8e799584a0$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $f5f5dc8e799584a0$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $f5f5dc8e799584a0$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $f5f5dc8e799584a0$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $d9ad77da5c2a1d8a$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $f5f5dc8e799584a0$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $f5f5dc8e799584a0$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $eeb30ec09a46be00$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $f5f5dc8e799584a0$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $f5f5dc8e799584a0$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $f5f5dc8e799584a0$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $690f8cb2a8c0da64$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $b5c947d66a8564cd$export$2e2bcd8739ae039)(padding, (0, $f5f5dc8e799584a0$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $f5f5dc8e799584a0$export$ae5ab1c730825774) ? (0, $f5f5dc8e799584a0$export$ca50aac9f3ba507f) : (0, $f5f5dc8e799584a0$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $4f5e76bb865a8fb2$export$2e2bcd8739ae039)((0, $ea3dadf9ae11c0d5$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $9b6bf19f7af0bd3d$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $770bcd2fe7238312$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $e7258e5b0920db65$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $54689a87d9c593d3$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $f5f5dc8e799584a0$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $f5f5dc8e799584a0$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $f5f5dc8e799584a0$export$79ffe56a765070d2),
                (0, $f5f5dc8e799584a0$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $f5f5dc8e799584a0$export$1e95b668f3b82d),
                (0, $f5f5dc8e799584a0$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $7bc6f290b65ea21e$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $f5f5dc8e799584a0$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $b2f278014f4156d8$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $f5f5dc8e799584a0$export$368f9a87e87fa4e1) : (0, $f5f5dc8e799584a0$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $b2f278014f4156d8$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $f5f5dc8e799584a0$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $eeb30ec09a46be00$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $1939daaee1c43e73$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $7665f76d0b67ff70$var$getExpandedFallbackPlacements(placement) {
    if ((0, $1939daaee1c43e73$export$2e2bcd8739ae039)(placement) === (0, $f5f5dc8e799584a0$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $ca4f2c7d99422290$export$2e2bcd8739ae039)(placement);
    return [
        (0, $4e96942aa819603b$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $4e96942aa819603b$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $7665f76d0b67ff70$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $1939daaee1c43e73$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $ca4f2c7d99422290$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $7665f76d0b67ff70$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $1939daaee1c43e73$export$2e2bcd8739ae039)(placement) === (0, $f5f5dc8e799584a0$export$dfb5619354ba860) ? (0, $7bc6f290b65ea21e$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $1939daaee1c43e73$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $b2f278014f4156d8$export$2e2bcd8739ae039)(placement) === (0, $f5f5dc8e799584a0$export$b3571188c770cc5a);
        var isVertical = [
            (0, $f5f5dc8e799584a0$export$1e95b668f3b82d),
            (0, $f5f5dc8e799584a0$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $eeb30ec09a46be00$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $f5f5dc8e799584a0$export$79ffe56a765070d2) : (0, $f5f5dc8e799584a0$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $f5f5dc8e799584a0$export$40e543e69a8b3fbb) : (0, $f5f5dc8e799584a0$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $ca4f2c7d99422290$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $ca4f2c7d99422290$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $7665f76d0b67ff70$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $7665f76d0b67ff70$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $3940c04d93f1771e$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $3940c04d93f1771e$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $f5f5dc8e799584a0$export$1e95b668f3b82d),
        (0, $f5f5dc8e799584a0$export$79ffe56a765070d2),
        (0, $f5f5dc8e799584a0$export$40e543e69a8b3fbb),
        (0, $f5f5dc8e799584a0$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $3940c04d93f1771e$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $eeb30ec09a46be00$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $eeb30ec09a46be00$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $3940c04d93f1771e$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $3940c04d93f1771e$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $3940c04d93f1771e$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $3940c04d93f1771e$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $3940c04d93f1771e$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $3940c04d93f1771e$var$hide
};




function $61b4016f4d917af8$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $1939daaee1c43e73$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $f5f5dc8e799584a0$export$eabcd2c8791e7bf4),
        (0, $f5f5dc8e799584a0$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $f5f5dc8e799584a0$export$eabcd2c8791e7bf4),
        (0, $f5f5dc8e799584a0$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $61b4016f4d917af8$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $f5f5dc8e799584a0$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $61b4016f4d917af8$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $61b4016f4d917af8$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $61b4016f4d917af8$var$offset
};



function $5b780a29ad0bea69$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $e7258e5b0920db65$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $5b780a29ad0bea69$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $5b780a29ad0bea69$var$popperOffsets,
    data: {}
};





function $97387341f38d56bf$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $8d68ebca01da9ca3$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $eeb30ec09a46be00$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $1939daaee1c43e73$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $b2f278014f4156d8$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $d9ad77da5c2a1d8a$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $97387341f38d56bf$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $f5f5dc8e799584a0$export$1e95b668f3b82d) : (0, $f5f5dc8e799584a0$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $f5f5dc8e799584a0$export$40e543e69a8b3fbb) : (0, $f5f5dc8e799584a0$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $f5f5dc8e799584a0$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $f5f5dc8e799584a0$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $7f4df160e3d12556$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $8839d800d4eecb77$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $eabd0bf518fd3388$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $d4605e327deaec55$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $eabd0bf518fd3388$export$f28d906d67a997f3)(tether ? (0, $55bed22464e5409d$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $55bed22464e5409d$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $f5f5dc8e799584a0$export$1e95b668f3b82d) : (0, $f5f5dc8e799584a0$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $f5f5dc8e799584a0$export$40e543e69a8b3fbb) : (0, $f5f5dc8e799584a0$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $f5f5dc8e799584a0$export$1e95b668f3b82d),
            (0, $f5f5dc8e799584a0$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $eabd0bf518fd3388$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $eabd0bf518fd3388$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $8d68ebca01da9ca3$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $8d68ebca01da9ca3$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};








function $94cafd85e47787fd$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ed63e9df2a77e929$export$2e2bcd8739ae039(node) {
    if (node === (0, $fa5f8796cd52395c$export$2e2bcd8739ae039)(node) || !(0, $ea3dadf9ae11c0d5$export$1b3bfaa9684536aa)(node)) return (0, $43a4df761cf82fa9$export$2e2bcd8739ae039)(node);
    else return (0, $94cafd85e47787fd$export$2e2bcd8739ae039)(node);
}








function $f505ba4a774a8750$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $55bed22464e5409d$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $55bed22464e5409d$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $f505ba4a774a8750$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $ea3dadf9ae11c0d5$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $ea3dadf9ae11c0d5$export$1b3bfaa9684536aa)(offsetParent) && $f505ba4a774a8750$var$isElementScaled(offsetParent);
    var documentElement = (0, $9b6bf19f7af0bd3d$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $770bcd2fe7238312$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $29687ec9f6ee164f$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $e79ff55a316916d3$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ed63e9df2a77e929$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $ea3dadf9ae11c0d5$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $770bcd2fe7238312$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $79d85edbdb464983$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $3c6bf587e558a6c3$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $3c6bf587e558a6c3$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $3c6bf587e558a6c3$var$order(modifiers); // order based on phase
    return (0, $f5f5dc8e799584a0$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $487faae5a222740a$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $67106f9606c86bef$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $36f6067a80e359f0$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $36f6067a80e359f0$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $36f6067a80e359f0$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $36f6067a80e359f0$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $36f6067a80e359f0$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $ea3dadf9ae11c0d5$export$45a5e7f76e0caa8d)(reference) ? (0, $4c4e510cb5c0056f$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $4c4e510cb5c0056f$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $4c4e510cb5c0056f$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $3c6bf587e558a6c3$export$2e2bcd8739ae039)((0, $67106f9606c86bef$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$36f6067a80e359f0$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $f505ba4a774a8750$export$2e2bcd8739ae039)(reference, (0, $d4605e327deaec55$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $7f4df160e3d12556$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $487faae5a222740a$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$36f6067a80e359f0$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $36f6067a80e359f0$export$8f7491d57c8f97a9 = /*#__PURE__*/ $36f6067a80e359f0$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $cbce3287da02ea86$export$d34966752335dd47 = [
    (0, $71b46d08bc4c1acf$export$2e2bcd8739ae039),
    (0, $5b780a29ad0bea69$export$2e2bcd8739ae039),
    (0, $62907a1cfcefc14d$export$2e2bcd8739ae039),
    (0, $8355a151646ac2da$export$2e2bcd8739ae039),
    (0, $61b4016f4d917af8$export$2e2bcd8739ae039),
    (0, $7665f76d0b67ff70$export$2e2bcd8739ae039),
    (0, $8d68ebca01da9ca3$export$2e2bcd8739ae039),
    (0, $7fea263e29145da0$export$2e2bcd8739ae039),
    (0, $3940c04d93f1771e$export$2e2bcd8739ae039)
];
var $cbce3287da02ea86$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $36f6067a80e359f0$export$ed5e13716264f202)({
    defaultModifiers: $cbce3287da02ea86$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $c6c5dcfbc6208579$export$d34966752335dd47 = [
    (0, $71b46d08bc4c1acf$export$2e2bcd8739ae039),
    (0, $5b780a29ad0bea69$export$2e2bcd8739ae039),
    (0, $62907a1cfcefc14d$export$2e2bcd8739ae039),
    (0, $8355a151646ac2da$export$2e2bcd8739ae039)
];
var $c6c5dcfbc6208579$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $36f6067a80e359f0$export$ed5e13716264f202)({
    defaultModifiers: $c6c5dcfbc6208579$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($9c7d6940ce3062ea$exports, $f5f5dc8e799584a0$exports);
$parcel$exportWildcard($9c7d6940ce3062ea$exports, $e572d264a00d9174$exports);


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b3d00e7418f714d6$var$elementMap = new Map();
const $b3d00e7418f714d6$var$Data = {
    set (element, key, instance) {
        if (!$b3d00e7418f714d6$var$elementMap.has(element)) $b3d00e7418f714d6$var$elementMap.set(element, new Map());
        const instanceMap = $b3d00e7418f714d6$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($b3d00e7418f714d6$var$elementMap.has(element)) return $b3d00e7418f714d6$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$b3d00e7418f714d6$var$elementMap.has(element)) return;
        const instanceMap = $b3d00e7418f714d6$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $b3d00e7418f714d6$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $b3d00e7418f714d6$var$MAX_UID = 1000000;
const $b3d00e7418f714d6$var$MILLISECONDS_MULTIPLIER = 1000;
const $b3d00e7418f714d6$var$TRANSITION_END = 'transitionend';
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $b3d00e7418f714d6$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $b3d00e7418f714d6$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $b3d00e7418f714d6$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $b3d00e7418f714d6$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $b3d00e7418f714d6$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(',')[0];
    transitionDelay = transitionDelay.split(',')[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $b3d00e7418f714d6$var$MILLISECONDS_MULTIPLIER;
};
const $b3d00e7418f714d6$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($b3d00e7418f714d6$var$TRANSITION_END));
};
const $b3d00e7418f714d6$var$isElement = (object)=>{
    if (!object || typeof object !== 'object') return false;
    if (typeof object.jquery !== 'undefined') object = object[0];
    return typeof object.nodeType !== 'undefined';
};
const $b3d00e7418f714d6$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($b3d00e7418f714d6$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === 'string' && object.length > 0) return document.querySelector($b3d00e7418f714d6$var$parseSelector(object));
    return null;
};
const $b3d00e7418f714d6$var$isVisible = (element)=>{
    if (!$b3d00e7418f714d6$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest('details:not([open])');
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest('summary');
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $b3d00e7418f714d6$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains('disabled')) return true;
    if (typeof element.disabled !== 'undefined') return element.disabled;
    return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
};
const $b3d00e7418f714d6$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === 'function') {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $b3d00e7418f714d6$var$findShadowRoot(element.parentNode);
};
const $b3d00e7418f714d6$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.harrytheo.com/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $b3d00e7418f714d6$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $b3d00e7418f714d6$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
    return null;
};
const $b3d00e7418f714d6$var$DOMContentLoadedCallbacks = [];
const $b3d00e7418f714d6$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === 'loading') {
        // add listener on the first call when the document is in loading state
        if (!$b3d00e7418f714d6$var$DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', ()=>{
            for (const callback of $b3d00e7418f714d6$var$DOMContentLoadedCallbacks)callback();
        });
        $b3d00e7418f714d6$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $b3d00e7418f714d6$var$isRTL = ()=>document.documentElement.dir === 'rtl';
const $b3d00e7418f714d6$var$defineJQueryPlugin = (plugin)=>{
    $b3d00e7418f714d6$var$onDOMContentLoaded(()=>{
        const $ = $b3d00e7418f714d6$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $b3d00e7418f714d6$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === 'function' ? possibleCallback.call(...args) : defaultValue;
};
const $b3d00e7418f714d6$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $b3d00e7418f714d6$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $b3d00e7418f714d6$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($b3d00e7418f714d6$var$TRANSITION_END, handler);
        $b3d00e7418f714d6$var$execute(callback);
    };
    transitionElement.addEventListener($b3d00e7418f714d6$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $b3d00e7418f714d6$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $b3d00e7418f714d6$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b3d00e7418f714d6$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $b3d00e7418f714d6$var$stripNameRegex = /\..*/;
const $b3d00e7418f714d6$var$stripUidRegex = /::\d+$/;
const $b3d00e7418f714d6$var$eventRegistry = {}; // Events storage
let $b3d00e7418f714d6$var$uidEvent = 1;
const $b3d00e7418f714d6$var$customEvents = {
    mouseenter: 'mouseover',
    mouseleave: 'mouseout'
};
const $b3d00e7418f714d6$var$nativeEvents = new Set([
    'click',
    'dblclick',
    'mouseup',
    'mousedown',
    'contextmenu',
    'mousewheel',
    'DOMMouseScroll',
    'mouseover',
    'mouseout',
    'mousemove',
    'selectstart',
    'selectend',
    'keydown',
    'keypress',
    'keyup',
    'orientationchange',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'pointerdown',
    'pointermove',
    'pointerup',
    'pointerleave',
    'pointercancel',
    'gesturestart',
    'gesturechange',
    'gestureend',
    'focus',
    'blur',
    'change',
    'reset',
    'select',
    'submit',
    'focusin',
    'focusout',
    'load',
    'unload',
    'beforeunload',
    'resize',
    'move',
    'DOMContentLoaded',
    'readystatechange',
    'error',
    'abort',
    'scroll'
]);
/**
 * Private methods
 */ function $b3d00e7418f714d6$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$b3d00e7418f714d6$var$uidEvent++}` || element.uidEvent || $b3d00e7418f714d6$var$uidEvent++;
}
function $b3d00e7418f714d6$var$getElementEvents(element) {
    const uid = $b3d00e7418f714d6$var$makeEventUid(element);
    element.uidEvent = uid;
    $b3d00e7418f714d6$var$eventRegistry[uid] = $b3d00e7418f714d6$var$eventRegistry[uid] || {};
    return $b3d00e7418f714d6$var$eventRegistry[uid];
}
function $b3d00e7418f714d6$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $b3d00e7418f714d6$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $b3d00e7418f714d6$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $b3d00e7418f714d6$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $b3d00e7418f714d6$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $b3d00e7418f714d6$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $b3d00e7418f714d6$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $b3d00e7418f714d6$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === 'string';
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $b3d00e7418f714d6$var$getTypeEvent(originalTypeEvent);
    if (!$b3d00e7418f714d6$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $b3d00e7418f714d6$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== 'string' || !element) return;
    let [isDelegated, callable, typeEvent] = $b3d00e7418f714d6$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $b3d00e7418f714d6$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $b3d00e7418f714d6$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $b3d00e7418f714d6$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $b3d00e7418f714d6$var$makeEventUid(callable, originalTypeEvent.replace($b3d00e7418f714d6$var$namespaceRegex, ''));
    const fn = isDelegated ? $b3d00e7418f714d6$var$bootstrapDelegationHandler(element, handler, callable) : $b3d00e7418f714d6$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $b3d00e7418f714d6$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $b3d00e7418f714d6$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $b3d00e7418f714d6$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $b3d00e7418f714d6$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $b3d00e7418f714d6$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($b3d00e7418f714d6$var$stripNameRegex, '');
    return $b3d00e7418f714d6$var$customEvents[event] || event;
}
const $b3d00e7418f714d6$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $b3d00e7418f714d6$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $b3d00e7418f714d6$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        const [isDelegated, callable, typeEvent] = $b3d00e7418f714d6$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $b3d00e7418f714d6$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith('.');
        if (typeof callable !== 'undefined') {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $b3d00e7418f714d6$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$b3d00e7418f714d6$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($b3d00e7418f714d6$var$stripUidRegex, '');
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $b3d00e7418f714d6$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== 'string' || !element) return null;
        const $ = $b3d00e7418f714d6$var$getjQuery();
        const typeEvent = $b3d00e7418f714d6$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $b3d00e7418f714d6$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $b3d00e7418f714d6$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $b3d00e7418f714d6$var$normalizeData(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === '' || value === 'null') return null;
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $b3d00e7418f714d6$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $b3d00e7418f714d6$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$b3d00e7418f714d6$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$b3d00e7418f714d6$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith('bs') && !key.startsWith('bsConfig'));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, '');
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1);
            attributes[pureKey] = $b3d00e7418f714d6$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $b3d00e7418f714d6$var$normalizeData(element.getAttribute(`data-bs-${$b3d00e7418f714d6$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $b3d00e7418f714d6$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $b3d00e7418f714d6$var$isElement(element) ? $b3d00e7418f714d6$var$Manipulator.getDataAttribute(element, 'config') : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === 'object' ? jsonConfig : {},
            ...$b3d00e7418f714d6$var$isElement(element) ? $b3d00e7418f714d6$var$Manipulator.getDataAttributes(element) : {},
            ...typeof config === 'object' ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $b3d00e7418f714d6$var$isElement(value) ? 'element' : $b3d00e7418f714d6$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b3d00e7418f714d6$var$VERSION = '5.3.8';
/**
 * Class definition
 */ class $b3d00e7418f714d6$var$BaseComponent extends $b3d00e7418f714d6$var$Config {
    constructor(element, config){
        super();
        element = $b3d00e7418f714d6$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $b3d00e7418f714d6$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        $b3d00e7418f714d6$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $b3d00e7418f714d6$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    // Private
    _queueCallback(callback, element, isAnimated = true) {
        $b3d00e7418f714d6$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return $b3d00e7418f714d6$var$Data.get($b3d00e7418f714d6$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === 'object' ? config : null);
    }
    static get VERSION() {
        return $b3d00e7418f714d6$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $b3d00e7418f714d6$var$getSelector = (element)=>{
    let selector = element.getAttribute('data-bs-target');
    if (!selector || selector === '#') {
        let hrefAttribute = element.getAttribute('href');
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = `#${hrefAttribute.split('#')[1]}`;
        selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(',').map((sel)=>$b3d00e7418f714d6$var$parseSelector(sel)).join(',') : null;
};
const $b3d00e7418f714d6$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            'a',
            'button',
            'input',
            'textarea',
            'select',
            'details',
            '[tabindex]',
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(',');
        return this.find(focusables, element).filter((el)=>!$b3d00e7418f714d6$var$isDisabled(el) && $b3d00e7418f714d6$var$isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = $b3d00e7418f714d6$var$getSelector(element);
        if (selector) return $b3d00e7418f714d6$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $b3d00e7418f714d6$var$getSelector(element);
        return selector ? $b3d00e7418f714d6$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $b3d00e7418f714d6$var$getSelector(element);
        return selector ? $b3d00e7418f714d6$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $b3d00e7418f714d6$var$enableDismissTrigger = (component, method = 'hide')=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $b3d00e7418f714d6$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if ($b3d00e7418f714d6$var$isDisabled(this)) return;
        const target = $b3d00e7418f714d6$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b3d00e7418f714d6$var$NAME$f = 'alert';
const $b3d00e7418f714d6$var$DATA_KEY$a = 'bs.alert';
const $b3d00e7418f714d6$var$EVENT_KEY$b = `.${$b3d00e7418f714d6$var$DATA_KEY$a}`;
const $b3d00e7418f714d6$var$EVENT_CLOSE = `close${$b3d00e7418f714d6$var$EVENT_KEY$b}`;
const $b3d00e7418f714d6$var$EVENT_CLOSED = `closed${$b3d00e7418f714d6$var$EVENT_KEY$b}`;
const $b3d00e7418f714d6$var$CLASS_NAME_FADE$5 = 'fade';
const $b3d00e7418f714d6$var$CLASS_NAME_SHOW$8 = 'show';
/**
 * Class definition
 */ class $b3d00e7418f714d6$export$caec2af78bcc877f extends $b3d00e7418f714d6$var$BaseComponent {
    // Getters
    static get NAME() {
        return $b3d00e7418f714d6$var$NAME$f;
    }
    // Public
    close() {
        const closeEvent = $b3d00e7418f714d6$var$EventHandler.trigger(this._element, $b3d00e7418f714d6$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($b3d00e7418f714d6$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($b3d00e7418f714d6$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $b3d00e7418f714d6$var$EventHandler.trigger(this._element, $b3d00e7418f714d6$var$EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $b3d00e7418f714d6$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $b3d00e7418f714d6$var$enableDismissTrigger($b3d00e7418f714d6$export$caec2af78bcc877f, 'close');
/**
 * jQuery
 */ $b3d00e7418f714d6$var$defineJQueryPlugin($b3d00e7418f714d6$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b3d00e7418f714d6$var$NAME$e = 'button';
const $b3d00e7418f714d6$var$DATA_KEY$9 = 'bs.button';
const $b3d00e7418f714d6$var$EVENT_KEY$a = `.${$b3d00e7418f714d6$var$DATA_KEY$9}`;
const $b3d00e7418f714d6$var$DATA_API_KEY$6 = '.data-api';
const $b3d00e7418f714d6$var$CLASS_NAME_ACTIVE$3 = 'active';
const $b3d00e7418f714d6$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $b3d00e7418f714d6$var$EVENT_CLICK_DATA_API$6 = `click${$b3d00e7418f714d6$var$EVENT_KEY$a}${$b3d00e7418f714d6$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $b3d00e7418f714d6$export$353f5b6fc5456de1 extends $b3d00e7418f714d6$var$BaseComponent {
    // Getters
    static get NAME() {
        return $b3d00e7418f714d6$var$NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute('aria-pressed', this._element.classList.toggle($b3d00e7418f714d6$var$CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $b3d00e7418f714d6$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === 'toggle') data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $b3d00e7418f714d6$var$EventHandler.on(document, $b3d00e7418f714d6$var$EVENT_CLICK_DATA_API$6, $b3d00e7418f714d6$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($b3d00e7418f714d6$var$SELECTOR_DATA_TOGGLE$5);
    const data = $b3d00e7418f714d6$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $b3d00e7418f714d6$var$defineJQueryPlugin($b3d00e7418f714d6$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b3d00e7418f714d6$var$NAME$d = 'swipe';
const $b3d00e7418f714d6$var$EVENT_KEY$9 = '.bs.swipe';
const $b3d00e7418f714d6$var$EVENT_TOUCHSTART = `touchstart${$b3d00e7418f714d6$var$EVENT_KEY$9}`;
const $b3d00e7418f714d6$var$EVENT_TOUCHMOVE = `touchmove${$b3d00e7418f714d6$var$EVENT_KEY$9}`;
const $b3d00e7418f714d6$var$EVENT_TOUCHEND = `touchend${$b3d00e7418f714d6$var$EVENT_KEY$9}`;
const $b3d00e7418f714d6$var$EVENT_POINTERDOWN = `pointerdown${$b3d00e7418f714d6$var$EVENT_KEY$9}`;
const $b3d00e7418f714d6$var$EVENT_POINTERUP = `pointerup${$b3d00e7418f714d6$var$EVENT_KEY$9}`;
const $b3d00e7418f714d6$var$POINTER_TYPE_TOUCH = 'touch';
const $b3d00e7418f714d6$var$POINTER_TYPE_PEN = 'pen';
const $b3d00e7418f714d6$var$CLASS_NAME_POINTER_EVENT = 'pointer-event';
const $b3d00e7418f714d6$var$SWIPE_THRESHOLD = 40;
const $b3d00e7418f714d6$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $b3d00e7418f714d6$var$DefaultType$c = {
    endCallback: '(function|null)',
    leftCallback: '(function|null)',
    rightCallback: '(function|null)'
};
/**
 * Class definition
 */ class $b3d00e7418f714d6$var$Swipe extends $b3d00e7418f714d6$var$Config {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$b3d00e7418f714d6$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return $b3d00e7418f714d6$var$Default$c;
    }
    static get DefaultType() {
        return $b3d00e7418f714d6$var$DefaultType$c;
    }
    static get NAME() {
        return $b3d00e7418f714d6$var$NAME$d;
    }
    // Public
    dispose() {
        $b3d00e7418f714d6$var$EventHandler.off(this._element, $b3d00e7418f714d6$var$EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $b3d00e7418f714d6$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $b3d00e7418f714d6$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $b3d00e7418f714d6$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $b3d00e7418f714d6$var$EventHandler.on(this._element, $b3d00e7418f714d6$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $b3d00e7418f714d6$var$EventHandler.on(this._element, $b3d00e7418f714d6$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($b3d00e7418f714d6$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $b3d00e7418f714d6$var$EventHandler.on(this._element, $b3d00e7418f714d6$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $b3d00e7418f714d6$var$EventHandler.on(this._element, $b3d00e7418f714d6$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $b3d00e7418f714d6$var$EventHandler.on(this._element, $b3d00e7418f714d6$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $b3d00e7418f714d6$var$POINTER_TYPE_PEN || event.pointerType === $b3d00e7418f714d6$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b3d00e7418f714d6$var$NAME$c = 'carousel';
const $b3d00e7418f714d6$var$DATA_KEY$8 = 'bs.carousel';
const $b3d00e7418f714d6$var$EVENT_KEY$8 = `.${$b3d00e7418f714d6$var$DATA_KEY$8}`;
const $b3d00e7418f714d6$var$DATA_API_KEY$5 = '.data-api';
const $b3d00e7418f714d6$var$ARROW_LEFT_KEY$1 = 'ArrowLeft';
const $b3d00e7418f714d6$var$ARROW_RIGHT_KEY$1 = 'ArrowRight';
const $b3d00e7418f714d6$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $b3d00e7418f714d6$var$ORDER_NEXT = 'next';
const $b3d00e7418f714d6$var$ORDER_PREV = 'prev';
const $b3d00e7418f714d6$var$DIRECTION_LEFT = 'left';
const $b3d00e7418f714d6$var$DIRECTION_RIGHT = 'right';
const $b3d00e7418f714d6$var$EVENT_SLIDE = `slide${$b3d00e7418f714d6$var$EVENT_KEY$8}`;
const $b3d00e7418f714d6$var$EVENT_SLID = `slid${$b3d00e7418f714d6$var$EVENT_KEY$8}`;
const $b3d00e7418f714d6$var$EVENT_KEYDOWN$1 = `keydown${$b3d00e7418f714d6$var$EVENT_KEY$8}`;
const $b3d00e7418f714d6$var$EVENT_MOUSEENTER$1 = `mouseenter${$b3d00e7418f714d6$var$EVENT_KEY$8}`;
const $b3d00e7418f714d6$var$EVENT_MOUSELEAVE$1 = `mouseleave${$b3d00e7418f714d6$var$EVENT_KEY$8}`;
const $b3d00e7418f714d6$var$EVENT_DRAG_START = `dragstart${$b3d00e7418f714d6$var$EVENT_KEY$8}`;
const $b3d00e7418f714d6$var$EVENT_LOAD_DATA_API$3 = `load${$b3d00e7418f714d6$var$EVENT_KEY$8}${$b3d00e7418f714d6$var$DATA_API_KEY$5}`;
const $b3d00e7418f714d6$var$EVENT_CLICK_DATA_API$5 = `click${$b3d00e7418f714d6$var$EVENT_KEY$8}${$b3d00e7418f714d6$var$DATA_API_KEY$5}`;
const $b3d00e7418f714d6$var$CLASS_NAME_CAROUSEL = 'carousel';
const $b3d00e7418f714d6$var$CLASS_NAME_ACTIVE$2 = 'active';
const $b3d00e7418f714d6$var$CLASS_NAME_SLIDE = 'slide';
const $b3d00e7418f714d6$var$CLASS_NAME_END = 'carousel-item-end';
const $b3d00e7418f714d6$var$CLASS_NAME_START = 'carousel-item-start';
const $b3d00e7418f714d6$var$CLASS_NAME_NEXT = 'carousel-item-next';
const $b3d00e7418f714d6$var$CLASS_NAME_PREV = 'carousel-item-prev';
const $b3d00e7418f714d6$var$SELECTOR_ACTIVE = '.active';
const $b3d00e7418f714d6$var$SELECTOR_ITEM = '.carousel-item';
const $b3d00e7418f714d6$var$SELECTOR_ACTIVE_ITEM = $b3d00e7418f714d6$var$SELECTOR_ACTIVE + $b3d00e7418f714d6$var$SELECTOR_ITEM;
const $b3d00e7418f714d6$var$SELECTOR_ITEM_IMG = '.carousel-item img';
const $b3d00e7418f714d6$var$SELECTOR_INDICATORS = '.carousel-indicators';
const $b3d00e7418f714d6$var$SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
const $b3d00e7418f714d6$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $b3d00e7418f714d6$var$KEY_TO_DIRECTION = {
    [$b3d00e7418f714d6$var$ARROW_LEFT_KEY$1]: $b3d00e7418f714d6$var$DIRECTION_RIGHT,
    [$b3d00e7418f714d6$var$ARROW_RIGHT_KEY$1]: $b3d00e7418f714d6$var$DIRECTION_LEFT
};
const $b3d00e7418f714d6$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: 'hover',
    ride: false,
    touch: true,
    wrap: true
};
const $b3d00e7418f714d6$var$DefaultType$b = {
    interval: '(number|boolean)',
    // TODO:v6 remove boolean support
    keyboard: 'boolean',
    pause: '(string|boolean)',
    ride: '(boolean|string)',
    touch: 'boolean',
    wrap: 'boolean'
};
/**
 * Class definition
 */ class $b3d00e7418f714d6$export$144901db2ea8e967 extends $b3d00e7418f714d6$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $b3d00e7418f714d6$var$SelectorEngine.findOne($b3d00e7418f714d6$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $b3d00e7418f714d6$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return $b3d00e7418f714d6$var$Default$b;
    }
    static get DefaultType() {
        return $b3d00e7418f714d6$var$DefaultType$b;
    }
    static get NAME() {
        return $b3d00e7418f714d6$var$NAME$c;
    }
    // Public
    next() {
        this._slide($b3d00e7418f714d6$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $b3d00e7418f714d6$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($b3d00e7418f714d6$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $b3d00e7418f714d6$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $b3d00e7418f714d6$var$EventHandler.one(this._element, $b3d00e7418f714d6$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $b3d00e7418f714d6$var$EventHandler.one(this._element, $b3d00e7418f714d6$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $b3d00e7418f714d6$var$ORDER_NEXT : $b3d00e7418f714d6$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $b3d00e7418f714d6$var$EventHandler.on(this._element, $b3d00e7418f714d6$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === 'hover') {
            $b3d00e7418f714d6$var$EventHandler.on(this._element, $b3d00e7418f714d6$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $b3d00e7418f714d6$var$EventHandler.on(this._element, $b3d00e7418f714d6$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $b3d00e7418f714d6$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $b3d00e7418f714d6$var$SelectorEngine.find($b3d00e7418f714d6$var$SELECTOR_ITEM_IMG, this._element))$b3d00e7418f714d6$var$EventHandler.on(img, $b3d00e7418f714d6$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== 'hover') return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $b3d00e7418f714d6$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($b3d00e7418f714d6$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($b3d00e7418f714d6$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $b3d00e7418f714d6$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $b3d00e7418f714d6$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $b3d00e7418f714d6$var$SelectorEngine.findOne($b3d00e7418f714d6$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($b3d00e7418f714d6$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute('aria-current');
        const newActiveIndicator = $b3d00e7418f714d6$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($b3d00e7418f714d6$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute('aria-current', 'true');
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $b3d00e7418f714d6$var$ORDER_NEXT;
        const nextElement = element || $b3d00e7418f714d6$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $b3d00e7418f714d6$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($b3d00e7418f714d6$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $b3d00e7418f714d6$var$CLASS_NAME_START : $b3d00e7418f714d6$var$CLASS_NAME_END;
        const orderClassName = isNext ? $b3d00e7418f714d6$var$CLASS_NAME_NEXT : $b3d00e7418f714d6$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $b3d00e7418f714d6$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($b3d00e7418f714d6$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($b3d00e7418f714d6$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($b3d00e7418f714d6$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($b3d00e7418f714d6$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $b3d00e7418f714d6$var$SelectorEngine.findOne($b3d00e7418f714d6$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $b3d00e7418f714d6$var$SelectorEngine.find($b3d00e7418f714d6$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($b3d00e7418f714d6$var$isRTL()) return direction === $b3d00e7418f714d6$var$DIRECTION_LEFT ? $b3d00e7418f714d6$var$ORDER_PREV : $b3d00e7418f714d6$var$ORDER_NEXT;
        return direction === $b3d00e7418f714d6$var$DIRECTION_LEFT ? $b3d00e7418f714d6$var$ORDER_NEXT : $b3d00e7418f714d6$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($b3d00e7418f714d6$var$isRTL()) return order === $b3d00e7418f714d6$var$ORDER_PREV ? $b3d00e7418f714d6$var$DIRECTION_LEFT : $b3d00e7418f714d6$var$DIRECTION_RIGHT;
        return order === $b3d00e7418f714d6$var$ORDER_PREV ? $b3d00e7418f714d6$var$DIRECTION_RIGHT : $b3d00e7418f714d6$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $b3d00e7418f714d6$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === 'number') {
                data.to(config);
                return;
            }
            if (typeof config === 'string') {
                if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $b3d00e7418f714d6$var$EventHandler.on(document, $b3d00e7418f714d6$var$EVENT_CLICK_DATA_API$5, $b3d00e7418f714d6$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $b3d00e7418f714d6$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($b3d00e7418f714d6$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $b3d00e7418f714d6$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute('data-bs-slide-to');
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($b3d00e7418f714d6$var$Manipulator.getDataAttribute(this, 'slide') === 'next') {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$b3d00e7418f714d6$var$EventHandler.on(window, $b3d00e7418f714d6$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $b3d00e7418f714d6$var$SelectorEngine.find($b3d00e7418f714d6$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$b3d00e7418f714d6$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $b3d00e7418f714d6$var$defineJQueryPlugin($b3d00e7418f714d6$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b3d00e7418f714d6$var$NAME$b = 'collapse';
const $b3d00e7418f714d6$var$DATA_KEY$7 = 'bs.collapse';
const $b3d00e7418f714d6$var$EVENT_KEY$7 = `.${$b3d00e7418f714d6$var$DATA_KEY$7}`;
const $b3d00e7418f714d6$var$DATA_API_KEY$4 = '.data-api';
const $b3d00e7418f714d6$var$EVENT_SHOW$6 = `show${$b3d00e7418f714d6$var$EVENT_KEY$7}`;
const $b3d00e7418f714d6$var$EVENT_SHOWN$6 = `shown${$b3d00e7418f714d6$var$EVENT_KEY$7}`;
const $b3d00e7418f714d6$var$EVENT_HIDE$6 = `hide${$b3d00e7418f714d6$var$EVENT_KEY$7}`;
const $b3d00e7418f714d6$var$EVENT_HIDDEN$6 = `hidden${$b3d00e7418f714d6$var$EVENT_KEY$7}`;
const $b3d00e7418f714d6$var$EVENT_CLICK_DATA_API$4 = `click${$b3d00e7418f714d6$var$EVENT_KEY$7}${$b3d00e7418f714d6$var$DATA_API_KEY$4}`;
const $b3d00e7418f714d6$var$CLASS_NAME_SHOW$7 = 'show';
const $b3d00e7418f714d6$var$CLASS_NAME_COLLAPSE = 'collapse';
const $b3d00e7418f714d6$var$CLASS_NAME_COLLAPSING = 'collapsing';
const $b3d00e7418f714d6$var$CLASS_NAME_COLLAPSED = 'collapsed';
const $b3d00e7418f714d6$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$b3d00e7418f714d6$var$CLASS_NAME_COLLAPSE} .${$b3d00e7418f714d6$var$CLASS_NAME_COLLAPSE}`;
const $b3d00e7418f714d6$var$CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
const $b3d00e7418f714d6$var$WIDTH = 'width';
const $b3d00e7418f714d6$var$HEIGHT = 'height';
const $b3d00e7418f714d6$var$SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
const $b3d00e7418f714d6$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $b3d00e7418f714d6$var$Default$a = {
    parent: null,
    toggle: true
};
const $b3d00e7418f714d6$var$DefaultType$a = {
    parent: '(null|element)',
    toggle: 'boolean'
};
/**
 * Class definition
 */ class $b3d00e7418f714d6$export$78768a9af065a7b extends $b3d00e7418f714d6$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $b3d00e7418f714d6$var$SelectorEngine.find($b3d00e7418f714d6$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $b3d00e7418f714d6$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $b3d00e7418f714d6$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return $b3d00e7418f714d6$var$Default$a;
    }
    static get DefaultType() {
        return $b3d00e7418f714d6$var$DefaultType$a;
    }
    static get NAME() {
        return $b3d00e7418f714d6$var$NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($b3d00e7418f714d6$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$b3d00e7418f714d6$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $b3d00e7418f714d6$var$EventHandler.trigger(this._element, $b3d00e7418f714d6$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($b3d00e7418f714d6$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($b3d00e7418f714d6$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($b3d00e7418f714d6$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($b3d00e7418f714d6$var$CLASS_NAME_COLLAPSE, $b3d00e7418f714d6$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = '';
            $b3d00e7418f714d6$var$EventHandler.trigger(this._element, $b3d00e7418f714d6$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $b3d00e7418f714d6$var$EventHandler.trigger(this._element, $b3d00e7418f714d6$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $b3d00e7418f714d6$var$reflow(this._element);
        this._element.classList.add($b3d00e7418f714d6$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($b3d00e7418f714d6$var$CLASS_NAME_COLLAPSE, $b3d00e7418f714d6$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $b3d00e7418f714d6$var$SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($b3d00e7418f714d6$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($b3d00e7418f714d6$var$CLASS_NAME_COLLAPSE);
            $b3d00e7418f714d6$var$EventHandler.trigger(this._element, $b3d00e7418f714d6$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = '';
        this._queueCallback(complete, this._element, true);
    }
    // Private
    _isShown(element = this._element) {
        return element.classList.contains($b3d00e7418f714d6$var$CLASS_NAME_SHOW$7);
    }
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $b3d00e7418f714d6$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($b3d00e7418f714d6$var$CLASS_NAME_HORIZONTAL) ? $b3d00e7418f714d6$var$WIDTH : $b3d00e7418f714d6$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($b3d00e7418f714d6$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $b3d00e7418f714d6$var$SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $b3d00e7418f714d6$var$SelectorEngine.find($b3d00e7418f714d6$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return $b3d00e7418f714d6$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($b3d00e7418f714d6$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute('aria-expanded', isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $b3d00e7418f714d6$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $b3d00e7418f714d6$var$EventHandler.on(document, $b3d00e7418f714d6$var$EVENT_CLICK_DATA_API$4, $b3d00e7418f714d6$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
    for (const element of $b3d00e7418f714d6$var$SelectorEngine.getMultipleElementsFromSelector(this))$b3d00e7418f714d6$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $b3d00e7418f714d6$var$defineJQueryPlugin($b3d00e7418f714d6$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b3d00e7418f714d6$var$NAME$a = 'dropdown';
const $b3d00e7418f714d6$var$DATA_KEY$6 = 'bs.dropdown';
const $b3d00e7418f714d6$var$EVENT_KEY$6 = `.${$b3d00e7418f714d6$var$DATA_KEY$6}`;
const $b3d00e7418f714d6$var$DATA_API_KEY$3 = '.data-api';
const $b3d00e7418f714d6$var$ESCAPE_KEY$2 = 'Escape';
const $b3d00e7418f714d6$var$TAB_KEY$1 = 'Tab';
const $b3d00e7418f714d6$var$ARROW_UP_KEY$1 = 'ArrowUp';
const $b3d00e7418f714d6$var$ARROW_DOWN_KEY$1 = 'ArrowDown';
const $b3d00e7418f714d6$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $b3d00e7418f714d6$var$EVENT_HIDE$5 = `hide${$b3d00e7418f714d6$var$EVENT_KEY$6}`;
const $b3d00e7418f714d6$var$EVENT_HIDDEN$5 = `hidden${$b3d00e7418f714d6$var$EVENT_KEY$6}`;
const $b3d00e7418f714d6$var$EVENT_SHOW$5 = `show${$b3d00e7418f714d6$var$EVENT_KEY$6}`;
const $b3d00e7418f714d6$var$EVENT_SHOWN$5 = `shown${$b3d00e7418f714d6$var$EVENT_KEY$6}`;
const $b3d00e7418f714d6$var$EVENT_CLICK_DATA_API$3 = `click${$b3d00e7418f714d6$var$EVENT_KEY$6}${$b3d00e7418f714d6$var$DATA_API_KEY$3}`;
const $b3d00e7418f714d6$var$EVENT_KEYDOWN_DATA_API = `keydown${$b3d00e7418f714d6$var$EVENT_KEY$6}${$b3d00e7418f714d6$var$DATA_API_KEY$3}`;
const $b3d00e7418f714d6$var$EVENT_KEYUP_DATA_API = `keyup${$b3d00e7418f714d6$var$EVENT_KEY$6}${$b3d00e7418f714d6$var$DATA_API_KEY$3}`;
const $b3d00e7418f714d6$var$CLASS_NAME_SHOW$6 = 'show';
const $b3d00e7418f714d6$var$CLASS_NAME_DROPUP = 'dropup';
const $b3d00e7418f714d6$var$CLASS_NAME_DROPEND = 'dropend';
const $b3d00e7418f714d6$var$CLASS_NAME_DROPSTART = 'dropstart';
const $b3d00e7418f714d6$var$CLASS_NAME_DROPUP_CENTER = 'dropup-center';
const $b3d00e7418f714d6$var$CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
const $b3d00e7418f714d6$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $b3d00e7418f714d6$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$b3d00e7418f714d6$var$SELECTOR_DATA_TOGGLE$3}.${$b3d00e7418f714d6$var$CLASS_NAME_SHOW$6}`;
const $b3d00e7418f714d6$var$SELECTOR_MENU = '.dropdown-menu';
const $b3d00e7418f714d6$var$SELECTOR_NAVBAR = '.navbar';
const $b3d00e7418f714d6$var$SELECTOR_NAVBAR_NAV = '.navbar-nav';
const $b3d00e7418f714d6$var$SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
const $b3d00e7418f714d6$var$PLACEMENT_TOP = $b3d00e7418f714d6$var$isRTL() ? 'top-end' : 'top-start';
const $b3d00e7418f714d6$var$PLACEMENT_TOPEND = $b3d00e7418f714d6$var$isRTL() ? 'top-start' : 'top-end';
const $b3d00e7418f714d6$var$PLACEMENT_BOTTOM = $b3d00e7418f714d6$var$isRTL() ? 'bottom-end' : 'bottom-start';
const $b3d00e7418f714d6$var$PLACEMENT_BOTTOMEND = $b3d00e7418f714d6$var$isRTL() ? 'bottom-start' : 'bottom-end';
const $b3d00e7418f714d6$var$PLACEMENT_RIGHT = $b3d00e7418f714d6$var$isRTL() ? 'left-start' : 'right-start';
const $b3d00e7418f714d6$var$PLACEMENT_LEFT = $b3d00e7418f714d6$var$isRTL() ? 'right-start' : 'left-start';
const $b3d00e7418f714d6$var$PLACEMENT_TOPCENTER = 'top';
const $b3d00e7418f714d6$var$PLACEMENT_BOTTOMCENTER = 'bottom';
const $b3d00e7418f714d6$var$Default$9 = {
    autoClose: true,
    boundary: 'clippingParents',
    display: 'dynamic',
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: 'toggle'
};
const $b3d00e7418f714d6$var$DefaultType$9 = {
    autoClose: '(boolean|string)',
    boundary: '(string|element)',
    display: 'string',
    offset: '(array|string|function)',
    popperConfig: '(null|object|function)',
    reference: '(string|element|object)'
};
/**
 * Class definition
 */ class $b3d00e7418f714d6$export$931cbfb6bfb85fc extends $b3d00e7418f714d6$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = $b3d00e7418f714d6$var$SelectorEngine.next(this._element, $b3d00e7418f714d6$var$SELECTOR_MENU)[0] || $b3d00e7418f714d6$var$SelectorEngine.prev(this._element, $b3d00e7418f714d6$var$SELECTOR_MENU)[0] || $b3d00e7418f714d6$var$SelectorEngine.findOne($b3d00e7418f714d6$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return $b3d00e7418f714d6$var$Default$9;
    }
    static get DefaultType() {
        return $b3d00e7418f714d6$var$DefaultType$9;
    }
    static get NAME() {
        return $b3d00e7418f714d6$var$NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($b3d00e7418f714d6$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $b3d00e7418f714d6$var$EventHandler.trigger(this._element, $b3d00e7418f714d6$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement && !this._parent.closest($b3d00e7418f714d6$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$b3d00e7418f714d6$var$EventHandler.on(element, 'mouseover', $b3d00e7418f714d6$var$noop);
        this._element.focus();
        this._element.setAttribute('aria-expanded', true);
        this._menu.classList.add($b3d00e7418f714d6$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($b3d00e7418f714d6$var$CLASS_NAME_SHOW$6);
        $b3d00e7418f714d6$var$EventHandler.trigger(this._element, $b3d00e7418f714d6$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($b3d00e7418f714d6$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $b3d00e7418f714d6$var$EventHandler.trigger(this._element, $b3d00e7418f714d6$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$b3d00e7418f714d6$var$EventHandler.off(element, 'mouseover', $b3d00e7418f714d6$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($b3d00e7418f714d6$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($b3d00e7418f714d6$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute('aria-expanded', 'false');
        $b3d00e7418f714d6$var$Manipulator.removeDataAttribute(this._menu, 'popper');
        $b3d00e7418f714d6$var$EventHandler.trigger(this._element, $b3d00e7418f714d6$var$EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === 'object' && !$b3d00e7418f714d6$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$b3d00e7418f714d6$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $9c7d6940ce3062ea$exports === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org/docs/v2/)');
        let referenceElement = this._element;
        if (this._config.reference === 'parent') referenceElement = this._parent;
        else if ($b3d00e7418f714d6$var$isElement(this._config.reference)) referenceElement = $b3d00e7418f714d6$var$getElement(this._config.reference);
        else if (typeof this._config.reference === 'object') referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $9c7d6940ce3062ea$exports.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($b3d00e7418f714d6$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($b3d00e7418f714d6$var$CLASS_NAME_DROPEND)) return $b3d00e7418f714d6$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($b3d00e7418f714d6$var$CLASS_NAME_DROPSTART)) return $b3d00e7418f714d6$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($b3d00e7418f714d6$var$CLASS_NAME_DROPUP_CENTER)) return $b3d00e7418f714d6$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($b3d00e7418f714d6$var$CLASS_NAME_DROPDOWN_CENTER)) return $b3d00e7418f714d6$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
        if (parentDropdown.classList.contains($b3d00e7418f714d6$var$CLASS_NAME_DROPUP)) return isEnd ? $b3d00e7418f714d6$var$PLACEMENT_TOPEND : $b3d00e7418f714d6$var$PLACEMENT_TOP;
        return isEnd ? $b3d00e7418f714d6$var$PLACEMENT_BOTTOMEND : $b3d00e7418f714d6$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($b3d00e7418f714d6$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === 'static') {
            $b3d00e7418f714d6$var$Manipulator.setDataAttribute(this._menu, 'popper', 'static'); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...$b3d00e7418f714d6$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $b3d00e7418f714d6$var$SelectorEngine.find($b3d00e7418f714d6$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$b3d00e7418f714d6$var$isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $b3d00e7418f714d6$var$getNextActiveElement(items, target, key === $b3d00e7418f714d6$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $b3d00e7418f714d6$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $b3d00e7418f714d6$var$RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== $b3d00e7418f714d6$var$TAB_KEY$1) return;
        const openToggles = $b3d00e7418f714d6$var$SelectorEngine.find($b3d00e7418f714d6$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $b3d00e7418f714d6$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === $b3d00e7418f714d6$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === 'click') relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $b3d00e7418f714d6$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $b3d00e7418f714d6$var$ARROW_UP_KEY$1,
            $b3d00e7418f714d6$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($b3d00e7418f714d6$var$SELECTOR_DATA_TOGGLE$3) ? this : $b3d00e7418f714d6$var$SelectorEngine.prev(this, $b3d00e7418f714d6$var$SELECTOR_DATA_TOGGLE$3)[0] || $b3d00e7418f714d6$var$SelectorEngine.next(this, $b3d00e7418f714d6$var$SELECTOR_DATA_TOGGLE$3)[0] || $b3d00e7418f714d6$var$SelectorEngine.findOne($b3d00e7418f714d6$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $b3d00e7418f714d6$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ $b3d00e7418f714d6$var$EventHandler.on(document, $b3d00e7418f714d6$var$EVENT_KEYDOWN_DATA_API, $b3d00e7418f714d6$var$SELECTOR_DATA_TOGGLE$3, $b3d00e7418f714d6$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$b3d00e7418f714d6$var$EventHandler.on(document, $b3d00e7418f714d6$var$EVENT_KEYDOWN_DATA_API, $b3d00e7418f714d6$var$SELECTOR_MENU, $b3d00e7418f714d6$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$b3d00e7418f714d6$var$EventHandler.on(document, $b3d00e7418f714d6$var$EVENT_CLICK_DATA_API$3, $b3d00e7418f714d6$export$931cbfb6bfb85fc.clearMenus);
$b3d00e7418f714d6$var$EventHandler.on(document, $b3d00e7418f714d6$var$EVENT_KEYUP_DATA_API, $b3d00e7418f714d6$export$931cbfb6bfb85fc.clearMenus);
$b3d00e7418f714d6$var$EventHandler.on(document, $b3d00e7418f714d6$var$EVENT_CLICK_DATA_API$3, $b3d00e7418f714d6$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $b3d00e7418f714d6$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $b3d00e7418f714d6$var$defineJQueryPlugin($b3d00e7418f714d6$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b3d00e7418f714d6$var$NAME$9 = 'backdrop';
const $b3d00e7418f714d6$var$CLASS_NAME_FADE$4 = 'fade';
const $b3d00e7418f714d6$var$CLASS_NAME_SHOW$5 = 'show';
const $b3d00e7418f714d6$var$EVENT_MOUSEDOWN = `mousedown.bs.${$b3d00e7418f714d6$var$NAME$9}`;
const $b3d00e7418f714d6$var$Default$8 = {
    className: 'modal-backdrop',
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: 'body' // give the choice to place backdrop under different elements
};
const $b3d00e7418f714d6$var$DefaultType$8 = {
    className: 'string',
    clickCallback: '(function|null)',
    isAnimated: 'boolean',
    isVisible: 'boolean',
    rootElement: '(element|string)'
};
/**
 * Class definition
 */ class $b3d00e7418f714d6$var$Backdrop extends $b3d00e7418f714d6$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $b3d00e7418f714d6$var$Default$8;
    }
    static get DefaultType() {
        return $b3d00e7418f714d6$var$DefaultType$8;
    }
    static get NAME() {
        return $b3d00e7418f714d6$var$NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $b3d00e7418f714d6$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $b3d00e7418f714d6$var$reflow(element);
        element.classList.add($b3d00e7418f714d6$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $b3d00e7418f714d6$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $b3d00e7418f714d6$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($b3d00e7418f714d6$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $b3d00e7418f714d6$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $b3d00e7418f714d6$var$EventHandler.off(this._element, $b3d00e7418f714d6$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement('div');
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($b3d00e7418f714d6$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $b3d00e7418f714d6$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $b3d00e7418f714d6$var$EventHandler.on(element, $b3d00e7418f714d6$var$EVENT_MOUSEDOWN, ()=>{
            $b3d00e7418f714d6$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $b3d00e7418f714d6$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b3d00e7418f714d6$var$NAME$8 = 'focustrap';
const $b3d00e7418f714d6$var$DATA_KEY$5 = 'bs.focustrap';
const $b3d00e7418f714d6$var$EVENT_KEY$5 = `.${$b3d00e7418f714d6$var$DATA_KEY$5}`;
const $b3d00e7418f714d6$var$EVENT_FOCUSIN$2 = `focusin${$b3d00e7418f714d6$var$EVENT_KEY$5}`;
const $b3d00e7418f714d6$var$EVENT_KEYDOWN_TAB = `keydown.tab${$b3d00e7418f714d6$var$EVENT_KEY$5}`;
const $b3d00e7418f714d6$var$TAB_KEY = 'Tab';
const $b3d00e7418f714d6$var$TAB_NAV_FORWARD = 'forward';
const $b3d00e7418f714d6$var$TAB_NAV_BACKWARD = 'backward';
const $b3d00e7418f714d6$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $b3d00e7418f714d6$var$DefaultType$7 = {
    autofocus: 'boolean',
    trapElement: 'element'
};
/**
 * Class definition
 */ class $b3d00e7418f714d6$var$FocusTrap extends $b3d00e7418f714d6$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $b3d00e7418f714d6$var$Default$7;
    }
    static get DefaultType() {
        return $b3d00e7418f714d6$var$DefaultType$7;
    }
    static get NAME() {
        return $b3d00e7418f714d6$var$NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $b3d00e7418f714d6$var$EventHandler.off(document, $b3d00e7418f714d6$var$EVENT_KEY$5); // guard against infinite focus loop
        $b3d00e7418f714d6$var$EventHandler.on(document, $b3d00e7418f714d6$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $b3d00e7418f714d6$var$EventHandler.on(document, $b3d00e7418f714d6$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $b3d00e7418f714d6$var$EventHandler.off(document, $b3d00e7418f714d6$var$EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $b3d00e7418f714d6$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $b3d00e7418f714d6$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $b3d00e7418f714d6$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $b3d00e7418f714d6$var$TAB_NAV_BACKWARD : $b3d00e7418f714d6$var$TAB_NAV_FORWARD;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b3d00e7418f714d6$var$SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
const $b3d00e7418f714d6$var$SELECTOR_STICKY_CONTENT = '.sticky-top';
const $b3d00e7418f714d6$var$PROPERTY_PADDING = 'padding-right';
const $b3d00e7418f714d6$var$PROPERTY_MARGIN = 'margin-right';
/**
 * Class definition
 */ class $b3d00e7418f714d6$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $b3d00e7418f714d6$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($b3d00e7418f714d6$var$SELECTOR_FIXED_CONTENT, $b3d00e7418f714d6$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($b3d00e7418f714d6$var$SELECTOR_STICKY_CONTENT, $b3d00e7418f714d6$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, 'overflow');
        this._resetElementAttributes(this._element, $b3d00e7418f714d6$var$PROPERTY_PADDING);
        this._resetElementAttributes($b3d00e7418f714d6$var$SELECTOR_FIXED_CONTENT, $b3d00e7418f714d6$var$PROPERTY_PADDING);
        this._resetElementAttributes($b3d00e7418f714d6$var$SELECTOR_STICKY_CONTENT, $b3d00e7418f714d6$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, 'overflow');
        this._element.style.overflow = 'hidden';
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $b3d00e7418f714d6$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $b3d00e7418f714d6$var$Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $b3d00e7418f714d6$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($b3d00e7418f714d6$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $b3d00e7418f714d6$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b3d00e7418f714d6$var$NAME$7 = 'modal';
const $b3d00e7418f714d6$var$DATA_KEY$4 = 'bs.modal';
const $b3d00e7418f714d6$var$EVENT_KEY$4 = `.${$b3d00e7418f714d6$var$DATA_KEY$4}`;
const $b3d00e7418f714d6$var$DATA_API_KEY$2 = '.data-api';
const $b3d00e7418f714d6$var$ESCAPE_KEY$1 = 'Escape';
const $b3d00e7418f714d6$var$EVENT_HIDE$4 = `hide${$b3d00e7418f714d6$var$EVENT_KEY$4}`;
const $b3d00e7418f714d6$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$b3d00e7418f714d6$var$EVENT_KEY$4}`;
const $b3d00e7418f714d6$var$EVENT_HIDDEN$4 = `hidden${$b3d00e7418f714d6$var$EVENT_KEY$4}`;
const $b3d00e7418f714d6$var$EVENT_SHOW$4 = `show${$b3d00e7418f714d6$var$EVENT_KEY$4}`;
const $b3d00e7418f714d6$var$EVENT_SHOWN$4 = `shown${$b3d00e7418f714d6$var$EVENT_KEY$4}`;
const $b3d00e7418f714d6$var$EVENT_RESIZE$1 = `resize${$b3d00e7418f714d6$var$EVENT_KEY$4}`;
const $b3d00e7418f714d6$var$EVENT_CLICK_DISMISS = `click.dismiss${$b3d00e7418f714d6$var$EVENT_KEY$4}`;
const $b3d00e7418f714d6$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$b3d00e7418f714d6$var$EVENT_KEY$4}`;
const $b3d00e7418f714d6$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$b3d00e7418f714d6$var$EVENT_KEY$4}`;
const $b3d00e7418f714d6$var$EVENT_CLICK_DATA_API$2 = `click${$b3d00e7418f714d6$var$EVENT_KEY$4}${$b3d00e7418f714d6$var$DATA_API_KEY$2}`;
const $b3d00e7418f714d6$var$CLASS_NAME_OPEN = 'modal-open';
const $b3d00e7418f714d6$var$CLASS_NAME_FADE$3 = 'fade';
const $b3d00e7418f714d6$var$CLASS_NAME_SHOW$4 = 'show';
const $b3d00e7418f714d6$var$CLASS_NAME_STATIC = 'modal-static';
const $b3d00e7418f714d6$var$OPEN_SELECTOR$1 = '.modal.show';
const $b3d00e7418f714d6$var$SELECTOR_DIALOG = '.modal-dialog';
const $b3d00e7418f714d6$var$SELECTOR_MODAL_BODY = '.modal-body';
const $b3d00e7418f714d6$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $b3d00e7418f714d6$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $b3d00e7418f714d6$var$DefaultType$6 = {
    backdrop: '(boolean|string)',
    focus: 'boolean',
    keyboard: 'boolean'
};
/**
 * Class definition
 */ class $b3d00e7418f714d6$export$2b77a92f1a5ad772 extends $b3d00e7418f714d6$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._dialog = $b3d00e7418f714d6$var$SelectorEngine.findOne($b3d00e7418f714d6$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $b3d00e7418f714d6$var$ScrollBarHelper();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $b3d00e7418f714d6$var$Default$6;
    }
    static get DefaultType() {
        return $b3d00e7418f714d6$var$DefaultType$6;
    }
    static get NAME() {
        return $b3d00e7418f714d6$var$NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $b3d00e7418f714d6$var$EventHandler.trigger(this._element, $b3d00e7418f714d6$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($b3d00e7418f714d6$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $b3d00e7418f714d6$var$EventHandler.trigger(this._element, $b3d00e7418f714d6$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($b3d00e7418f714d6$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $b3d00e7418f714d6$var$EventHandler.off(window, $b3d00e7418f714d6$var$EVENT_KEY$4);
        $b3d00e7418f714d6$var$EventHandler.off(this._dialog, $b3d00e7418f714d6$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $b3d00e7418f714d6$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $b3d00e7418f714d6$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = 'block';
        this._element.removeAttribute('aria-hidden');
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.scrollTop = 0;
        const modalBody = $b3d00e7418f714d6$var$SelectorEngine.findOne($b3d00e7418f714d6$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $b3d00e7418f714d6$var$reflow(this._element);
        this._element.classList.add($b3d00e7418f714d6$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $b3d00e7418f714d6$var$EventHandler.trigger(this._element, $b3d00e7418f714d6$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $b3d00e7418f714d6$var$EventHandler.on(this._element, $b3d00e7418f714d6$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $b3d00e7418f714d6$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $b3d00e7418f714d6$var$EventHandler.on(window, $b3d00e7418f714d6$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $b3d00e7418f714d6$var$EventHandler.on(this._element, $b3d00e7418f714d6$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $b3d00e7418f714d6$var$EventHandler.one(this._element, $b3d00e7418f714d6$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === 'static') {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = 'none';
        this._element.setAttribute('aria-hidden', true);
        this._element.removeAttribute('aria-modal');
        this._element.removeAttribute('role');
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($b3d00e7418f714d6$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $b3d00e7418f714d6$var$EventHandler.trigger(this._element, $b3d00e7418f714d6$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($b3d00e7418f714d6$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $b3d00e7418f714d6$var$EventHandler.trigger(this._element, $b3d00e7418f714d6$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === 'hidden' || this._element.classList.contains($b3d00e7418f714d6$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
        this._element.classList.add($b3d00e7418f714d6$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($b3d00e7418f714d6$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $b3d00e7418f714d6$var$isRTL() ? 'paddingLeft' : 'paddingRight';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $b3d00e7418f714d6$var$isRTL() ? 'paddingRight' : 'paddingLeft';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = '';
        this._element.style.paddingRight = '';
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $b3d00e7418f714d6$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ $b3d00e7418f714d6$var$EventHandler.on(document, $b3d00e7418f714d6$var$EVENT_CLICK_DATA_API$2, $b3d00e7418f714d6$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $b3d00e7418f714d6$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    $b3d00e7418f714d6$var$EventHandler.one(target, $b3d00e7418f714d6$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $b3d00e7418f714d6$var$EventHandler.one(target, $b3d00e7418f714d6$var$EVENT_HIDDEN$4, ()=>{
            if ($b3d00e7418f714d6$var$isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $b3d00e7418f714d6$var$SelectorEngine.findOne($b3d00e7418f714d6$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $b3d00e7418f714d6$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $b3d00e7418f714d6$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$b3d00e7418f714d6$var$enableDismissTrigger($b3d00e7418f714d6$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $b3d00e7418f714d6$var$defineJQueryPlugin($b3d00e7418f714d6$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b3d00e7418f714d6$var$NAME$6 = 'offcanvas';
const $b3d00e7418f714d6$var$DATA_KEY$3 = 'bs.offcanvas';
const $b3d00e7418f714d6$var$EVENT_KEY$3 = `.${$b3d00e7418f714d6$var$DATA_KEY$3}`;
const $b3d00e7418f714d6$var$DATA_API_KEY$1 = '.data-api';
const $b3d00e7418f714d6$var$EVENT_LOAD_DATA_API$2 = `load${$b3d00e7418f714d6$var$EVENT_KEY$3}${$b3d00e7418f714d6$var$DATA_API_KEY$1}`;
const $b3d00e7418f714d6$var$ESCAPE_KEY = 'Escape';
const $b3d00e7418f714d6$var$CLASS_NAME_SHOW$3 = 'show';
const $b3d00e7418f714d6$var$CLASS_NAME_SHOWING$1 = 'showing';
const $b3d00e7418f714d6$var$CLASS_NAME_HIDING = 'hiding';
const $b3d00e7418f714d6$var$CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
const $b3d00e7418f714d6$var$OPEN_SELECTOR = '.offcanvas.show';
const $b3d00e7418f714d6$var$EVENT_SHOW$3 = `show${$b3d00e7418f714d6$var$EVENT_KEY$3}`;
const $b3d00e7418f714d6$var$EVENT_SHOWN$3 = `shown${$b3d00e7418f714d6$var$EVENT_KEY$3}`;
const $b3d00e7418f714d6$var$EVENT_HIDE$3 = `hide${$b3d00e7418f714d6$var$EVENT_KEY$3}`;
const $b3d00e7418f714d6$var$EVENT_HIDE_PREVENTED = `hidePrevented${$b3d00e7418f714d6$var$EVENT_KEY$3}`;
const $b3d00e7418f714d6$var$EVENT_HIDDEN$3 = `hidden${$b3d00e7418f714d6$var$EVENT_KEY$3}`;
const $b3d00e7418f714d6$var$EVENT_RESIZE = `resize${$b3d00e7418f714d6$var$EVENT_KEY$3}`;
const $b3d00e7418f714d6$var$EVENT_CLICK_DATA_API$1 = `click${$b3d00e7418f714d6$var$EVENT_KEY$3}${$b3d00e7418f714d6$var$DATA_API_KEY$1}`;
const $b3d00e7418f714d6$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$b3d00e7418f714d6$var$EVENT_KEY$3}`;
const $b3d00e7418f714d6$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $b3d00e7418f714d6$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $b3d00e7418f714d6$var$DefaultType$5 = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    scroll: 'boolean'
};
/**
 * Class definition
 */ class $b3d00e7418f714d6$export$591ca0244c9dfcd4 extends $b3d00e7418f714d6$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $b3d00e7418f714d6$var$Default$5;
    }
    static get DefaultType() {
        return $b3d00e7418f714d6$var$DefaultType$5;
    }
    static get NAME() {
        return $b3d00e7418f714d6$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $b3d00e7418f714d6$var$EventHandler.trigger(this._element, $b3d00e7418f714d6$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $b3d00e7418f714d6$var$ScrollBarHelper().hide();
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.classList.add($b3d00e7418f714d6$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($b3d00e7418f714d6$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($b3d00e7418f714d6$var$CLASS_NAME_SHOWING$1);
            $b3d00e7418f714d6$var$EventHandler.trigger(this._element, $b3d00e7418f714d6$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $b3d00e7418f714d6$var$EventHandler.trigger(this._element, $b3d00e7418f714d6$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($b3d00e7418f714d6$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($b3d00e7418f714d6$var$CLASS_NAME_SHOW$3, $b3d00e7418f714d6$var$CLASS_NAME_HIDING);
            this._element.removeAttribute('aria-modal');
            this._element.removeAttribute('role');
            if (!this._config.scroll) new $b3d00e7418f714d6$var$ScrollBarHelper().reset();
            $b3d00e7418f714d6$var$EventHandler.trigger(this._element, $b3d00e7418f714d6$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === 'static') {
                $b3d00e7418f714d6$var$EventHandler.trigger(this._element, $b3d00e7418f714d6$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $b3d00e7418f714d6$var$Backdrop({
            className: $b3d00e7418f714d6$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $b3d00e7418f714d6$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $b3d00e7418f714d6$var$EventHandler.on(this._element, $b3d00e7418f714d6$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $b3d00e7418f714d6$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $b3d00e7418f714d6$var$EventHandler.trigger(this._element, $b3d00e7418f714d6$var$EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $b3d00e7418f714d6$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $b3d00e7418f714d6$var$EventHandler.on(document, $b3d00e7418f714d6$var$EVENT_CLICK_DATA_API$1, $b3d00e7418f714d6$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $b3d00e7418f714d6$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($b3d00e7418f714d6$var$isDisabled(this)) return;
    $b3d00e7418f714d6$var$EventHandler.one(target, $b3d00e7418f714d6$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($b3d00e7418f714d6$var$isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $b3d00e7418f714d6$var$SelectorEngine.findOne($b3d00e7418f714d6$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $b3d00e7418f714d6$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $b3d00e7418f714d6$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$b3d00e7418f714d6$var$EventHandler.on(window, $b3d00e7418f714d6$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $b3d00e7418f714d6$var$SelectorEngine.find($b3d00e7418f714d6$var$OPEN_SELECTOR))$b3d00e7418f714d6$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$b3d00e7418f714d6$var$EventHandler.on(window, $b3d00e7418f714d6$var$EVENT_RESIZE, ()=>{
    for (const element of $b3d00e7418f714d6$var$SelectorEngine.find('[aria-modal][class*=show][class*=offcanvas-]'))if (getComputedStyle(element).position !== 'fixed') $b3d00e7418f714d6$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$b3d00e7418f714d6$var$enableDismissTrigger($b3d00e7418f714d6$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $b3d00e7418f714d6$var$defineJQueryPlugin($b3d00e7418f714d6$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const $b3d00e7418f714d6$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $b3d00e7418f714d6$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    '*': [
        'class',
        'dir',
        'id',
        'lang',
        'role',
        $b3d00e7418f714d6$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        'target',
        'href',
        'title',
        'rel'
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        'src',
        'srcset',
        'alt',
        'title',
        'width',
        'height'
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const $b3d00e7418f714d6$var$uriAttributes = new Set([
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ const $b3d00e7418f714d6$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $b3d00e7418f714d6$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($b3d00e7418f714d6$var$uriAttributes.has(attributeName)) return Boolean($b3d00e7418f714d6$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $b3d00e7418f714d6$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === 'function') return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
    const elements = [].concat(...createdDocument.body.querySelectorAll('*'));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList['*'] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$b3d00e7418f714d6$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b3d00e7418f714d6$var$NAME$5 = 'TemplateFactory';
const $b3d00e7418f714d6$var$Default$4 = {
    allowList: $b3d00e7418f714d6$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: '',
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: '<div></div>'
};
const $b3d00e7418f714d6$var$DefaultType$4 = {
    allowList: 'object',
    content: 'object',
    extraClass: '(string|function)',
    html: 'boolean',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    template: 'string'
};
const $b3d00e7418f714d6$var$DefaultContentType = {
    entry: '(string|element|function|null)',
    selector: '(string|element)'
};
/**
 * Class definition
 */ class $b3d00e7418f714d6$var$TemplateFactory extends $b3d00e7418f714d6$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    // Getters
    static get Default() {
        return $b3d00e7418f714d6$var$Default$4;
    }
    static get DefaultType() {
        return $b3d00e7418f714d6$var$DefaultType$4;
    }
    static get NAME() {
        return $b3d00e7418f714d6$var$NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement('div');
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(' '));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $b3d00e7418f714d6$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $b3d00e7418f714d6$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($b3d00e7418f714d6$var$isElement(content)) {
            this._putElementInTemplate($b3d00e7418f714d6$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $b3d00e7418f714d6$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $b3d00e7418f714d6$var$execute(arg, [
            undefined,
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = '';
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b3d00e7418f714d6$var$NAME$4 = 'tooltip';
const $b3d00e7418f714d6$var$DISALLOWED_ATTRIBUTES = new Set([
    'sanitize',
    'allowList',
    'sanitizeFn'
]);
const $b3d00e7418f714d6$var$CLASS_NAME_FADE$2 = 'fade';
const $b3d00e7418f714d6$var$CLASS_NAME_MODAL = 'modal';
const $b3d00e7418f714d6$var$CLASS_NAME_SHOW$2 = 'show';
const $b3d00e7418f714d6$var$SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
const $b3d00e7418f714d6$var$SELECTOR_MODAL = `.${$b3d00e7418f714d6$var$CLASS_NAME_MODAL}`;
const $b3d00e7418f714d6$var$EVENT_MODAL_HIDE = 'hide.bs.modal';
const $b3d00e7418f714d6$var$TRIGGER_HOVER = 'hover';
const $b3d00e7418f714d6$var$TRIGGER_FOCUS = 'focus';
const $b3d00e7418f714d6$var$TRIGGER_CLICK = 'click';
const $b3d00e7418f714d6$var$TRIGGER_MANUAL = 'manual';
const $b3d00e7418f714d6$var$EVENT_HIDE$2 = 'hide';
const $b3d00e7418f714d6$var$EVENT_HIDDEN$2 = 'hidden';
const $b3d00e7418f714d6$var$EVENT_SHOW$2 = 'show';
const $b3d00e7418f714d6$var$EVENT_SHOWN$2 = 'shown';
const $b3d00e7418f714d6$var$EVENT_INSERTED = 'inserted';
const $b3d00e7418f714d6$var$EVENT_CLICK$1 = 'click';
const $b3d00e7418f714d6$var$EVENT_FOCUSIN$1 = 'focusin';
const $b3d00e7418f714d6$var$EVENT_FOCUSOUT$1 = 'focusout';
const $b3d00e7418f714d6$var$EVENT_MOUSEENTER = 'mouseenter';
const $b3d00e7418f714d6$var$EVENT_MOUSELEAVE = 'mouseleave';
const $b3d00e7418f714d6$var$AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: $b3d00e7418f714d6$var$isRTL() ? 'left' : 'right',
    BOTTOM: 'bottom',
    LEFT: $b3d00e7418f714d6$var$isRTL() ? 'right' : 'left'
};
const $b3d00e7418f714d6$var$Default$3 = {
    allowList: $b3d00e7418f714d6$var$DefaultAllowlist,
    animation: true,
    boundary: 'clippingParents',
    container: false,
    customClass: '',
    delay: 0,
    fallbackPlacements: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: 'top',
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: '',
    trigger: 'hover focus'
};
const $b3d00e7418f714d6$var$DefaultType$3 = {
    allowList: 'object',
    animation: 'boolean',
    boundary: '(string|element)',
    container: '(string|element|boolean)',
    customClass: '(string|function)',
    delay: '(number|object)',
    fallbackPlacements: 'array',
    html: 'boolean',
    offset: '(array|string|function)',
    placement: '(string|function)',
    popperConfig: '(null|object|function)',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    selector: '(string|boolean)',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string'
};
/**
 * Class definition
 */ class $b3d00e7418f714d6$export$28c660c63b792dea extends $b3d00e7418f714d6$var$BaseComponent {
    constructor(element, config){
        if (typeof $9c7d6940ce3062ea$exports === 'undefined') throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org/docs/v2/)');
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    // Getters
    static get Default() {
        return $b3d00e7418f714d6$var$Default$3;
    }
    static get DefaultType() {
        return $b3d00e7418f714d6$var$DefaultType$3;
    }
    static get NAME() {
        return $b3d00e7418f714d6$var$NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $b3d00e7418f714d6$var$EventHandler.off(this._element.closest($b3d00e7418f714d6$var$SELECTOR_MODAL), $b3d00e7418f714d6$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute('data-bs-original-title')) this._element.setAttribute('title', this._element.getAttribute('data-bs-original-title'));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === 'none') throw new Error('Please use show on visible elements');
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $b3d00e7418f714d6$var$EventHandler.trigger(this._element, this.constructor.eventName($b3d00e7418f714d6$var$EVENT_SHOW$2));
        const shadowRoot = $b3d00e7418f714d6$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute('aria-describedby', tip.getAttribute('id'));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $b3d00e7418f714d6$var$EventHandler.trigger(this._element, this.constructor.eventName($b3d00e7418f714d6$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($b3d00e7418f714d6$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$b3d00e7418f714d6$var$EventHandler.on(element, 'mouseover', $b3d00e7418f714d6$var$noop);
        const complete = ()=>{
            $b3d00e7418f714d6$var$EventHandler.trigger(this._element, this.constructor.eventName($b3d00e7418f714d6$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $b3d00e7418f714d6$var$EventHandler.trigger(this._element, this.constructor.eventName($b3d00e7418f714d6$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($b3d00e7418f714d6$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$b3d00e7418f714d6$var$EventHandler.off(element, 'mouseover', $b3d00e7418f714d6$var$noop);
        this._activeTrigger[$b3d00e7418f714d6$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$b3d00e7418f714d6$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$b3d00e7418f714d6$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute('aria-describedby');
            $b3d00e7418f714d6$var$EventHandler.trigger(this._element, this.constructor.eventName($b3d00e7418f714d6$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove($b3d00e7418f714d6$var$CLASS_NAME_FADE$2, $b3d00e7418f714d6$var$CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $b3d00e7418f714d6$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute('id', tipId);
        if (this._isAnimated()) tip.classList.add($b3d00e7418f714d6$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $b3d00e7418f714d6$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$b3d00e7418f714d6$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute('data-bs-original-title');
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($b3d00e7418f714d6$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($b3d00e7418f714d6$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = $b3d00e7418f714d6$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $b3d00e7418f714d6$var$AttachmentMap[placement.toUpperCase()];
        return $9c7d6940ce3062ea$exports.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return $b3d00e7418f714d6$var$execute(arg, [
            this._element,
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'arrow',
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: 'preSetPlacement',
                    enabled: true,
                    phase: 'beforeMain',
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute('data-popper-placement', data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...$b3d00e7418f714d6$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(' ');
        for (const trigger of triggers){
            if (trigger === 'click') $b3d00e7418f714d6$var$EventHandler.on(this._element, this.constructor.eventName($b3d00e7418f714d6$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context._activeTrigger[$b3d00e7418f714d6$var$TRIGGER_CLICK] = !(context._isShown() && context._activeTrigger[$b3d00e7418f714d6$var$TRIGGER_CLICK]);
                context.toggle();
            });
            else if (trigger !== $b3d00e7418f714d6$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $b3d00e7418f714d6$var$TRIGGER_HOVER ? this.constructor.eventName($b3d00e7418f714d6$var$EVENT_MOUSEENTER) : this.constructor.eventName($b3d00e7418f714d6$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $b3d00e7418f714d6$var$TRIGGER_HOVER ? this.constructor.eventName($b3d00e7418f714d6$var$EVENT_MOUSELEAVE) : this.constructor.eventName($b3d00e7418f714d6$var$EVENT_FOCUSOUT$1);
                $b3d00e7418f714d6$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusin' ? $b3d00e7418f714d6$var$TRIGGER_FOCUS : $b3d00e7418f714d6$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $b3d00e7418f714d6$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusout' ? $b3d00e7418f714d6$var$TRIGGER_FOCUS : $b3d00e7418f714d6$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $b3d00e7418f714d6$var$EventHandler.on(this._element.closest($b3d00e7418f714d6$var$SELECTOR_MODAL), $b3d00e7418f714d6$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute('title');
        if (!title) return;
        if (!this._element.getAttribute('aria-label') && !this._element.textContent.trim()) this._element.setAttribute('aria-label', title);
        this._element.setAttribute('data-bs-original-title', title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute('title');
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $b3d00e7418f714d6$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($b3d00e7418f714d6$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === 'object' && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $b3d00e7418f714d6$var$getElement(config.container);
        if (typeof config.delay === 'number') config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === 'number') config.title = config.title.toString();
        if (typeof config.content === 'number') config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = 'manual';
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $b3d00e7418f714d6$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $b3d00e7418f714d6$var$defineJQueryPlugin($b3d00e7418f714d6$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b3d00e7418f714d6$var$NAME$3 = 'popover';
const $b3d00e7418f714d6$var$SELECTOR_TITLE = '.popover-header';
const $b3d00e7418f714d6$var$SELECTOR_CONTENT = '.popover-body';
const $b3d00e7418f714d6$var$Default$2 = {
    ...$b3d00e7418f714d6$export$28c660c63b792dea.Default,
    content: '',
    offset: [
        0,
        8
    ],
    placement: 'right',
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: 'click'
};
const $b3d00e7418f714d6$var$DefaultType$2 = {
    ...$b3d00e7418f714d6$export$28c660c63b792dea.DefaultType,
    content: '(null|string|element|function)'
};
/**
 * Class definition
 */ class $b3d00e7418f714d6$export$5b6b19405a83ff9d extends $b3d00e7418f714d6$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $b3d00e7418f714d6$var$Default$2;
    }
    static get DefaultType() {
        return $b3d00e7418f714d6$var$DefaultType$2;
    }
    static get NAME() {
        return $b3d00e7418f714d6$var$NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$b3d00e7418f714d6$var$SELECTOR_TITLE]: this._getTitle(),
            [$b3d00e7418f714d6$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $b3d00e7418f714d6$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $b3d00e7418f714d6$var$defineJQueryPlugin($b3d00e7418f714d6$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b3d00e7418f714d6$var$NAME$2 = 'scrollspy';
const $b3d00e7418f714d6$var$DATA_KEY$2 = 'bs.scrollspy';
const $b3d00e7418f714d6$var$EVENT_KEY$2 = `.${$b3d00e7418f714d6$var$DATA_KEY$2}`;
const $b3d00e7418f714d6$var$DATA_API_KEY = '.data-api';
const $b3d00e7418f714d6$var$EVENT_ACTIVATE = `activate${$b3d00e7418f714d6$var$EVENT_KEY$2}`;
const $b3d00e7418f714d6$var$EVENT_CLICK = `click${$b3d00e7418f714d6$var$EVENT_KEY$2}`;
const $b3d00e7418f714d6$var$EVENT_LOAD_DATA_API$1 = `load${$b3d00e7418f714d6$var$EVENT_KEY$2}${$b3d00e7418f714d6$var$DATA_API_KEY}`;
const $b3d00e7418f714d6$var$CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
const $b3d00e7418f714d6$var$CLASS_NAME_ACTIVE$1 = 'active';
const $b3d00e7418f714d6$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $b3d00e7418f714d6$var$SELECTOR_TARGET_LINKS = '[href]';
const $b3d00e7418f714d6$var$SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
const $b3d00e7418f714d6$var$SELECTOR_NAV_LINKS = '.nav-link';
const $b3d00e7418f714d6$var$SELECTOR_NAV_ITEMS = '.nav-item';
const $b3d00e7418f714d6$var$SELECTOR_LIST_ITEMS = '.list-group-item';
const $b3d00e7418f714d6$var$SELECTOR_LINK_ITEMS = `${$b3d00e7418f714d6$var$SELECTOR_NAV_LINKS}, ${$b3d00e7418f714d6$var$SELECTOR_NAV_ITEMS} > ${$b3d00e7418f714d6$var$SELECTOR_NAV_LINKS}, ${$b3d00e7418f714d6$var$SELECTOR_LIST_ITEMS}`;
const $b3d00e7418f714d6$var$SELECTOR_DROPDOWN = '.dropdown';
const $b3d00e7418f714d6$var$SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
const $b3d00e7418f714d6$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: '0px 0px -25%',
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $b3d00e7418f714d6$var$DefaultType$1 = {
    offset: '(number|null)',
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: 'string',
    smoothScroll: 'boolean',
    target: 'element',
    threshold: 'array'
};
/**
 * Class definition
 */ class $b3d00e7418f714d6$export$a6472a5298a374be extends $b3d00e7418f714d6$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === 'visible' ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
    // Getters
    static get Default() {
        return $b3d00e7418f714d6$var$Default$1;
    }
    static get DefaultType() {
        return $b3d00e7418f714d6$var$DefaultType$1;
    }
    static get NAME() {
        return $b3d00e7418f714d6$var$NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $b3d00e7418f714d6$var$getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === 'string') config.threshold = config.threshold.split(',').map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        $b3d00e7418f714d6$var$EventHandler.off(this._config.target, $b3d00e7418f714d6$var$EVENT_CLICK);
        $b3d00e7418f714d6$var$EventHandler.on(this._config.target, $b3d00e7418f714d6$var$EVENT_CLICK, $b3d00e7418f714d6$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: 'smooth'
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $b3d00e7418f714d6$var$SelectorEngine.find($b3d00e7418f714d6$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $b3d00e7418f714d6$var$isDisabled(anchor)) continue;
            const observableSection = $b3d00e7418f714d6$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if ($b3d00e7418f714d6$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($b3d00e7418f714d6$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $b3d00e7418f714d6$var$EventHandler.trigger(this._element, $b3d00e7418f714d6$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($b3d00e7418f714d6$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $b3d00e7418f714d6$var$SelectorEngine.findOne($b3d00e7418f714d6$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($b3d00e7418f714d6$var$SELECTOR_DROPDOWN)).classList.add($b3d00e7418f714d6$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $b3d00e7418f714d6$var$SelectorEngine.parents(target, $b3d00e7418f714d6$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $b3d00e7418f714d6$var$SelectorEngine.prev(listGroup, $b3d00e7418f714d6$var$SELECTOR_LINK_ITEMS))item.classList.add($b3d00e7418f714d6$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($b3d00e7418f714d6$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $b3d00e7418f714d6$var$SelectorEngine.find(`${$b3d00e7418f714d6$var$SELECTOR_TARGET_LINKS}.${$b3d00e7418f714d6$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($b3d00e7418f714d6$var$CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $b3d00e7418f714d6$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $b3d00e7418f714d6$var$EventHandler.on(window, $b3d00e7418f714d6$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $b3d00e7418f714d6$var$SelectorEngine.find($b3d00e7418f714d6$var$SELECTOR_DATA_SPY))$b3d00e7418f714d6$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $b3d00e7418f714d6$var$defineJQueryPlugin($b3d00e7418f714d6$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b3d00e7418f714d6$var$NAME$1 = 'tab';
const $b3d00e7418f714d6$var$DATA_KEY$1 = 'bs.tab';
const $b3d00e7418f714d6$var$EVENT_KEY$1 = `.${$b3d00e7418f714d6$var$DATA_KEY$1}`;
const $b3d00e7418f714d6$var$EVENT_HIDE$1 = `hide${$b3d00e7418f714d6$var$EVENT_KEY$1}`;
const $b3d00e7418f714d6$var$EVENT_HIDDEN$1 = `hidden${$b3d00e7418f714d6$var$EVENT_KEY$1}`;
const $b3d00e7418f714d6$var$EVENT_SHOW$1 = `show${$b3d00e7418f714d6$var$EVENT_KEY$1}`;
const $b3d00e7418f714d6$var$EVENT_SHOWN$1 = `shown${$b3d00e7418f714d6$var$EVENT_KEY$1}`;
const $b3d00e7418f714d6$var$EVENT_CLICK_DATA_API = `click${$b3d00e7418f714d6$var$EVENT_KEY$1}`;
const $b3d00e7418f714d6$var$EVENT_KEYDOWN = `keydown${$b3d00e7418f714d6$var$EVENT_KEY$1}`;
const $b3d00e7418f714d6$var$EVENT_LOAD_DATA_API = `load${$b3d00e7418f714d6$var$EVENT_KEY$1}`;
const $b3d00e7418f714d6$var$ARROW_LEFT_KEY = 'ArrowLeft';
const $b3d00e7418f714d6$var$ARROW_RIGHT_KEY = 'ArrowRight';
const $b3d00e7418f714d6$var$ARROW_UP_KEY = 'ArrowUp';
const $b3d00e7418f714d6$var$ARROW_DOWN_KEY = 'ArrowDown';
const $b3d00e7418f714d6$var$HOME_KEY = 'Home';
const $b3d00e7418f714d6$var$END_KEY = 'End';
const $b3d00e7418f714d6$var$CLASS_NAME_ACTIVE = 'active';
const $b3d00e7418f714d6$var$CLASS_NAME_FADE$1 = 'fade';
const $b3d00e7418f714d6$var$CLASS_NAME_SHOW$1 = 'show';
const $b3d00e7418f714d6$var$CLASS_DROPDOWN = 'dropdown';
const $b3d00e7418f714d6$var$SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
const $b3d00e7418f714d6$var$SELECTOR_DROPDOWN_MENU = '.dropdown-menu';
const $b3d00e7418f714d6$var$NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${$b3d00e7418f714d6$var$SELECTOR_DROPDOWN_TOGGLE})`;
const $b3d00e7418f714d6$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $b3d00e7418f714d6$var$SELECTOR_OUTER = '.nav-item, .list-group-item';
const $b3d00e7418f714d6$var$SELECTOR_INNER = `.nav-link${$b3d00e7418f714d6$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$b3d00e7418f714d6$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$b3d00e7418f714d6$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $b3d00e7418f714d6$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const $b3d00e7418f714d6$var$SELECTOR_INNER_ELEM = `${$b3d00e7418f714d6$var$SELECTOR_INNER}, ${$b3d00e7418f714d6$var$SELECTOR_DATA_TOGGLE}`;
const $b3d00e7418f714d6$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$b3d00e7418f714d6$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$b3d00e7418f714d6$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$b3d00e7418f714d6$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $b3d00e7418f714d6$export$3e41faf802a29e71 extends $b3d00e7418f714d6$var$BaseComponent {
    constructor(element){
        super(element);
        this._parent = this._element.closest($b3d00e7418f714d6$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $b3d00e7418f714d6$var$EventHandler.on(this._element, $b3d00e7418f714d6$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
    // Getters
    static get NAME() {
        return $b3d00e7418f714d6$var$NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $b3d00e7418f714d6$var$EventHandler.trigger(active, $b3d00e7418f714d6$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $b3d00e7418f714d6$var$EventHandler.trigger(innerElem, $b3d00e7418f714d6$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($b3d00e7418f714d6$var$CLASS_NAME_ACTIVE);
        this._activate($b3d00e7418f714d6$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.add($b3d00e7418f714d6$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute('tabindex');
            element.setAttribute('aria-selected', true);
            this._toggleDropDown(element, true);
            $b3d00e7418f714d6$var$EventHandler.trigger(element, $b3d00e7418f714d6$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($b3d00e7418f714d6$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($b3d00e7418f714d6$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($b3d00e7418f714d6$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.remove($b3d00e7418f714d6$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute('aria-selected', false);
            element.setAttribute('tabindex', '-1');
            this._toggleDropDown(element, false);
            $b3d00e7418f714d6$var$EventHandler.trigger(element, $b3d00e7418f714d6$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($b3d00e7418f714d6$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $b3d00e7418f714d6$var$ARROW_LEFT_KEY,
            $b3d00e7418f714d6$var$ARROW_RIGHT_KEY,
            $b3d00e7418f714d6$var$ARROW_UP_KEY,
            $b3d00e7418f714d6$var$ARROW_DOWN_KEY,
            $b3d00e7418f714d6$var$HOME_KEY,
            $b3d00e7418f714d6$var$END_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter((element)=>!$b3d00e7418f714d6$var$isDisabled(element));
        let nextActiveElement;
        if ([
            $b3d00e7418f714d6$var$HOME_KEY,
            $b3d00e7418f714d6$var$END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === $b3d00e7418f714d6$var$HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                $b3d00e7418f714d6$var$ARROW_RIGHT_KEY,
                $b3d00e7418f714d6$var$ARROW_DOWN_KEY
            ].includes(event.key);
            nextActiveElement = $b3d00e7418f714d6$var$getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $b3d00e7418f714d6$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $b3d00e7418f714d6$var$SelectorEngine.find($b3d00e7418f714d6$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, 'role', 'tablist');
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute('aria-selected', isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, 'role', 'presentation');
        if (!isActive) child.setAttribute('tabindex', '-1');
        this._setAttributeIfNotExists(child, 'role', 'tab');
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $b3d00e7418f714d6$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, 'role', 'tabpanel');
        if (child.id) this._setAttributeIfNotExists(target, 'aria-labelledby', `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($b3d00e7418f714d6$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $b3d00e7418f714d6$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($b3d00e7418f714d6$var$SELECTOR_DROPDOWN_TOGGLE, $b3d00e7418f714d6$var$CLASS_NAME_ACTIVE);
        toggle($b3d00e7418f714d6$var$SELECTOR_DROPDOWN_MENU, $b3d00e7418f714d6$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute('aria-expanded', open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($b3d00e7418f714d6$var$CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($b3d00e7418f714d6$var$SELECTOR_INNER_ELEM) ? elem : $b3d00e7418f714d6$var$SelectorEngine.findOne($b3d00e7418f714d6$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($b3d00e7418f714d6$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $b3d00e7418f714d6$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $b3d00e7418f714d6$var$EventHandler.on(document, $b3d00e7418f714d6$var$EVENT_CLICK_DATA_API, $b3d00e7418f714d6$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($b3d00e7418f714d6$var$isDisabled(this)) return;
    $b3d00e7418f714d6$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $b3d00e7418f714d6$var$EventHandler.on(window, $b3d00e7418f714d6$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $b3d00e7418f714d6$var$SelectorEngine.find($b3d00e7418f714d6$var$SELECTOR_DATA_TOGGLE_ACTIVE))$b3d00e7418f714d6$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $b3d00e7418f714d6$var$defineJQueryPlugin($b3d00e7418f714d6$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b3d00e7418f714d6$var$NAME = 'toast';
const $b3d00e7418f714d6$var$DATA_KEY = 'bs.toast';
const $b3d00e7418f714d6$var$EVENT_KEY = `.${$b3d00e7418f714d6$var$DATA_KEY}`;
const $b3d00e7418f714d6$var$EVENT_MOUSEOVER = `mouseover${$b3d00e7418f714d6$var$EVENT_KEY}`;
const $b3d00e7418f714d6$var$EVENT_MOUSEOUT = `mouseout${$b3d00e7418f714d6$var$EVENT_KEY}`;
const $b3d00e7418f714d6$var$EVENT_FOCUSIN = `focusin${$b3d00e7418f714d6$var$EVENT_KEY}`;
const $b3d00e7418f714d6$var$EVENT_FOCUSOUT = `focusout${$b3d00e7418f714d6$var$EVENT_KEY}`;
const $b3d00e7418f714d6$var$EVENT_HIDE = `hide${$b3d00e7418f714d6$var$EVENT_KEY}`;
const $b3d00e7418f714d6$var$EVENT_HIDDEN = `hidden${$b3d00e7418f714d6$var$EVENT_KEY}`;
const $b3d00e7418f714d6$var$EVENT_SHOW = `show${$b3d00e7418f714d6$var$EVENT_KEY}`;
const $b3d00e7418f714d6$var$EVENT_SHOWN = `shown${$b3d00e7418f714d6$var$EVENT_KEY}`;
const $b3d00e7418f714d6$var$CLASS_NAME_FADE = 'fade';
const $b3d00e7418f714d6$var$CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility
const $b3d00e7418f714d6$var$CLASS_NAME_SHOW = 'show';
const $b3d00e7418f714d6$var$CLASS_NAME_SHOWING = 'showing';
const $b3d00e7418f714d6$var$DefaultType = {
    animation: 'boolean',
    autohide: 'boolean',
    delay: 'number'
};
const $b3d00e7418f714d6$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $b3d00e7418f714d6$export$8d8dc7d5f743331b extends $b3d00e7418f714d6$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    // Getters
    static get Default() {
        return $b3d00e7418f714d6$var$Default;
    }
    static get DefaultType() {
        return $b3d00e7418f714d6$var$DefaultType;
    }
    static get NAME() {
        return $b3d00e7418f714d6$var$NAME;
    }
    // Public
    show() {
        const showEvent = $b3d00e7418f714d6$var$EventHandler.trigger(this._element, $b3d00e7418f714d6$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($b3d00e7418f714d6$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($b3d00e7418f714d6$var$CLASS_NAME_SHOWING);
            $b3d00e7418f714d6$var$EventHandler.trigger(this._element, $b3d00e7418f714d6$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($b3d00e7418f714d6$var$CLASS_NAME_HIDE); // @deprecated
        $b3d00e7418f714d6$var$reflow(this._element);
        this._element.classList.add($b3d00e7418f714d6$var$CLASS_NAME_SHOW, $b3d00e7418f714d6$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $b3d00e7418f714d6$var$EventHandler.trigger(this._element, $b3d00e7418f714d6$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($b3d00e7418f714d6$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($b3d00e7418f714d6$var$CLASS_NAME_SHOWING, $b3d00e7418f714d6$var$CLASS_NAME_SHOW);
            $b3d00e7418f714d6$var$EventHandler.trigger(this._element, $b3d00e7418f714d6$var$EVENT_HIDDEN);
        };
        this._element.classList.add($b3d00e7418f714d6$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($b3d00e7418f714d6$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($b3d00e7418f714d6$var$CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case 'mouseover':
            case 'mouseout':
                this._hasMouseInteraction = isInteracting;
                break;
            case 'focusin':
            case 'focusout':
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $b3d00e7418f714d6$var$EventHandler.on(this._element, $b3d00e7418f714d6$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $b3d00e7418f714d6$var$EventHandler.on(this._element, $b3d00e7418f714d6$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $b3d00e7418f714d6$var$EventHandler.on(this._element, $b3d00e7418f714d6$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $b3d00e7418f714d6$var$EventHandler.on(this._element, $b3d00e7418f714d6$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $b3d00e7418f714d6$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
/**
 * Data API implementation
 */ $b3d00e7418f714d6$var$enableDismissTrigger($b3d00e7418f714d6$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $b3d00e7418f714d6$var$defineJQueryPlugin($b3d00e7418f714d6$export$8d8dc7d5f743331b);


class $2ca636422b82d242$export$2e2bcd8739ae039 extends (0, $c8b99022ff3c634f$export$bd0bf19f25da8474) {
    static targets = [
        "nameInput",
        "identifierInput",
        "resultsOutput",
        "dropdown"
    ];
    ROR_API_URL = "https://api.ror.org/v2/organizations";
    DEBOUNCE_DELAY = 300 // milliseconds
    ;
    debounceTimer = null;
    connect() {
        this.resetResults();
    }
    disconnect() {
        this.resetDebounceTimer();
    }
    resetDebounceTimer() {
        if (this.debounceTimer) clearTimeout(this.debounceTimer);
    }
    handleInput(event) {
        event.preventDefault();
        event.stopPropagation();
        this.resetIdentifier();
        this.performSearch();
    }
    handleKeydown(event) {
        console.log("Keydown event:", event.key);
        if (event.key === "Escape") {
            this.closeDropdown();
            this.nameInputTarget.focus();
        } else if (event.key === "Enter") {
            event.preventDefault();
            event.stopPropagation();
        } else if (event.key === "ArrowDown") {
            event.preventDefault();
            event.stopPropagation();
            this.openDropdown();
            this.focusFirstDropdownItem();
        }
    }
    performSearch() {
        const query = this.nameInputTarget.value.trim();
        if (query.length < 3) {
            this.resetResults();
            return;
        }
        this.resetDebounceTimer();
        this.debounceTimer = setTimeout(()=>{
            this.fetchResults(query);
        }, this.DEBOUNCE_DELAY);
    }
    async fetchResults(query) {
        if (!query) {
            this.resetResults();
            return;
        }
        try {
            const response = await fetch(`${this.ROR_API_URL}?query=${encodeURIComponent(query)}*`);
            if (!response.ok) throw new Error(`ROR API request failed: ${response.statusText}`);
            const data = await response.json();
            this.displayResults(data.items || []);
        } catch (error) {
            this.setTextResult("Error fetching ROR data", true);
            this.openDropdown();
            this.nameInputTarget.focus();
        }
    }
    _getDisplayName(item) {
        if (item.names && Array.isArray(item.names) && item.names.length > 0) {
            const preferredTypes = [
                "ror_display",
                "label"
            ];
            for (const type of preferredTypes){
                const nameObj = item.names.find((n)=>n && n.types && Array.isArray(n.types) && n.types.includes(type));
                if (nameObj && typeof nameObj.value === 'string') return nameObj.value;
            }
        }
        return "N.a."; // Final fallback
    }
    displayResults(items) {
        this.resultsOutputTarget.innerHTML = "";
        if (items.length === 0) {
            this.setNoResult();
            return;
        }
        items.forEach((item)=>{
            this.addResult(item);
        });
        this.openDropdown();
        this.nameInputTarget.focus();
    }
    setNoResult() {
        this.setTextResult("No results found");
    }
    setTextResult(message, error = false) {
        const resultElement = document.createElement("div");
        resultElement.classList.add("dropdown-item");
        resultElement.classList.add("fst-italic");
        resultElement.textContent = message;
        if (error) resultElement.classList.add("text-danger");
        const listElement = document.createElement("li");
        listElement.appendChild(resultElement);
        this.resultsOutputTarget.innerHTML = "";
        this.resultsOutputTarget.appendChild(listElement);
    }
    addResult(item) {
        const displayName = this._getDisplayName(item);
        const resultElement = document.createElement("a");
        resultElement.href = "#";
        resultElement.classList.add("dropdown-item");
        resultElement.textContent = displayName;
        resultElement.dataset.rorId = item.id;
        resultElement.dataset.rorName = displayName;
        resultElement.addEventListener("click", this.selectResult.bind(this));
        const listElement = document.createElement("li");
        listElement.appendChild(resultElement);
        this.resultsOutputTarget.appendChild(listElement);
    }
    selectResult(event) {
        event.preventDefault();
        event.stopPropagation();
        const selectedItem = event.currentTarget;
        this.setName(selectedItem.dataset.rorName);
        this.setIdentifier(selectedItem.dataset.rorId);
        this.closeDropdown();
        this.nameInputTarget.focus();
    }
    resetResults() {
        this.setTextResult("Enter 3 or more characters to search organizations against ROR...");
    }
    openDropdown() {
        const dropdownInstance = (0, $b3d00e7418f714d6$export$931cbfb6bfb85fc).getOrCreateInstance(this.dropdownTarget);
        if (dropdownInstance) dropdownInstance.show();
    }
    closeDropdown() {
        const dropdownInstance = (0, $b3d00e7418f714d6$export$931cbfb6bfb85fc).getOrCreateInstance(this.dropdownTarget);
        if (dropdownInstance) dropdownInstance.hide();
    }
    setName(value) {
        if (this.hasNameInputTarget) this.nameInputTarget.value = value;
    }
    setIdentifier(value) {
        if (this.hasIdentifierInputTarget) this.identifierInputTarget.value = value;
    }
    resetIdentifier() {
        this.setIdentifier("");
    }
    focusFirstDropdownItem() {
        if (this.hasResultsOutputTarget) {
            const firstItem = this.resultsOutputTarget.querySelector('li:first-child > a.dropdown-item');
            if (firstItem) firstItem.focus();
        }
    }
}


// Start Stimulus application
const $91d619205dd6bcef$var$application = (0, $c8b99022ff3c634f$export$16975c34e60e1e61).start();
// Configure Stimulus development experience
$91d619205dd6bcef$var$application.debug = false;
window.Stimulus = $91d619205dd6bcef$var$application;
$91d619205dd6bcef$var$application.register("color-mode-switcher", (0, $730b239cf4b48d74$export$2e2bcd8739ae039));
$91d619205dd6bcef$var$application.register("nested-form", (0, $07e8f9449b8acef1$export$2e2bcd8739ae039));
$91d619205dd6bcef$var$application.register("autocomplete", (0, $4ca809d63d45f9a1$export$2e2bcd8739ae039));
$91d619205dd6bcef$var$application.register("stickybar", (0, $242c575d17b95698$export$2e2bcd8739ae039));
$91d619205dd6bcef$var$application.register("doi-registration--creator", (0, $d90d775eacadaaad$export$2e2bcd8739ae039));
$91d619205dd6bcef$var$application.register("doi-registration--ror-lookup", (0, $2ca636422b82d242$export$2e2bcd8739ae039));



window.Turbo = (0, $ee40788d37d3b5ae$exports);
(0, $ee40788d37d3b5ae$exports).config.drive.progressBarDelay = 200;



})();
//# sourceMappingURL=application.js.map
